export default [
  ["Pakistan","Competitions","Ocean Cleanup","Grant",1,0.5473,"PK"],
  ["Japan","Nonprofit","Ocean Cleanup","Equity",4,0.493,"JP"],
  ["South Korea","Crowdfunding","Waste Management","Equity",1,0.0298,"KR"],
  ["Israel","Public / Semi-public","Circular Economy","Lending",1,0.1344,"IL"],
  ["Paraguay","Impact Investor","Waste Management","Equity",1,0.9609,"PY"],
  ["Tuvalu","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TV"],
  ["Timor-Leste","Nonprofit","Ocean Cleanup","Lending",1,0.365,"TL"],
  ["Israel","Public / Semi-public","Circular Economy","Equity",1,0.5416,"IL"],
  ["Thailand","Incubator","Ocean Cleanup","Equity",1,0.1194,"TH"],
  ["Malaysia","Competitions","Ocean Cleanup","Grant",1,0.2734,"MY"],
  ["Tunisia","Impact Investor","Ocean Cleanup","Grant",2,0.3447,"TN"],
  ["Nepal","Bank","Waste Management","Lending",1,0.11,"NP"],
  ["Canada","Impact Investor","Ocean Cleanup","Grant",3,0.7607,"CA"],
  ["India","Foundation","Ocean Cleanup","Grant",5,2.024,"IN"],
  ["Malaysia","Foundation","Circular Economy","Equity",1,0.1234,"MY"],
  ["Cameroon","Nonprofit","Ocean Cleanup","Lending",1,0.2843,"CM"],
  ["Tajikistan","Bank","Circular Economy","Lending",1,0.4342,"TJ"],
  ["Lesotho","Venture Capital","Waste Management","Equity",1,0.0506,"LS"],
  ["Angola","Impact Investor","Ocean Cleanup","Lending",1,0.3036,"AO"],
  ["New Zealand","Impact Investor","Ocean Cleanup","Lending",3,0.3983,"NZ"],
  ["Greece","Impact Investor","Waste Management","Equity",2,0.2336,"GR"],
  ["Saudi Arabia","Financial Service Provider","Waste Management","Equity",1,0.0452,"SA"],
  ["Saudi Arabia","Bank","Waste Management","Equity",1,0.0897,"SA"],
  ["Switzerland","Impact Investor","Waste Management","Grant",2,0.1747,"CH"],
  ["Brazil","Foundation","Waste Management","Lending",2,0.2885,"BR"],
  ["Vietnam","Nonprofit","Waste Management","Equity",1,0.3319,"VN"],
  ["Canada","Venture Capital","Circular Economy","Equity",1,0.0266,"CA"],
  ["Botswana","Public / Semi-public","Ocean Cleanup","Grant",2,0.1498,"BW"],
  ["France","Impact Investor","Ocean Cleanup","Equity",5,1.5405,"FR"],
  ["Rwanda","Financial Service Provider","Ocean Cleanup","Lending",1,0.3697,"RW"],
  ["Cabo Verde","Venture Capital","Circular Economy","Equity",1,1.0,"CV"],
  ["Laos","Financial Service Provider","Circular Economy","Lending",1,0.3455,"LA"],
  ["South Sudan","Impact Investor","Circular Economy","Equity",1,0.0464,"SS"],
  ["Peru","Financial Service Provider","Ocean Cleanup","Equity",1,0.3019,"PE"],
  ["Egypt","Public / Semi-public","Circular Economy","Grant",6,1.246,"EG"],
  ["Pakistan","Financial Service Provider","Waste Management","Lending",2,0.2312,"PK"],
  ["Mauritius","Venture Capital","Circular Economy","Equity",1,1.0,"MU"],
  ["Senegal","Financial Service Provider","Waste Management","Equity",1,1.0,"SN"],
  ["Dominican Republic","Public / Semi-public","Circular Economy","Equity",1,0.2237,"DO"],
  ["Ecuador","Public / Semi-public","Waste Management","Equity",2,0.7965,"EC"],
  ["Bangladesh","Incubator","Ocean Cleanup","Equity",1,0.1501,"BD"],
  ["Switzerland","Impact Investor","Circular Economy","Lending",2,0.4351,"CH"],
  ["Australia","Financial Service Provider","Ocean Cleanup","Lending",1,0.1125,"AU"],
  ["Mexico","Public / Semi-public","Circular Economy","Equity",7,1.3919,"MX"],
  ["Costa Rica","Foundation","Circular Economy","Grant",1,0.3493,"CR"],
  ["Qatar","Public / Semi-public","Circular Economy","Grant",1,0.2608,"QA"],
  ["Jordan","Public / Semi-public","Ocean Cleanup","Equity",6,1.9524,"JO"],
  ["Dominica","Venture Capital","Circular Economy","Equity",1,1.0,"DM"],
  ["Ecuador","Foundation","Circular Economy","Grant",1,0.3653,"EC"],
  ["Paraguay","Public / Semi-public","Ocean Cleanup","Lending",1,0.0427,"PY"],
  ["Oman","Impact Investor","Waste Management","Equity",1,0.0362,"OM"],
  ["Qatar","Impact Investor","Ocean Cleanup","Grant",1,0.1194,"QA"],
  ["Malaysia","Competitions","Waste Management","Grant",1,0.2734,"MY"],
  ["Thailand","Nonprofit","Waste Management","Lending",2,0.2033,"TH"],
  ["Kyrgyz Republic","Public / Semi-public","Ocean Cleanup","Lending",2,0.215,"KG"],
  ["Sudan","Bank","Ocean Cleanup","Lending",1,0.0294,"SD"],
  ["Germany","Financial Service Provider","Ocean Cleanup","Lending",1,0.1571,"DE"],
  ["India","Bank","Ocean Cleanup","Equity",2,0.3624,"IN"],
  ["Namibia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"NA"],
  ["Egypt","Bank","Ocean Cleanup","Lending",5,1.4901,"EG"],
  ["Belize","Impact Investor","Waste Management","Lending",1,0.835,"BZ"],
  ["China","Public / Semi-public","Waste Management","Lending",5,1.1444,"CN"],
  ["Sweden","Nonprofit","Circular Economy","Lending",2,0.2787,"SE"],
  ["Kenya","Incubator","Waste Management","Equity",3,0.5246,"KE"],
  ["France","Nonprofit","Circular Economy","Equity",2,0.7102,"FR"],
  ["Qatar","Nonprofit","Waste Management","Grant",1,0.2192,"QA"],
  ["India","Foundation","Circular Economy","Grant",4,1.2561,"IN"],
  ["Sri Lanka","Public / Semi-public","Waste Management","Equity",5,0.9391,"LK"],
  ["Malawi","Impact Investor","Circular Economy","Equity",1,1.0,"MW"],
  ["Dominican Republic","Crowdfunding","Ocean Cleanup","Equity",1,0.0307,"DO"],
  ["Congo, Dem. Rep","Financial Service Provider","Ocean Cleanup","Equity",1,0.1017,"CD"],
  ["Lebanon","Foundation","Circular Economy","Grant",2,0.3749,"LB"],
  ["Germany","Financial Service Provider","Circular Economy","Lending",1,0.1587,"DE"],
  ["Australia","Financial Service Provider","Ocean Cleanup","Equity",1,0.1125,"AU"],
  ["United Kingdom","Impact Investor","Waste Management","Grant",3,1.1973,"GB"],
  ["Cameroon","Public / Semi-public","Ocean Cleanup","Lending",4,1.7404,"CM"],
  ["Costa Rica","Bank","Circular Economy","Equity",1,0.1133,"CR"],
  ["Israel","Impact Investor","Waste Management","Lending",1,0.0674,"IL"],
  ["Haiti","Public / Semi-public","Waste Management","Lending",4,1.8046,"HT"],
  ["Colombia","Foundation","Circular Economy","Grant",2,0.5915,"CO"],
  ["Senegal","Public / Semi-public","Circular Economy","Equity",2,0.6491,"SN"],
  ["Benin","Nonprofit","Ocean Cleanup","Equity",1,0.2566,"BJ"],
  ["China","Bank","Circular Economy","Lending",4,1.2319,"CN"],
  ["Austria","Incubator","Waste Management","Equity",2,0.4386,"AT"],
  ["Saudi Arabia","Bank","Circular Economy","Lending",3,0.8834,"SA"],
  ["Afghanistan","Venture Capital","Waste Management","Equity",1,0.0344,"AF"],
  ["Germany","Incubator","Circular Economy","Grant",1,0.2359,"DE"],
  ["Thailand","Financial Service Provider","Ocean Cleanup","Equity",1,0.0626,"TH"],
  ["Botswana","Financial Service Provider","Circular Economy","Equity",1,0.076,"BW"],
  ["Sweden","Incubator","Circular Economy","Equity",1,0.2522,"SE"],
  ["Indonesia","Financial Service Provider","Ocean Cleanup","Lending",1,0.2676,"ID"],
  ["Indonesia","Nonprofit","Waste Management","Grant",5,1.3844,"ID"],
  ["Uganda","Public / Semi-public","Ocean Cleanup","Equity",6,2.505,"UG"],
  ["Malawi","Impact Investor","Waste Management","Lending",1,0.2661,"MW"],
  ["Indonesia","Public / Semi-public","Waste Management","Equity",8,2.3732,"ID"],
  ["Ireland","Public / Semi-public","Waste Management","Grant",1,0.1082,"IE"],
  ["Timor-Leste","Foundation","Ocean Cleanup","Grant",1,0.3973,"TL"],
  ["Malaysia","Bank","Ocean Cleanup","Lending",3,0.5383,"MY"],
  ["Venezuela","Public / Semi-public","Waste Management","Equity",3,2.0467,"VE"],
  ["Morocco","Impact Investor","Waste Management","Lending",1,0.1828,"MA"],
  ["Turkey","Nonprofit","Waste Management","Equity",3,0.5893,"TR"],
  ["Denmark","Impact Investor","Ocean Cleanup","Equity",1,0.1324,"DK"],
  ["Uganda","Public / Semi-public","Ocean Cleanup","Grant",6,1.1381,"UG"],
  ["Colombia","Impact Investor","Waste Management","Equity",5,1.9551,"CO"],
  ["Oman","Foundation","Ocean Cleanup","Lending",1,0.1749,"OM"],
  ["Costa Rica","Impact Investor","Waste Management","Equity",1,0.2987,"CR"],
  ["Uganda","Bank","Waste Management","Equity",1,0.3043,"UG"],
  ["China","Incubator","Circular Economy","Grant",1,0.1338,"CN"],
  ["Lebanon","Public / Semi-public","Circular Economy","Lending",2,0.3018,"LB"],
  ["Brazil","Nonprofit","Circular Economy","Equity",2,0.7256,"BR"],
  ["Spain","Nonprofit","Waste Management","Lending",4,0.9315,"ES"],
  ["Iran","Foundation","Ocean Cleanup","Grant",3,0.8641,"IR"],
  ["Mexico","Financial Service Provider","Ocean Cleanup","Lending",1,0.0867,"MX"],
  ["Benin","Nonprofit","Ocean Cleanup","Lending",1,0.2566,"BJ"],
  ["Mongolia","Bank","Ocean Cleanup","Equity",1,0.2663,"MN"],
  ["Congo, Dem. Rep","Foundation","Ocean Cleanup","Equity",1,0.1508,"CD"],
  ["Panama","Venture Capital","Ocean Cleanup","Equity",1,1.0,"PA"],
  ["Egypt","Financial Service Provider","Circular Economy","Grant",1,0.0634,"EG"],
  ["Malaysia","Nonprofit","Circular Economy","Lending",2,0.2745,"MY"],
  ["Lesotho","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"LS"],
  ["Nigeria","Nonprofit","Circular Economy","Lending",2,0.1756,"NG"],
  ["Bangladesh","Impact Investor","Waste Management","Lending",4,1.254,"BD"],
  ["Canada","Bank","Waste Management","Lending",2,0.3114,"CA"],
  ["Mayotte","Venture Capital","Circular Economy","Equity",1,1.0,"YT"],
  ["South Africa","Venture Capital","Ocean Cleanup","Grant",1,1.0,"ZA"],
  ["Malaysia","Nonprofit","Waste Management","Equity",2,0.2745,"MY"],
  ["Romania","Public / Semi-public","Circular Economy","Lending",1,0.0493,"RO"],
  ["Poland","Financial Service Provider","Circular Economy","Grant",1,0.1154,"PL"],
  ["Malaysia","Bank","Circular Economy","Lending",2,0.5626,"MY"],
  ["Ireland","Crowdfunding","Ocean Cleanup","Grant",1,0.063,"IE"],
  ["Ethiopia","Public / Semi-public","Ocean Cleanup","Lending",4,1.7915,"ET"],
  ["Togo","Bank","Circular Economy","Lending",1,0.2171,"TG"],
  ["Guatemala","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GT"],
  ["Kosovo","Venture Capital","Circular Economy","Equity",1,1.0,"XK"],
  ["Indonesia","Incubator","Ocean Cleanup","Equity",1,0.1298,"ID"],
  ["India","Incubator","Circular Economy","Equity",1,1.0,"IN"],
  ["India","Nonprofit","Waste Management","Grant",5,2.3384,"IN"],
  ["Singapore","Nonprofit","Waste Management","Grant",2,0.497,"SG"],
  ["United Kingdom","Public / Semi-public","Circular Economy","Lending",8,1.9903,"GB"],
  ["Sierra Leone","Foundation","Waste Management","Grant",1,0.1579,"SL"],
  ["Sudan","Impact Investor","Waste Management","Grant",2,0.3118,"SD"],
  ["Anguilla","Public / Semi-public","Circular Economy","Equity",1,1.0,"AI"],
  ["Switzerland","Impact Investor","Circular Economy","Equity",2,0.4351,"CH"],
  ["France","Public / Semi-public","Ocean Cleanup","Equity",13,5.2068,"FR"],
  ["Myanmar","Foundation","Ocean Cleanup","Grant",2,0.7752,"MM"],
  ["Nauru","Venture Capital","Ocean Cleanup","Equity",1,1.0,"NR"],
  ["Denmark","Foundation","Circular Economy","Grant",1,0.0515,"DK"],
  ["Italy","Incubator","Waste Management","Grant",1,0.3791,"IT"],
  ["Burundi","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"BI"],
  ["Egypt","Financial Service Provider","Waste Management","Grant",1,0.0634,"EG"],
  ["Mali","Public / Semi-public","Waste Management","Equity",4,1.1445,"ML"],
  ["New Zealand","Nonprofit","Ocean Cleanup","Lending",4,0.8578,"NZ"],
  ["Lesotho","Venture Capital","Circular Economy","Equity",2,1.0506,"LS"],
  ["Argentina","Bank","Circular Economy","Lending",1,0.2475,"AR"],
  ["West Bank and Gaza","Incubator","Waste Management","Equity",1,0.1488,"PS"],
  ["Bangladesh","Nonprofit","Circular Economy","Equity",2,0.8757,"BD"],
  ["Tanzania","Foundation","Ocean Cleanup","Lending",2,0.7151,"TZ"],
  ["Myanmar","Financial Service Provider","Waste Management","Grant",1,0.1013,"MM"],
  ["Lebanon","Venture Capital","Circular Economy","Equity",2,1.0318,"LB"],
  ["Congo, Rep.","Financial Service Provider","Circular Economy","Equity",1,1.0,"CG"],
  ["Saudi Arabia","Nonprofit","Ocean Cleanup","Grant",5,1.0262,"SA"],
  ["Lebanon","Foundation","Ocean Cleanup","Lending",1,0.1624,"LB"],
  ["Pakistan","Bank","Circular Economy","Equity",3,0.6848,"PK"],
  ["Nigeria","Competitions","Ocean Cleanup","Grant",1,0.198,"NG"],
  ["Niger","Public / Semi-public","Waste Management","Lending",2,0.7075,"NE"],
  ["Netherlands","Impact Investor","Ocean Cleanup","Grant",3,1.3936,"NL"],
  ["Vietnam","Public / Semi-public","Circular Economy","Equity",5,1.1448,"VN"],
  ["Bouvet Island","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BV"],
  ["Burkina Faso","Nonprofit","Waste Management","Lending",1,0.2036,"BF"],
  ["Australia","Financial Service Provider","Circular Economy","Equity",2,0.2352,"AU"],
  ["Poland","Foundation","Circular Economy","Grant",2,0.4994,"PL"],
  ["Indonesia","Financial Service Provider","Circular Economy","Equity",2,0.4797,"ID"],
  ["United States","Nonprofit","Waste Management","Grant",5,1.8134,"US"],
  ["Uganda","Bank","Waste Management","Lending",2,0.8681,"UG"],
  ["Belgium","Impact Investor","Circular Economy","Lending",2,0.3263,"BE"],
  ["United States","Crowdfunding","Ocean Cleanup","Equity",1,0.5548,"US"],
  ["Indonesia","Public / Semi-public","Ocean Cleanup","Equity",9,2.9192,"ID"],
  ["Brazil","Bank","Waste Management","Equity",1,0.0904,"BR"],
  ["Nepal","Incubator","Circular Economy","Equity",1,0.1003,"NP"],
  ["Armenia","Bank","Ocean Cleanup","Lending",1,0.3815,"AM"],
  ["Equatorial Guinea","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"GQ"],
  ["Japan","Foundation","Circular Economy","Grant",1,0.0592,"JP"],
  ["Poland","Public / Semi-public","Ocean Cleanup","Lending",2,0.375,"PL"],
  ["French Polynesia","Public / Semi-public","Waste Management","Lending",1,0.6939,"PF"],
  ["Greece","Bank","Ocean Cleanup","Lending",1,0.1975,"GR"],
  ["Slovakia","Financial Service Provider","Waste Management","Equity",1,0.0583,"SK"],
  ["United Arab Emirates","Impact Investor","Ocean Cleanup","Lending",3,0.4178,"AE"],
  ["Kenya","Foundation","Circular Economy","Lending",1,1.0,"KE"],
  ["Bangladesh","Bank","Circular Economy","Equity",3,0.6218,"BD"],
  ["Bolivia","Nonprofit","Ocean Cleanup","Grant",3,0.4277,"BO"],
  ["United States","Financial Service Provider","Waste Management","Equity",4,1.4743,"US"],
  ["New Zealand","Financial Service Provider","Circular Economy","Lending",2,0.4089,"NZ"],
  ["Guatemala","Foundation","Waste Management","Grant",1,0.3814,"GT"],
  ["Qatar","Public / Semi-public","Circular Economy","Equity",3,0.5758,"QA"],
  ["Ghana","Impact Investor","Ocean Cleanup","Equity",1,0.0885,"GH"],
  ["Israel","Impact Investor","Circular Economy","Grant",1,0.0788,"IL"],
  ["Nauru","Venture Capital","Circular Economy","Equity",1,1.0,"NR"],
  ["Algeria","Public / Semi-public","Ocean Cleanup","Equity",9,3.9445,"DZ"],
  ["Philippines","Public / Semi-public","Waste Management","Grant",5,0.6315,"PH"],
  ["Portugal","Financial Service Provider","Circular Economy","Grant",1,0.0822,"PT"],
  ["Nepal","Public / Semi-public","Waste Management","Lending",4,1.7975,"NP"],
  ["Niger","Venture Capital","Circular Economy","Equity",1,1.0,"NE"],
  ["United Arab Emirates","Venture Capital","Waste Management","Equity",1,0.0716,"AE"],
  ["Malawi","Venture Capital","Circular Economy","Equity",1,1.0,"MW"],
  ["Bangladesh","Public / Semi-public","Circular Economy","Grant",5,1.4476,"BD"],
  ["Zimbabwe","Nonprofit","Waste Management","Equity",2,0.5163,"ZW"],
  ["Syria","Nonprofit","Waste Management","Grant",1,0.3336,"SY"],
  ["Barbados","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"BB"],
  ["Croatia","Public / Semi-public","Circular Economy","Equity",1,0.1004,"HR"],
  ["Ukraine","Public / Semi-public","Waste Management","Lending",2,0.9948,"UA"],
  ["Belarus","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BY"],
  ["Libya","Nonprofit","Circular Economy","Grant",1,0.4748,"LY"],
  ["Australia","Public / Semi-public","Waste Management","Grant",5,0.7398,"AU"],
  ["Cyprus","Bank","Ocean Cleanup","Lending",2,0.7848,"CY"],
  ["Honduras","Bank","Waste Management","Equity",1,0.1958,"HN"],
  ["Rwanda","Foundation","Circular Economy","Lending",1,0.2108,"RW"],
  ["Zambia","Financial Service Provider","Waste Management","Grant",1,1.0,"ZM"],
  ["Jordan","Venture Capital","Ocean Cleanup","Equity",1,1.0,"JO"],
  ["Finland","Impact Investor","Waste Management","Grant",1,0.0906,"FI"],
  ["Dominica","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"DM"],
  ["Chile","Nonprofit","Ocean Cleanup","Lending",2,0.4762,"CL"],
  ["Malaysia","Bank","Waste Management","Lending",1,0.2158,"MY"],
  ["Iran","Public / Semi-public","Waste Management","Lending",1,0.6446,"IR"],
  ["Australia","Venture Capital","Circular Economy","Equity",2,1.0443,"AU"],
  ["Thailand","Public / Semi-public","Ocean Cleanup","Lending",6,1.5553,"TH"],
  ["United States","Bank","Ocean Cleanup","Equity",2,0.3565,"US"],
  ["Indonesia","Nonprofit","Ocean Cleanup","Grant",8,2.8031,"ID"],
  ["Tunisia","Impact Investor","Waste Management","Lending",1,0.609,"TN"],
  ["Australia","Foundation","Ocean Cleanup","Lending",2,0.3742,"AU"],
  ["India","Foundation","Waste Management","Grant",6,1.9867,"IN"],
  ["Vietnam","Foundation","Ocean Cleanup","Equity",2,0.2963,"VN"],
  ["Switzerland","Nonprofit","Circular Economy","Equity",2,0.4351,"CH"],
  ["Bahrain","Foundation","Waste Management","Equity",1,0.1767,"BH"],
  ["United States","Incubator","Ocean Cleanup","Lending",1,1.0,"US"],
  ["Albania","Impact Investor","Ocean Cleanup","Equity",1,1.0,"AL"],
  ["Sri Lanka","Public / Semi-public","Circular Economy","Equity",2,0.4751,"LK"],
  ["Netherlands","Impact Investor","Circular Economy","Grant",1,1.0,"NL"],
  ["Nigeria","Impact Investor","Waste Management","Equity",5,0.5482,"NG"],
  ["Cyprus","Nonprofit","Circular Economy","Equity",1,0.107,"CY"],
  ["Lithuania","Impact Investor","Waste Management","Equity",1,0.0474,"LT"],
  ["Saudi Arabia","Incubator","Waste Management","Equity",4,0.6035,"SA"],
  ["Norway","Crowdfunding","Waste Management","Lending",1,0.0324,"NO"],
  ["Argentina","Bank","Circular Economy","Equity",1,0.2475,"AR"],
  ["Taiwan","Financial Service Provider","Circular Economy","Lending",1,0.1236,"TW"],
  ["Spain","Public / Semi-public","Waste Management","Lending",7,1.7576,"ES"],
  ["Tanzania","Financial Service Provider","Waste Management","Equity",3,1.7975,"TZ"],
  ["China","Public / Semi-public","Circular Economy","Lending",4,1.3074,"CN"],
  ["Georgia","Public / Semi-public","Waste Management","Lending",3,1.05,"GE"],
  ["Dominican Republic","Venture Capital","Ocean Cleanup","Equity",1,1.0,"DO"],
  ["Oman","Crowdfunding","Waste Management","Lending",1,0.0542,"OM"],
  ["Algeria","Nonprofit","Ocean Cleanup","Grant",4,0.7777,"DZ"],
  ["Uzbekistan","Public / Semi-public","Ocean Cleanup","Equity",1,0.8243,"UZ"],
  ["Zambia","Impact Investor","Waste Management","Grant",3,0.3328,"ZM"],
  ["Bosnia and Herzegovina","Public / Semi-public","Ocean Cleanup","Grant",1,0.4105,"BA"],
  ["Sweden","Crowdfunding","Waste Management","Lending",1,0.0308,"SE"],
  ["Greenland","Venture Capital","Circular Economy","Equity",1,1.0,"GL"],
  ["Somalia","Foundation","Ocean Cleanup","Grant",1,0.2496,"SO"],
  ["Denmark","Public / Semi-public","Circular Economy","Equity",2,0.2442,"DK"],
  ["Bhutan","Public / Semi-public","Waste Management","Grant",1,0.1081,"BT"],
  ["Morocco","Venture Capital","Circular Economy","Equity",2,1.0262,"MA"],
  ["Sweden","Financial Service Provider","Ocean Cleanup","Equity",1,0.0989,"SE"],
  ["United Kingdom","Crowdfunding","Waste Management","Equity",1,0.2489,"GB"],
  ["Argentina","Bank","Waste Management","Equity",1,0.2475,"AR"],
  ["Mozambique","Impact Investor","Circular Economy","Equity",1,1.0,"MZ"],
  ["United Arab Emirates","Bank","Circular Economy","Equity",2,0.5937,"AE"],
  ["Myanmar","Foundation","Circular Economy","Grant",2,0.4546,"MM"],
  ["Somalia","Foundation","Circular Economy","Grant",1,0.2496,"SO"],
  ["New Zealand","Foundation","Circular Economy","Grant",2,0.2672,"NZ"],
  ["Nigeria","Foundation","Waste Management","Grant",4,0.8521,"NG"],
  ["Bahamas, The","Public / Semi-public","Waste Management","Lending",1,1.0,"BS"],
  ["Netherlands","Incubator","Ocean Cleanup","Grant",1,0.0739,"NL"],
  ["Vatican City","Venture Capital","Circular Economy","Equity",1,1.0,"VA"],
  ["Benin","Public / Semi-public","Waste Management","Grant",2,0.7428,"BJ"],
  ["Greece","Impact Investor","Ocean Cleanup","Grant",1,0.3605,"GR"],
  ["Bangladesh","Bank","Circular Economy","Lending",4,0.6134,"BD"],
  ["Finland","Incubator","Ocean Cleanup","Grant",1,0.0906,"FI"],
  ["Ghana","Foundation","Ocean Cleanup","Grant",2,0.6323,"GH"],
  ["Ireland","Nonprofit","Circular Economy","Lending",1,0.0953,"IE"],
  ["Guinea-Bisau","Venture Capital","Circular Economy","Equity",1,1.0,"GW"],
  ["Mali","Financial Service Provider","Ocean Cleanup","Equity",1,0.2892,"ML"],
  ["New Zealand","Coworking Space","Waste Management","Equity",1,0.0329,"NZ"],
  ["Japan","Crowdfunding","Waste Management","Lending",1,0.0249,"JP"],
  ["Chile","Impact Investor","Waste Management","Equity",2,0.9586,"CL"],
  ["Brunei","Venture Capital","Circular Economy","Equity",1,1.0,"BN"],
  ["Indonesia","Public / Semi-public","Circular Economy","Grant",5,1.1982,"ID"],
  ["Argentina","Nonprofit","Waste Management","Grant",3,1.0331,"AR"],
  ["South Sudan","Foundation","Circular Economy","Lending",1,0.3356,"SS"],
  ["Cyprus","Public / Semi-public","Ocean Cleanup","Lending",1,0.0748,"CY"],
  ["Colombia","Bank","Ocean Cleanup","Lending",2,0.3162,"CO"],
  ["Germany","Public / Semi-public","Circular Economy","Grant",6,1.1759,"DE"],
  ["Iraq","Financial Service Provider","Circular Economy","Grant",1,0.0524,"IQ"],
  ["Australia","Foundation","Waste Management","Grant",6,1.6776,"AU"],
  ["Belgium","Incubator","Waste Management","Equity",3,0.3918,"BE"],
  ["Brazil","Public / Semi-public","Circular Economy","Lending",8,1.6213,"BR"],
  ["Cambodia","Crowdfunding","Waste Management","Equity",1,0.2021,"KH"],
  ["Japan","Impact Investor","Circular Economy","Equity",2,0.2261,"JP"],
  ["Sweden","Foundation","Ocean Cleanup","Lending",2,0.3141,"SE"],
  ["Togo","Public / Semi-public","Circular Economy","Lending",1,0.4885,"TG"],
  ["Kyrgyz Republic","Venture Capital","Circular Economy","Equity",1,1.0,"KG"],
  ["Oman","Bank","Ocean Cleanup","Equity",1,0.179,"OM"],
  ["Italy","Public / Semi-public","Ocean Cleanup","Equity",11,3.0814,"IT"],
  ["Marshall Islands","Venture Capital","Circular Economy","Equity",1,1.0,"MH"],
  ["Mexico","Bank","Waste Management","Lending",1,0.108,"MX"],
  ["Canada","Competitions","Waste Management","Grant",1,0.2484,"CA"],
  ["Iceland","Venture Capital","Circular Economy","Equity",1,1.0,"IS"],
  ["Guyana","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GY"],
  ["Italy","Bank","Ocean Cleanup","Equity",1,0.1926,"IT"],
  ["India","Financial Service Provider","Ocean Cleanup","Equity",2,0.5123,"IN"],
  ["Kenya","Impact Investor","Circular Economy","Grant",2,1.3707,"KE"],
  ["Bahrain","Impact Investor","Waste Management","Grant",1,0.0825,"BH"],
  ["Uganda","Financial Service Provider","Ocean Cleanup","Equity",1,0.3731,"UG"],
  ["Rwanda","Incubator","Ocean Cleanup","Grant",1,0.0745,"RW"],
  ["Vietnam","Financial Service Provider","Waste Management","Lending",2,0.4624,"VN"],
  ["Bulgaria","Venture Capital","Circular Economy","Equity",2,1.0374,"BG"],
  ["Comoros","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"KM"],
  ["Guatemala","Bank","Waste Management","Equity",1,0.1152,"GT"],
  ["Kosovo","Nonprofit","Circular Economy","Grant",1,0.7165,"XK"],
  ["Indonesia","Foundation","Waste Management","Equity",2,0.2581,"ID"],
  ["Vietnam","Foundation","Waste Management","Lending",2,0.2963,"VN"],
  ["Madagascar","Foundation","Waste Management","Grant",2,1.4149,"MG"],
  ["Sri Lanka","Venture Capital","Ocean Cleanup","Equity",1,1.0,"LK"],
  ["Kenya","Bank","Circular Economy","Equity",2,1.374,"KE"],
  ["Sierra Leone","Venture Capital","Circular Economy","Equity",1,1.0,"SL"],
  ["Comoros","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"KM"],
  ["Sudan","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"SD"],
  ["United States","Foundation","Ocean Cleanup","Lending",2,1.2322,"US"],
  ["Qatar","Incubator","Waste Management","Grant",1,0.1194,"QA"],
  ["Tanzania","Impact Investor","Waste Management","Lending",2,0.5192,"TZ"],
  ["Guatemala","Public / Semi-public","Circular Economy","Equity",1,0.3085,"GT"],
  ["India","Impact Investor","Ocean Cleanup","Lending",3,1.6508,"IN"],
  ["Ghana","Foundation","Circular Economy","Equity",1,0.1774,"GH"],
  ["Fiji","Public / Semi-public","Ocean Cleanup","Grant",1,0.5692,"FJ"],
  ["Saudi Arabia","Microfinance Institution","Waste Management","Lending",1,0.0476,"SA"],
  ["Costa Rica","Public / Semi-public","Waste Management","Lending",2,0.3298,"CR"],
  ["Spain","Impact Investor","Circular Economy","Lending",2,0.6234,"ES"],
  ["Bangladesh","Crowdfunding","Ocean Cleanup","Equity",1,0.1412,"BD"],
  ["Thailand","Bank","Ocean Cleanup","Equity",2,0.1836,"TH"],
  ["Nepal","Nonprofit","Ocean Cleanup","Grant",8,2.9015,"NP"],
  ["Mali","Venture Capital","Circular Economy","Equity",1,1.0,"ML"],
  ["Benin","Nonprofit","Ocean Cleanup","Grant",1,0.3631,"BJ"],
  ["United Arab Emirates","Public / Semi-public","Waste Management","Lending",5,0.942,"AE"],
  ["Argentina","Bank","Ocean Cleanup","Equity",1,0.2475,"AR"],
  ["Panama","Public / Semi-public","Waste Management","Equity",1,0.9208,"PA"],
  ["Nigeria","Financial Service Provider","Ocean Cleanup","Equity",2,0.1602,"NG"],
  ["Georgia","Public / Semi-public","Waste Management","Grant",1,0.2008,"GE"],
  ["Chile","Public / Semi-public","Waste Management","Grant",1,0.1183,"CL"],
  ["Tanzania","Financial Service Provider","Ocean Cleanup","Lending",1,0.3587,"TZ"],
  ["Spain","Incubator","Ocean Cleanup","Lending",1,0.1756,"ES"],
  ["Spain","Competitions","Ocean Cleanup","Grant",1,0.2018,"ES"],
  ["Gabon","Financial Service Provider","Waste Management","Equity",1,0.177,"GA"],
  ["Cambodia","Bank","Circular Economy","Lending",3,0.3915,"KH"],
  ["Hong Kong","Venture Capital","Waste Management","Equity",1,0.0326,"HK"],
  ["Liechtenstein","Venture Capital","Circular Economy","Equity",1,1.0,"LI"],
  ["Ethiopia","Nonprofit","Circular Economy","Grant",3,0.9225,"ET"],
  ["United Arab Emirates","Foundation","Ocean Cleanup","Lending",2,0.3681,"AE"],
  ["Oman","Nonprofit","Ocean Cleanup","Grant",2,0.3225,"OM"],
  ["El Salvador","Nonprofit","Ocean Cleanup","Lending",1,0.0946,"SV"],
  ["South Korea","Nonprofit","Waste Management","Equity",2,0.2789,"KR"],
  ["United Arab Emirates","Financial Service Provider","Circular Economy","Grant",1,0.0651,"AE"],
  ["Afghanistan","Nonprofit","Ocean Cleanup","Grant",1,0.6192,"AF"],
  ["Senegal","Public / Semi-public","Ocean Cleanup","Equity",4,1.9461,"SN"],
  ["United Kingdom","Nonprofit","Ocean Cleanup","Grant",9,3.6751,"GB"],
  ["Cyprus","Impact Investor","Ocean Cleanup","Equity",1,0.107,"CY"],
  ["Libya","Bank","Waste Management","Lending",1,0.1873,"LY"],
  ["West Bank and Gaza","Public / Semi-public","Circular Economy","Equity",2,0.9396,"PS"],
  ["San Marino","Venture Capital","Circular Economy","Equity",1,1.0,"SM"],
  ["Italy","Nonprofit","Circular Economy","Equity",2,0.607,"IT"],
  ["Ukraine","Foundation","Ocean Cleanup","Equity",1,0.1787,"UA"],
  ["Brazil","Incubator","Circular Economy","Equity",1,0.1168,"BR"],
  ["Mozambique","Nonprofit","Waste Management","Equity",1,0.4,"MZ"],
  ["Belgium","Foundation","Waste Management","Equity",2,0.3402,"BE"],
  ["Wallis and Futuna","Venture Capital","Circular Economy","Equity",1,1.0,"WF"],
  ["Cameroon","Financial Service Provider","Ocean Cleanup","Equity",1,0.2843,"CM"],
  ["Gabon","Public / Semi-public","Ocean Cleanup","Lending",2,1.4243,"GA"],
  ["Finland","Impact Investor","Waste Management","Equity",1,0.0634,"FI"],
  ["Pakistan","Crowdfunding","Ocean Cleanup","Grant",1,0.0568,"PK"],
  ["Poland","Incubator","Circular Economy","Equity",1,0.0916,"PL"],
  ["Albania","Impact Investor","Circular Economy","Lending",1,1.0,"AL"],
  ["Mexico","Public / Semi-public","Ocean Cleanup","Grant",8,2.2409,"MX"],
  ["China","Incubator","Ocean Cleanup","Grant",1,0.0959,"CN"],
  ["Belize","Venture Capital","Circular Economy","Equity",1,1.0,"BZ"],
  ["Chad","Public / Semi-public","Circular Economy","Grant",1,0.386,"TD"],
  ["Israel","Venture Capital","Waste Management","Equity",1,0.0296,"IL"],
  ["Philippines","Foundation","Waste Management","Lending",2,0.2822,"PH"],
  ["France","Incubator","Circular Economy","Grant",1,0.19,"FR"],
  ["Kenya","Bank","Waste Management","Equity",1,0.374,"KE"],
  ["Portugal","Nonprofit","Ocean Cleanup","Grant",6,1.7874,"PT"],
  ["Guatemala","Nonprofit","Circular Economy","Grant",1,0.583,"GT"],
  ["Italy","Foundation","Ocean Cleanup","Equity",2,0.3556,"IT"],
  ["Mauritius","Public / Semi-public","Waste Management","Lending",1,0.0329,"MU"],
  ["Taiwan","Foundation","Circular Economy","Grant",1,0.0932,"TW"],
  ["Malaysia","Impact Investor","Ocean Cleanup","Grant",2,0.399,"MY"],
  ["Malawi","Incubator","Waste Management","Equity",1,0.2661,"MW"],
  ["Seychelles","Venture Capital","Circular Economy","Equity",1,1.0,"SC"],
  ["Gabon","Public / Semi-public","Circular Economy","Grant",1,0.4243,"GA"],
  ["Brazil","Nonprofit","Ocean Cleanup","Lending",5,1.3959,"BR"],
  ["Finland","Public / Semi-public","Ocean Cleanup","Equity",2,0.2974,"FI"],
  ["French Polynesia","Public / Semi-public","Waste Management","Equity",1,0.6939,"PF"],
  ["Lebanon","Foundation","Circular Economy","Equity",1,0.1624,"LB"],
  ["Kenya","Public / Semi-public","Ocean Cleanup","Grant",8,3.5763,"KE"],
  ["Ghana","Incubator","Waste Management","Grant",1,0.0785,"GH"],
  ["Denmark","Bank","Circular Economy","Equity",1,0.1139,"DK"],
  ["India","Impact Investor","Ocean Cleanup","Grant",3,0.6339,"IN"],
  ["Peru","Foundation","Waste Management","Grant",3,1.1621,"PE"],
  ["Mali","Nonprofit","Ocean Cleanup","Lending",1,0.2892,"ML"],
  ["Vietnam","Bank","Ocean Cleanup","Lending",3,0.253,"VN"],
  ["Malawi","Financial Service Provider","Circular Economy","Equity",1,1.0,"MW"],
  ["South Korea","Public / Semi-public","Waste Management","Lending",4,0.8079,"KR"],
  ["Turkey","Venture Capital","Circular Economy","Equity",1,1.0,"TR"],
  ["Germany","Financial Service Provider","Waste Management","Grant",2,0.5582,"DE"],
  ["South Africa","Financial Service Provider","Waste Management","Grant",2,0.3712,"ZA"],
  ["Morocco","Crowdfunding","Ocean Cleanup","Equity",1,0.0257,"MA"],
  ["Portugal","Nonprofit","Ocean Cleanup","Equity",4,0.7089,"PT"],
  ["Ghana","Foundation","Circular Economy","Grant",1,0.1774,"GH"],
  ["Ecuador","Venture Capital","Circular Economy","Equity",1,1.0,"EC"],
  ["Israel","Incubator","Waste Management","Equity",2,0.1939,"IL"],
  ["El Salvador","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SV"],
  ["Singapore","Public / Semi-public","Ocean Cleanup","Equity",3,0.6855,"SG"],
  ["Laos","Public / Semi-public","Ocean Cleanup","Equity",2,0.8534,"LA"],
  ["China","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CN"],
  ["Canada","Bank","Ocean Cleanup","Equity",2,0.3274,"CA"],
  ["Sweden","Financial Service Provider","Circular Economy","Lending",1,0.0931,"SE"],
  ["Mozambique","Foundation","Ocean Cleanup","Grant",1,0.6148,"MZ"],
  ["Hong Kong","Public / Semi-public","Circular Economy","Equity",1,0.274,"HK"],
  ["Qatar","Public / Semi-public","Waste Management","Grant",1,0.1194,"QA"],
  ["United States","Public / Semi-public","Waste Management","Equity",13,5.4022,"US"],
  ["United Arab Emirates","Nonprofit","Circular Economy","Equity",2,0.2889,"AE"],
  ["Germany","Incubator","Ocean Cleanup","Equity",1,0.1844,"DE"],
  ["Mongolia","Public / Semi-public","Ocean Cleanup","Grant",1,0.4893,"MN"],
  ["France","Foundation","Waste Management","Grant",6,1.6746,"FR"],
  ["Madagascar","Public / Semi-public","Waste Management","Grant",3,0.9463,"MG"],
  ["Bahrain","Nonprofit","Waste Management","Lending",1,0.0376,"BH"],
  ["United States","Impact Investor","Circular Economy","Equity",4,2.4621,"US"],
  ["Israel","Bank","Ocean Cleanup","Lending",2,0.5248,"IL"],
  ["Madagascar","Venture Capital","Waste Management","Equity",1,0.0343,"MG"],
  ["Barbados","Impact Investor","Waste Management","Grant",1,0.3399,"BB"],
  ["Uganda","Nonprofit","Circular Economy","Grant",3,0.9064,"UG"],
  ["Sweden","Impact Investor","Ocean Cleanup","Lending",3,0.4164,"SE"],
  ["Switzerland","Impact Investor","Ocean Cleanup","Grant",2,0.1747,"CH"],
  ["Kuwait","Bank","Ocean Cleanup","Lending",2,0.3727,"KW"],
  ["Barbados","Public / Semi-public","Circular Economy","Equity",1,1.0,"BB"],
  ["Mali","Public / Semi-public","Circular Economy","Grant",1,0.4836,"ML"],
  ["Cuba","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CU"],
  ["Nepal","Nonprofit","Circular Economy","Grant",5,2.2628,"NP"],
  ["South Sudan","Foundation","Waste Management","Lending",1,0.3356,"SS"],
  ["Venezuela","Financial Service Provider","Waste Management","Lending",1,0.1406,"VE"],
  ["Chad","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TD"],
  ["Thailand","Bank","Circular Economy","Equity",3,0.3484,"TH"],
  ["Central African Republic","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CF"],
  ["Burkina Faso","Financial Service Provider","Waste Management","Equity",1,0.2036,"BF"],
  ["Sweden","Impact Investor","Circular Economy","Equity",3,0.3286,"SE"],
  ["Peru","Foundation","Ocean Cleanup","Grant",3,1.1811,"PE"],
  ["Kiribati","Venture Capital","Ocean Cleanup","Equity",1,1.0,"KI"],
  ["Australia","Nonprofit","Circular Economy","Equity",2,0.6231,"AU"],
  ["Canada","Foundation","Circular Economy","Equity",1,0.1729,"CA"],
  ["South Africa","Incubator","Ocean Cleanup","Equity",1,0.3203,"ZA"],
  ["Colombia","Public / Semi-public","Waste Management","Equity",9,3.5406,"CO"],
  ["Australia","Financial Service Provider","Waste Management","Equity",3,0.343,"AU"],
  ["Ghana","Competitions","Ocean Cleanup","Grant",1,0.2935,"GH"],
  ["Myanmar","Impact Investor","Waste Management","Lending",1,0.207,"MM"],
  ["Slovakia","Public / Semi-public","Ocean Cleanup","Equity",1,0.0694,"SK"],
  ["Haiti","Public / Semi-public","Ocean Cleanup","Equity",3,1.5725,"HT"],
  ["Congo, Rep.","Public / Semi-public","Waste Management","Lending",1,0.4715,"CG"],
  ["Congo, Dem. Rep","Financial Service Provider","Ocean Cleanup","Lending",1,0.1017,"CD"],
  ["China","Impact Investor","Waste Management","Grant",2,0.1862,"CN"],
  ["Australia","Incubator","Waste Management","Equity",5,0.6652,"AU"],
  ["Albania","Public / Semi-public","Ocean Cleanup","Grant",1,0.4161,"AL"],
  ["Rwanda","Public / Semi-public","Circular Economy","Grant",2,0.7929,"RW"],
  ["Bolivia","Impact Investor","Circular Economy","Grant",1,0.066,"BO"],
  ["Malaysia","Foundation","Ocean Cleanup","Grant",5,1.3179,"MY"],
  ["China","Financial Service Provider","Circular Economy","Grant",1,0.26,"CN"],
  ["Ghana","Bank","Waste Management","Equity",1,0.2441,"GH"],
  ["Japan","Financial Service Provider","Waste Management","Equity",1,0.1299,"JP"],
  ["Poland","Bank","Ocean Cleanup","Lending",1,0.1752,"PL"],
  ["Qatar","Nonprofit","Ocean Cleanup","Grant",2,0.2874,"QA"],
  ["Hong Kong","Incubator","Waste Management","Equity",2,0.2446,"HK"],
  ["Thailand","Foundation","Waste Management","Lending",2,0.2465,"TH"],
  ["Turkey","Foundation","Ocean Cleanup","Equity",1,0.1285,"TR"],
  ["Costa Rica","Bank","Ocean Cleanup","Equity",1,0.1133,"CR"],
  ["Philippines","Incubator","Ocean Cleanup","Equity",2,0.2035,"PH"],
  ["China","Financial Service Provider","Waste Management","Equity",3,0.3075,"CN"],
  ["Chile","Public / Semi-public","Waste Management","Equity",3,1.1893,"CL"],
  ["New Zealand","Venture Capital","Circular Economy","Equity",1,1.0,"NZ"],
  ["Hungary","Nonprofit","Ocean Cleanup","Equity",1,0.1092,"HU"],
  ["Lebanon","Public / Semi-public","Circular Economy","Equity",3,0.9824,"LB"],
  ["Costa Rica","Public / Semi-public","Ocean Cleanup","Lending",1,0.0311,"CR"],
  ["Russia","Impact Investor","Waste Management","Equity",1,0.1588,"RU"],
  ["Saudi Arabia","Public / Semi-public","Circular Economy","Grant",4,0.7758,"SA"],
  ["Guinea","Public / Semi-public","Circular Economy","Grant",1,0.3291,"GN"],
  ["Ireland","Incubator","Ocean Cleanup","Equity",1,0.1463,"IE"],
  ["United Arab Emirates","Impact Investor","Waste Management","Lending",3,0.4178,"AE"],
  ["Guinea","Public / Semi-public","Ocean Cleanup","Equity",4,1.4475,"GN"],
  ["France","Nonprofit","Waste Management","Grant",5,1.3653,"FR"],
  ["Laos","Public / Semi-public","Ocean Cleanup","Lending",3,1.1832,"LA"],
  ["Cambodia","Public / Semi-public","Waste Management","Grant",4,0.8075,"KH"],
  ["Ukraine","Incubator","Waste Management","Equity",1,0.1787,"UA"],
  ["Oman","Foundation","Waste Management","Lending",1,0.1749,"OM"],
  ["Malawi","Foundation","Waste Management","Grant",1,0.1866,"MW"],
  ["Canada","Bank","Circular Economy","Equity",3,0.5659,"CA"],
  ["Zimbabwe","Venture Capital","Ocean Cleanup","Equity",1,1.0,"ZW"],
  ["Philippines","Incubator","Ocean Cleanup","Lending",1,0.1605,"PH"],
  ["Spain","Bank","Ocean Cleanup","Equity",2,0.2526,"ES"],
  ["Senegal","Nonprofit","Waste Management","Grant",1,0.047,"SN"],
  ["Ecuador","Financial Service Provider","Circular Economy","Lending",1,0.0931,"EC"],
  ["Cambodia","Public / Semi-public","Ocean Cleanup","Grant",7,1.9154,"KH"],
  ["United Kingdom","Impact Investor","Waste Management","Equity",4,1.0138,"GB"],
  ["United Arab Emirates","Impact Investor","Circular Economy","Grant",1,0.0568,"AE"],
  ["Indonesia","Financial Service Provider","Waste Management","Equity",4,0.502,"ID"],
  ["Sri Lanka","Nonprofit","Ocean Cleanup","Equity",1,0.1508,"LK"],
  ["Germany","Nonprofit","Circular Economy","Lending",2,0.9297,"DE"],
  ["Morocco","Public / Semi-public","Waste Management","Lending",9,2.4681,"MA"],
  ["Albania","Nonprofit","Ocean Cleanup","Lending",1,1.0,"AL"],
  ["South Africa","Competitions","Ocean Cleanup","Grant",1,0.185,"ZA"],
  ["Ukraine","Financial Service Provider","Circular Economy","Grant",1,0.0921,"UA"],
  ["Georgia","Foundation","Ocean Cleanup","Grant",1,0.4367,"GE"],
  ["Nepal","Incubator","Waste Management","Grant",1,0.0576,"NP"],
  ["Rwanda","Impact Investor","Circular Economy","Grant",2,1.4061,"RW"],
  ["Iraq","Bank","Circular Economy","Equity",1,0.1932,"IQ"],
  ["Romania","Public / Semi-public","Ocean Cleanup","Lending",3,0.3453,"RO"],
  ["Germany","Incubator","Waste Management","Grant",1,0.1068,"DE"],
  ["Poland","Incubator","Waste Management","Equity",2,0.1894,"PL"],
  ["Kyrgyz Republic","Public / Semi-public","Ocean Cleanup","Equity",2,0.215,"KG"],
  ["Greece","Incubator","Ocean Cleanup","Lending",1,0.1497,"GR"],
  ["Germany","Coworking Space","Waste Management","Lending",1,0.0489,"DE"],
  ["Zimbabwe","Bank","Circular Economy","Lending",2,0.1458,"ZW"],
  ["Bangladesh","Crowdfunding","Waste Management","Equity",1,0.1412,"BD"],
  ["Morocco","Public / Semi-public","Circular Economy","Lending",6,1.3221,"MA"],
  ["Nigeria","Incubator","Ocean Cleanup","Equity",1,0.1221,"NG"],
  ["Mongolia","Bank","Circular Economy","Lending",1,0.2663,"MN"],
  ["Iran","Public / Semi-public","Ocean Cleanup","Equity",1,0.6446,"IR"],
  ["Djibouti","Public / Semi-public","Circular Economy","Equity",1,0.5076,"DJ"],
  ["Ireland","Foundation","Ocean Cleanup","Lending",1,0.1463,"IE"],
  ["Canada","Foundation","Ocean Cleanup","Equity",2,0.3725,"CA"],
  ["Rwanda","Financial Service Provider","Waste Management","Equity",3,1.7087,"RW"],
  ["South Africa","Nonprofit","Ocean Cleanup","Equity",5,0.7093,"ZA"],
  ["Nepal","Financial Service Provider","Waste Management","Equity",2,0.5843,"NP"],
  ["Bahrain","Venture Capital","Waste Management","Equity",1,0.0358,"BH"],
  ["Montenegro","Venture Capital","Circular Economy","Equity",1,1.0,"ME"],
  ["Bangladesh","Public / Semi-public","Waste Management","Lending",8,2.9303,"BD"],
  ["Uganda","Foundation","Waste Management","Grant",4,1.5091,"UG"],
  ["Bangladesh","Incubator","Circular Economy","Grant",1,0.2639,"BD"],
  ["Belgium","Foundation","Circular Economy","Equity",1,0.1889,"BE"],
  ["Saudi Arabia","Nonprofit","Waste Management","Grant",3,0.649,"SA"],
  ["Taiwan","Financial Service Provider","Circular Economy","Grant",1,0.0932,"TW"],
  ["United Arab Emirates","Impact Investor","Waste Management","Grant",2,0.1854,"AE"],
  ["Mozambique","Public / Semi-public","Waste Management","Grant",1,0.4613,"MZ"],
  ["Sweden","Impact Investor","Waste Management","Equity",3,0.4164,"SE"],
  ["France","Impact Investor","Circular Economy","Equity",3,0.74,"FR"],
  ["Philippines","Impact Investor","Circular Economy","Equity",3,0.2044,"PH"],
  ["Norway","Foundation","Circular Economy","Grant",1,0.3553,"NO"],
  ["Vietnam","Venture Capital","Waste Management","Equity",1,0.0786,"VN"],
  ["United Arab Emirates","Competitions","Waste Management","Grant",1,0.3105,"AE"],
  ["New Zealand","Bank","Ocean Cleanup","Lending",1,0.148,"NZ"],
  ["Papua New Guinea","Bank","Circular Economy","Equity",1,0.1536,"PG"],
  ["Central African Republic","Public / Semi-public","Ocean Cleanup","Equity",2,1.1834,"CF"],
  ["Uganda","Venture Capital","Ocean Cleanup","Equity",1,1.0,"UG"],
  ["Netherlands","Bank","Waste Management","Lending",1,1.0,"NL"],
  ["Australia","Impact Investor","Ocean Cleanup","Equity",4,1.3697,"AU"],
  ["Sri Lanka","Public / Semi-public","Waste Management","Grant",1,0.0268,"LK"],
  ["Morocco","Public / Semi-public","Ocean Cleanup","Equity",12,3.8536,"MA"],
  ["Sri Lanka","Crowdfunding","Waste Management","Lending",1,0.027,"LK"],
  ["Malaysia","Incubator","Waste Management","Lending",1,0.1402,"MY"],
  ["Djibouti","Public / Semi-public","Waste Management","Grant",1,0.5076,"DJ"],
  ["El Salvador","Financial Service Provider","Waste Management","Lending",1,0.0946,"SV"],
  ["Zimbabwe","Nonprofit","Circular Economy","Grant",1,0.2408,"ZW"],
  ["Spain","Impact Investor","Ocean Cleanup","Equity",4,1.1474,"ES"],
  ["Nigeria","Public / Semi-public","Circular Economy","Lending",6,1.065,"NG"],
  ["Jordan","Foundation","Circular Economy","Lending",1,0.143,"JO"],
  ["Cameroon","Impact Investor","Waste Management","Grant",3,0.3142,"CM"],
  ["Argentina","Nonprofit","Ocean Cleanup","Lending",3,0.5969,"AR"],
  ["Sweden","Nonprofit","Ocean Cleanup","Lending",5,0.88,"SE"],
  ["South Africa","Financial Service Provider","Circular Economy","Grant",1,0.1257,"ZA"],
  ["Malaysia","Foundation","Ocean Cleanup","Equity",2,0.2636,"MY"],
  ["Bolivia","Public / Semi-public","Ocean Cleanup","Grant",2,0.1548,"BO"],
  ["Afghanistan","Public / Semi-public","Waste Management","Lending",4,1.7817,"AF"],
  ["St. Vincent and the Grenadines","Venture Capital","Circular Economy","Equity",1,1.0,"VC"],
  ["Tunisia","Bank","Circular Economy","Lending",2,0.1371,"TN"],
  ["Austria","Nonprofit","Ocean Cleanup","Grant",1,0.0367,"AT"],
  ["South Africa","Nonprofit","Circular Economy","Grant",5,1.0703,"ZA"],
  ["Mauritius","Crowdfunding","Waste Management","Lending",1,0.0297,"MU"],
  ["Algeria","Incubator","Waste Management","Equity",1,0.1723,"DZ"],
  ["Italy","Competitions","Waste Management","Grant",1,0.2219,"IT"],
  ["Zambia","Public / Semi-public","Circular Economy","Lending",1,0.2529,"ZM"],
  ["Malaysia","Public / Semi-public","Circular Economy","Equity",2,0.6181,"MY"],
  ["Taiwan","Financial Service Provider","Waste Management","Grant",1,0.0932,"TW"],
  ["Indonesia","Coworking Space","Waste Management","Equity",1,1.0,"ID"],
  ["Morocco","Impact Investor","Circular Economy","Lending",1,0.1828,"MA"],
  ["United Arab Emirates","Public / Semi-public","Ocean Cleanup","Grant",6,1.1639,"AE"],
  ["Belgium","Foundation","Ocean Cleanup","Lending",2,0.3402,"BE"],
  ["France","Foundation","Ocean Cleanup","Lending",2,0.3481,"FR"],
  ["Mexico","Financial Service Provider","Circular Economy","Grant",1,0.1402,"MX"],
  ["Burkina Faso","Nonprofit","Ocean Cleanup","Lending",1,0.2036,"BF"],
  ["United Kingdom","Public / Semi-public","Ocean Cleanup","Grant",9,2.7464,"GB"],
  ["Puerto Rico","Public / Semi-public","Circular Economy","Equity",1,0.2656,"PR"],
  ["Mozambique","Public / Semi-public","Circular Economy","Grant",1,0.4613,"MZ"],
  ["South Georgia & South Sandwich Islands","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GS"],
  ["Jordan","Bank","Ocean Cleanup","Equity",1,0.1707,"JO"],
  ["Maldives","Venture Capital","Waste Management","Equity",1,0.0707,"MV"],
  ["Lebanon","Impact Investor","Circular Economy","Equity",1,0.0318,"LB"],
  ["Côte d'Ivoire","Public / Semi-public","Circular Economy","Lending",3,0.6205,"CI"],
  ["Tanzania","Bank","Ocean Cleanup","Equity",1,0.1089,"TZ"],
  ["Bahrain","Impact Investor","Ocean Cleanup","Grant",1,0.0825,"BH"],
  ["Uganda","Foundation","Ocean Cleanup","Grant",4,1.455,"UG"],
  ["Botswana","Public / Semi-public","Circular Economy","Grant",1,0.0763,"BW"],
  ["Israel","Incubator","Ocean Cleanup","Grant",1,0.0748,"IL"],
  ["Thailand","Public / Semi-public","Waste Management","Grant",3,0.4908,"TH"],
  ["Malaysia","Foundation","Circular Economy","Lending",1,0.1234,"MY"],
  ["Iran","Public / Semi-public","Ocean Cleanup","Grant",3,0.6169,"IR"],
  ["Djibouti","Public / Semi-public","Ocean Cleanup","Grant",1,0.5076,"DJ"],
  ["Sweden","Foundation","Waste Management","Equity",2,0.3141,"SE"],
  ["Brazil","Financial Service Provider","Circular Economy","Lending",1,0.1346,"BR"],
  ["Nepal","Venture Capital","Circular Economy","Equity",1,1.0,"NP"],
  ["Rwanda","Public / Semi-public","Waste Management","Equity",4,1.3737,"RW"],
  ["United Kingdom","Foundation","Ocean Cleanup","Lending",2,0.5696,"GB"],
  ["Kenya","Foundation","Waste Management","Grant",4,2.1873,"KE"],
  ["Malaysia","Nonprofit","Waste Management","Lending",2,0.2745,"MY"],
  ["Ethiopia","Bank","Circular Economy","Lending",1,0.0725,"ET"],
  ["United Arab Emirates","Nonprofit","Waste Management","Equity",4,0.3993,"AE"],
  ["China","Foundation","Ocean Cleanup","Lending",1,0.1911,"CN"],
  ["Gambia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GM"],
  ["Ghana","Incubator","Ocean Cleanup","Grant",1,0.0785,"GH"],
  ["Honduras","Public / Semi-public","Waste Management","Lending",1,0.8799,"HN"],
  ["Angola","Public / Semi-public","Circular Economy","Equity",1,0.2469,"AO"],
  ["Germany","Public / Semi-public","Ocean Cleanup","Lending",9,2.285,"DE"],
  ["Australia","Financial Service Provider","Waste Management","Grant",2,0.3011,"AU"],
  ["Afghanistan","Public / Semi-public","Circular Economy","Grant",2,0.7648,"AF"],
  ["Portugal","Foundation","Waste Management","Lending",1,0.1527,"PT"],
  ["Indonesia","Financial Service Provider","Ocean Cleanup","Equity",2,0.3089,"ID"],
  ["Zimbabwe","Bank","Ocean Cleanup","Lending",2,0.1458,"ZW"],
  ["Germany","Foundation","Ocean Cleanup","Equity",2,0.3766,"DE"],
  ["Pakistan","Nonprofit","Waste Management","Equity",3,0.4858,"PK"],
  ["Bangladesh","Foundation","Waste Management","Lending",2,0.3228,"BD"],
  ["Greece","Financial Service Provider","Circular Economy","Grant",1,0.0771,"GR"],
  ["Syria","Venture Capital","Circular Economy","Equity",1,1.0,"SY"],
  ["Netherlands","Bank","Waste Management","Equity",1,1.0,"NL"],
  ["Mexico","Foundation","Ocean Cleanup","Equity",1,0.1863,"MX"],
  ["Jamaica","Impact Investor","Waste Management","Lending",1,0.8863,"JM"],
  ["Sweden","Foundation","Ocean Cleanup","Equity",2,0.3141,"SE"],
  ["Ghana","Financial Service Provider","Waste Management","Lending",2,1.3561,"GH"],
  ["Spain","Financial Service Provider","Waste Management","Lending",3,0.4795,"ES"],
  ["Bahamas, The","Impact Investor","Waste Management","Equity",1,1.0,"BS"],
  ["Lebanon","Incubator","Waste Management","Equity",1,0.1606,"LB"],
  ["Hong Kong","Bank","Ocean Cleanup","Lending",1,0.2594,"HK"],
  ["Israel","Nonprofit","Ocean Cleanup","Grant",5,0.9134,"IL"],
  ["Zambia","Nonprofit","Waste Management","Lending",2,0.5112,"ZM"],
  ["West Bank and Gaza","Public / Semi-public","Circular Economy","Grant",1,0.2137,"PS"],
  ["Oman","Crowdfunding","Ocean Cleanup","Grant",1,0.0946,"OM"],
  ["Cambodia","Crowdfunding","Ocean Cleanup","Equity",1,0.2021,"KH"],
  ["Israel","Nonprofit","Circular Economy","Grant",4,0.8199,"IL"],
  ["Russia","Nonprofit","Waste Management","Grant",1,0.0381,"RU"],
  ["Iran","Foundation","Waste Management","Grant",2,0.6715,"IR"],
  ["Colombia","Incubator","Ocean Cleanup","Equity",1,0.147,"CO"],
  ["Ethiopia","Public / Semi-public","Circular Economy","Equity",2,0.4037,"ET"],
  ["Australia","Bank","Ocean Cleanup","Lending",4,0.491,"AU"],
  ["Portugal","Venture Capital","Circular Economy","Equity",1,1.0,"PT"],
  ["Nicaragua","Nonprofit","Ocean Cleanup","Lending",1,0.3848,"NI"],
  ["Uganda","Bank","Ocean Cleanup","Lending",2,1.3043,"UG"],
  ["Malaysia","Incubator","Ocean Cleanup","Equity",1,0.1402,"MY"],
  ["Peru","Incubator","Ocean Cleanup","Lending",1,0.1455,"PE"],
  ["Saudi Arabia","Nonprofit","Circular Economy","Grant",4,0.9538,"SA"],
  ["Brazil","Nonprofit","Ocean Cleanup","Equity",4,1.0522,"BR"],
  ["Ghana","Nonprofit","Ocean Cleanup","Equity",2,0.516,"GH"],
  ["Saudi Arabia","Crowdfunding","Ocean Cleanup","Equity",1,0.044,"SA"],
  ["United Arab Emirates","Foundation","Circular Economy","Equity",1,0.2392,"AE"],
  ["Kosovo","Public / Semi-public","Ocean Cleanup","Equity",2,1.1388,"XK"],
  ["Fiji","Public / Semi-public","Ocean Cleanup","Lending",1,0.5692,"FJ"],
  ["Vatican City","Venture Capital","Ocean Cleanup","Equity",1,1.0,"VA"],
  ["Micronesia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"FM"],
  ["Uganda","Incubator","Waste Management","Equity",3,0.268,"UG"],
  ["Canada","Impact Investor","Waste Management","Grant",3,0.4013,"CA"],
  ["Papua New Guinea","Public / Semi-public","Circular Economy","Grant",1,0.4001,"PG"],
  ["Switzerland","Venture Capital","Circular Economy","Equity",1,1.0,"CH"],
  ["Qatar","Impact Investor","Circular Economy","Equity",2,0.0953,"QA"],
  ["Jordan","Competitions","Waste Management","Grant",1,0.3531,"JO"],
  ["Romania","Impact Investor","Ocean Cleanup","Equity",1,0.14,"RO"],
  ["Italy","Bank","Waste Management","Lending",1,0.2692,"IT"],
  ["Singapore","Incubator","Circular Economy","Equity",2,0.3981,"SG"],
  ["France","Venture Capital","Circular Economy","Lending",1,0.029,"FR"],
  ["Belgium","Nonprofit","Ocean Cleanup","Lending",5,0.985,"BE"],
  ["India","Financial Service Provider","Waste Management","Grant",2,0.2808,"IN"],
  ["Cyprus","Public / Semi-public","Waste Management","Grant",1,0.2005,"CY"],
  ["New Zealand","Incubator","Ocean Cleanup","Lending",1,0.143,"NZ"],
  ["Sudan","Impact Investor","Circular Economy","Grant",1,0.2373,"SD"],
  ["Niger","Financial Service Provider","Waste Management","Lending",1,0.2378,"NE"],
  ["Cambodia","Impact Investor","Waste Management","Equity",1,0.0658,"KH"],
  ["Angola","Public / Semi-public","Waste Management","Grant",1,0.2469,"AO"],
  ["Netherlands","Foundation","Waste Management","Equity",2,0.3139,"NL"],
  ["Qatar","Bank","Circular Economy","Equity",2,0.6219,"QA"],
  ["Congo, Dem. Rep","Financial Service Provider","Circular Economy","Equity",1,1.0,"CD"],
  ["Mexico","Public / Semi-public","Waste Management","Lending",11,3.7218,"MX"],
  ["Indonesia","Nonprofit","Circular Economy","Grant",5,1.9971,"ID"],
  ["Slovakia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SK"],
  ["Malaysia","Nonprofit","Circular Economy","Equity",2,0.2745,"MY"],
  ["United Arab Emirates","Impact Investor","Circular Economy","Lending",2,0.2889,"AE"],
  ["Italy","Nonprofit","Waste Management","Lending",4,0.7779,"IT"],
  ["Sudan","Public / Semi-public","Circular Economy","Grant",2,0.3733,"SD"],
  ["Thailand","Public / Semi-public","Ocean Cleanup","Equity",7,1.8692,"TH"],
  ["France","Incubator","Waste Management","Grant",1,0.0755,"FR"],
  ["Jordan","Impact Investor","Waste Management","Equity",1,0.0471,"JO"],
  ["British Indian Ocean Territory","Venture Capital","Circular Economy","Equity",1,1.0,"IO"],
  ["Finland","Venture Capital","Circular Economy","Equity",1,1.0,"FI"],
  ["Portugal","Foundation","Ocean Cleanup","Grant",3,1.2575,"PT"],
  ["Malaysia","Financial Service Provider","Waste Management","Lending",1,0.1349,"MY"],
  ["United Arab Emirates","Foundation","Circular Economy","Grant",4,0.9175,"AE"],
  ["Vietnam","Nonprofit","Waste Management","Grant",4,1.2197,"VN"],
  ["Tajikistan","Foundation","Circular Economy","Grant",1,1.0,"TJ"],
  ["China","Nonprofit","Ocean Cleanup","Grant",4,0.9502,"CN"],
  ["Argentina","Foundation","Waste Management","Grant",4,1.115,"AR"],
  ["Qatar","Incubator","Ocean Cleanup","Grant",1,0.1194,"QA"],
  ["Congo, Dem. Rep","Public / Semi-public","Waste Management","Lending",3,0.5012,"CD"],
  ["Micronesia","Venture Capital","Circular Economy","Equity",1,1.0,"FM"],
  ["Malta","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MT"],
  ["Colombia","Nonprofit","Waste Management","Equity",4,1.1427,"CO"],
  ["Tajikistan","Foundation","Ocean Cleanup","Grant",2,1.561,"TJ"],
  ["Malawi","Impact Investor","Ocean Cleanup","Lending",1,0.2661,"MW"],
  ["South Africa","Impact Investor","Ocean Cleanup","Lending",4,1.5348,"ZA"],
  ["Cambodia","Microfinance Institution","Waste Management","Lending",1,0.0297,"KH"],
  ["Mozambique","Nonprofit","Ocean Cleanup","Equity",1,0.4,"MZ"],
  ["Azerbaijan","Public / Semi-public","Ocean Cleanup","Grant",1,0.5155,"AZ"],
  ["Taiwan","Crowdfunding","Ocean Cleanup","Grant",1,0.0939,"TW"],
  ["Canada","Nonprofit","Ocean Cleanup","Lending",5,1.5243,"CA"],
  ["Romania","Foundation","Ocean Cleanup","Grant",1,0.3044,"RO"],
  ["United Kingdom","Impact Investor","Waste Management","Lending",4,1.0138,"GB"],
  ["Egypt","Foundation","Waste Management","Grant",6,1.9541,"EG"],
  ["Ecuador","Public / Semi-public","Circular Economy","Grant",1,0.1211,"EC"],
  ["Central African Republic","Venture Capital","Circular Economy","Equity",1,1.0,"CF"],
  ["Nepal","Public / Semi-public","Ocean Cleanup","Equity",5,2.3435,"NP"],
  ["Belize","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BZ"],
  ["Niger","Nonprofit","Waste Management","Equity",1,0.2378,"NE"],
  ["Isle of Man","Venture Capital","Ocean Cleanup","Equity",1,1.0,"IM"],
  ["Morocco","Nonprofit","Circular Economy","Equity",1,0.1828,"MA"],
  ["Djibouti","Venture Capital","Circular Economy","Equity",1,1.0,"DJ"],
  ["Turkey","Impact Investor","Waste Management","Lending",3,0.543,"TR"],
  ["Zimbabwe","Incubator","Ocean Cleanup","Grant",1,0.076,"ZW"],
  ["Lebanon","Foundation","Ocean Cleanup","Grant",3,0.565,"LB"],
  ["Vietnam","Bank","Waste Management","Lending",2,0.3311,"VN"],
  ["Somalia","Bank","Circular Economy","Lending",1,0.0551,"SO"],
  ["Ethiopia","Foundation","Waste Management","Lending",1,0.2045,"ET"],
  ["Lithuania","Venture Capital","Ocean Cleanup","Equity",1,1.0,"LT"],
  ["Nepal","Impact Investor","Circular Economy","Equity",3,0.5342,"NP"],
  ["Spain","Financial Service Provider","Circular Economy","Grant",1,0.2589,"ES"],
  ["Rwanda","Foundation","Ocean Cleanup","Equity",1,0.2108,"RW"],
  ["Kenya","Competitions","Waste Management","Grant",1,0.4081,"KE"],
  ["Argentina","Nonprofit","Circular Economy","Equity",2,0.2498,"AR"],
  ["Indonesia","Financial Service Provider","Circular Economy","Grant",1,0.117,"ID"],
  ["Azerbaijan","Public / Semi-public","Waste Management","Lending",1,0.4882,"AZ"],
  ["United States","Financial Service Provider","Circular Economy","Grant",1,0.318,"US"],
  ["Russia","Incubator","Ocean Cleanup","Lending",1,0.1588,"RU"],
  ["Uruguay","Impact Investor","Waste Management","Lending",1,1.0,"UY"],
  ["Egypt","Public / Semi-public","Waste Management","Lending",9,2.7978,"EG"],
  ["Côte d'Ivoire","Financial Service Provider","Waste Management","Lending",1,0.0687,"CI"],
  ["South Sudan","Impact Investor","Ocean Cleanup","Grant",1,0.1369,"SS"],
  ["Belgium","Incubator","Circular Economy","Grant",1,0.2194,"BE"],
  ["Myanmar","Impact Investor","Waste Management","Equity",1,0.207,"MM"],
  ["Germany","Impact Investor","Waste Management","Grant",3,0.3762,"DE"],
  ["Guernsey","Venture Capital","Circular Economy","Equity",1,1.0,"GG"],
  ["China","Venture Capital","Circular Economy","Equity",3,1.0707,"CN"],
  ["Portugal","Nonprofit","Circular Economy","Lending",2,0.3427,"PT"],
  ["Venezuela","Venture Capital","Ocean Cleanup","Equity",1,1.0,"VE"],
  ["Guatemala","Foundation","Circular Economy","Grant",1,0.3814,"GT"],
  ["Bangladesh","Nonprofit","Ocean Cleanup","Grant",8,1.9398,"BD"],
  ["Cameroon","Venture Capital","Circular Economy","Equity",1,1.0,"CM"],
  ["Sri Lanka","Impact Investor","Waste Management","Grant",1,0.202,"LK"],
  ["Sao Tome and Principe","Public / Semi-public","Circular Economy","Equity",1,0.4041,"ST"],
  ["United Arab Emirates","Impact Investor","Ocean Cleanup","Grant",3,0.4882,"AE"],
  ["United States","Coworking Space","Waste Management","Lending",1,0.0916,"US"],
  ["Indonesia","Bank","Circular Economy","Lending",3,0.7166,"ID"],
  ["Australia","Public / Semi-public","Circular Economy","Lending",4,1.043,"AU"],
  ["Chile","Impact Investor","Circular Economy","Equity",1,0.1561,"CL"],
  ["Morocco","Nonprofit","Ocean Cleanup","Equity",2,0.2611,"MA"],
  ["Rwanda","Venture Capital","Circular Economy","Grant",1,1.0,"RW"],
  ["Myanmar","Impact Investor","Circular Economy","Equity",1,0.207,"MM"],
  ["Botswana","Bank","Circular Economy","Lending",2,1.1937,"BW"],
  ["Tanzania","Nonprofit","Ocean Cleanup","Grant",5,1.937,"TZ"],
  ["Mexico","Public / Semi-public","Circular Economy","Grant",6,1.2013,"MX"],
  ["Guatemala","Bank","Circular Economy","Equity",1,0.1152,"GT"],
  ["Canada","Incubator","Circular Economy","Equity",2,0.2502,"CA"],
  ["Finland","Impact Investor","Circular Economy","Equity",1,0.058,"FI"],
  ["Philippines","Incubator","Waste Management","Lending",1,0.1605,"PH"],
  ["Congo, Dem. Rep","Public / Semi-public","Ocean Cleanup","Grant",2,0.4349,"CD"],
  ["Morocco","Bank","Circular Economy","Lending",1,0.083,"MA"],
  ["Israel","Financial Service Provider","Waste Management","Equity",2,0.0605,"IL"],
  ["Solomon Islands","Nonprofit","Ocean Cleanup","Lending",1,0.9097,"SB"],
  ["Zambia","Foundation","Ocean Cleanup","Lending",2,0.4553,"ZM"],
  ["Barbados","Public / Semi-public","Waste Management","Lending",1,1.0,"BB"],
  ["China","Competitions","Ocean Cleanup","Grant",1,0.2745,"CN"],
  ["Tajikistan","Venture Capital","Circular Economy","Equity",1,1.0,"TJ"],
  ["Australia","Bank","Ocean Cleanup","Equity",2,0.4339,"AU"],
  ["United States","Impact Investor","Waste Management","Lending",4,3.4237,"US"],
  ["New Zealand","Foundation","Ocean Cleanup","Equity",1,0.143,"NZ"],
  ["Denmark","Nonprofit","Ocean Cleanup","Lending",2,0.3667,"DK"],
  ["Rwanda","Impact Investor","Waste Management","Grant",2,0.4806,"RW"],
  ["Ireland","Nonprofit","Ocean Cleanup","Grant",1,0.5381,"IE"],
  ["Guinea","Venture Capital","Circular Economy","Equity",1,1.0,"GN"],
  ["Ukraine","Financial Service Provider","Waste Management","Grant",1,0.0921,"UA"],
  ["Saudi Arabia","Foundation","Circular Economy","Grant",4,0.9302,"SA"],
  ["South Korea","Financial Service Provider","Waste Management","Equity",2,0.1408,"KR"],
  ["Benin","Public / Semi-public","Circular Economy","Equity",3,0.5329,"BJ"],
  ["Netherlands","Incubator","Circular Economy","Grant",1,1.0,"NL"],
  ["Brazil","Bank","Waste Management","Lending",2,0.6116,"BR"],
  ["United Arab Emirates","Nonprofit","Waste Management","Lending",5,0.4881,"AE"],
  ["Turkey","Foundation","Circular Economy","Grant",3,0.6795,"TR"],
  ["New Zealand","Nonprofit","Waste Management","Grant",3,0.4512,"NZ"],
  ["Lesotho","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"LS"],
  ["Myanmar","Nonprofit","Ocean Cleanup","Equity",2,0.4352,"MM"],
  ["Morocco","Nonprofit","Waste Management","Grant",2,0.4948,"MA"],
  ["Peru","Impact Investor","Ocean Cleanup","Equity",4,0.7325,"PE"],
  ["Italy","Impact Investor","Waste Management","Lending",4,1.208,"IT"],
  ["Georgia","Bank","Circular Economy","Lending",1,0.3414,"GE"],
  ["Egypt","Nonprofit","Circular Economy","Grant",5,1.0691,"EG"],
  ["Morocco","Coworking Space","Waste Management","Equity",1,0.0271,"MA"],
  ["Moldova","Financial Service Provider","Ocean Cleanup","Equity",1,0.2645,"MD"],
  ["Turkey","Financial Service Provider","Circular Economy","Lending",1,0.1808,"TR"],
  ["Japan","Nonprofit","Waste Management","Equity",3,0.356,"JP"],
  ["Equatorial Guinea","Venture Capital","Circular Economy","Equity",2,1.0649,"GQ"],
  ["Australia","Incubator","Ocean Cleanup","Equity",2,0.2151,"AU"],
  ["Sri Lanka","Public / Semi-public","Ocean Cleanup","Lending",3,0.4363,"LK"],
  ["Denmark","Bank","Circular Economy","Lending",1,0.1139,"DK"],
  ["Afghanistan","Foundation","Ocean Cleanup","Lending",1,0.1614,"AF"],
  ["Peru","Nonprofit","Ocean Cleanup","Grant",6,1.8605,"PE"],
  ["Angola","Impact Investor","Ocean Cleanup","Equity",1,0.3036,"AO"],
  ["Ukraine","Venture Capital","Circular Economy","Equity",2,1.0461,"UA"],
  ["Thailand","Public / Semi-public","Waste Management","Lending",7,2.0044,"TH"],
  ["Germany","Nonprofit","Circular Economy","Equity",2,0.9297,"DE"],
  ["Costa Rica","Public / Semi-public","Ocean Cleanup","Equity",2,0.1923,"CR"],
  ["Singapore","Crowdfunding","Waste Management","Lending",1,0.0616,"SG"],
  ["Comoros","Venture Capital","Circular Economy","Equity",1,1.0,"KM"],
  ["Congo, Dem. Rep","Bank","Circular Economy","Equity",1,0.2044,"CD"],
  ["Taiwan","Public / Semi-public","Circular Economy","Lending",2,0.5176,"TW"],
  ["Croatia","Public / Semi-public","Ocean Cleanup","Equity",1,0.1004,"HR"],
  ["Romania","Nonprofit","Ocean Cleanup","Equity",1,0.1669,"RO"],
  ["Albania","Impact Investor","Circular Economy","Equity",1,1.0,"AL"],
  ["Ecuador","Foundation","Waste Management","Grant",2,0.7118,"EC"],
  ["Poland","Incubator","Circular Economy","Grant",1,0.1549,"PL"],
  ["Poland","Financial Service Provider","Waste Management","Lending",1,0.2489,"PL"],
  ["Saudi Arabia","Public / Semi-public","Ocean Cleanup","Grant",7,1.4794,"SA"],
  ["Yemen","Public / Semi-public","Waste Management","Grant",1,0.2452,"YE"],
  ["Algeria","Financial Service Provider","Ocean Cleanup","Equity",1,0.115,"DZ"],
  ["South Africa","Foundation","Waste Management","Grant",6,1.1137,"ZA"],
  ["Malaysia","Venture Capital","Waste Management","Equity",1,0.0766,"MY"],
  ["Malawi","Incubator","Waste Management","Lending",1,0.2661,"MW"],
  ["Cambodia","Nonprofit","Waste Management","Grant",1,0.2211,"KH"],
  ["Bosnia and Herzegovina","Public / Semi-public","Waste Management","Equity",2,0.7346,"BA"],
  ["Barbados","Venture Capital","Circular Economy","Equity",1,1.0,"BB"],
  ["Angola","Venture Capital","Ocean Cleanup","Equity",1,1.0,"AO"],
  ["Indonesia","Competitions","Ocean Cleanup","Grant",1,0.3929,"ID"],
  ["Norfolk Island","Venture Capital","Circular Economy","Equity",1,1.0,"NF"],
  ["Hong Kong","Coworking Space","Waste Management","Lending",1,0.0541,"HK"],
  ["Zimbabwe","Financial Service Provider","Ocean Cleanup","Lending",1,0.3336,"ZW"],
  ["Argentina","Incubator","Circular Economy","Equity",1,0.0812,"AR"],
  ["Singapore","Nonprofit","Circular Economy","Grant",2,0.8523,"SG"],
  ["Sweden","Nonprofit","Waste Management","Equity",3,0.3776,"SE"],
  ["Chile","Foundation","Waste Management","Grant",2,0.8518,"CL"],
  ["Italy","Foundation","Waste Management","Grant",6,1.2051,"IT"],
  ["Ghana","Financial Service Provider","Waste Management","Grant",1,0.1059,"GH"],
  ["New Zealand","Impact Investor","Circular Economy","Lending",2,0.2553,"NZ"],
  ["Bosnia and Herzegovina","Public / Semi-public","Circular Economy","Equity",1,0.4105,"BA"],
  ["Iran","Venture Capital","Waste Management","Equity",1,0.0333,"IR"],
  ["Albania","Public / Semi-public","Ocean Cleanup","Equity",3,1.2908,"AL"],
  ["Papua New Guinea","Public / Semi-public","Circular Economy","Equity",1,0.4001,"PG"],
  ["Malaysia","Public / Semi-public","Circular Economy","Lending",4,1.0425,"MY"],
  ["Japan","Foundation","Ocean Cleanup","Equity",1,0.184,"JP"],
  ["Ukraine","Foundation","Ocean Cleanup","Lending",1,0.1787,"UA"],
  ["Morocco","Impact Investor","Circular Economy","Equity",1,0.1828,"MA"],
  ["United Arab Emirates","Incubator","Ocean Cleanup","Grant",1,0.1286,"AE"],
  ["Singapore","Impact Investor","Ocean Cleanup","Lending",2,0.2463,"SG"],
  ["Turkey","Incubator","Ocean Cleanup","Equity",1,0.1285,"TR"],
  ["Libya","Public / Semi-public","Waste Management","Equity",2,0.3167,"LY"],
  ["Cyprus","Public / Semi-public","Ocean Cleanup","Grant",1,0.2005,"CY"],
  ["Greece","Venture Capital","Circular Economy","Equity",1,1.0,"GR"],
  ["South Africa","Nonprofit","Waste Management","Lending",4,0.6301,"ZA"],
  ["Cameroon","Nonprofit","Ocean Cleanup","Equity",1,0.2843,"CM"],
  ["Germany","Incubator","Ocean Cleanup","Lending",1,0.1844,"DE"],
  ["Bahrain","Incubator","Waste Management","Grant",1,0.0825,"BH"],
  ["Ghana","Public / Semi-public","Circular Economy","Equity",2,0.3477,"GH"],
  ["Italy","Bank","Circular Economy","Equity",2,0.4795,"IT"],
  ["United States","Nonprofit","Waste Management","Lending",4,1.8236,"US"],
  ["Ghana","Public / Semi-public","Waste Management","Lending",5,1.5654,"GH"],
  ["Mauritius","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MU"],
  ["Ireland","Venture Capital","Circular Economy","Equity",1,1.0,"IE"],
  ["United Kingdom","Crowdfunding","Waste Management","Lending",1,0.0821,"GB"],
  ["Tanzania","Public / Semi-public","Circular Economy","Lending",4,0.791,"TZ"],
  ["Kosovo","Public / Semi-public","Waste Management","Equity",2,1.1388,"XK"],
  ["Canada","Nonprofit","Waste Management","Equity",3,1.5766,"CA"],
  ["Afghanistan","Competitions","Ocean Cleanup","Grant",1,0.2242,"AF"],
  ["Belize","Impact Investor","Waste Management","Equity",1,0.835,"BZ"],
  ["Christmas Island","Venture Capital","Circular Economy","Equity",1,1.0,"CX"],
  ["India","Incubator","Ocean Cleanup","Grant",1,0.101,"IN"],
  ["Nepal","Nonprofit","Circular Economy","Equity",2,0.5047,"NP"],
  ["Jordan","Venture Capital","Circular Economy","Lending",1,0.0268,"JO"],
  ["Kuwait","Venture Capital","Circular Economy","Equity",1,1.0,"KW"],
  ["Belgium","Nonprofit","Waste Management","Lending",5,0.6775,"BE"],
  ["Nigeria","Foundation","Waste Management","Lending",2,0.309,"NG"],
  ["Myanmar","Bank","Ocean Cleanup","Lending",2,0.2476,"MM"],
  ["Nigeria","Impact Investor","Ocean Cleanup","Lending",3,0.2977,"NG"],
  ["Brazil","Impact Investor","Ocean Cleanup","Lending",3,0.8916,"BR"],
  ["Turkey","Nonprofit","Circular Economy","Equity",2,0.4145,"TR"],
  ["Turkey","Public / Semi-public","Ocean Cleanup","Grant",7,1.7448,"TR"],
  ["Greece","Nonprofit","Circular Economy","Lending",1,0.0839,"GR"],
  ["Honduras","Venture Capital","Ocean Cleanup","Equity",1,1.0,"HN"],
  ["Pakistan","Impact Investor","Circular Economy","Lending",2,0.3771,"PK"],
  ["Bangladesh","Venture Capital","Circular Economy","Equity",2,2.0,"BD"],
  ["Nigeria","Public / Semi-public","Waste Management","Grant",6,0.8478,"NG"],
  ["Mexico","Nonprofit","Circular Economy","Equity",1,0.225,"MX"],
  ["Bangladesh","Foundation","Circular Economy","Grant",2,0.7149,"BD"],
  ["Malaysia","Public / Semi-public","Ocean Cleanup","Grant",6,1.3051,"MY"],
  ["Zambia","Foundation","Waste Management","Grant",2,0.3668,"ZM"],
  ["South Africa","Financial Service Provider","Waste Management","Lending",3,1.4156,"ZA"],
  ["Montserrat","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MS"],
  ["Trinidad and Tobago","Impact Investor","Waste Management","Lending",1,0.7546,"TT"],
  ["Zimbabwe","Impact Investor","Ocean Cleanup","Equity",1,0.1829,"ZW"],
  ["Oman","Nonprofit","Waste Management","Grant",1,0.234,"OM"],
  ["Chad","Public / Semi-public","Ocean Cleanup","Grant",1,0.386,"TD"],
  ["Jordan","Foundation","Ocean Cleanup","Lending",1,0.143,"JO"],
  ["Sweden","Financial Service Provider","Waste Management","Equity",2,0.1301,"SE"],
  ["China","Incubator","Circular Economy","Equity",1,0.1019,"CN"],
  ["Denmark","Public / Semi-public","Waste Management","Grant",2,0.0956,"DK"],
  ["Cameroon","Bank","Ocean Cleanup","Lending",1,0.0661,"CM"],
  ["Peru","Public / Semi-public","Waste Management","Equity",9,3.2759,"PE"],
  ["New Zealand","Impact Investor","Waste Management","Grant",1,0.1741,"NZ"],
  ["South Korea","Impact Investor","Circular Economy","Equity",2,0.3374,"KR"],
  ["Turkey","Foundation","Ocean Cleanup","Lending",1,0.1285,"TR"],
  ["Qatar","Impact Investor","Ocean Cleanup","Equity",1,0.0475,"QA"],
  ["Jordan","Bank","Ocean Cleanup","Lending",3,0.3532,"JO"],
  ["France","Nonprofit","Ocean Cleanup","Grant",9,2.9851,"FR"],
  ["Norway","Public / Semi-public","Circular Economy","Equity",1,0.1992,"NO"],
  ["United Kingdom","Nonprofit","Ocean Cleanup","Lending",6,2.1136,"GB"],
  ["Switzerland","Public / Semi-public","Circular Economy","Equity",2,0.4322,"CH"],
  ["Mali","Public / Semi-public","Ocean Cleanup","Equity",5,2.1445,"ML"],
  ["Norway","Nonprofit","Ocean Cleanup","Equity",1,0.2036,"NO"],
  ["Mozambique","Bank","Ocean Cleanup","Lending",1,1.0,"MZ"],
  ["Sudan","Incubator","Waste Management","Grant",1,0.0745,"SD"],
  ["United Kingdom","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GB"],
  ["Niger","Bank","Waste Management","Lending",1,0.2239,"NE"],
  ["United Kingdom","Incubator","Waste Management","Grant",1,0.125,"GB"],
  ["Ghana","Public / Semi-public","Waste Management","Grant",3,0.6539,"GH"],
  ["Sweden","Impact Investor","Waste Management","Lending",3,0.4164,"SE"],
  ["Japan","Impact Investor","Ocean Cleanup","Equity",4,0.6842,"JP"],
  ["Singapore","Public / Semi-public","Waste Management","Lending",2,0.6276,"SG"],
  ["Madagascar","Nonprofit","Ocean Cleanup","Equity",1,1.0,"MG"],
  ["Reunion","Public / Semi-public","Circular Economy","Lending",2,0.6139,"RE"],
  ["Kazakhstan","Foundation","Circular Economy","Grant",1,0.8492,"KZ"],
  ["Peru","Impact Investor","Ocean Cleanup","Grant",2,0.4095,"PE"],
  ["Guatemala","Public / Semi-public","Circular Economy","Lending",2,0.5058,"GT"],
  ["Colombia","Impact Investor","Circular Economy","Grant",1,0.0647,"CO"],
  ["Costa Rica","Public / Semi-public","Waste Management","Equity",3,0.491,"CR"],
  ["Suriname","Public / Semi-public","Waste Management","Lending",1,1.0,"SR"],
  ["Maldives","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MV"],
  ["Benin","Impact Investor","Circular Economy","Grant",1,0.3631,"BJ"],
  ["Ireland","Public / Semi-public","Ocean Cleanup","Equity",1,0.0507,"IE"],
  ["Costa Rica","Nonprofit","Circular Economy","Grant",1,0.3979,"CR"],
  ["Bangladesh","Nonprofit","Circular Economy","Lending",2,0.8757,"BD"],
  ["Israel","Competitions","Ocean Cleanup","Grant",1,0.2057,"IL"],
  ["Canada","Incubator","Waste Management","Lending",1,0.1996,"CA"],
  ["Kenya","Nonprofit","Waste Management","Grant",3,0.9199,"KE"],
  ["Israel","Crowdfunding","Ocean Cleanup","Grant",1,0.067,"IL"],
  ["Zimbabwe","Incubator","Ocean Cleanup","Equity",1,0.1829,"ZW"],
  ["Egypt","Bank","Circular Economy","Equity",3,0.3842,"EG"],
  ["Bolivia","Foundation","Circular Economy","Grant",1,0.317,"BO"],
  ["Malawi","Impact Investor","Ocean Cleanup","Equity",1,0.2661,"MW"],
  ["United States","Incubator","Waste Management","Lending",1,1.0,"US"],
  ["Germany","Bank","Circular Economy","Equity",3,0.7129,"DE"],
  ["Zambia","Foundation","Waste Management","Lending",2,0.4553,"ZM"],
  ["Netherlands","Impact Investor","Waste Management","Grant",3,1.2016,"NL"],
  ["Myanmar","Nonprofit","Circular Economy","Equity",1,0.207,"MM"],
  ["Cambodia","Impact Investor","Ocean Cleanup","Lending",1,0.0658,"KH"],
  ["South Africa","Public / Semi-public","Waste Management","Grant",6,1.6791,"ZA"],
  ["Fiji","Foundation","Ocean Cleanup","Grant",1,0.3795,"FJ"],
  ["Pakistan","Bank","Circular Economy","Lending",4,0.7127,"PK"],
  ["Lebanon","Nonprofit","Waste Management","Grant",1,0.0322,"LB"],
  ["Puerto Rico","Financial Service Provider","Circular Economy","Grant",1,0.0861,"PR"],
  ["United Kingdom","Impact Investor","Ocean Cleanup","Lending",3,0.7668,"GB"],
  ["Israel","Impact Investor","Waste Management","Equity",1,0.0674,"IL"],
  ["Chad","Financial Service Provider","Waste Management","Lending",1,0.1916,"TD"],
  ["Grenada","Public / Semi-public","Waste Management","Equity",1,1.0,"GD"],
  ["Germany","Impact Investor","Circular Economy","Grant",1,0.1077,"DE"],
  ["United Kingdom","Public / Semi-public","Ocean Cleanup","Lending",9,1.7429,"GB"],
  ["Hungary","Impact Investor","Circular Economy","Lending",1,0.1092,"HU"],
  ["Egypt","Financial Service Provider","Circular Economy","Equity",1,0.0242,"EG"],
  ["Romania","Impact Investor","Waste Management","Grant",1,0.0612,"RO"],
  ["Switzerland","Foundation","Ocean Cleanup","Grant",1,0.7126,"CH"],
  ["Hong Kong","Venture Capital","Circular Economy","Equity",2,1.0326,"HK"],
  ["Brazil","Impact Investor","Circular Economy","Lending",2,0.7256,"BR"],
  ["Japan","Bank","Circular Economy","Equity",1,0.336,"JP"],
  ["Romania","Nonprofit","Waste Management","Grant",3,0.8119,"RO"],
  ["Honduras","Venture Capital","Circular Economy","Equity",2,1.0404,"HN"],
  ["Spain","Foundation","Circular Economy","Grant",4,1.1733,"ES"],
  ["Oman","Foundation","Circular Economy","Equity",1,0.1749,"OM"],
  ["Kenya","Nonprofit","Circular Economy","Lending",2,0.1937,"KE"],
  ["Indonesia","Foundation","Circular Economy","Lending",1,0.1283,"ID"],
  ["France","Bank","Waste Management","Equity",1,0.2794,"FR"],
  ["New Zealand","Crowdfunding","Ocean Cleanup","Grant",1,0.1121,"NZ"],
  ["Uganda","Nonprofit","Ocean Cleanup","Grant",6,2.1858,"UG"],
  ["Saudi Arabia","Impact Investor","Ocean Cleanup","Equity",5,0.764,"SA"],
  ["New Zealand","Venture Capital","Ocean Cleanup","Equity",1,1.0,"NZ"],
  ["South Africa","Venture Capital","Ocean Cleanup","Lending",1,1.0,"ZA"],
  ["Ukraine","Financial Service Provider","Waste Management","Equity",1,0.0561,"UA"],
  ["Ethiopia","Impact Investor","Ocean Cleanup","Equity",1,0.3656,"ET"],
  ["Spain","Bank","Waste Management","Lending",2,0.2884,"ES"],
  ["Ethiopia","Financial Service Provider","Waste Management","Equity",2,0.5534,"ET"],
  ["Egypt","Nonprofit","Circular Economy","Lending",2,0.2427,"EG"],
  ["Israel","Public / Semi-public","Waste Management","Lending",1,0.1344,"IL"],
  ["Mexico","Financial Service Provider","Waste Management","Lending",3,0.404,"MX"],
  ["Uganda","Public / Semi-public","Ocean Cleanup","Lending",4,1.7709,"UG"],
  ["Benin","Financial Service Provider","Waste Management","Equity",2,0.4377,"BJ"],
  ["Germany","Impact Investor","Ocean Cleanup","Lending",3,1.1141,"DE"],
  ["Malaysia","Public / Semi-public","Circular Economy","Grant",3,0.6457,"MY"],
  ["Côte d'Ivoire","Public / Semi-public","Waste Management","Lending",3,0.6205,"CI"],
  ["South Africa","Public / Semi-public","Circular Economy","Grant",4,0.4965,"ZA"],
  ["Nigeria","Foundation","Circular Economy","Equity",1,0.1869,"NG"],
  ["Vietnam","Financial Service Provider","Circular Economy","Equity",1,0.2785,"VN"],
  ["New Zealand","Nonprofit","Circular Economy","Lending",2,0.2553,"NZ"],
  ["Myanmar","Impact Investor","Ocean Cleanup","Grant",1,0.3532,"MM"],
  ["Japan","Nonprofit","Circular Economy","Lending",2,0.2261,"JP"],
  ["Mozambique","Impact Investor","Waste Management","Equity",1,1.0,"MZ"],
  ["Maldives","Venture Capital","Circular Economy","Equity",2,1.098,"MV"],
  ["Philippines","Impact Investor","Circular Economy","Lending",1,0.1309,"PH"],
  ["Netherlands","Incubator","Ocean Cleanup","Lending",1,0.1605,"NL"],
  ["South Africa","Impact Investor","Circular Economy","Grant",2,1.0765,"ZA"],
  ["Belgium","Crowdfunding","Ocean Cleanup","Grant",1,0.1144,"BE"],
  ["Australia","Nonprofit","Ocean Cleanup","Grant",8,2.4656,"AU"],
  ["Morocco","Financial Service Provider","Ocean Cleanup","Lending",1,0.0783,"MA"],
  ["Qatar","Foundation","Waste Management","Lending",1,0.2624,"QA"],
  ["Botswana","Foundation","Ocean Cleanup","Equity",1,0.3088,"BW"],
  ["Gabon","Public / Semi-public","Waste Management","Grant",1,0.4243,"GA"],
  ["Lebanon","Public / Semi-public","Ocean Cleanup","Lending",3,0.7644,"LB"],
  ["Tunisia","Nonprofit","Waste Management","Grant",3,0.4877,"TN"],
  ["Nigeria","Public / Semi-public","Ocean Cleanup","Lending",6,1.8048,"NG"],
  ["Bangladesh","Foundation","Waste Management","Grant",4,1.3267,"BD"],
  ["New Zealand","Incubator","Circular Economy","Grant",1,0.1227,"NZ"],
  ["Germany","Crowdfunding","Ocean Cleanup","Grant",1,0.1124,"DE"],
  ["Egypt","Incubator","Ocean Cleanup","Grant",1,0.0472,"EG"],
  ["Nigeria","Foundation","Waste Management","Equity",2,0.309,"NG"],
  ["Portugal","Financial Service Provider","Waste Management","Equity",1,0.054,"PT"],
  ["Australia","Financial Service Provider","Waste Management","Lending",3,0.644,"AU"],
  ["Haiti","Nonprofit","Ocean Cleanup","Equity",1,0.5941,"HT"],
  ["United Arab Emirates","Foundation","Circular Economy","Lending",1,0.2392,"AE"],
  ["Uzbekistan","Bank","Waste Management","Lending",1,0.3086,"UZ"],
  ["Portugal","Impact Investor","Ocean Cleanup","Equity",4,0.8552,"PT"],
  ["Serbia","Public / Semi-public","Ocean Cleanup","Grant",1,0.2945,"RS"],
  ["Sierra Leone","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"SL"],
  ["Iraq","Venture Capital","Ocean Cleanup","Equity",1,1.0,"IQ"],
  ["Argentina","Financial Service Provider","Waste Management","Grant",1,0.1293,"AR"],
  ["Turkey","Foundation","Ocean Cleanup","Grant",4,1.3764,"TR"],
  ["Côte d'Ivoire","Bank","Waste Management","Lending",1,0.2309,"CI"],
  ["Switzerland","Public / Semi-public","Waste Management","Lending",5,1.2129,"CH"],
  ["Myanmar","Venture Capital","Circular Economy","Equity",1,1.0,"MM"],
  ["Denmark","Public / Semi-public","Ocean Cleanup","Lending",4,0.5036,"DK"],
  ["Albania","Public / Semi-public","Circular Economy","Grant",1,0.4161,"AL"],
  ["South Korea","Nonprofit","Waste Management","Grant",1,0.3065,"KR"],
  ["Austria","Nonprofit","Circular Economy","Equity",2,0.2765,"AT"],
  ["South Korea","Bank","Circular Economy","Lending",2,0.4885,"KR"],
  ["Iraq","Public / Semi-public","Circular Economy","Grant",5,0.7101,"IQ"],
  ["Thailand","Bank","Ocean Cleanup","Lending",3,0.3383,"TH"],
  ["Belgium","Impact Investor","Ocean Cleanup","Equity",5,0.8836,"BE"],
  ["Zambia","Financial Service Provider","Waste Management","Lending",2,0.5112,"ZM"],
  ["Madagascar","Nonprofit","Ocean Cleanup","Lending",2,1.3578,"MG"],
  ["India","Impact Investor","Waste Management","Lending",4,1.8806,"IN"],
  ["Cambodia","Public / Semi-public","Circular Economy","Equity",5,1.6185,"KH"],
  ["Pakistan","Nonprofit","Circular Economy","Equity",2,0.3771,"PK"],
  ["Sierra Leone","Financial Service Provider","Waste Management","Lending",1,0.036,"SL"],
  ["Russia","Financial Service Provider","Waste Management","Grant",2,0.2447,"RU"],
  ["Austria","Impact Investor","Ocean Cleanup","Lending",2,0.2765,"AT"],
  ["Thailand","Nonprofit","Waste Management","Grant",3,1.0415,"TH"],
  ["Russia","Financial Service Provider","Circular Economy","Grant",1,0.075,"RU"],
  ["Ukraine","Public / Semi-public","Circular Economy","Lending",2,1.007,"UA"],
  ["Philippines","Competitions","Waste Management","Grant",1,0.3468,"PH"],
  ["Taiwan","Financial Service Provider","Waste Management","Lending",1,0.1236,"TW"],
  ["Peru","Nonprofit","Ocean Cleanup","Lending",6,1.2363,"PE"],
  ["Cambodia","Bank","Waste Management","Equity",1,0.0863,"KH"],
  ["Armenia","Bank","Circular Economy","Lending",1,0.3815,"AM"],
  ["Uganda","Financial Service Provider","Waste Management","Grant",1,0.1007,"UG"],
  ["Brazil","Financial Service Provider","Circular Economy","Equity",1,0.0242,"BR"],
  ["Turkey","Nonprofit","Waste Management","Grant",4,1.257,"TR"],
  ["Libya","Crowdfunding","Ocean Cleanup","Equity",1,0.0549,"LY"],
  ["Malawi","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"MW"],
  ["Germany","Financial Service Provider","Waste Management","Equity",3,0.3733,"DE"],
  ["Nepal","Nonprofit","Waste Management","Equity",3,1.0581,"NP"],
  ["Saudi Arabia","Impact Investor","Waste Management","Equity",4,0.4547,"SA"],
  ["Peru","Incubator","Circular Economy","Grant",1,0.1387,"PE"],
  ["India","Nonprofit","Waste Management","Equity",4,1.7276,"IN"],
  ["Belgium","Venture Capital","Circular Economy","Equity",2,1.0326,"BE"],
  ["United Kingdom","Incubator","Waste Management","Lending",1,0.3691,"GB"],
  ["Myanmar","Public / Semi-public","Ocean Cleanup","Lending",5,1.3928,"MM"],
  ["Lebanon","Foundation","Ocean Cleanup","Equity",1,0.1624,"LB"],
  ["Tanzania","Financial Service Provider","Waste Management","Grant",1,0.1637,"TZ"],
  ["Finland","Financial Service Provider","Waste Management","Grant",1,0.0898,"FI"],
  ["Vietnam","Impact Investor","Circular Economy","Equity",2,0.0791,"VN"],
  ["Nicaragua","Impact Investor","Waste Management","Equity",1,1.0,"NI"],
  ["Cameroon","Public / Semi-public","Waste Management","Grant",5,0.6384,"CM"],
  ["United Kingdom","Impact Investor","Circular Economy","Grant",1,0.0723,"GB"],
  ["Rwanda","Impact Investor","Circular Economy","Lending",1,1.0,"RW"],
  ["Hong Kong","Public / Semi-public","Circular Economy","Grant",1,0.274,"HK"],
  ["Ghana","Nonprofit","Waste Management","Equity",2,1.3561,"GH"],
  ["Iraq","Nonprofit","Ocean Cleanup","Equity",1,0.1332,"IQ"],
  ["Morocco","Nonprofit","Waste Management","Equity",2,0.2611,"MA"],
  ["St. Lucia","Venture Capital","Circular Economy","Equity",1,1.0,"LC"],
  ["Serbia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"RS"],
  ["West Bank and Gaza","Public / Semi-public","Ocean Cleanup","Grant",1,0.2137,"PS"],
  ["Portugal","Incubator","Ocean Cleanup","Lending",1,0.1527,"PT"],
  ["Haiti","Public / Semi-public","Ocean Cleanup","Grant",1,0.5017,"HT"],
  ["India","Crowdfunding","Ocean Cleanup","Equity",1,0.2261,"IN"],
  ["Denmark","Public / Semi-public","Waste Management","Equity",2,0.2442,"DK"],
  ["Russia","Venture Capital","Circular Economy","Equity",2,1.0375,"RU"],
  ["Turkey","Bank","Ocean Cleanup","Equity",1,0.319,"TR"],
  ["Brazil","Incubator","Waste Management","Equity",4,0.4702,"BR"],
  ["Nicaragua","Nonprofit","Ocean Cleanup","Grant",1,0.4251,"NI"],
  ["Uzbekistan","Venture Capital","Ocean Cleanup","Equity",1,1.0,"UZ"],
  ["Malawi","Nonprofit","Ocean Cleanup","Grant",2,0.5949,"MW"],
  ["Rwanda","Foundation","Ocean Cleanup","Lending",1,0.2108,"RW"],
  ["North Korea","Venture Capital","Circular Economy","Equity",1,1.0,"KP"],
  ["South Sudan","Foundation","Ocean Cleanup","Equity",1,0.3356,"SS"],
  ["Ireland","Public / Semi-public","Ocean Cleanup","Grant",1,0.1082,"IE"],
  ["Afghanistan","Foundation","Waste Management","Grant",2,1.0697,"AF"],
  ["Mexico","Impact Investor","Ocean Cleanup","Equity",3,0.9803,"MX"],
  ["Vietnam","Venture Capital","Ocean Cleanup","Equity",1,1.0,"VN"],
  ["France","Incubator","Circular Economy","Equity",1,0.1718,"FR"],
  ["United States","Crowdfunding","Waste Management","Lending",1,0.6363,"US"],
  ["Cambodia","Impact Investor","Ocean Cleanup","Grant",1,0.3339,"KH"],
  ["Montserrat","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"MS"],
  ["Denmark","Nonprofit","Waste Management","Lending",1,0.1324,"DK"],
  ["Greece","Impact Investor","Ocean Cleanup","Lending",2,0.2336,"GR"],
  ["Zimbabwe","Impact Investor","Waste Management","Equity",2,0.2388,"ZW"],
  ["Serbia","Public / Semi-public","Circular Economy","Lending",2,0.589,"RS"],
  ["Côte d'Ivoire","Public / Semi-public","Circular Economy","Grant",1,0.3499,"CI"],
  ["Egypt","Nonprofit","Waste Management","Lending",3,0.405,"EG"],
  ["Japan","Nonprofit","Circular Economy","Grant",1,0.3546,"JP"],
  ["Nigeria","Nonprofit","Circular Economy","Equity",2,0.1756,"NG"],
  ["Singapore","Public / Semi-public","Waste Management","Equity",3,0.5937,"SG"],
  ["Brazil","Public / Semi-public","Ocean Cleanup","Equity",11,3.0096,"BR"],
  ["Bhutan","Financial Service Provider","Circular Economy","Equity",1,0.241,"BT"],
  ["Sudan","Financial Service Provider","Waste Management","Grant",1,0.0804,"SD"],
  ["Norway","Public / Semi-public","Waste Management","Equity",1,0.1992,"NO"],
  ["Kenya","Competitions","Ocean Cleanup","Grant",1,0.4081,"KE"],
  ["Pakistan","Incubator","Waste Management","Grant",1,0.0852,"PK"],
  ["Argentina","Impact Investor","Waste Management","Grant",1,0.1509,"AR"],
  ["Bermuda","Venture Capital","Circular Economy","Equity",1,1.0,"BM"],
  ["Egypt","Venture Capital","Ocean Cleanup","Equity",1,1.0,"EG"],
  ["Canada","Financial Service Provider","Circular Economy","Lending",2,0.2095,"CA"],
  ["Greece","Financial Service Provider","Circular Economy","Lending",1,0.0983,"GR"],
  ["Ukraine","Impact Investor","Waste Management","Lending",1,0.1787,"UA"],
  ["Ghana","Incubator","Circular Economy","Equity",1,0.0785,"GH"],
  ["South Korea","Crowdfunding","Ocean Cleanup","Equity",1,0.0298,"KR"],
  ["Honduras","Bank","Circular Economy","Lending",1,0.1958,"HN"],
  ["Saudi Arabia","Incubator","Waste Management","Grant",1,0.1111,"SA"],
  ["Switzerland","Incubator","Ocean Cleanup","Equity",1,0.039,"CH"],
  ["United States","Crowdfunding","Circular Economy","Grant",1,1.0,"US"],
  ["Belgium","Public / Semi-public","Waste Management","Equity",10,2.7991,"BE"],
  ["Bangladesh","Foundation","Circular Economy","Equity",1,0.1727,"BD"],
  ["Syria","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SY"],
  ["Brazil","Bank","Ocean Cleanup","Equity",2,0.1775,"BR"],
  ["Macau","Bank","Ocean Cleanup","Lending",2,0.4119,"MO"],
  ["Iraq","Nonprofit","Circular Economy","Grant",4,1.3692,"IQ"],
  ["Bolivia","Public / Semi-public","Waste Management","Lending",2,1.0569,"BO"],
  ["Tanzania","Incubator","Ocean Cleanup","Grant",1,0.1468,"TZ"],
  ["Laos","Financial Service Provider","Ocean Cleanup","Lending",1,0.3935,"LA"],
  ["Ireland","Financial Service Provider","Ocean Cleanup","Equity",1,0.0336,"IE"],
  ["Philippines","Bank","Ocean Cleanup","Equity",2,1.2507,"PH"],
  ["Kenya","Financial Service Provider","Waste Management","Grant",1,0.1004,"KE"],
  ["Afghanistan","Bank","Circular Economy","Equity",1,0.2511,"AF"],
  ["Cayman Islands","Venture Capital","Waste Management","Equity",1,0.2013,"KY"],
  ["United Kingdom","Financial Service Provider","Waste Management","Lending",3,0.3885,"GB"],
  ["Mongolia","Financial Service Provider","Waste Management","Equity",1,0.0313,"MN"],
  ["Norway","Financial Service Provider","Waste Management","Grant",1,0.0897,"NO"],
  ["United Kingdom","Foundation","Waste Management","Lending",2,0.5696,"GB"],
  ["Oman","Foundation","Ocean Cleanup","Grant",2,0.3943,"OM"],
  ["Thailand","Competitions","Waste Management","Grant",1,0.1859,"TH"],
  ["Sweden","Public / Semi-public","Circular Economy","Grant",1,1.0,"SE"],
  ["Uganda","Incubator","Circular Economy","Grant",1,0.1229,"UG"],
  ["Bahrain","Foundation","Waste Management","Grant",1,0.1767,"BH"],
  ["Saudi Arabia","Competitions","Ocean Cleanup","Grant",1,0.3281,"SA"],
  ["Nigeria","Crowdfunding","Waste Management","Equity",1,0.0362,"NG"],
  ["Germany","Impact Investor","Waste Management","Lending",4,1.5109,"DE"],
  ["South Africa","Venture Capital","Waste Management","Equity",2,1.0259,"ZA"],
  ["Sierra Leone","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"SL"],
  ["Eritrea","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"ER"],
  ["India","Venture Capital","Ocean Cleanup","Equity",1,1.0,"IN"],
  ["Tanzania","Foundation","Circular Economy","Grant",2,0.835,"TZ"],
  ["Sweden","Financial Service Provider","Waste Management","Grant",1,0.0962,"SE"],
  ["South Africa","Venture Capital","Circular Economy","Equity",4,3.0264,"ZA"],
  ["Congo, Rep.","Public / Semi-public","Ocean Cleanup","Grant",1,0.4715,"CG"],
  ["Paraguay","Financial Service Provider","Waste Management","Equity",1,0.0415,"PY"],
  ["Morocco","Foundation","Ocean Cleanup","Grant",1,0.2998,"MA"],
  ["West Bank and Gaza","Bank","Ocean Cleanup","Lending",1,0.1748,"PS"],
  ["Sweden","Impact Investor","Circular Economy","Lending",2,0.2787,"SE"],
  ["Paraguay","Public / Semi-public","Waste Management","Lending",2,1.0036,"PY"],
  ["Belgium","Nonprofit","Waste Management","Grant",4,1.0486,"BE"],
  ["Senegal","Public / Semi-public","Ocean Cleanup","Grant",1,0.3764,"SN"],
  ["Russia","Foundation","Waste Management","Equity",1,0.1588,"RU"],
  ["South Africa","Public / Semi-public","Circular Economy","Lending",6,0.7446,"ZA"],
  ["Spain","Bank","Circular Economy","Lending",3,0.4503,"ES"],
  ["Jordan","Incubator","Waste Management","Equity",1,0.1531,"JO"],
  ["Malaysia","Impact Investor","Ocean Cleanup","Lending",3,0.4147,"MY"],
  ["Bangladesh","Bank","Waste Management","Lending",2,0.4762,"BD"],
  ["Bolivia","Impact Investor","Waste Management","Equity",1,0.8102,"BO"],
  ["Pakistan","Venture Capital","Circular Economy","Equity",2,1.0252,"PK"],
  ["Canada","Foundation","Waste Management","Lending",2,0.3725,"CA"],
  ["Malaysia","Nonprofit","Ocean Cleanup","Lending",5,1.753,"MY"],
  ["Iran","Financial Service Provider","Circular Economy","Equity",1,0.3311,"IR"],
  ["Venezuela","Nonprofit","Ocean Cleanup","Lending",1,0.3811,"VE"],
  ["United States","Impact Investor","Waste Management","Equity",5,3.4489,"US"],
  ["Puerto Rico","Public / Semi-public","Ocean Cleanup","Equity",1,0.2656,"PR"],
  ["Tanzania","Bank","Ocean Cleanup","Lending",2,0.6011,"TZ"],
  ["Turkey","Bank","Ocean Cleanup","Lending",2,1.0509,"TR"],
  ["Singapore","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SG"],
  ["Chile","Nonprofit","Waste Management","Equity",2,0.3723,"CL"],
  ["Egypt","Financial Service Provider","Waste Management","Lending",2,0.2956,"EG"],
  ["Germany","Crowdfunding","Waste Management","Equity",1,0.0288,"DE"],
  ["Puerto Rico","Venture Capital","Ocean Cleanup","Equity",1,1.0,"PR"],
  ["Australia","Bank","Waste Management","Equity",1,0.0925,"AU"],
  ["Mongolia","Crowdfunding","Waste Management","Lending",1,0.0296,"MN"],
  ["Mexico","Impact Investor","Circular Economy","Lending",1,0.225,"MX"],
  ["Singapore","Incubator","Ocean Cleanup","Equity",1,0.0334,"SG"],
  ["Angola","Public / Semi-public","Ocean Cleanup","Grant",1,0.2469,"AO"],
  ["Peru","Foundation","Ocean Cleanup","Lending",1,0.1455,"PE"],
  ["Guatemala","Bank","Circular Economy","Lending",1,0.1152,"GT"],
  ["Taiwan","Public / Semi-public","Ocean Cleanup","Equity",2,0.5589,"TW"],
  ["Turkey","Bank","Waste Management","Lending",1,0.2439,"TR"],
  ["Mozambique","Financial Service Provider","Ocean Cleanup","Lending",1,0.4,"MZ"],
  ["Switzerland","Impact Investor","Circular Economy","Grant",1,0.085,"CH"],
  ["Mozambique","Public / Semi-public","Ocean Cleanup","Equity",3,1.5673,"MZ"],
  ["Aruba","Venture Capital","Ocean Cleanup","Equity",1,1.0,"AW"],
  ["Indonesia","Incubator","Circular Economy","Grant",1,0.1571,"ID"],
  ["Costa Rica","Bank","Waste Management","Equity",1,0.1133,"CR"],
  ["Mozambique","Impact Investor","Waste Management","Grant",1,0.4613,"MZ"],
  ["Oman","Nonprofit","Circular Economy","Grant",1,0.234,"OM"],
  ["Kenya","Incubator","Circular Economy","Equity",1,0.1039,"KE"],
  ["Spain","Nonprofit","Waste Management","Grant",4,1.0576,"ES"],
  ["Brunei","Bank","Circular Economy","Equity",1,0.3757,"BN"],
  ["Congo, Dem. Rep","Public / Semi-public","Waste Management","Equity",4,0.5634,"CD"],
  ["Greece","Public / Semi-public","Waste Management","Grant",2,0.4563,"GR"],
  ["Belgium","Public / Semi-public","Circular Economy","Equity",5,1.455,"BE"],
  ["Congo, Dem. Rep","Foundation","Ocean Cleanup","Grant",2,0.3732,"CD"],
  ["Colombia","Nonprofit","Ocean Cleanup","Lending",6,1.7177,"CO"],
  ["Zambia","Venture Capital","Waste Management","Equity",1,0.0322,"ZM"],
  ["Sweden","Foundation","Waste Management","Lending",2,0.3141,"SE"],
  ["Nigeria","Nonprofit","Waste Management","Lending",4,0.4749,"NG"],
  ["New Zealand","Public / Semi-public","Waste Management","Equity",1,0.2237,"NZ"],
  ["Afghanistan","Public / Semi-public","Ocean Cleanup","Equity",4,1.9341,"AF"],
  ["Iraq","Impact Investor","Waste Management","Grant",1,0.0533,"IQ"],
  ["Tunisia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TN"],
  ["Belgium","Public / Semi-public","Ocean Cleanup","Equity",11,2.8339,"BE"],
  ["Philippines","Nonprofit","Waste Management","Equity",1,0.1309,"PH"],
  ["Kenya","Impact Investor","Circular Economy","Equity",4,1.486,"KE"],
  ["Peru","Impact Investor","Waste Management","Grant",1,0.0743,"PE"],
  ["Mexico","Impact Investor","Ocean Cleanup","Grant",2,0.6378,"MX"],
  ["El Salvador","Public / Semi-public","Waste Management","Equity",2,0.4001,"SV"],
  ["South Korea","Foundation","Circular Economy","Grant",1,0.0609,"KR"],
  ["Nepal","Nonprofit","Ocean Cleanup","Equity",5,1.3936,"NP"],
  ["Dominican Republic","Public / Semi-public","Waste Management","Lending",2,0.3402,"DO"],
  ["Thailand","Impact Investor","Ocean Cleanup","Equity",4,0.6035,"TH"],
  ["Tunisia","Impact Investor","Circular Economy","Grant",1,0.0711,"TN"],
  ["Spain","Nonprofit","Circular Economy","Equity",2,0.6234,"ES"],
  ["New Zealand","Nonprofit","Waste Management","Equity",2,0.2553,"NZ"],
  ["Mexico","Foundation","Waste Management","Equity",1,0.1863,"MX"],
  ["Sierra Leone","Nonprofit","Ocean Cleanup","Grant",2,0.2694,"SL"],
  ["Brazil","Impact Investor","Ocean Cleanup","Equity",5,1.4475,"BR"],
  ["Puerto Rico","Financial Service Provider","Waste Management","Equity",2,0.3365,"PR"],
  ["Guatemala","Bank","Ocean Cleanup","Lending",1,0.1152,"GT"],
  ["Botswana","Public / Semi-public","Waste Management","Equity",1,0.0915,"BW"],
  ["Chile","Impact Investor","Waste Management","Lending",2,0.9586,"CL"],
  ["Angola","Foundation","Waste Management","Grant",2,0.3299,"AO"],
  ["Tunisia","Impact Investor","Ocean Cleanup","Lending",1,0.609,"TN"],
  ["Benin","Financial Service Provider","Waste Management","Lending",2,0.4377,"BJ"],
  ["Finland","Impact Investor","Ocean Cleanup","Equity",1,0.058,"FI"],
  ["Australia","Competitions","Ocean Cleanup","Grant",1,0.2815,"AU"],
  ["Taiwan","Crowdfunding","Waste Management","Lending",1,0.0289,"TW"],
  ["Chad","Public / Semi-public","Waste Management","Equity",1,0.386,"TD"],
  ["Albania","Venture Capital","Ocean Cleanup","Equity",1,1.0,"AL"],
  ["Paraguay","Public / Semi-public","Ocean Cleanup","Equity",1,0.0427,"PY"],
  ["Hungary","Impact Investor","Waste Management","Equity",1,0.1092,"HU"],
  ["Central African Republic","Public / Semi-public","Waste Management","Equity",1,0.1834,"CF"],
  ["Chad","Public / Semi-public","Ocean Cleanup","Equity",2,1.386,"TD"],
  ["Australia","Financial Service Provider","Circular Economy","Grant",1,0.1693,"AU"],
  ["Togo","Venture Capital","Circular Economy","Equity",1,1.0,"TG"],
  ["Zimbabwe","Foundation","Circular Economy","Lending",1,0.1598,"ZW"],
  ["Japan","Incubator","Waste Management","Equity",4,0.8545,"JP"],
  ["Bahrain","Venture Capital","Circular Economy","Equity",1,1.0,"BH"],
  ["Italy","Foundation","Circular Economy","Equity",1,0.1585,"IT"],
  ["Italy","Foundation","Circular Economy","Lending",1,0.1585,"IT"],
  ["Tanzania","Impact Investor","Circular Economy","Lending",1,0.0598,"TZ"],
  ["Vietnam","Foundation","Circular Economy","Lending",1,0.1677,"VN"],
  ["Sudan","Foundation","Ocean Cleanup","Grant",1,0.1536,"SD"],
  ["Iran","Financial Service Provider","Waste Management","Lending",1,0.107,"IR"],
  ["Haiti","Nonprofit","Ocean Cleanup","Lending",1,0.5941,"HT"],
  ["Cyprus","Crowdfunding","Waste Management","Equity",1,0.0464,"CY"],
  ["Egypt","Public / Semi-public","Waste Management","Grant",6,1.1677,"EG"],
  ["Peru","Foundation","Waste Management","Lending",1,0.1455,"PE"],
  ["Finland","Public / Semi-public","Ocean Cleanup","Lending",2,0.4314,"FI"],
  ["Turkey","Public / Semi-public","Waste Management","Equity",7,2.3643,"TR"],
  ["Kosovo","Nonprofit","Ocean Cleanup","Grant",1,0.7165,"XK"],
  ["Portugal","Impact Investor","Waste Management","Grant",1,0.1206,"PT"],
  ["Malaysia","Foundation","Ocean Cleanup","Lending",2,0.2636,"MY"],
  ["Singapore","Competitions","Waste Management","Grant",1,0.2029,"SG"],
  ["Israel","Incubator","Circular Economy","Equity",1,0.0813,"IL"],
  ["Netherlands","Nonprofit","Ocean Cleanup","Grant",7,2.8329,"NL"],
  ["Brunei","Crowdfunding","Waste Management","Equity",1,0.2407,"BN"],
  ["Netherlands Antilles","Venture Capital","Ocean Cleanup","Equity",1,1.0,"AN"],
  ["Canada","Bank","Ocean Cleanup","Lending",2,0.3274,"CA"],
  ["Vietnam","Financial Service Provider","Ocean Cleanup","Lending",1,0.3319,"VN"],
  ["Colombia","Nonprofit","Circular Economy","Grant",5,2.0225,"CO"],
  ["United Kingdom","Impact Investor","Ocean Cleanup","Equity",5,1.2626,"GB"],
  ["Kenya","Public / Semi-public","Waste Management","Equity",10,2.7375,"KE"],
  ["Afghanistan","Competitions","Waste Management","Grant",1,0.2242,"AF"],
  ["Denmark","Impact Investor","Waste Management","Grant",1,0.0637,"DK"],
  ["Saudi Arabia","Competitions","Waste Management","Grant",1,0.3281,"SA"],
  ["Kuwait","Public / Semi-public","Ocean Cleanup","Lending",1,0.3266,"KW"],
  ["Zambia","Incubator","Ocean Cleanup","Equity",1,0.2714,"ZM"],
  ["Oman","Financial Service Provider","Waste Management","Equity",1,0.0551,"OM"],
  ["Hong Kong","Foundation","Waste Management","Grant",1,0.1366,"HK"],
  ["Argentina","Financial Service Provider","Waste Management","Equity",1,1.0,"AR"],
  ["Germany","Public / Semi-public","Circular Economy","Equity",7,1.6349,"DE"],
  ["Yemen","Venture Capital","Circular Economy","Equity",1,1.0,"YE"],
  ["Macau","Bank","Ocean Cleanup","Equity",1,0.3005,"MO"],
  ["Italy","Incubator","Circular Economy","Equity",2,0.1926,"IT"],
  ["Brazil","Competitions","Waste Management","Grant",1,0.4354,"BR"],
  ["Japan","Nonprofit","Ocean Cleanup","Grant",3,0.6757,"JP"],
  ["Nigeria","Incubator","Waste Management","Lending",1,0.1221,"NG"],
  ["Uzbekistan","Bank","Circular Economy","Lending",1,0.3086,"UZ"],
  ["Guinea","Bank","Circular Economy","Lending",1,0.0299,"GN"],
  ["Iraq","Public / Semi-public","Circular Economy","Equity",3,0.4967,"IQ"],
  ["India","Financial Service Provider","Circular Economy","Lending",2,0.3966,"IN"],
  ["United States","Public / Semi-public","Waste Management","Lending",11,5.4791,"US"],
  ["Cameroon","Public / Semi-public","Circular Economy","Lending",2,0.4561,"CM"],
  ["Switzerland","Incubator","Circular Economy","Grant",1,0.2022,"CH"],
  ["Albania","Public / Semi-public","Circular Economy","Equity",2,0.5388,"AL"],
  ["Thailand","Impact Investor","Ocean Cleanup","Lending",3,0.3227,"TH"],
  ["Nigeria","Foundation","Ocean Cleanup","Grant",3,0.6284,"NG"],
  ["Nicaragua","Financial Service Provider","Ocean Cleanup","Lending",1,0.3848,"NI"],
  ["France","Bank","Circular Economy","Lending",3,0.6673,"FR"],
  ["Austria","Nonprofit","Waste Management","Grant",1,0.0367,"AT"],
  ["Vanuatu","Venture Capital","Circular Economy","Equity",1,1.0,"VU"],
  ["Congo, Rep.","Public / Semi-public","Circular Economy","Equity",1,0.4715,"CG"],
  ["Nicaragua","Nonprofit","Circular Economy","Grant",1,0.4251,"NI"],
  ["Angola","Public / Semi-public","Ocean Cleanup","Lending",2,1.2469,"AO"],
  ["Kenya","Public / Semi-public","Waste Management","Grant",7,2.4151,"KE"],
  ["Denmark","Financial Service Provider","Circular Economy","Grant",1,0.0515,"DK"],
  ["Togo","Public / Semi-public","Circular Economy","Grant",1,0.4885,"TG"],
  ["Turkey","Financial Service Provider","Circular Economy","Grant",1,0.0565,"TR"],
  ["Thailand","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TH"],
  ["Rwanda","Bank","Circular Economy","Equity",1,0.5481,"RW"],
  ["Tanzania","Impact Investor","Waste Management","Grant",3,0.3603,"TZ"],
  ["Belgium","Public / Semi-public","Ocean Cleanup","Grant",5,1.2932,"BE"],
  ["Austria","Incubator","Circular Economy","Equity",1,0.2986,"AT"],
  ["China","Nonprofit","Waste Management","Grant",4,0.8398,"CN"],
  ["Argentina","Impact Investor","Circular Economy","Equity",2,0.2498,"AR"],
  ["Italy","Financial Service Provider","Circular Economy","Lending",1,0.1707,"IT"],
  ["Bulgaria","Nonprofit","Ocean Cleanup","Grant",2,0.559,"BG"],
  ["Iceland","Venture Capital","Ocean Cleanup","Equity",1,1.0,"IS"],
  ["British Virgin Islands","Venture Capital","Ocean Cleanup","Equity",1,1.0,"VG"],
  ["Niger","Public / Semi-public","Circular Economy","Lending",1,0.4697,"NE"],
  ["Senegal","Public / Semi-public","Waste Management","Lending",3,0.7764,"SN"],
  ["Hong Kong","Financial Service Provider","Waste Management","Grant",1,0.1366,"HK"],
  ["Tanzania","Bank","Waste Management","Equity",1,0.1089,"TZ"],
  ["Uzbekistan","Bank","Circular Economy","Equity",1,0.3086,"UZ"],
  ["Saudi Arabia","Foundation","Circular Economy","Lending",1,0.2377,"SA"],
  ["Falkland Islands (Islas Malvinas)","Venture Capital","Circular Economy","Equity",1,1.0,"FK"],
  ["Turkmenistan","Venture Capital","Circular Economy","Equity",1,1.0,"TM"],
  ["Laos","Venture Capital","Ocean Cleanup","Equity",1,1.0,"LA"],
  ["Indonesia","Impact Investor","Ocean Cleanup","Grant",3,0.8367,"ID"],
  ["Singapore","Financial Service Provider","Waste Management","Grant",1,0.0948,"SG"],
  ["Colombia","Nonprofit","Ocean Cleanup","Equity",5,1.3048,"CO"],
  ["Anguilla","Public / Semi-public","Waste Management","Equity",1,1.0,"AI"],
  ["Romania","Venture Capital","Ocean Cleanup","Equity",1,1.0,"RO"],
  ["South Africa","Financial Service Provider","Ocean Cleanup","Equity",2,0.1609,"ZA"],
  ["Greece","Public / Semi-public","Waste Management","Equity",3,1.1196,"GR"],
  ["Austria","Nonprofit","Ocean Cleanup","Lending",2,0.2765,"AT"],
  ["Belgium","Nonprofit","Ocean Cleanup","Grant",8,2.158,"BE"],
  ["Algeria","Venture Capital","Ocean Cleanup","Equity",1,1.0,"DZ"],
  ["China","Nonprofit","Waste Management","Lending",2,0.2725,"CN"],
  ["Cambodia","Impact Investor","Waste Management","Lending",1,0.0658,"KH"],
  ["Costa Rica","Venture Capital","Circular Economy","Equity",1,1.0,"CR"],
  ["Zimbabwe","Incubator","Waste Management","Grant",1,0.076,"ZW"],
  ["Spain","Public / Semi-public","Circular Economy","Grant",5,0.8277,"ES"],
  ["Netherlands","Public / Semi-public","Waste Management","Grant",3,1.1619,"NL"],
  ["Syria","Impact Investor","Waste Management","Equity",1,0.0753,"SY"],
  ["Netherlands","Impact Investor","Waste Management","Equity",4,1.0346,"NL"],
  ["United States","Impact Investor","Ocean Cleanup","Equity",5,3.7895,"US"],
  ["Hungary","Public / Semi-public","Waste Management","Equity",1,0.2434,"HU"],
  ["Myanmar","Incubator","Waste Management","Equity",1,0.0966,"MM"],
  ["Paraguay","Foundation","Ocean Cleanup","Grant",1,0.5065,"PY"],
  ["Honduras","Public / Semi-public","Waste Management","Equity",1,0.8799,"HN"],
  ["Zimbabwe","Public / Semi-public","Waste Management","Grant",3,0.2462,"ZW"],
  ["Afghanistan","Public / Semi-public","Ocean Cleanup","Grant",3,1.1607,"AF"],
  ["Brazil","Competitions","Ocean Cleanup","Grant",1,0.4354,"BR"],
  ["Brazil","Incubator","Circular Economy","Grant",1,0.2088,"BR"],
  ["Tunisia","Financial Service Provider","Waste Management","Equity",1,0.1901,"TN"],
  ["Tajikistan","Bank","Ocean Cleanup","Lending",1,0.4342,"TJ"],
  ["United Kingdom","Nonprofit","Waste Management","Grant",5,1.4923,"GB"],
  ["El Salvador","Impact Investor","Waste Management","Equity",1,0.3055,"SV"],
  ["Angola","Foundation","Circular Economy","Grant",2,0.3299,"AO"],
  ["Pakistan","Nonprofit","Waste Management","Grant",4,1.3133,"PK"],
  ["South Africa","Financial Service Provider","Ocean Cleanup","Lending",1,0.1334,"ZA"],
  ["Cameroon","Impact Investor","Circular Economy","Grant",1,0.0722,"CM"],
  ["Tanzania","Financial Service Provider","Ocean Cleanup","Equity",1,0.3587,"TZ"],
  ["Israel","Venture Capital","Ocean Cleanup","Equity",1,1.0,"IL"],
  ["Netherlands","Public / Semi-public","Ocean Cleanup","Lending",4,1.5671,"NL"],
  ["Germany","Bank","Ocean Cleanup","Lending",5,0.9051,"DE"],
  ["Ecuador","Nonprofit","Waste Management","Lending",1,0.1688,"EC"],
  ["Thailand","Incubator","Circular Economy","Equity",1,0.0613,"TH"],
  ["Portugal","Nonprofit","Circular Economy","Grant",3,1.1435,"PT"],
  ["Mozambique","Bank","Circular Economy","Lending",1,0.5015,"MZ"],
  ["Italy","Financial Service Provider","Waste Management","Equity",3,0.2132,"IT"],
  ["Spain","Foundation","Circular Economy","Lending",1,0.1561,"ES"],
  ["United Arab Emirates","Nonprofit","Circular Economy","Lending",2,0.2889,"AE"],
  ["Turkey","Bank","Circular Economy","Equity",1,0.319,"TR"],
  ["Italy","Venture Capital","Circular Economy","Equity",2,1.0607,"IT"],
  ["Lebanon","Foundation","Waste Management","Equity",1,0.1624,"LB"],
  ["Algeria","Public / Semi-public","Circular Economy","Grant",3,0.6448,"DZ"],
  ["Greece","Public / Semi-public","Circular Economy","Equity",1,0.3476,"GR"],
  ["Singapore","Impact Investor","Waste Management","Lending",2,0.2463,"SG"],
  ["New Zealand","Foundation","Ocean Cleanup","Grant",2,0.3738,"NZ"],
  ["Rwanda","Nonprofit","Waste Management","Grant",2,1.4061,"RW"],
  ["Germany","Competitions","Ocean Cleanup","Grant",1,0.2387,"DE"],
  ["Israel","Foundation","Waste Management","Grant",1,0.3304,"IL"],
  ["Guatemala","Public / Semi-public","Waste Management","Lending",3,1.385,"GT"],
  ["Australia","Impact Investor","Circular Economy","Lending",2,0.6231,"AU"],
  ["Puerto Rico","Financial Service Provider","Circular Economy","Equity",1,0.0922,"PR"],
  ["Italy","Nonprofit","Ocean Cleanup","Grant",9,2.5463,"IT"],
  ["Malawi","Public / Semi-public","Waste Management","Equity",1,0.7289,"MW"],
  ["Suriname","Public / Semi-public","Circular Economy","Equity",1,1.0,"SR"],
  ["Bangladesh","Public / Semi-public","Ocean Cleanup","Lending",6,2.1896,"BD"],
  ["Laos","Public / Semi-public","Waste Management","Lending",2,0.7233,"LA"],
  ["United States","Public / Semi-public","Ocean Cleanup","Grant",9,3.5834,"US"],
  ["Venezuela","Financial Service Provider","Circular Economy","Lending",1,0.1406,"VE"],
  ["Egypt","Public / Semi-public","Waste Management","Equity",10,3.4152,"EG"],
  ["France","Venture Capital","Circular Economy","Equity",2,1.0298,"FR"],
  ["Benin","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BJ"],
  ["Mongolia","Financial Service Provider","Ocean Cleanup","Equity",1,0.0313,"MN"],
  ["Ukraine","Impact Investor","Waste Management","Equity",2,0.2354,"UA"],
  ["Spain","Public / Semi-public","Waste Management","Grant",5,0.9404,"ES"],
  ["Mali","Public / Semi-public","Waste Management","Lending",2,0.7728,"ML"],
  ["Ghana","Incubator","Waste Management","Equity",2,0.1783,"GH"],
  ["Germany","Incubator","Ocean Cleanup","Grant",1,0.1068,"DE"],
  ["Zambia","Public / Semi-public","Waste Management","Lending",2,0.5729,"ZM"],
  ["Botswana","Venture Capital","Waste Management","Equity",1,0.076,"BW"],
  ["Netherlands","Crowdfunding","Waste Management","Lending",1,0.0288,"NL"],
  ["Hungary","Foundation","Ocean Cleanup","Grant",1,0.4006,"HU"],
  ["Mozambique","Bank","Waste Management","Lending",1,0.5015,"MZ"],
  ["Philippines","Crowdfunding","Waste Management","Equity",1,0.2685,"PH"],
  ["Italy","Public / Semi-public","Circular Economy","Equity",6,1.8314,"IT"],
  ["United Arab Emirates","Nonprofit","Waste Management","Grant",3,0.6235,"AE"],
  ["Somalia","Foundation","Waste Management","Equity",1,0.2496,"SO"],
  ["Tunisia","Bank","Ocean Cleanup","Lending",3,0.3218,"TN"],
  ["Mozambique","Nonprofit","Circular Economy","Grant",1,0.4613,"MZ"],
  ["Gibraltar","Venture Capital","Circular Economy","Equity",1,1.0,"GI"],
  ["Guyana","Impact Investor","Waste Management","Grant",1,0.1954,"GY"],
  ["Haiti","Impact Investor","Waste Management","Equity",2,1.5043,"HT"],
  ["South Africa","Bank","Waste Management","Equity",1,1.0,"ZA"],
  ["Vietnam","Financial Service Provider","Ocean Cleanup","Equity",1,0.3319,"VN"],
  ["Peru","Bank","Waste Management","Lending",1,0.1073,"PE"],
  ["Belgium","Microfinance Institution","Waste Management","Lending",1,0.0338,"BE"],
  ["Pakistan","Impact Investor","Circular Economy","Equity",4,0.4424,"PK"],
  ["France","Incubator","Ocean Cleanup","Equity",1,0.2017,"FR"],
  ["Saudi Arabia","Foundation","Ocean Cleanup","Lending",2,0.3619,"SA"],
  ["Ukraine","Foundation","Waste Management","Grant",2,0.6209,"UA"],
  ["Bangladesh","Public / Semi-public","Circular Economy","Lending",6,1.955,"BD"],
  ["Poland","Foundation","Waste Management","Grant",2,0.4994,"PL"],
  ["Germany","Foundation","Circular Economy","Lending",1,0.1922,"DE"],
  ["United Arab Emirates","Competitions","Ocean Cleanup","Grant",1,0.3105,"AE"],
  ["Spain","Incubator","Waste Management","Lending",1,0.1756,"ES"],
  ["Nepal","Nonprofit","Waste Management","Grant",5,1.2066,"NP"],
  ["Mali","Financial Service Provider","Ocean Cleanup","Lending",1,0.2892,"ML"],
  ["Zimbabwe","Impact Investor","Waste Management","Grant",2,0.2143,"ZW"],
  ["Madagascar","Financial Service Provider","Circular Economy","Equity",1,0.0343,"MG"],
  ["Congo, Rep.","Public / Semi-public","Waste Management","Equity",1,0.4715,"CG"],
  ["Colombia","Nonprofit","Circular Economy","Equity",2,0.6987,"CO"],
  ["French Polynesia","Public / Semi-public","Ocean Cleanup","Lending",1,0.6939,"PF"],
  ["Belgium","Venture Capital","Waste Management","Equity",1,0.0326,"BE"],
  ["Oman","Bank","Ocean Cleanup","Lending",2,0.2135,"OM"],
  ["Belgium","Nonprofit","Ocean Cleanup","Equity",4,0.6397,"BE"],
  ["New Zealand","Incubator","Waste Management","Equity",3,0.3556,"NZ"],
  ["China","Bank","Ocean Cleanup","Equity",1,0.432,"CN"],
  ["United Kingdom","Impact Investor","Ocean Cleanup","Grant",3,0.5527,"GB"],
  ["Nepal","Competitions","Ocean Cleanup","Grant",1,0.543,"NP"],
  ["Indonesia","Competitions","Waste Management","Grant",1,0.3929,"ID"],
  ["Iraq","Public / Semi-public","Ocean Cleanup","Grant",7,1.2616,"IQ"],
  ["Colombia","Bank","Waste Management","Lending",1,0.1107,"CO"],
  ["Venezuela","Public / Semi-public","Waste Management","Lending",2,1.3028,"VE"],
  ["Poland","Foundation","Ocean Cleanup","Grant",1,0.384,"PL"],
  ["Thailand","Bank","Circular Economy","Lending",3,0.332,"TH"],
  ["Kenya","Nonprofit","Circular Economy","Equity",2,0.1937,"KE"],
  ["Djibouti","Public / Semi-public","Waste Management","Lending",1,0.5076,"DJ"],
  ["Egypt","Nonprofit","Circular Economy","Equity",2,0.2427,"EG"],
  ["Albania","Bank","Waste Management","Lending",1,0.1833,"AL"],
  ["Argentina","Foundation","Waste Management","Lending",1,0.1547,"AR"],
  ["United Arab Emirates","Incubator","Ocean Cleanup","Equity",1,0.1289,"AE"],
  ["Zimbabwe","Bank","Waste Management","Lending",1,0.1109,"ZW"],
  ["Hungary","Public / Semi-public","Waste Management","Lending",1,0.2434,"HU"],
  ["Somalia","Foundation","Circular Economy","Lending",1,0.2496,"SO"],
  ["Botswana","Foundation","Ocean Cleanup","Lending",1,0.3088,"BW"],
  ["Mauritius","Public / Semi-public","Waste Management","Equity",2,0.0643,"MU"],
  ["Ecuador","Public / Semi-public","Circular Economy","Lending",1,0.0341,"EC"],
  ["Philippines","Impact Investor","Ocean Cleanup","Grant",2,0.3742,"PH"],
  ["Bolivia","Impact Investor","Waste Management","Lending",1,0.8102,"BO"],
  ["Madagascar","Public / Semi-public","Circular Economy","Lending",2,0.9678,"MG"],
  ["Antigua and Barbuda","Venture Capital","Circular Economy","Equity",1,1.0,"AG"],
  ["Egypt","Incubator","Waste Management","Grant",1,0.0472,"EG"],
  ["Cambodia","Financial Service Provider","Circular Economy","Equity",1,0.9712,"KH"],
  ["Nepal","Nonprofit","Circular Economy","Lending",2,0.5047,"NP"],
  ["Nepal","Public / Semi-public","Circular Economy","Lending",3,1.0175,"NP"],
  ["Belgium","Foundation","Waste Management","Lending",2,0.3402,"BE"],
  ["Egypt","Foundation","Ocean Cleanup","Grant",5,1.9182,"EG"],
  ["Colombia","Public / Semi-public","Ocean Cleanup","Grant",7,2.0405,"CO"],
  ["Maldives","Public / Semi-public","Ocean Cleanup","Equity",1,0.7429,"MV"],
  ["Germany","Foundation","Waste Management","Lending",2,0.3766,"DE"],
  ["Russia","Public / Semi-public","Ocean Cleanup","Equity",1,0.2545,"RU"],
  ["Argentina","Incubator","Waste Management","Equity",2,0.2359,"AR"],
  ["Brazil","Nonprofit","Waste Management","Lending",3,0.9179,"BR"],
  ["United States","Impact Investor","Circular Economy","Lending",2,1.4237,"US"],
  ["Canada","Financial Service Provider","Circular Economy","Grant",1,0.1342,"CA"],
  ["Malaysia","Crowdfunding","Waste Management","Equity",1,1.0,"MY"],
  ["Rwanda","Foundation","Waste Management","Lending",1,0.2108,"RW"],
  ["Bangladesh","Impact Investor","Circular Economy","Grant",1,0.088,"BD"],
  ["Trinidad and Tobago","Venture Capital","Circular Economy","Equity",1,1.0,"TT"],
  ["Colombia","Nonprofit","Ocean Cleanup","Grant",8,2.769,"CO"],
  ["Japan","Nonprofit","Ocean Cleanup","Lending",5,0.7494,"JP"],
  ["Spain","Foundation","Ocean Cleanup","Grant",5,1.2406,"ES"],
  ["Zambia","Incubator","Waste Management","Lending",1,0.2714,"ZM"],
  ["Ghana","Impact Investor","Circular Economy","Grant",1,0.4435,"GH"],
  ["Italy","Financial Service Provider","Circular Economy","Equity",1,0.0607,"IT"],
  ["Afghanistan","Incubator","Waste Management","Equity",1,0.113,"AF"],
  ["Greece","Impact Investor","Ocean Cleanup","Equity",4,0.6467,"GR"],
  ["Brazil","Crowdfunding","Waste Management","Equity",1,0.0238,"BR"],
  ["Timor-Leste","Public / Semi-public","Circular Economy","Lending",1,0.3718,"TL"],
  ["Saudi Arabia","Public / Semi-public","Waste Management","Lending",7,1.3291,"SA"],
  ["Qatar","Foundation","Circular Economy","Grant",2,0.4743,"QA"],
  ["Greece","Impact Investor","Circular Economy","Equity",2,0.1365,"GR"],
  ["Venezuela","Public / Semi-public","Circular Economy","Equity",1,0.7439,"VE"],
  ["Benin","Public / Semi-public","Waste Management","Lending",3,0.7092,"BJ"],
  ["Kyrgyz Republic","Public / Semi-public","Circular Economy","Equity",1,0.1117,"KG"],
  ["Italy","Nonprofit","Waste Management","Equity",3,0.7282,"IT"],
  ["Uganda","Bank","Circular Economy","Lending",3,1.8681,"UG"],
  ["Serbia","Public / Semi-public","Ocean Cleanup","Lending",3,1.2097,"RS"],
  ["Kosovo","Public / Semi-public","Circular Economy","Lending",2,0.7028,"XK"],
  ["Israel","Incubator","Waste Management","Grant",1,0.0748,"IL"],
  ["New Zealand","Impact Investor","Ocean Cleanup","Equity",3,0.3983,"NZ"],
  ["Portugal","Financial Service Provider","Ocean Cleanup","Equity",1,0.054,"PT"],
  ["Ireland","Venture Capital","Circular Economy","Lending",1,0.0314,"IE"],
  ["Portugal","Foundation","Waste Management","Equity",1,0.1527,"PT"],
  ["Algeria","Nonprofit","Waste Management","Lending",1,0.115,"DZ"],
  ["Ireland","Incubator","Ocean Cleanup","Lending",1,0.1463,"IE"],
  ["Colombia","Incubator","Waste Management","Lending",1,0.147,"CO"],
  ["Mozambique","Impact Investor","Ocean Cleanup","Grant",1,0.4613,"MZ"],
  ["United Kingdom","Financial Service Provider","Ocean Cleanup","Equity",1,0.1363,"GB"],
  ["Ghana","Public / Semi-public","Circular Economy","Grant",2,0.5754,"GH"],
  ["Finland","Public / Semi-public","Waste Management","Equity",3,0.3608,"FI"],
  ["West Bank and Gaza","Public / Semi-public","Waste Management","Lending",2,0.2612,"PS"],
  ["Mali","Financial Service Provider","Waste Management","Equity",2,0.5464,"ML"],
  ["Haiti","Nonprofit","Circular Economy","Lending",1,0.5941,"HT"],
  ["Germany","Coworking Space","Waste Management","Equity",1,0.0489,"DE"],
  ["United States","Venture Capital","Circular Economy","Equity",3,1.1128,"US"],
  ["Morocco","Nonprofit","Waste Management","Lending",2,0.2611,"MA"],
  ["Hong Kong","Public / Semi-public","Circular Economy","Lending",2,0.3909,"HK"],
  ["Rwanda","Impact Investor","Circular Economy","Equity",3,2.0662,"RW"],
  ["Sweden","Nonprofit","Circular Economy","Equity",2,0.2787,"SE"],
  ["Japan","Public / Semi-public","Ocean Cleanup","Equity",6,0.9129,"JP"],
  ["Romania","Nonprofit","Circular Economy","Grant",2,0.887,"RO"],
  ["China","Foundation","Waste Management","Equity",1,0.1911,"CN"],
  ["Saudi Arabia","Incubator","Circular Economy","Equity",1,0.0828,"SA"],
  ["Australia","Impact Investor","Waste Management","Grant",2,0.2929,"AU"],
  ["Poland","Public / Semi-public","Ocean Cleanup","Equity",2,0.375,"PL"],
  ["Mauritania","Public / Semi-public","Waste Management","Lending",1,0.3609,"MR"],
  ["Lebanon","Nonprofit","Circular Economy","Grant",1,0.661,"LB"],
  ["Cyprus","Public / Semi-public","Waste Management","Equity",1,0.0887,"CY"],
  ["Cambodia","Financial Service Provider","Waste Management","Lending",1,0.3259,"KH"],
  ["Vietnam","Foundation","Waste Management","Grant",3,0.6258,"VN"],
  ["Costa Rica","Nonprofit","Ocean Cleanup","Grant",3,0.9024,"CR"],
  ["Sri Lanka","Bank","Ocean Cleanup","Lending",1,0.0274,"LK"],
  ["Nicaragua","Impact Investor","Waste Management","Lending",1,1.0,"NI"],
  ["Nicaragua","Financial Service Provider","Waste Management","Lending",1,0.3848,"NI"],
  ["Kuwait","Crowdfunding","Ocean Cleanup","Grant",1,0.0767,"KW"],
  ["Sudan","Foundation","Ocean Cleanup","Lending",1,0.1536,"SD"],
  ["Burundi","Bank","Ocean Cleanup","Lending",1,0.2383,"BI"],
  ["Gabon","Public / Semi-public","Circular Economy","Equity",1,0.4243,"GA"],
  ["Bangladesh","Impact Investor","Waste Management","Equity",5,1.3747,"BD"],
  ["Uganda","Impact Investor","Circular Economy","Equity",2,2.0,"UG"],
  ["Brazil","Foundation","Circular Economy","Grant",4,1.1,"BR"],
  ["Lebanon","Public / Semi-public","Waste Management","Grant",1,0.2662,"LB"],
  ["Italy","Impact Investor","Circular Economy","Lending",2,0.607,"IT"],
  ["Nepal","Impact Investor","Circular Economy","Lending",2,0.5047,"NP"],
  ["Mongolia","Public / Semi-public","Ocean Cleanup","Equity",1,0.4893,"MN"],
  ["Italy","Impact Investor","Ocean Cleanup","Equity",5,1.2325,"IT"],
  ["Bangladesh","Financial Service Provider","Circular Economy","Equity",1,0.3354,"BD"],
  ["Cambodia","Crowdfunding","Ocean Cleanup","Grant",1,0.0564,"KH"],
  ["Jordan","Bank","Circular Economy","Lending",1,0.1707,"JO"],
  ["Singapore","Crowdfunding","Ocean Cleanup","Grant",1,0.2107,"SG"],
  ["Denmark","Nonprofit","Circular Economy","Lending",1,0.1324,"DK"],
  ["Vietnam","Nonprofit","Waste Management","Lending",1,0.3319,"VN"],
  ["Nigeria","Competitions","Waste Management","Grant",1,0.198,"NG"],
  ["Iran","Venture Capital","Circular Economy","Equity",1,1.0,"IR"],
  ["Philippines","Nonprofit","Circular Economy","Lending",1,0.1309,"PH"],
  ["Ethiopia","Foundation","Circular Economy","Equity",1,0.2045,"ET"],
  ["Indonesia","Foundation","Ocean Cleanup","Grant",5,1.4778,"ID"],
  ["Oman","Public / Semi-public","Waste Management","Lending",1,0.2405,"OM"],
  ["Indonesia","Bank","Waste Management","Lending",2,0.4143,"ID"],
  ["Italy","Public / Semi-public","Waste Management","Lending",8,2.3061,"IT"],
  ["Haiti","Venture Capital","Circular Economy","Equity",1,1.0,"HT"],
  ["Italy","Foundation","Waste Management","Equity",2,0.3556,"IT"],
  ["Germany","Incubator","Waste Management","Lending",1,0.1844,"DE"],
  ["Kenya","Incubator","Waste Management","Grant",1,1.0,"KE"],
  ["Cyprus","Bank","Circular Economy","Lending",2,0.7052,"CY"],
  ["Philippines","Microfinance Institution","Waste Management","Lending",1,1.0,"PH"],
  ["Switzerland","Impact Investor","Ocean Cleanup","Equity",2,0.4351,"CH"],
  ["Australia","Crowdfunding","Ocean Cleanup","Equity",1,0.3309,"AU"],
  ["Pakistan","Financial Service Provider","Circular Economy","Lending",2,0.2876,"PK"],
  ["Zimbabwe","Financial Service Provider","Waste Management","Equity",4,0.604,"ZW"],
  ["France","Crowdfunding","Ocean Cleanup","Grant",1,0.117,"FR"],
  ["Philippines","Venture Capital","Circular Economy","Equity",2,1.0243,"PH"],
  ["Israel","Impact Investor","Ocean Cleanup","Lending",1,0.0674,"IL"],
  ["Algeria","Financial Service Provider","Circular Economy","Lending",1,0.0794,"DZ"],
  ["Indonesia","Public / Semi-public","Ocean Cleanup","Lending",7,2.3194,"ID"],
  ["France","Impact Investor","Circular Economy","Lending",2,0.7102,"FR"],
  ["Australia","Foundation","Circular Economy","Lending",1,0.1891,"AU"],
  ["Tanzania","Nonprofit","Ocean Cleanup","Lending",3,0.6031,"TZ"],
  ["Romania","Incubator","Waste Management","Grant",1,0.0612,"RO"],
  ["Belgium","Impact Investor","Waste Management","Lending",4,0.9016,"BE"],
  ["Pakistan","Microfinance Institution","Waste Management","Lending",1,0.026,"PK"],
  ["Yemen","Public / Semi-public","Circular Economy","Equity",1,0.1153,"YE"],
  ["Brazil","Impact Investor","Circular Economy","Equity",3,0.7498,"BR"],
  ["Kenya","Public / Semi-public","Ocean Cleanup","Lending",9,2.9111,"KE"],
  ["Indonesia","Incubator","Waste Management","Grant",1,0.0615,"ID"],
  ["Canada","Competitions","Ocean Cleanup","Grant",1,0.2484,"CA"],
  ["Denmark","Incubator","Circular Economy","Grant",1,0.1795,"DK"],
  ["France","Public / Semi-public","Waste Management","Grant",5,1.7486,"FR"],
  ["New Zealand","Financial Service Provider","Waste Management","Lending",1,0.0951,"NZ"],
  ["Montenegro","Venture Capital","Ocean Cleanup","Equity",1,1.0,"ME"],
  ["South Korea","Competitions","Ocean Cleanup","Grant",1,0.2503,"KR"],
  ["Hong Kong","Nonprofit","Ocean Cleanup","Grant",1,0.1032,"HK"],
  ["Bolivia","Public / Semi-public","Ocean Cleanup","Lending",1,0.2467,"BO"],
  ["Russia","Financial Service Provider","Waste Management","Equity",1,0.0396,"RU"],
  ["Madagascar","Public / Semi-public","Ocean Cleanup","Lending",3,1.9678,"MG"],
  ["Ukraine","Financial Service Provider","Waste Management","Lending",1,0.2134,"UA"],
  ["Kuwait","Venture Capital","Ocean Cleanup","Equity",1,1.0,"KW"],
  ["Spain","Financial Service Provider","Circular Economy","Lending",1,0.1714,"ES"],
  ["India","Public / Semi-public","Ocean Cleanup","Grant",9,2.4522,"IN"],
  ["Bangladesh","Public / Semi-public","Ocean Cleanup","Equity",8,2.4119,"BD"],
  ["Vietnam","Incubator","Circular Economy","Equity",1,0.0839,"VN"],
  ["Brunei","Crowdfunding","Ocean Cleanup","Equity",1,0.2407,"BN"],
  ["Bangladesh","Incubator","Waste Management","Lending",1,0.1501,"BD"],
  ["Turkey","Impact Investor","Ocean Cleanup","Grant",2,0.3918,"TR"],
  ["Kenya","Bank","Circular Economy","Lending",4,1.9652,"KE"],
  ["Cyprus","Nonprofit","Ocean Cleanup","Lending",1,0.107,"CY"],
  ["Fiji","Public / Semi-public","Ocean Cleanup","Equity",1,0.5692,"FJ"],
  ["Jamaica","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"JM"],
  ["Honduras","Bank","Waste Management","Lending",1,0.1958,"HN"],
  ["Tanzania","Foundation","Circular Economy","Equity",1,0.2557,"TZ"],
  ["Cameroon","Financial Service Provider","Waste Management","Equity",2,0.4764,"CM"],
  ["Cameroon","Impact Investor","Circular Economy","Equity",1,0.0304,"CM"],
  ["Indonesia","Incubator","Circular Economy","Equity",1,0.0911,"ID"],
  ["Laos","Public / Semi-public","Circular Economy","Equity",1,0.4599,"LA"],
  ["Israel","Nonprofit","Waste Management","Grant",2,0.2701,"IL"],
  ["Guyana","Impact Investor","Waste Management","Equity",1,0.9789,"GY"],
  ["Spain","Crowdfunding","Ocean Cleanup","Grant",1,0.1161,"ES"],
  ["Botswana","Financial Service Provider","Waste Management","Grant",1,0.1565,"BW"],
  ["Iran","Foundation","Circular Economy","Grant",2,0.6715,"IR"],
  ["United Kingdom","Financial Service Provider","Waste Management","Grant",2,1.1789,"GB"],
  ["United Arab Emirates","Incubator","Ocean Cleanup","Lending",1,0.1289,"AE"],
  ["Isle of Man","Venture Capital","Circular Economy","Equity",1,1.0,"IM"],
  ["Somalia","Foundation","Ocean Cleanup","Equity",1,0.2496,"SO"],
  ["Nigeria","Bank","Circular Economy","Equity",2,0.3377,"NG"],
  ["Greece","Foundation","Waste Management","Equity",1,0.1497,"GR"],
  ["Nepal","Impact Investor","Circular Economy","Grant",1,0.06,"NP"],
  ["Ecuador","Public / Semi-public","Ocean Cleanup","Equity",1,0.0341,"EC"],
  ["Morocco","Foundation","Circular Economy","Grant",1,0.2998,"MA"],
  ["Saudi Arabia","Crowdfunding","Ocean Cleanup","Grant",1,0.1428,"SA"],
  ["United States","Foundation","Waste Management","Equity",2,1.2322,"US"],
  ["Nepal","Public / Semi-public","Circular Economy","Grant",4,1.172,"NP"],
  ["Italy","Financial Service Provider","Waste Management","Lending",2,0.2919,"IT"],
  ["Germany","Nonprofit","Ocean Cleanup","Lending",6,1.8413,"DE"],
  ["Georgia","Bank","Ocean Cleanup","Equity",1,0.3414,"GE"],
  ["Nepal","Nonprofit","Ocean Cleanup","Lending",6,1.6985,"NP"],
  ["Mozambique","Public / Semi-public","Waste Management","Equity",1,0.4,"MZ"],
  ["South Africa","Incubator","Waste Management","Equity",3,0.5284,"ZA"],
  ["Cambodia","Nonprofit","Circular Economy","Equity",1,0.0658,"KH"],
  ["United Kingdom","Public / Semi-public","Circular Economy","Grant",6,1.9752,"GB"],
  ["Kazakhstan","Foundation","Ocean Cleanup","Grant",1,0.8492,"KZ"],
  ["Canada","Incubator","Circular Economy","Grant",1,0.1497,"CA"],
  ["Mozambique","Nonprofit","Ocean Cleanup","Grant",1,0.4613,"MZ"],
  ["Pakistan","Venture Capital","Waste Management","Equity",1,0.0499,"PK"],
  ["Singapore","Venture Capital","Waste Management","Equity",1,0.0486,"SG"],
  ["Belgium","Bank","Circular Economy","Lending",2,0.3399,"BE"],
  ["Pakistan","Foundation","Ocean Cleanup","Lending",2,0.291,"PK"],
  ["Canada","Impact Investor","Circular Economy","Equity",3,0.8027,"CA"],
  ["Belgium","Incubator","Ocean Cleanup","Lending",1,0.1513,"BE"],
  ["South Korea","Nonprofit","Waste Management","Lending",2,0.2789,"KR"],
  ["Thailand","Financial Service Provider","Waste Management","Grant",1,0.1209,"TH"],
  ["Portugal","Financial Service Provider","Waste Management","Lending",1,0.3393,"PT"],
  ["Croatia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"HR"],
  ["France","Foundation","Waste Management","Lending",2,0.3481,"FR"],
  ["United Arab Emirates","Foundation","Waste Management","Equity",2,0.3681,"AE"],
  ["Vietnam","Venture Capital","Circular Economy","Equity",2,1.0487,"VN"],
  ["Brazil","Public / Semi-public","Waste Management","Grant",6,1.4511,"BR"],
  ["Philippines","Nonprofit","Waste Management","Grant",3,0.9644,"PH"],
  ["Eritrea","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"ER"],
  ["Angola","Foundation","Waste Management","Equity",2,0.4394,"AO"],
  ["South Korea","Impact Investor","Waste Management","Lending",2,0.397,"KR"],
  ["Malawi","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"MW"],
  ["Cyprus","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CY"],
  ["Kenya","Financial Service Provider","Ocean Cleanup","Equity",2,0.5085,"KE"],
  ["Romania","Nonprofit","Ocean Cleanup","Grant",4,1.2697,"RO"],
  ["Denmark","Financial Service Provider","Waste Management","Grant",2,0.1252,"DK"],
  ["Philippines","Foundation","Circular Economy","Equity",1,0.1217,"PH"],
  ["Libya","Public / Semi-public","Ocean Cleanup","Lending",2,1.2347,"LY"],
  ["Jamaica","Impact Investor","Waste Management","Equity",1,0.8863,"JM"],
  ["Yemen","Public / Semi-public","Ocean Cleanup","Grant",1,0.2452,"YE"],
  ["Denmark","Impact Investor","Circular Economy","Equity",1,0.1324,"DK"],
  ["Zambia","Nonprofit","Ocean Cleanup","Equity",2,0.8776,"ZM"],
  ["Senegal","Public / Semi-public","Waste Management","Grant",1,0.3764,"SN"],
  ["Zimbabwe","Public / Semi-public","Ocean Cleanup","Equity",5,1.6198,"ZW"],
  ["Papua New Guinea","Public / Semi-public","Circular Economy","Lending",1,0.4001,"PG"],
  ["Turks and Caicos Islands","Public / Semi-public","Circular Economy","Equity",1,0.7953,"TC"],
  ["Angola","Incubator","Waste Management","Equity",1,0.3036,"AO"],
  ["Singapore","Impact Investor","Circular Economy","Equity",4,0.3588,"SG"],
  ["Pakistan","Impact Investor","Ocean Cleanup","Lending",3,0.5142,"PK"],
  ["Chad","Nonprofit","Waste Management","Lending",1,0.1916,"TD"],
  ["Cyprus","Bank","Ocean Cleanup","Equity",1,0.4329,"CY"],
  ["Tanzania","Incubator","Waste Management","Grant",1,0.1468,"TZ"],
  ["India","Bank","Waste Management","Equity",1,0.2307,"IN"],
  ["Philippines","Nonprofit","Waste Management","Lending",2,1.1309,"PH"],
  ["Brazil","Incubator","Ocean Cleanup","Equity",1,0.166,"BR"],
  ["Bangladesh","Incubator","Circular Economy","Equity",1,0.1162,"BD"],
  ["Thailand","Financial Service Provider","Circular Economy","Lending",2,1.1064,"TH"],
  ["Congo, Rep.","Public / Semi-public","Waste Management","Grant",1,0.4715,"CG"],
  ["United Kingdom","Foundation","Circular Economy","Equity",1,0.2005,"GB"],
  ["Ecuador","Public / Semi-public","Ocean Cleanup","Grant",1,0.1211,"EC"],
  ["Afghanistan","Crowdfunding","Waste Management","Lending",1,0.0344,"AF"],
  ["Hungary","Venture Capital","Circular Economy","Equity",1,1.0,"HU"],
  ["Ghana","Financial Service Provider","Ocean Cleanup","Lending",1,0.3561,"GH"],
  ["Dominican Republic","Venture Capital","Circular Economy","Equity",1,1.0,"DO"],
  ["South Korea","Financial Service Provider","Waste Management","Lending",1,0.1092,"KR"],
  ["Kyrgyz Republic","Foundation","Ocean Cleanup","Grant",2,2.0,"KG"],
  ["Canada","Foundation","Circular Economy","Lending",1,0.1729,"CA"],
  ["Netherlands","Financial Service Provider","Ocean Cleanup","Equity",1,1.0,"NL"],
  ["Pakistan","Foundation","Circular Economy","Lending",1,0.1539,"PK"],
  ["Bhutan","Foundation","Waste Management","Grant",1,0.6099,"BT"],
  ["Hungary","Crowdfunding","Waste Management","Lending",1,0.0404,"HU"],
  ["Mali","Nonprofit","Waste Management","Equity",2,0.5464,"ML"],
  ["Rwanda","Public / Semi-public","Ocean Cleanup","Lending",4,1.9634,"RW"],
  ["Saudi Arabia","Impact Investor","Waste Management","Lending",3,0.4059,"SA"],
  ["Malaysia","Public / Semi-public","Ocean Cleanup","Equity",6,1.4587,"MY"],
  ["Spain","Public / Semi-public","Ocean Cleanup","Equity",9,3.2442,"ES"],
  ["Sweden","Public / Semi-public","Ocean Cleanup","Equity",5,1.5491,"SE"],
  ["Slovakia","Public / Semi-public","Ocean Cleanup","Lending",1,0.0694,"SK"],
  ["Philippines","Financial Service Provider","Circular Economy","Lending",2,0.8023,"PH"],
  ["Pakistan","Foundation","Ocean Cleanup","Grant",5,1.9284,"PK"],
  ["Czech Republic","Venture Capital","Circular Economy","Equity",1,1.0,"CZ"],
  ["Philippines","Incubator","Waste Management","Grant",1,0.0549,"PH"],
  ["Guam","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GU"],
  ["Latvia","Venture Capital","Circular Economy","Equity",1,1.0,"LV"],
  ["Tonga","Venture Capital","Circular Economy","Equity",1,1.0,"TO"],
  ["Indonesia","Public / Semi-public","Ocean Cleanup","Grant",8,2.2794,"ID"],
  ["Argentina","Nonprofit","Circular Economy","Grant",2,1.0854,"AR"],
  ["Tristan da Cunha","Venture Capital","Circular Economy","Equity",1,1.0,"TA"],
  ["Equatorial Guinea","Financial Service Provider","Circular Economy","Equity",1,0.0649,"GQ"],
  ["Hong Kong","Incubator","Circular Economy","Equity",1,0.1343,"HK"],
  ["Denmark","Public / Semi-public","Waste Management","Lending",3,0.295,"DK"],
  ["Philippines","Competitions","Ocean Cleanup","Grant",1,0.3468,"PH"],
  ["Indonesia","Nonprofit","Circular Economy","Lending",2,0.2109,"ID"],
  ["Bangladesh","Public / Semi-public","Ocean Cleanup","Grant",8,2.2824,"BD"],
  ["Saudi Arabia","Foundation","Ocean Cleanup","Grant",4,1.1145,"SA"],
  ["Sweden","Financial Service Provider","Waste Management","Lending",2,0.192,"SE"],
  ["Spain","Impact Investor","Ocean Cleanup","Grant",2,0.429,"ES"],
  ["Thailand","Financial Service Provider","Waste Management","Lending",1,0.1064,"TH"],
  ["Israel","Bank","Ocean Cleanup","Equity",1,0.3428,"IL"],
  ["Cameroon","Impact Investor","Ocean Cleanup","Equity",1,0.0304,"CM"],
  ["Portugal","Financial Service Provider","Circular Economy","Lending",1,0.3393,"PT"],
  ["Turkey","Impact Investor","Ocean Cleanup","Lending",3,0.543,"TR"],
  ["Brazil","Nonprofit","Ocean Cleanup","Grant",8,2.2699,"BR"],
  ["Jordan","Impact Investor","Waste Management","Grant",1,0.0627,"JO"],
  ["Benin","Impact Investor","Ocean Cleanup","Grant",1,0.3631,"BJ"],
  ["Russia","Incubator","Waste Management","Equity",2,0.3063,"RU"],
  ["Ethiopia","Public / Semi-public","Circular Economy","Grant",4,0.6085,"ET"],
  ["Japan","Foundation","Waste Management","Grant",1,0.0592,"JP"],
  ["Ghana","Nonprofit","Waste Management","Grant",1,0.4435,"GH"],
  ["United States","Nonprofit","Circular Economy","Grant",5,2.6963,"US"],
  ["Bhutan","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BT"],
  ["Kenya","Nonprofit","Waste Management","Lending",5,1.2459,"KE"],
  ["Belgium","Financial Service Provider","Waste Management","Lending",3,0.4302,"BE"],
  ["Qatar","Venture Capital","Circular Economy","Equity",2,1.0478,"QA"],
  ["United States","Impact Investor","Circular Economy","Grant",1,0.1326,"US"],
  ["Norway","Public / Semi-public","Waste Management","Lending",1,0.1992,"NO"],
  ["Taiwan","Public / Semi-public","Circular Economy","Equity",1,0.2658,"TW"],
  ["Hong Kong","Venture Capital","Ocean Cleanup","Equity",1,1.0,"HK"],
  ["Jordan","Foundation","Ocean Cleanup","Equity",1,0.143,"JO"],
  ["Tanzania","Incubator","Waste Management","Equity",1,0.4594,"TZ"],
  ["Nepal","Bank","Circular Economy","Lending",1,0.11,"NP"],
  ["Norway","Venture Capital","Circular Economy","Equity",1,1.0,"NO"],
  ["Peru","Financial Service Provider","Circular Economy","Equity",2,0.0723,"PE"],
  ["Tanzania","Impact Investor","Waste Management","Equity",4,1.5468,"TZ"],
  ["Slovakia","Public / Semi-public","Waste Management","Lending",1,0.0694,"SK"],
  ["Qatar","Venture Capital","Ocean Cleanup","Equity",1,1.0,"QA"],
  ["Afghanistan","Impact Investor","Waste Management","Equity",1,0.0588,"AF"],
  ["Italy","Incubator","Circular Economy","Grant",1,0.2127,"IT"],
  ["Chile","Impact Investor","Circular Economy","Lending",1,0.1561,"CL"],
  ["Chad","Venture Capital","Circular Economy","Equity",1,1.0,"TD"],
  ["Myanmar","Bank","Ocean Cleanup","Equity",2,0.2476,"MM"],
  ["China","Bank","Circular Economy","Equity",2,0.9287,"CN"],
  ["Kyrgyz Republic","Public / Semi-public","Waste Management","Equity",2,0.215,"KG"],
  ["Costa Rica","Foundation","Ocean Cleanup","Grant",2,0.5037,"CR"],
  ["Uzbekistan","Bank","Ocean Cleanup","Lending",1,0.3086,"UZ"],
  ["Japan","Nonprofit","Waste Management","Grant",2,0.605,"JP"],
  ["Bangladesh","Nonprofit","Ocean Cleanup","Lending",6,2.4742,"BD"],
  ["United Kingdom","Nonprofit","Waste Management","Lending",5,0.6433,"GB"],
  ["Netherlands","Public / Semi-public","Circular Economy","Lending",3,0.4805,"NL"],
  ["South Sudan","Foundation","Waste Management","Grant",1,0.3356,"SS"],
  ["Austria","Incubator","Circular Economy","Grant",1,0.1804,"AT"],
  ["Gabon","Financial Service Provider","Waste Management","Lending",1,0.177,"GA"],
  ["Timor-Leste","Venture Capital","Circular Economy","Equity",1,1.0,"TL"],
  ["Guatemala","Public / Semi-public","Waste Management","Equity",2,1.1877,"GT"],
  ["South Africa","Bank","Ocean Cleanup","Lending",5,1.4043,"ZA"],
  ["Romania","Incubator","Ocean Cleanup","Lending",1,0.14,"RO"],
  ["Nigeria","Incubator","Waste Management","Grant",1,0.0755,"NG"],
  ["Taiwan","Competitions","Waste Management","Grant",1,0.2104,"TW"],
  ["France","Nonprofit","Waste Management","Equity",4,1.0441,"FR"],
  ["Saudi Arabia","Impact Investor","Waste Management","Grant",2,0.1871,"SA"],
  ["Papua New Guinea","Public / Semi-public","Ocean Cleanup","Lending",1,0.4001,"PG"],
  ["Uganda","Venture Capital","Waste Management","Equity",1,0.0459,"UG"],
  ["Belgium","Bank","Waste Management","Equity",1,0.1255,"BE"],
  ["Ireland","Incubator","Waste Management","Lending",1,0.1463,"IE"],
  ["Tanzania","Foundation","Ocean Cleanup","Equity",2,0.7151,"TZ"],
  ["Bangladesh","Financial Service Provider","Ocean Cleanup","Lending",1,0.3696,"BD"],
  ["Madagascar","Public / Semi-public","Waste Management","Lending",2,0.9678,"MG"],
  ["Rwanda","Impact Investor","Waste Management","Equity",1,1.0,"RW"],
  ["Portugal","Bank","Ocean Cleanup","Lending",1,0.4614,"PT"],
  ["Libya","Bank","Circular Economy","Lending",1,0.1873,"LY"],
  ["West Bank and Gaza","Public / Semi-public","Ocean Cleanup","Equity",2,0.9396,"PS"],
  ["Russia","Bank","Circular Economy","Lending",1,0.2354,"RU"],
  ["Tanzania","Nonprofit","Circular Economy","Grant",2,0.245,"TZ"],
  ["Zimbabwe","Foundation","Circular Economy","Equity",1,0.1598,"ZW"],
  ["Morocco","Financial Service Provider","Ocean Cleanup","Equity",1,0.0783,"MA"],
  ["French Polynesia","Venture Capital","Circular Economy","Equity",1,1.0,"PF"],
  ["United States","Coworking Space","Waste Management","Equity",1,0.0916,"US"],
  ["Japan","Incubator","Waste Management","Lending",1,0.184,"JP"],
  ["South Korea","Financial Service Provider","Waste Management","Grant",1,0.0609,"KR"],
  ["Italy","Bank","Circular Economy","Lending",3,0.4914,"IT"],
  ["Russia","Public / Semi-public","Ocean Cleanup","Lending",2,0.6298,"RU"],
  ["Spain","Public / Semi-public","Ocean Cleanup","Lending",6,1.2357,"ES"],
  ["Italy","Impact Investor","Waste Management","Equity",4,1.208,"IT"],
  ["Germany","Public / Semi-public","Ocean Cleanup","Equity",13,4.4877,"DE"],
  ["Taiwan","Public / Semi-public","Ocean Cleanup","Lending",2,0.5176,"TW"],
  ["United Arab Emirates","Venture Capital","Ocean Cleanup","Equity",1,1.0,"AE"],
  ["Benin","Public / Semi-public","Waste Management","Equity",4,0.7895,"BJ"],
  ["St. Lucia","Public / Semi-public","Waste Management","Equity",1,1.0,"LC"],
  ["South Africa","Impact Investor","Waste Management","Grant",3,0.3726,"ZA"],
  ["Romania","Incubator","Ocean Cleanup","Equity",1,0.14,"RO"],
  ["Germany","Financial Service Provider","Waste Management","Lending",3,0.5012,"DE"],
  ["Côte d'Ivoire","Public / Semi-public","Ocean Cleanup","Lending",3,1.4917,"CI"],
  ["Mexico","Nonprofit","Circular Economy","Lending",1,0.225,"MX"],
  ["Switzerland","Impact Investor","Ocean Cleanup","Lending",2,0.4351,"CH"],
  ["Vietnam","Public / Semi-public","Ocean Cleanup","Lending",7,1.7376,"VN"],
  ["Thailand","Foundation","Waste Management","Grant",4,0.8172,"TH"],
  ["India","Incubator","Ocean Cleanup","Equity",1,0.19,"IN"],
  ["Saudi Arabia","Incubator","Ocean Cleanup","Equity",1,0.1242,"SA"],
  ["Israel","Public / Semi-public","Circular Economy","Grant",1,0.0788,"IL"],
  ["Saudi Arabia","Impact Investor","Ocean Cleanup","Grant",3,0.4999,"SA"],
  ["Mauritius","Public / Semi-public","Ocean Cleanup","Lending",2,1.0329,"MU"],
  ["Romania","Public / Semi-public","Ocean Cleanup","Equity",4,0.6821,"RO"],
  ["Angola","Foundation","Ocean Cleanup","Lending",2,0.4394,"AO"],
  ["Kenya","Microfinance Institution","Waste Management","Lending",1,0.0266,"KE"],
  ["India","Financial Service Provider","Waste Management","Equity",4,0.677,"IN"],
  ["Bahamas, The","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"BS"],
  ["Tunisia","Nonprofit","Ocean Cleanup","Equity",2,0.7513,"TN"],
  ["Botswana","Bank","Circular Economy","Equity",1,0.2875,"BW"],
  ["Taiwan","Nonprofit","Circular Economy","Lending",1,0.0662,"TW"],
  ["Uganda","Impact Investor","Circular Economy","Lending",1,1.0,"UG"],
  ["Argentina","Impact Investor","Ocean Cleanup","Lending",3,0.4045,"AR"],
  ["Tanzania","Nonprofit","Circular Economy","Lending",1,0.0598,"TZ"],
  ["Rwanda","Nonprofit","Waste Management","Equity",2,0.7087,"RW"],
  ["Madagascar","Impact Investor","Waste Management","Grant",1,0.0696,"MG"],
  ["Nicaragua","Venture Capital","Ocean Cleanup","Equity",1,1.0,"NI"],
  ["Vietnam","Incubator","Waste Management","Lending",1,0.1286,"VN"],
  ["Morocco","Public / Semi-public","Circular Economy","Grant",2,0.5539,"MA"],
  ["Botswana","Public / Semi-public","Waste Management","Grant",3,0.2133,"BW"],
  ["Malaysia","Coworking Space","Waste Management","Equity",1,0.2409,"MY"],
  ["Kuwait","Nonprofit","Waste Management","Grant",1,0.2124,"KW"],
  ["Ethiopia","Competitions","Waste Management","Grant",1,0.3822,"ET"],
  ["Myanmar","Nonprofit","Ocean Cleanup","Grant",4,1.0021,"MM"],
  ["Niger","Nonprofit","Ocean Cleanup","Equity",1,0.2378,"NE"],
  ["Brazil","Incubator","Ocean Cleanup","Grant",1,0.0549,"BR"],
  ["South Sudan","Impact Investor","Waste Management","Grant",1,0.1369,"SS"],
  ["Zimbabwe","Public / Semi-public","Waste Management","Lending",4,1.2787,"ZW"],
  ["Sweden","Foundation","Circular Economy","Grant",2,0.6604,"SE"],
  ["Ghana","Public / Semi-public","Circular Economy","Lending",3,0.5056,"GH"],
  ["Netherlands","Public / Semi-public","Ocean Cleanup","Grant",5,1.6565,"NL"],
  ["Congo, Dem. Rep","Public / Semi-public","Waste Management","Grant",2,0.4349,"CD"],
  ["Lesotho","Bank","Circular Economy","Lending",1,0.2004,"LS"],
  ["Thailand","Venture Capital","Waste Management","Equity",1,0.0388,"TH"],
  ["Sudan","Foundation","Circular Economy","Grant",1,0.1536,"SD"],
  ["Mexico","Bank","Ocean Cleanup","Equity",1,0.108,"MX"],
  ["Guyana","Impact Investor","Waste Management","Lending",1,0.9789,"GY"],
  ["South Africa","Public / Semi-public","Ocean Cleanup","Lending",6,1.5593,"ZA"],
  ["Bhutan","Public / Semi-public","Circular Economy","Lending",1,0.4851,"BT"],
  ["Reunion","Public / Semi-public","Waste Management","Grant",1,0.4382,"RE"],
  ["Nepal","Financial Service Provider","Ocean Cleanup","Equity",2,0.5843,"NP"],
  ["Central African Republic","Public / Semi-public","Circular Economy","Lending",1,0.1834,"CF"],
  ["Bahrain","Foundation","Circular Economy","Lending",1,0.1767,"BH"],
  ["Kuwait","Incubator","Waste Management","Equity",1,0.2247,"KW"],
  ["Kuwait","Nonprofit","Waste Management","Lending",1,0.0319,"KW"],
  ["Argentina","Financial Service Provider","Circular Economy","Lending",1,0.1092,"AR"],
  ["United Kingdom","Financial Service Provider","Circular Economy","Lending",2,0.215,"GB"],
  ["Somalia","Incubator","Ocean Cleanup","Grant",1,0.1256,"SO"],
  ["Turkey","Foundation","Waste Management","Equity",1,0.1285,"TR"],
  ["Netherlands","Coworking Space","Waste Management","Lending",1,0.0483,"NL"],
  ["Netherlands","Public / Semi-public","Waste Management","Equity",7,2.7647,"NL"],
  ["Mexico","Financial Service Provider","Ocean Cleanup","Equity",1,0.0867,"MX"],
  ["Argentina","Public / Semi-public","Circular Economy","Grant",2,0.3351,"AR"],
  ["Congo, Rep.","Impact Investor","Circular Economy","Equity",1,1.0,"CG"],
  ["Portugal","Venture Capital","Waste Management","Equity",1,0.0306,"PT"],
  ["Nigeria","Bank","Ocean Cleanup","Equity",1,0.1225,"NG"],
  ["Taiwan","Public / Semi-public","Waste Management","Grant",2,0.405,"TW"],
  ["Antigua and Barbuda","Public / Semi-public","Circular Economy","Equity",1,0.4639,"AG"],
  ["Cameroon","Incubator","Ocean Cleanup","Grant",1,0.0596,"CM"],
  ["Panama","Public / Semi-public","Waste Management","Lending",1,0.9208,"PA"],
  ["Germany","Nonprofit","Waste Management","Grant",5,1.1976,"DE"],
  ["South Korea","Financial Service Provider","Ocean Cleanup","Equity",2,0.1408,"KR"],
  ["Austria","Public / Semi-public","Ocean Cleanup","Equity",3,1.2705,"AT"],
  ["Ireland","Nonprofit","Circular Economy","Equity",1,0.0953,"IE"],
  ["Nigeria","Financial Service Provider","Ocean Cleanup","Lending",1,0.1094,"NG"],
  ["Sudan","Venture Capital","Circular Economy","Equity",1,1.0,"SD"],
  ["Kuwait","Bank","Circular Economy","Lending",1,0.3238,"KW"],
  ["Ghana","Incubator","Circular Economy","Grant",1,0.3974,"GH"],
  ["Angola","Financial Service Provider","Waste Management","Grant",1,0.1024,"AO"],
  ["Singapore","Financial Service Provider","Waste Management","Equity",1,0.0522,"SG"],
  ["Zimbabwe","Foundation","Waste Management","Lending",2,0.3427,"ZW"],
  ["Suriname","Impact Investor","Waste Management","Equity",1,1.0,"SR"],
  ["Germany","Nonprofit","Ocean Cleanup","Equity",5,1.4847,"DE"],
  ["Kuwait","Foundation","Ocean Cleanup","Grant",1,0.1662,"KW"],
  ["Costa Rica","Bank","Waste Management","Lending",1,0.1133,"CR"],
  ["Fiji","Public / Semi-public","Circular Economy","Equity",1,0.5692,"FJ"],
  ["Russia","Financial Service Provider","Ocean Cleanup","Equity",1,0.0396,"RU"],
  ["Bulgaria","Bank","Ocean Cleanup","Lending",1,0.2798,"BG"],
  ["Senegal","Financial Service Provider","Waste Management","Lending",1,1.0,"SN"],
  ["Myanmar","Nonprofit","Circular Economy","Lending",1,0.207,"MM"],
  ["Spain","Public / Semi-public","Ocean Cleanup","Grant",7,1.4725,"ES"],
  ["Switzerland","Nonprofit","Ocean Cleanup","Grant",6,2.0479,"CH"],
  ["United States","Public / Semi-public","Ocean Cleanup","Equity",13,4.1269,"US"],
  ["Pakistan","Crowdfunding","Ocean Cleanup","Equity",1,0.0795,"PK"],
  ["Canada","Foundation","Ocean Cleanup","Grant",5,1.7953,"CA"],
  ["Qatar","Bank","Ocean Cleanup","Equity",1,0.2712,"QA"],
  ["United States","Bank","Waste Management","Equity",1,0.16,"US"],
  ["India","Public / Semi-public","Waste Management","Grant",7,1.4366,"IN"],
  ["Malawi","Foundation","Waste Management","Equity",1,0.2661,"MW"],
  ["Nigeria","Incubator","Circular Economy","Grant",1,0.0932,"NG"],
  ["Denmark","Public / Semi-public","Circular Economy","Lending",4,0.5036,"DK"],
  ["Colombia","Incubator","Circular Economy","Grant",1,0.1716,"CO"],
  ["Indonesia","Nonprofit","Circular Economy","Equity",2,0.2109,"ID"],
  ["Cambodia","Public / Semi-public","Ocean Cleanup","Lending",7,1.6716,"KH"],
  ["Romania","Foundation","Ocean Cleanup","Equity",1,0.14,"RO"],
  ["Uganda","Incubator","Waste Management","Grant",1,0.1325,"UG"],
  ["Oman","Foundation","Circular Economy","Grant",2,0.3943,"OM"],
  ["Iraq","Public / Semi-public","Waste Management","Equity",5,1.8485,"IQ"],
  ["Taiwan","Impact Investor","Circular Economy","Equity",1,0.0662,"TW"],
  ["Peru","Venture Capital","Circular Economy","Equity",2,1.0445,"PE"],
  ["Syria","Nonprofit","Ocean Cleanup","Grant",1,0.759,"SY"],
  ["Canada","Incubator","Waste Management","Grant",1,0.0605,"CA"],
  ["Colombia","Impact Investor","Waste Management","Grant",2,0.1915,"CO"],
  ["Tanzania","Incubator","Waste Management","Lending",1,0.4594,"TZ"],
  ["Nicaragua","Venture Capital","Circular Economy","Equity",1,1.0,"NI"],
  ["Mauritius","Venture Capital","Waste Management","Equity",1,0.0297,"MU"],
  ["Nigeria","Nonprofit","Waste Management","Equity",4,0.4749,"NG"],
  ["Bahrain","Competitions","Waste Management","Grant",1,0.2715,"BH"],
  ["Australia","Public / Semi-public","Ocean Cleanup","Grant",6,1.5674,"AU"],
  ["Georgia","Public / Semi-public","Waste Management","Equity",2,0.9868,"GE"],
  ["Cameroon","Foundation","Waste Management","Grant",2,0.5307,"CM"],
  ["Sweden","Public / Semi-public","Ocean Cleanup","Grant",1,1.0,"SE"],
  ["United Arab Emirates","Impact Investor","Waste Management","Equity",4,0.466,"AE"],
  ["Switzerland","Impact Investor","Waste Management","Equity",3,0.8397,"CH"],
  ["Belgium","Financial Service Provider","Ocean Cleanup","Equity",1,0.1033,"BE"],
  ["Canada","Impact Investor","Ocean Cleanup","Equity",5,1.5334,"CA"],
  ["Hong Kong","Incubator","Circular Economy","Grant",1,0.1315,"HK"],
  ["Germany","Venture Capital","Circular Economy","Equity",2,1.0295,"DE"],
  ["Sweden","Public / Semi-public","Waste Management","Equity",5,1.5491,"SE"],
  ["Saudi Arabia","Bank","Ocean Cleanup","Equity",2,0.6496,"SA"],
  ["Paraguay","Foundation","Circular Economy","Grant",1,0.5065,"PY"],
  ["Turkey","Impact Investor","Circular Economy","Lending",2,0.4145,"TR"],
  ["Sweden","Nonprofit","Waste Management","Grant",2,0.7188,"SE"],
  ["Norway","Bank","Ocean Cleanup","Lending",1,0.1145,"NO"],
  ["Kenya","Venture Capital","Ocean Cleanup","Grant",1,1.0,"KE"],
  ["France","Impact Investor","Waste Management","Grant",3,0.4682,"FR"],
  ["Argentina","Nonprofit","Circular Economy","Lending",2,0.2498,"AR"],
  ["Algeria","Nonprofit","Ocean Cleanup","Equity",2,0.2584,"DZ"],
  ["United States","Incubator","Circular Economy","Equity",2,1.2232,"US"],
  ["Spain","Nonprofit","Circular Economy","Grant",4,1.1912,"ES"],
  ["Ukraine","Impact Investor","Ocean Cleanup","Lending",1,0.1787,"UA"],
  ["Botswana","Nonprofit","Waste Management","Lending",1,0.1563,"BW"],
  ["Laos","Nonprofit","Waste Management","Lending",1,0.3935,"LA"],
  ["Chad","Nonprofit","Waste Management","Equity",1,0.1916,"TD"],
  ["Ghana","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GH"],
  ["South Africa","Public / Semi-public","Waste Management","Equity",6,0.9286,"ZA"],
  ["South Africa","Foundation","Circular Economy","Equity",1,0.2019,"ZA"],
  ["Canada","Public / Semi-public","Ocean Cleanup","Equity",10,2.4014,"CA"],
  ["Botswana","Incubator","Waste Management","Equity",1,0.3088,"BW"],
  ["Argentina","Incubator","Circular Economy","Grant",1,0.1463,"AR"],
  ["Sudan","Financial Service Provider","Waste Management","Equity",1,0.1759,"SD"],
  ["Kuwait","Public / Semi-public","Circular Economy","Equity",1,0.23,"KW"],
  ["Zimbabwe","Public / Semi-public","Ocean Cleanup","Lending",5,1.7652,"ZW"],
  ["Bahrain","Foundation","Ocean Cleanup","Grant",1,0.1767,"BH"],
  ["Norway","Nonprofit","Circular Economy","Grant",1,0.4245,"NO"],
  ["Kuwait","Nonprofit","Circular Economy","Grant",1,0.2124,"KW"],
  ["Peru","Nonprofit","Circular Economy","Equity",2,0.2518,"PE"],
  ["Haiti","Impact Investor","Circular Economy","Equity",1,0.5941,"HT"],
  ["United Kingdom","Crowdfunding","Ocean Cleanup","Equity",1,0.2489,"GB"],
  ["Somalia","Impact Investor","Ocean Cleanup","Grant",1,0.1256,"SO"],
  ["Singapore","Nonprofit","Waste Management","Lending",3,0.2976,"SG"],
  ["Tanzania","Venture Capital","Circular Economy","Equity",1,1.0,"TZ"],
  ["Netherlands","Public / Semi-public","Ocean Cleanup","Equity",9,3.1538,"NL"],
  ["India","Impact Investor","Waste Management","Equity",5,2.129,"IN"],
  ["Bangladesh","Impact Investor","Ocean Cleanup","Grant",3,0.6045,"BD"],
  ["Indonesia","Bank","Waste Management","Equity",1,0.2236,"ID"],
  ["United Kingdom","Foundation","Circular Economy","Lending",1,0.2005,"GB"],
  ["Jordan","Nonprofit","Waste Management","Grant",1,0.2849,"JO"],
  ["United States","Incubator","Ocean Cleanup","Equity",2,2.0,"US"],
  ["Poland","Nonprofit","Ocean Cleanup","Lending",1,0.0777,"PL"],
  ["Taiwan","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TW"],
  ["Senegal","Bank","Waste Management","Lending",1,0.1939,"SN"],
  ["Ecuador","Public / Semi-public","Waste Management","Lending",2,0.7965,"EC"],
  ["Mexico","Public / Semi-public","Ocean Cleanup","Equity",11,2.9053,"MX"],
  ["Argentina","Foundation","Ocean Cleanup","Equity",1,0.1547,"AR"],
  ["Thailand","Nonprofit","Circular Economy","Grant",2,0.9535,"TH"],
  ["Algeria","Foundation","Waste Management","Grant",2,0.436,"DZ"],
  ["Algeria","Financial Service Provider","Waste Management","Equity",1,0.115,"DZ"],
  ["Ghana","Bank","Circular Economy","Lending",4,1.074,"GH"],
  ["Gabon","Public / Semi-public","Waste Management","Lending",1,0.4243,"GA"],
  ["Congo, Dem. Rep","Foundation","Ocean Cleanup","Lending",1,0.1508,"CD"],
  ["Thailand","Nonprofit","Circular Economy","Lending",2,0.2033,"TH"],
  ["Macedonia","Public / Semi-public","Waste Management","Lending",1,0.2824,"MK"],
  ["Georgia","Public / Semi-public","Circular Economy","Grant",3,1.067,"GE"],
  ["Egypt","Bank","Ocean Cleanup","Equity",2,0.1963,"EG"],
  ["Israel","Financial Service Provider","Ocean Cleanup","Equity",1,0.0309,"IL"],
  ["Tunisia","Public / Semi-public","Ocean Cleanup","Lending",7,3.0989,"TN"],
  ["Serbia","Public / Semi-public","Ocean Cleanup","Equity",2,0.9152,"RS"],
  ["Somalia","Public / Semi-public","Waste Management","Grant",1,0.1256,"SO"],
  ["Ukraine","Incubator","Ocean Cleanup","Lending",1,0.1787,"UA"],
  ["Ukraine","Foundation","Waste Management","Lending",1,0.1787,"UA"],
  ["Oman","Foundation","Waste Management","Grant",2,0.3943,"OM"],
  ["Botswana","Foundation","Waste Management","Lending",1,0.3088,"BW"],
  ["Seychelles","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SC"],
  ["Indonesia","Impact Investor","Waste Management","Equity",4,0.4036,"ID"],
  ["Oman","Public / Semi-public","Waste Management","Equity",2,0.2767,"OM"],
  ["Netherlands","Foundation","Ocean Cleanup","Equity",2,0.3139,"NL"],
  ["Mozambique","Financial Service Provider","Circular Economy","Equity",2,1.0453,"MZ"],
  ["El Salvador","Impact Investor","Waste Management","Lending",1,0.3055,"SV"],
  ["Afghanistan","Venture Capital","Circular Economy","Equity",2,1.0349,"AF"],
  ["Australia","Public / Semi-public","Waste Management","Lending",6,1.2784,"AU"],
  ["Libya","Incubator","Waste Management","Equity",1,0.1273,"LY"],
  ["Malawi","Nonprofit","Circular Economy","Grant",1,0.5308,"MW"],
  ["Ethiopia","Foundation","Waste Management","Grant",1,0.2045,"ET"],
  ["Taiwan","Nonprofit","Ocean Cleanup","Equity",2,0.2156,"TW"],
  ["United Arab Emirates","Nonprofit","Ocean Cleanup","Equity",5,0.7165,"AE"],
  ["Qatar","Foundation","Circular Economy","Equity",1,0.2624,"QA"],
  ["United Kingdom","Incubator","Circular Economy","Equity",2,0.4309,"GB"],
  ["Uganda","Competitions","Waste Management","Grant",1,0.2759,"UG"],
  ["Singapore","Financial Service Provider","Circular Economy","Lending",2,0.3692,"SG"],
  ["Netherlands","Financial Service Provider","Circular Economy","Lending",1,0.1275,"NL"],
  ["Benin","Nonprofit","Waste Management","Grant",1,0.3631,"BJ"],
  ["Indonesia","Nonprofit","Ocean Cleanup","Lending",6,1.4408,"ID"],
  ["Singapore","Bank","Waste Management","Lending",1,0.0926,"SG"],
  ["Colombia","Financial Service Provider","Waste Management","Lending",3,0.5987,"CO"],
  ["Japan","Competitions","Waste Management","Grant",1,0.2432,"JP"],
  ["Zimbabwe","Financial Service Provider","Circular Economy","Equity",1,0.0531,"ZW"],
  ["Kenya","Foundation","Waste Management","Lending",2,1.3037,"KE"],
  ["Germany","Impact Investor","Ocean Cleanup","Equity",5,1.5416,"DE"],
  ["Bahrain","Public / Semi-public","Waste Management","Grant",1,0.0825,"BH"],
  ["Turkey","Public / Semi-public","Circular Economy","Lending",6,1.5796,"TR"],
  ["India","Crowdfunding","Waste Management","Lending",1,1.0,"IN"],
  ["United Arab Emirates","Incubator","Waste Management","Equity",4,0.6833,"AE"],
  ["Australia","Nonprofit","Ocean Cleanup","Lending",6,1.5888,"AU"],
  ["Austria","Public / Semi-public","Waste Management","Grant",1,0.0352,"AT"],
  ["Bosnia and Herzegovina","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BA"],
  ["Brazil","Venture Capital","Waste Management","Equity",2,0.0622,"BR"],
  ["Egypt","Crowdfunding","Ocean Cleanup","Equity",1,0.0377,"EG"],
  ["Japan","Impact Investor","Waste Management","Grant",1,0.0573,"JP"],
  ["Jordan","Foundation","Circular Economy","Grant",1,0.143,"JO"],
  ["Kenya","Venture Capital","Ocean Cleanup","Lending",1,1.0,"KE"],
  ["Finland","Incubator","Waste Management","Grant",1,0.0906,"FI"],
  ["Zambia","Impact Investor","Ocean Cleanup","Grant",2,0.1499,"ZM"],
  ["Belgium","Impact Investor","Waste Management","Equity",4,0.9016,"BE"],
  ["Bangladesh","Public / Semi-public","Circular Economy","Equity",4,1.1524,"BD"],
  ["Somalia","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"SO"],
  ["Russia","Foundation","Waste Management","Grant",2,0.6013,"RU"],
  ["Senegal","Bank","Ocean Cleanup","Lending",1,0.0305,"SN"],
  ["Dominica","Public / Semi-public","Waste Management","Equity",1,1.0,"DM"],
  ["New Zealand","Foundation","Waste Management","Grant",3,0.4413,"NZ"],
  ["South Korea","Incubator","Circular Economy","Equity",1,0.0768,"KR"],
  ["Tunisia","Nonprofit","Circular Economy","Grant",2,0.529,"TN"],
  ["Tanzania","Impact Investor","Circular Economy","Equity",3,1.1512,"TZ"],
  ["Italy","Nonprofit","Waste Management","Grant",5,1.2994,"IT"],
  ["Zimbabwe","Nonprofit","Waste Management","Lending",2,0.5163,"ZW"],
  ["Portugal","Impact Investor","Circular Economy","Lending",2,0.3427,"PT"],
  ["Switzerland","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CH"],
  ["New Zealand","Public / Semi-public","Waste Management","Lending",1,0.2237,"NZ"],
  ["Guatemala","Impact Investor","Waste Management","Lending",1,0.8792,"GT"],
  ["New Zealand","Financial Service Provider","Circular Economy","Grant",1,0.064,"NZ"],
  ["Benin","Public / Semi-public","Ocean Cleanup","Grant",2,0.7428,"BJ"],
  ["Mozambique","Venture Capital","Waste Management","Equity",1,0.0453,"MZ"],
  ["United States","Foundation","Waste Management","Grant",6,2.5033,"US"],
  ["Pakistan","Public / Semi-public","Ocean Cleanup","Grant",8,2.124,"PK"],
  ["Cyprus","Impact Investor","Waste Management","Lending",1,0.107,"CY"],
  ["Iraq","Foundation","Waste Management","Grant",3,0.5346,"IQ"],
  ["Malaysia","Nonprofit","Ocean Cleanup","Grant",6,2.0277,"MY"],
  ["Cameroon","Financial Service Provider","Ocean Cleanup","Lending",1,0.2843,"CM"],
  ["Kazakhstan","Venture Capital","Circular Economy","Equity",1,1.0,"KZ"],
  ["Canada","Nonprofit","Ocean Cleanup","Grant",9,2.5441,"CA"],
  ["India","Incubator","Waste Management","Lending",1,0.19,"IN"],
  ["French Polynesia","Public / Semi-public","Ocean Cleanup","Equity",1,0.6939,"PF"],
  ["Niger","Public / Semi-public","Waste Management","Equity",2,0.7075,"NE"],
  ["India","Crowdfunding","Circular Economy","Grant",1,0.5,"IN"],
  ["Lesotho","Financial Service Provider","Circular Economy","Equity",1,0.0506,"LS"],
  ["Nigeria","Impact Investor","Ocean Cleanup","Grant",3,0.4447,"NG"],
  ["New Zealand","Nonprofit","Circular Economy","Equity",2,0.2553,"NZ"],
  ["Lebanon","Foundation","Waste Management","Grant",2,0.3749,"LB"],
  ["United States","Nonprofit","Waste Management","Equity",4,1.8236,"US"],
  ["Romania","Impact Investor","Ocean Cleanup","Grant",1,0.0612,"RO"],
  ["Saint Kitts and Nevis","Venture Capital","Ocean Cleanup","Equity",1,1.0,"KN"],
  ["Poland","Financial Service Provider","Circular Economy","Lending",1,0.2489,"PL"],
  ["Sweden","Nonprofit","Ocean Cleanup","Grant",6,1.9829,"SE"],
  ["Jamaica","Impact Investor","Waste Management","Grant",1,0.1992,"JM"],
  ["Cambodia","Public / Semi-public","Ocean Cleanup","Equity",8,2.5083,"KH"],
  ["Cambodia","Nonprofit","Waste Management","Equity",2,0.3917,"KH"],
  ["Samoa","Venture Capital","Ocean Cleanup","Equity",1,1.0,"WS"],
  ["Tunisia","Public / Semi-public","Waste Management","Equity",8,3.4902,"TN"],
  ["China","Impact Investor","Circular Economy","Grant",1,0.0903,"CN"],
  ["Azerbaijan","Public / Semi-public","Ocean Cleanup","Equity",2,1.0037,"AZ"],
  ["Haiti","Nonprofit","Waste Management","Grant",1,0.0412,"HT"],
  ["Turkey","Financial Service Provider","Waste Management","Lending",2,0.3556,"TR"],
  ["Australia","Public / Semi-public","Waste Management","Equity",6,1.1517,"AU"],
  ["Morocco","Incubator","Circular Economy","Equity",1,0.0923,"MA"],
  ["China","Public / Semi-public","Waste Management","Equity",4,0.788,"CN"],
  ["Finland","Crowdfunding","Ocean Cleanup","Grant",1,0.081,"FI"],
  ["Brazil","Foundation","Ocean Cleanup","Equity",2,0.2885,"BR"],
  ["Papua New Guinea","Bank","Ocean Cleanup","Lending",1,0.1536,"PG"],
  ["United States","Impact Investor","Waste Management","Grant",3,0.4822,"US"],
  ["Ecuador","Nonprofit","Waste Management","Equity",1,0.1688,"EC"],
  ["Mexico","Public / Semi-public","Waste Management","Grant",5,1.2241,"MX"],
  ["Tunisia","Nonprofit","Circular Economy","Equity",1,0.609,"TN"],
  ["Italy","Crowdfunding","Ocean Cleanup","Grant",1,0.1177,"IT"],
  ["Zimbabwe","Public / Semi-public","Circular Economy","Lending",2,0.3958,"ZW"],
  ["Vietnam","Foundation","Circular Economy","Equity",1,0.1677,"VN"],
  ["Tunisia","Foundation","Circular Economy","Grant",1,0.2757,"TN"],
  ["Myanmar","Public / Semi-public","Circular Economy","Grant",4,1.1574,"MM"],
  ["Norway","Public / Semi-public","Circular Economy","Lending",2,0.3984,"NO"],
  ["Norway","Public / Semi-public","Circular Economy","Grant",1,0.1992,"NO"],
  ["Denmark","Venture Capital","Circular Economy","Equity",1,1.0,"DK"],
  ["Ghana","Nonprofit","Circular Economy","Grant",2,0.736,"GH"],
  ["Trinidad and Tobago","Public / Semi-public","Ocean Cleanup","Equity",2,1.0166,"TT"],
  ["Cyprus","Venture Capital","Circular Economy","Equity",1,1.0,"CY"],
  ["Germany","Nonprofit","Ocean Cleanup","Grant",9,2.5035,"DE"],
  ["Ukraine","Public / Semi-public","Waste Management","Equity",3,1.0515,"UA"],
  ["Finland","Crowdfunding","Waste Management","Lending",1,0.0355,"FI"],
  ["Peru","Foundation","Ocean Cleanup","Equity",1,0.1455,"PE"],
  ["South Africa","Nonprofit","Circular Economy","Equity",2,0.2145,"ZA"],
  ["Qatar","Foundation","Ocean Cleanup","Equity",1,0.2624,"QA"],
  ["South Korea","Public / Semi-public","Circular Economy","Equity",1,0.3066,"KR"],
  ["Australia","Impact Investor","Waste Management","Lending",3,0.8082,"AU"],
  ["Benin","Nonprofit","Circular Economy","Grant",1,0.3631,"BJ"],
  ["South Korea","Public / Semi-public","Circular Economy","Lending",2,0.4113,"KR"],
  ["Egypt","Public / Semi-public","Ocean Cleanup","Equity",11,4.1704,"EG"],
  ["Bahrain","Public / Semi-public","Ocean Cleanup","Grant",1,0.0825,"BH"],
  ["Congo, Rep.","Public / Semi-public","Circular Economy","Grant",1,0.4715,"CG"],
  ["Dominican Republic","Public / Semi-public","Ocean Cleanup","Equity",2,0.2785,"DO"],
  ["Argentina","Public / Semi-public","Circular Economy","Equity",3,0.6701,"AR"],
  ["Russia","Incubator","Ocean Cleanup","Equity",1,0.1588,"RU"],
  ["Venezuela","Foundation","Circular Economy","Grant",1,0.4253,"VE"],
  ["Zimbabwe","Public / Semi-public","Circular Economy","Equity",1,0.1979,"ZW"],
  ["Algeria","Nonprofit","Waste Management","Equity",1,0.115,"DZ"],
  ["Cambodia","Financial Service Provider","Waste Management","Equity",1,0.3259,"KH"],
  ["Peru","Nonprofit","Waste Management","Equity",4,0.7459,"PE"],
  ["Spain","Nonprofit","Ocean Cleanup","Grant",7,1.8855,"ES"],
  ["Peru","Impact Investor","Circular Economy","Grant",1,0.0743,"PE"],
  ["Netherlands","Foundation","Circular Economy","Grant",4,1.0348,"NL"],
  ["South Africa","Public / Semi-public","Ocean Cleanup","Grant",7,1.1404,"ZA"],
  ["Sao Tome and Principe","Public / Semi-public","Waste Management","Lending",1,0.4041,"ST"],
  ["Japan","Impact Investor","Ocean Cleanup","Grant",2,0.3314,"JP"],
  ["Tajikistan","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TJ"],
  ["Cameroon","Public / Semi-public","Ocean Cleanup","Equity",5,1.9139,"CM"],
  ["Thailand","Public / Semi-public","Circular Economy","Grant",4,0.8507,"TH"],
  ["Ghana","Nonprofit","Waste Management","Lending",2,1.3561,"GH"],
  ["Philippines","Impact Investor","Waste Management","Lending",3,0.482,"PH"],
  ["South Africa","Impact Investor","Circular Economy","Lending",3,1.2145,"ZA"],
  ["Chile","Foundation","Ocean Cleanup","Grant",2,0.8518,"CL"],
  ["Moldova","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MD"],
  ["Timor-Leste","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TL"],
  ["United Arab Emirates","Impact Investor","Ocean Cleanup","Equity",5,0.8019,"AE"],
  ["Indonesia","Financial Service Provider","Waste Management","Lending",3,0.6181,"ID"],
  ["Burundi","Bank","Circular Economy","Lending",1,0.2383,"BI"],
  ["Mozambique","Nonprofit","Ocean Cleanup","Lending",1,0.4,"MZ"],
  ["Saudi Arabia","Public / Semi-public","Circular Economy","Equity",4,0.8881,"SA"],
  ["Greece","Nonprofit","Ocean Cleanup","Equity",3,0.4303,"GR"],
  ["India","Impact Investor","Circular Economy","Lending",2,1.4608,"IN"],
  ["Vietnam","Financial Service Provider","Waste Management","Equity",1,0.3319,"VN"],
  ["Gibraltar","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GI"],
  ["Lebanon","Public / Semi-public","Ocean Cleanup","Grant",1,0.2662,"LB"],
  ["Zimbabwe","Nonprofit","Ocean Cleanup","Lending",1,0.3336,"ZW"],
  ["Malaysia","Incubator","Ocean Cleanup","Lending",1,0.1402,"MY"],
  ["China","Financial Service Provider","Circular Economy","Lending",2,0.4332,"CN"],
  ["China","Bank","Waste Management","Lending",1,0.4901,"CN"],
  ["Vietnam","Foundation","Waste Management","Equity",2,0.2963,"VN"],
  ["Australia","Impact Investor","Ocean Cleanup","Grant",2,0.6657,"AU"],
  ["Kenya","Bank","Ocean Cleanup","Equity",1,0.374,"KE"],
  ["Sao Tome and Principe","Venture Capital","Circular Economy","Equity",1,1.0,"ST"],
  ["Philippines","Bank","Circular Economy","Lending",3,1.4257,"PH"],
  ["Estonia","Venture Capital","Circular Economy","Equity",1,1.0,"EE"],
  ["Netherlands","Impact Investor","Waste Management","Lending",4,1.0346,"NL"],
  ["Nepal","Financial Service Provider","Waste Management","Lending",1,0.5534,"NP"],
  ["Solomon Islands","Venture Capital","Circular Economy","Equity",1,1.0,"SB"],
  ["Kenya","Bank","Ocean Cleanup","Lending",2,1.1885,"KE"],
  ["Fiji","Nonprofit","Circular Economy","Grant",1,0.2947,"FJ"],
  ["Pakistan","Financial Service Provider","Circular Economy","Equity",1,0.1651,"PK"],
  ["Japan","Nonprofit","Circular Economy","Equity",2,0.2261,"JP"],
  ["Ireland","Foundation","Circular Economy","Grant",1,0.0646,"IE"],
  ["Singapore","Financial Service Provider","Waste Management","Lending",1,0.1216,"SG"],
  ["Taiwan","Competitions","Ocean Cleanup","Grant",1,0.2104,"TW"],
  ["Russia","Nonprofit","Ocean Cleanup","Grant",1,0.0381,"RU"],
  ["Australia","Bank","Circular Economy","Lending",5,0.9628,"AU"],
  ["New Zealand","Financial Service Provider","Circular Economy","Equity",1,0.3138,"NZ"],
  ["Nicaragua","Nonprofit","Ocean Cleanup","Equity",1,0.3848,"NI"],
  ["Ethiopia","Foundation","Circular Economy","Grant",1,0.2045,"ET"],
  ["Pakistan","Nonprofit","Ocean Cleanup","Equity",5,0.8644,"PK"],
  ["Portugal","Foundation","Ocean Cleanup","Lending",1,0.1527,"PT"],
  ["Spain","Bank","Ocean Cleanup","Lending",2,0.2526,"ES"],
  ["Israel","Nonprofit","Circular Economy","Lending",1,0.0674,"IL"],
  ["South Korea","Venture Capital","Waste Management","Equity",1,0.0299,"KR"],
  ["Zimbabwe","Impact Investor","Ocean Cleanup","Lending",1,0.1829,"ZW"],
  ["Indonesia","Foundation","Ocean Cleanup","Equity",2,0.2581,"ID"],
  ["Philippines","Foundation","Ocean Cleanup","Lending",2,0.2822,"PH"],
  ["Singapore","Bank","Ocean Cleanup","Lending",2,0.3847,"SG"],
  ["Chile","Nonprofit","Waste Management","Lending",2,0.3723,"CL"],
  ["Macau","Crowdfunding","Ocean Cleanup","Grant",1,0.1334,"MO"],
  ["Ukraine","Public / Semi-public","Circular Economy","Equity",1,0.3636,"UA"],
  ["Uganda","Foundation","Ocean Cleanup","Lending",1,0.2744,"UG"],
  ["United States","Public / Semi-public","Circular Economy","Lending",8,2.4508,"US"],
  ["Cabo Verde","Financial Service Provider","Waste Management","Lending",1,0.0634,"CV"],
  ["United Arab Emirates","Public / Semi-public","Waste Management","Grant",4,0.5715,"AE"],
  ["Burkina Faso","Financial Service Provider","Waste Management","Lending",1,0.2036,"BF"],
  ["Israel","Public / Semi-public","Waste Management","Grant",2,0.1536,"IL"],
  ["France","Venture Capital","Ocean Cleanup","Equity",1,1.0,"FR"],
  ["Portugal","Impact Investor","Waste Management","Lending",4,0.8963,"PT"],
  ["Egypt","Bank","Waste Management","Equity",1,0.1068,"EG"],
  ["Benin","Public / Semi-public","Circular Economy","Lending",2,0.4526,"BJ"],
  ["Pakistan","Incubator","Ocean Cleanup","Equity",1,0.1371,"PK"],
  ["Tanzania","Nonprofit","Waste Management","Grant",3,0.7544,"TZ"],
  ["El Salvador","Public / Semi-public","Ocean Cleanup","Equity",1,0.0946,"SV"],
  ["Bahrain","Incubator","Ocean Cleanup","Grant",1,0.0825,"BH"],
  ["Vietnam","Competitions","Ocean Cleanup","Grant",1,0.2555,"VN"],
  ["Luxembourg","Venture Capital","Ocean Cleanup","Equity",1,1.0,"LU"],
  ["China","Incubator","Waste Management","Equity",3,0.613,"CN"],
  ["Saint Helena","Venture Capital","Circular Economy","Equity",1,1.0,"SH"],
  ["Belgium","Impact Investor","Circular Economy","Equity",3,0.3784,"BE"],
  ["France","Incubator","Waste Management","Equity",4,0.6978,"FR"],
  ["Vietnam","Incubator","Waste Management","Grant",1,0.0692,"VN"],
  ["Côte d'Ivoire","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CI"],
  ["Congo, Dem. Rep","Public / Semi-public","Circular Economy","Lending",2,0.3995,"CD"],
  ["Mexico","Foundation","Waste Management","Lending",1,0.1863,"MX"],
  ["Jordan","Nonprofit","Ocean Cleanup","Grant",1,0.631,"JO"],
  ["United Arab Emirates","Incubator","Waste Management","Lending",1,0.1289,"AE"],
  ["Italy","Public / Semi-public","Waste Management","Equity",10,3.3316,"IT"],
  ["Sao Tome and Principe","Public / Semi-public","Circular Economy","Lending",1,0.4041,"ST"],
  ["Peru","Bank","Circular Economy","Lending",1,0.1073,"PE"],
  ["Hungary","Impact Investor","Waste Management","Lending",1,0.1092,"HU"],
  ["Congo, Dem. Rep","Financial Service Provider","Waste Management","Lending",1,0.1017,"CD"],
  ["Botswana","Incubator","Ocean Cleanup","Equity",1,0.3088,"BW"],
  ["South Africa","Bank","Waste Management","Lending",2,1.2664,"ZA"],
  ["Timor-Leste","Public / Semi-public","Ocean Cleanup","Equity",1,0.3718,"TL"],
  ["Saudi Arabia","Foundation","Ocean Cleanup","Equity",2,0.3619,"SA"],
  ["Saudi Arabia","Nonprofit","Ocean Cleanup","Equity",3,0.4672,"SA"],
  ["Israel","Microfinance Institution","Waste Management","Lending",1,0.0305,"IL"],
  ["Mongolia","Bank","Circular Economy","Equity",1,0.2663,"MN"],
  ["Sweden","Nonprofit","Circular Economy","Grant",3,1.3113,"SE"],
  ["Equatorial Guinea","Financial Service Provider","Waste Management","Equity",1,0.0649,"GQ"],
  ["Malawi","Nonprofit","Waste Management","Grant",1,0.0641,"MW"],
  ["Niue","Venture Capital","Ocean Cleanup","Equity",1,1.0,"NU"],
  ["United Arab Emirates","Financial Service Provider","Ocean Cleanup","Lending",1,0.0828,"AE"],
  ["Botswana","Nonprofit","Waste Management","Equity",1,0.1563,"BW"],
  ["Slovenia","Venture Capital","Circular Economy","Equity",1,1.0,"SI"],
  ["Tanzania","Public / Semi-public","Waste Management","Grant",3,0.3246,"TZ"],
  ["Tajikistan","Bank","Waste Management","Lending",1,0.4342,"TJ"],
  ["Mauritania","Public / Semi-public","Ocean Cleanup","Equity",2,1.3609,"MR"],
  ["Guinea","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GN"],
  ["United Arab Emirates","Crowdfunding","Waste Management","Equity",1,0.027,"AE"],
  ["Sri Lanka","Nonprofit","Circular Economy","Grant",3,0.7151,"LK"],
  ["Morocco","Financial Service Provider","Waste Management","Lending",2,0.1784,"MA"],
  ["Tunisia","Public / Semi-public","Ocean Cleanup","Grant",6,1.3076,"TN"],
  ["New Caledonia","Venture Capital","Circular Economy","Equity",1,1.0,"NC"],
  ["Afghanistan","Foundation","Ocean Cleanup","Equity",1,0.1614,"AF"],
  ["Israel","Bank","Circular Economy","Lending",1,0.3428,"IL"],
  ["Indonesia","Bank","Ocean Cleanup","Equity",2,0.5259,"ID"],
  ["Zimbabwe","Venture Capital","Waste Management","Equity",1,0.0531,"ZW"],
  ["Uruguay","Nonprofit","Waste Management","Grant",1,0.1004,"UY"],
  ["India","Foundation","Circular Economy","Lending",1,0.1655,"IN"],
  ["Singapore","Public / Semi-public","Ocean Cleanup","Grant",1,0.3002,"SG"],
  ["Bangladesh","Impact Investor","Ocean Cleanup","Equity",5,1.4745,"BD"],
  ["Hong Kong","Financial Service Provider","Circular Economy","Equity",1,0.0326,"HK"],
  ["South Africa","Foundation","Ocean Cleanup","Equity",2,0.5222,"ZA"],
  ["Tanzania","Public / Semi-public","Ocean Cleanup","Lending",4,1.6959,"TZ"],
  ["South Africa","Financial Service Provider","Circular Economy","Equity",1,1.0,"ZA"],
  ["Japan","Impact Investor","Waste Management","Equity",3,0.4101,"JP"],
  ["Kuwait","Bank","Circular Economy","Equity",1,0.3238,"KW"],
  ["United Kingdom","Nonprofit","Circular Economy","Equity",2,0.3977,"GB"],
  ["Paraguay","Foundation","Waste Management","Grant",1,0.5065,"PY"],
  ["Nicaragua","Financial Service Provider","Waste Management","Equity",1,0.3848,"NI"],
  ["Bolivia","Public / Semi-public","Waste Management","Grant",2,0.1548,"BO"],
  ["Greece","Nonprofit","Circular Economy","Grant",2,0.9477,"GR"],
  ["Turkey","Nonprofit","Ocean Cleanup","Equity",4,0.7212,"TR"],
  ["India","Public / Semi-public","Circular Economy","Equity",7,2.4702,"IN"],
  ["Congo, Dem. Rep","Nonprofit","Waste Management","Grant",1,0.1163,"CD"],
  ["Denmark","Public / Semi-public","Ocean Cleanup","Grant",2,0.2723,"DK"],
  ["Canada","Public / Semi-public","Waste Management","Grant",6,1.3016,"CA"],
  ["Libya","Public / Semi-public","Waste Management","Grant",2,0.3631,"LY"],
  ["Canada","Financial Service Provider","Circular Economy","Equity",2,0.0689,"CA"],
  ["Ghana","Venture Capital","Waste Management","Equity",2,0.0566,"GH"],
  ["Morocco","Public / Semi-public","Ocean Cleanup","Lending",9,2.8595,"MA"],
  ["Faroe Islands","Venture Capital","Circular Economy","Equity",1,1.0,"FO"],
  ["Turkey","Public / Semi-public","Circular Economy","Grant",5,1.1266,"TR"],
  ["Australia","Incubator","Waste Management","Lending",1,0.1851,"AU"],
  ["Uzbekistan","Public / Semi-public","Waste Management","Lending",1,0.3601,"UZ"],
  ["Uganda","Impact Investor","Circular Economy","Grant",1,0.0766,"UG"],
  ["Cambodia","Financial Service Provider","Ocean Cleanup","Equity",1,0.3259,"KH"],
  ["Albania","Bank","Circular Economy","Lending",1,0.1833,"AL"],
  ["Botswana","Impact Investor","Waste Management","Grant",3,0.3162,"BW"],
  ["Belgium","Public / Semi-public","Circular Economy","Lending",5,0.9471,"BE"],
  ["Spain","Foundation","Waste Management","Lending",2,0.3317,"ES"],
  ["Colombia","Bank","Circular Economy","Lending",1,0.1107,"CO"],
  ["Turkey","Nonprofit","Ocean Cleanup","Grant",6,2.1301,"TR"],
  ["Kenya","Public / Semi-public","Circular Economy","Lending",7,1.3754,"KE"],
  ["Uruguay","Impact Investor","Waste Management","Equity",1,1.0,"UY"],
  ["Yemen","Public / Semi-public","Waste Management","Equity",3,0.9624,"YE"],
  ["Belgium","Incubator","Waste Management","Grant",1,0.0896,"BE"],
  ["Indonesia","Foundation","Waste Management","Grant",5,1.1811,"ID"],
  ["United States","Foundation","Circular Economy","Lending",1,0.2322,"US"],
  ["Rwanda","Venture Capital","Ocean Cleanup","Lending",1,1.0,"RW"],
  ["Costa Rica","Bank","Circular Economy","Lending",1,0.1133,"CR"],
  ["India","Nonprofit","Ocean Cleanup","Equity",5,2.0498,"IN"],
  ["Chile","Nonprofit","Circular Economy","Lending",1,0.1561,"CL"],
  ["Angola","Foundation","Circular Economy","Equity",1,0.1358,"AO"],
  ["Ghana","Nonprofit","Ocean Cleanup","Grant",2,0.736,"GH"],
  ["Oman","Public / Semi-public","Circular Economy","Equity",1,0.2405,"OM"],
  ["Congo, Rep.","Public / Semi-public","Ocean Cleanup","Lending",2,1.4715,"CG"],
  ["Togo","Bank","Waste Management","Lending",1,0.2171,"TG"],
  ["United Kingdom","Nonprofit","Circular Economy","Grant",5,2.2388,"GB"],
  ["Bhutan","Foundation","Ocean Cleanup","Grant",1,0.6099,"BT"],
  ["France","Nonprofit","Circular Economy","Lending",2,0.7102,"FR"],
  ["Australia","Foundation","Circular Economy","Grant",4,1.2349,"AU"],
  ["Austria","Venture Capital","Ocean Cleanup","Equity",1,1.0,"AT"],
  ["France","Microfinance Institution","Waste Management","Lending",1,0.0924,"FR"],
  ["Puerto Rico","Public / Semi-public","Waste Management","Equity",1,0.2656,"PR"],
  ["Sweden","Public / Semi-public","Ocean Cleanup","Lending",4,2.1331,"SE"],
  ["Qatar","Incubator","Waste Management","Equity",3,0.3926,"QA"],
  ["Peru","Incubator","Waste Management","Equity",1,0.1455,"PE"],
  ["French Southern and Antarctic Lands","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TF"],
  ["Spain","Competitions","Waste Management","Grant",1,0.2018,"ES"],
  ["Saudi Arabia","Foundation","Waste Management","Grant",4,0.9302,"SA"],
  ["Colombia","Financial Service Provider","Ocean Cleanup","Equity",2,0.2875,"CO"],
  ["Senegal","Public / Semi-public","Ocean Cleanup","Lending",3,1.6491,"SN"],
  ["Canada","Nonprofit","Waste Management","Grant",5,1.3724,"CA"],
  ["Cameroon","Public / Semi-public","Circular Economy","Equity",2,0.4561,"CM"],
  ["Rwanda","Venture Capital","Circular Economy","Lending",1,1.0,"RW"],
  ["Austria","Crowdfunding","Ocean Cleanup","Grant",1,0.0814,"AT"],
  ["Kenya","Public / Semi-public","Ocean Cleanup","Equity",10,4.316,"KE"],
  ["Iran","Venture Capital","Ocean Cleanup","Equity",1,1.0,"IR"],
  ["Oman","Foundation","Waste Management","Equity",1,0.1749,"OM"],
  ["Italy","Foundation","Ocean Cleanup","Grant",5,1.1361,"IT"],
  ["Bulgaria","Venture Capital","Waste Management","Equity",1,0.0374,"BG"],
  ["France","Public / Semi-public","Ocean Cleanup","Lending",9,3.4713,"FR"],
  ["Israel","Public / Semi-public","Waste Management","Equity",1,0.5416,"IL"],
  ["Netherlands","Financial Service Provider","Circular Economy","Grant",1,0.0831,"NL"],
  ["Uganda","Bank","Ocean Cleanup","Equity",1,0.3043,"UG"],
  ["Tunisia","Bank","Waste Management","Equity",1,0.1131,"TN"],
  ["Colombia","Competitions","Ocean Cleanup","Grant",1,0.1988,"CO"],
  ["India","Bank","Waste Management","Lending",2,0.4814,"IN"],
  ["New Zealand","Competitions","Ocean Cleanup","Grant",1,0.2009,"NZ"],
  ["Nigeria","Impact Investor","Waste Management","Grant",3,0.4159,"NG"],
  ["Thailand","Incubator","Ocean Cleanup","Lending",1,0.1194,"TH"],
  ["Nigeria","Impact Investor","Circular Economy","Equity",3,0.2373,"NG"],
  ["Netherlands","Bank","Ocean Cleanup","Lending",4,1.5905,"NL"],
  ["Angola","Foundation","Ocean Cleanup","Equity",2,0.4394,"AO"],
  ["Grenada","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"GD"],
  ["Nigeria","Foundation","Circular Economy","Grant",2,0.2736,"NG"],
  ["Costa Rica","Foundation","Waste Management","Grant",2,0.5037,"CR"],
  ["Norway","Foundation","Waste Management","Grant",1,0.3553,"NO"],
  ["Senegal","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SN"],
  ["Botswana","Venture Capital","Circular Economy","Equity",2,1.076,"BW"],
  ["West Bank and Gaza","Public / Semi-public","Waste Management","Equity",2,0.9396,"PS"],
  ["Puerto Rico","Foundation","Circular Economy","Grant",1,0.0861,"PR"],
  ["Macau","Bank","Circular Economy","Equity",1,0.3005,"MO"],
  ["Ireland","Foundation","Waste Management","Equity",1,0.1463,"IE"],
  ["Kyrgyz Republic","Foundation","Waste Management","Grant",1,1.0,"KG"],
  ["Zimbabwe","Financial Service Provider","Ocean Cleanup","Equity",2,0.3682,"ZW"],
  ["Bahamas, The","Public / Semi-public","Waste Management","Equity",2,2.0,"BS"],
  ["Italy","Incubator","Waste Management","Equity",4,0.5525,"IT"],
  ["South Korea","Impact Investor","Ocean Cleanup","Equity",3,0.689,"KR"],
  ["Madagascar","Impact Investor","Ocean Cleanup","Equity",1,0.0343,"MG"],
  ["Hong Kong","Financial Service Provider","Waste Management","Equity",1,0.0326,"HK"],
  ["Rwanda","Public / Semi-public","Waste Management","Lending",4,1.3737,"RW"],
  ["Liberia","Bank","Circular Economy","Lending",1,0.2622,"LR"],
  ["Egypt","Foundation","Ocean Cleanup","Lending",2,0.263,"EG"],
  ["Morocco","Venture Capital","Waste Management","Equity",1,0.0262,"MA"],
  ["South Africa","Venture Capital","Circular Economy","Grant",1,1.0,"ZA"],
  ["Pakistan","Public / Semi-public","Ocean Cleanup","Lending",8,2.0426,"PK"],
  ["Gabon","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GA"],
  ["Turkey","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TR"],
  ["Uganda","Public / Semi-public","Circular Economy","Lending",4,0.9061,"UG"],
  ["Greece","Public / Semi-public","Waste Management","Lending",1,0.2308,"GR"],
  ["Cyprus","Impact Investor","Ocean Cleanup","Lending",1,0.107,"CY"],
  ["Chile","Financial Service Provider","Waste Management","Equity",1,0.2162,"CL"],
  ["Ukraine","Public / Semi-public","Ocean Cleanup","Grant",1,0.6434,"UA"],
  ["Poland","Nonprofit","Circular Economy","Equity",1,0.0777,"PL"],
  ["Philippines","Impact Investor","Ocean Cleanup","Lending",2,0.2914,"PH"],
  ["Lebanon","Venture Capital","Ocean Cleanup","Equity",1,1.0,"LB"],
  ["Italy","Incubator","Ocean Cleanup","Grant",1,0.3791,"IT"],
  ["West Bank and Gaza","Venture Capital","Circular Economy","Equity",1,1.0,"PS"],
  ["Albania","Nonprofit","Circular Economy","Equity",1,1.0,"AL"],
  ["Congo, Dem. Rep","Nonprofit","Circular Economy","Grant",2,0.4524,"CD"],
  ["Algeria","Impact Investor","Ocean Cleanup","Equity",1,0.2893,"DZ"],
  ["Switzerland","Incubator","Waste Management","Equity",3,0.3225,"CH"],
  ["Congo, Dem. Rep","Nonprofit","Ocean Cleanup","Lending",1,0.1017,"CD"],
  ["Saudi Arabia","Bank","Waste Management","Lending",2,0.3235,"SA"],
  ["United Kingdom","Incubator","Ocean Cleanup","Equity",2,0.3984,"GB"],
  ["Zimbabwe","Foundation","Waste Management","Equity",2,0.3427,"ZW"],
  ["Ghana","Foundation","Waste Management","Equity",1,0.1774,"GH"],
  ["Bolivia","Nonprofit","Waste Management","Grant",2,0.2526,"BO"],
  ["Myanmar","Crowdfunding","Ocean Cleanup","Grant",1,0.0916,"MM"],
  ["Mongolia","Bank","Waste Management","Lending",1,0.2663,"MN"],
  ["Uzbekistan","Public / Semi-public","Circular Economy","Lending",2,1.1844,"UZ"],
  ["Vietnam","Public / Semi-public","Ocean Cleanup","Grant",7,1.5201,"VN"],
  ["Mozambique","Financial Service Provider","Ocean Cleanup","Equity",1,0.4,"MZ"],
  ["Uganda","Nonprofit","Ocean Cleanup","Lending",3,1.5596,"UG"],
  ["Uganda","Nonprofit","Circular Economy","Equity",1,1.0,"UG"],
  ["Portugal","Bank","Circular Economy","Equity",1,0.3175,"PT"],
  ["Morocco","Incubator","Waste Management","Equity",3,0.3495,"MA"],
  ["Singapore","Foundation","Waste Management","Grant",2,0.2205,"SG"],
  ["Mali","Public / Semi-public","Circular Economy","Lending",1,0.4836,"ML"],
  ["Tristan da Cunha","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TA"],
  ["Tanzania","Foundation","Waste Management","Grant",4,1.533,"TZ"],
  ["Equatorial Guinea","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GQ"],
  ["Venezuela","Foundation","Ocean Cleanup","Grant",1,0.4253,"VE"],
  ["Senegal","Public / Semi-public","Circular Economy","Lending",3,0.7764,"SN"],
  ["Slovenia","Public / Semi-public","Waste Management","Grant",1,0.3047,"SI"],
  ["Russia","Foundation","Circular Economy","Grant",2,0.6013,"RU"],
  ["Bangladesh","Incubator","Waste Management","Equity",3,0.6995,"BD"],
  ["Burundi","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"BI"],
  ["Russia","Impact Investor","Waste Management","Lending",1,0.1588,"RU"],
  ["United Kingdom","Public / Semi-public","Waste Management","Grant",7,2.1076,"GB"],
  ["Lebanon","Foundation","Circular Economy","Lending",1,0.1624,"LB"],
  ["United Kingdom","Microfinance Institution","Waste Management","Lending",1,0.0451,"GB"],
  ["Egypt","Foundation","Circular Economy","Grant",4,1.5334,"EG"],
  ["Canada","Impact Investor","Ocean Cleanup","Lending",3,0.7762,"CA"],
  ["Paraguay","Venture Capital","Circular Economy","Equity",1,1.0,"PY"],
  ["Chad","Financial Service Provider","Waste Management","Equity",1,0.1916,"TD"],
  ["Tanzania","Foundation","Waste Management","Equity",2,0.7151,"TZ"],
  ["Madagascar","Public / Semi-public","Circular Economy","Equity",2,0.9678,"MG"],
  ["Ghana","Financial Service Provider","Circular Economy","Lending",1,0.0284,"GH"],
  ["Japan","Public / Semi-public","Waste Management","Grant",3,0.405,"JP"],
  ["Myanmar","Nonprofit","Waste Management","Grant",3,0.5831,"MM"],
  ["Pakistan","Nonprofit","Circular Economy","Grant",5,1.9161,"PK"],
  ["Greece","Foundation","Ocean Cleanup","Lending",1,0.1497,"GR"],
  ["Tunisia","Nonprofit","Ocean Cleanup","Lending",2,0.7513,"TN"],
  ["Hong Kong","Crowdfunding","Ocean Cleanup","Equity",1,0.075,"HK"],
  ["Thailand","Financial Service Provider","Waste Management","Equity",2,0.1014,"TH"],
  ["Ethiopia","Foundation","Ocean Cleanup","Equity",1,0.2045,"ET"],
  ["Poland","Impact Investor","Waste Management","Lending",1,0.0777,"PL"],
  ["Ireland","Public / Semi-public","Circular Economy","Grant",1,0.1082,"IE"],
  ["Denmark","Impact Investor","Circular Economy","Lending",1,0.1324,"DK"],
  ["Philippines","Financial Service Provider","Waste Management","Lending",1,0.2055,"PH"],
  ["France","Incubator","Ocean Cleanup","Grant",1,0.0755,"FR"],
  ["Tanzania","Public / Semi-public","Ocean Cleanup","Equity",5,1.9912,"TZ"],
  ["Colombia","Financial Service Provider","Waste Management","Grant",1,0.1608,"CO"],
  ["Ukraine","Incubator","Ocean Cleanup","Equity",1,0.1787,"UA"],
  ["United Kingdom","Bank","Circular Economy","Lending",4,0.5814,"GB"],
  ["Peru","Public / Semi-public","Ocean Cleanup","Lending",7,1.791,"PE"],
  ["New Zealand","Bank","Ocean Cleanup","Equity",1,0.148,"NZ"],
  ["Japan","Financial Service Provider","Waste Management","Grant",1,0.0592,"JP"],
  ["Bolivia","Public / Semi-public","Waste Management","Equity",2,1.0569,"BO"],
  ["Egypt","Public / Semi-public","Ocean Cleanup","Grant",9,1.8765,"EG"],
  ["Nigeria","Bank","Waste Management","Lending",2,1.1225,"NG"],
  ["Algeria","Financial Service Provider","Ocean Cleanup","Lending",1,0.115,"DZ"],
  ["Denmark","Bank","Ocean Cleanup","Lending",1,0.1139,"DK"],
  ["Guadeloupe","Public / Semi-public","Circular Economy","Equity",1,0.8946,"GP"],
  ["United Arab Emirates","Bank","Ocean Cleanup","Equity",1,0.2597,"AE"],
  ["Zambia","Foundation","Circular Economy","Equity",1,0.1839,"ZM"],
  ["Ukraine","Public / Semi-public","Ocean Cleanup","Equity",3,1.0834,"UA"],
  ["Italy","Venture Capital","Waste Management","Equity",2,0.1078,"IT"],
  ["St. Lucia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"LC"],
  ["United States","Venture Capital","Circular Economy","Lending",1,0.5883,"US"],
  ["Singapore","Public / Semi-public","Circular Economy","Grant",1,0.3002,"SG"],
  ["Sweden","Foundation","Circular Economy","Lending",1,0.1764,"SE"],
  ["France","Impact Investor","Circular Economy","Grant",1,0.256,"FR"],
  ["Philippines","Incubator","Circular Economy","Equity",1,0.043,"PH"],
  ["Mexico","Incubator","Waste Management","Equity",3,0.3866,"MX"],
  ["Colombia","Nonprofit","Circular Economy","Lending",2,0.6987,"CO"],
  ["Spain","Impact Investor","Waste Management","Lending",4,1.3615,"ES"],
  ["Italy","Public / Semi-public","Ocean Cleanup","Lending",6,1.3995,"IT"],
  ["Brazil","Bank","Circular Economy","Lending",3,0.6987,"BR"],
  ["Afghanistan","Financial Service Provider","Circular Economy","Equity",1,0.0347,"AF"],
  ["Suriname","Venture Capital","Circular Economy","Equity",1,1.0,"SR"],
  ["Rwanda","Foundation","Waste Management","Grant",1,0.2108,"RW"],
  ["Uganda","Foundation","Waste Management","Lending",1,0.2744,"UG"],
  ["New Zealand","Foundation","Ocean Cleanup","Lending",1,0.143,"NZ"],
  ["Gabon","Public / Semi-public","Circular Economy","Lending",1,0.4243,"GA"],
  ["Portugal","Foundation","Ocean Cleanup","Equity",1,0.1527,"PT"],
  ["Vietnam","Incubator","Ocean Cleanup","Grant",1,0.0692,"VN"],
  ["Russia","Foundation","Ocean Cleanup","Grant",2,0.7363,"RU"],
  ["Poland","Nonprofit","Circular Economy","Lending",1,0.0777,"PL"],
  ["Latvia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"LV"],
  ["Jordan","Foundation","Ocean Cleanup","Grant",1,0.143,"JO"],
  ["Saint Kitts and Nevis","Public / Semi-public","Circular Economy","Equity",1,1.0,"KN"],
  ["South Georgia & South Sandwich Islands","Venture Capital","Circular Economy","Equity",1,1.0,"GS"],
  ["United Kingdom","Foundation","Ocean Cleanup","Grant",5,1.6003,"GB"],
  ["Bahrain","Foundation","Ocean Cleanup","Equity",1,0.1767,"BH"],
  ["Burkina Faso","Public / Semi-public","Waste Management","Grant",1,0.3578,"BF"],
  ["South Korea","Competitions","Waste Management","Grant",1,0.2503,"KR"],
  ["Ghana","Impact Investor","Ocean Cleanup","Grant",2,0.522,"GH"],
  ["Ukraine","Financial Service Provider","Circular Economy","Lending",1,0.2134,"UA"],
  ["Guyana","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"GY"],
  ["Trinidad and Tobago","Impact Investor","Waste Management","Equity",1,0.7546,"TT"],
  ["Finland","Venture Capital","Ocean Cleanup","Equity",1,1.0,"FI"],
  ["Cabo Verde","Financial Service Provider","Waste Management","Equity",1,0.0634,"CV"],
  ["Niger","Financial Service Provider","Ocean Cleanup","Lending",1,0.2378,"NE"],
  ["Canada","Crowdfunding","Ocean Cleanup","Equity",1,0.0262,"CA"],
  ["Italy","Incubator","Waste Management","Lending",1,0.1971,"IT"],
  ["Sri Lanka","Foundation","Waste Management","Grant",1,0.202,"LK"],
  ["Chile","Impact Investor","Ocean Cleanup","Equity",1,0.1561,"CL"],
  ["Hungary","Nonprofit","Circular Economy","Equity",1,0.1092,"HU"],
  ["Laos","Financial Service Provider","Waste Management","Equity",2,0.4258,"LA"],
  ["Portugal","Financial Service Provider","Waste Management","Grant",1,0.0822,"PT"],
  ["South Africa","Impact Investor","Ocean Cleanup","Equity",6,1.9096,"ZA"],
  ["Mozambique","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MZ"],
  ["Malaysia","Nonprofit","Ocean Cleanup","Equity",4,1.4625,"MY"],
  ["Taiwan","Public / Semi-public","Ocean Cleanup","Grant",3,0.6708,"TW"],
  ["Benin","Bank","Circular Economy","Lending",1,0.2869,"BJ"],
  ["Ethiopia","Nonprofit","Waste Management","Lending",2,0.5534,"ET"],
  ["Australia","Coworking Space","Waste Management","Equity",1,0.0695,"AU"],
  ["Malaysia","Foundation","Circular Economy","Grant",4,1.0131,"MY"],
  ["Saudi Arabia","Crowdfunding","Waste Management","Equity",1,0.044,"SA"],
  ["Nigeria","Impact Investor","Circular Economy","Lending",2,0.1756,"NG"],
  ["Nepal","Public / Semi-public","Ocean Cleanup","Lending",2,1.1522,"NP"],
  ["Greece","Nonprofit","Ocean Cleanup","Lending",4,0.7704,"GR"],
  ["Angola","Impact Investor","Waste Management","Equity",1,0.3036,"AO"],
  ["Brunei","Bank","Circular Economy","Lending",1,0.3757,"BN"],
  ["Egypt","Foundation","Waste Management","Lending",2,0.263,"EG"],
  ["Rwanda","Venture Capital","Ocean Cleanup","Grant",1,1.0,"RW"],
  ["Qatar","Foundation","Ocean Cleanup","Lending",1,0.2624,"QA"],
  ["Germany","Nonprofit","Circular Economy","Grant",5,1.6746,"DE"],
  ["Christmas Island","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CX"],
  ["Brazil","Venture Capital","Circular Economy","Equity",2,1.0242,"BR"],
  ["Morocco","Bank","Waste Management","Equity",1,0.083,"MA"],
  ["Laos","Nonprofit","Ocean Cleanup","Lending",1,0.3935,"LA"],
  ["Nigeria","Crowdfunding","Waste Management","Lending",1,0.0461,"NG"],
  ["New Caledonia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"NC"],
  ["Madagascar","Impact Investor","Ocean Cleanup","Grant",1,0.0696,"MG"],
  ["Thailand","Impact Investor","Circular Economy","Lending",2,0.2033,"TH"],
  ["Hong Kong","Foundation","Circular Economy","Grant",1,0.1366,"HK"],
  ["Germany","Foundation","Ocean Cleanup","Lending",2,0.3766,"DE"],
  ["Taiwan","Nonprofit","Waste Management","Grant",1,0.3026,"TW"],
  ["Oman","Foundation","Ocean Cleanup","Equity",1,0.1749,"OM"],
  ["Israel","Impact Investor","Ocean Cleanup","Grant",2,0.1536,"IL"],
  ["United Arab Emirates","Bank","Waste Management","Lending",1,0.2561,"AE"],
  ["India","Impact Investor","Ocean Cleanup","Equity",5,2.1966,"IN"],
  ["Philippines","Nonprofit","Ocean Cleanup","Lending",4,0.8728,"PH"],
  ["Côte d'Ivoire","Nonprofit","Ocean Cleanup","Grant",1,0.0295,"CI"],
  ["Trinidad and Tobago","Public / Semi-public","Waste Management","Equity",3,1.7712,"TT"],
  ["Sierra Leone","Nonprofit","Waste Management","Grant",1,0.0365,"SL"],
  ["Congo, Dem. Rep","Foundation","Waste Management","Equity",1,0.1508,"CD"],
  ["Panama","Impact Investor","Waste Management","Lending",1,0.9208,"PA"],
  ["Saudi Arabia","Impact Investor","Circular Economy","Equity",4,0.4105,"SA"],
  ["Switzerland","Incubator","Circular Economy","Equity",2,0.1641,"CH"],
  ["Cambodia","Impact Investor","Circular Economy","Lending",1,0.0658,"KH"],
  ["South Africa","Incubator","Circular Economy","Grant",1,0.1316,"ZA"],
  ["Pakistan","Impact Investor","Waste Management","Grant",3,0.4485,"PK"],
  ["Colombia","Bank","Circular Economy","Equity",1,0.1107,"CO"],
  ["Colombia","Nonprofit","Waste Management","Grant",5,1.2301,"CO"],
  ["Fiji","Public / Semi-public","Circular Economy","Grant",1,0.5692,"FJ"],
  ["Gabon","Nonprofit","Ocean Cleanup","Grant",1,0.0343,"GA"],
  ["Nigeria","Foundation","Ocean Cleanup","Lending",2,0.309,"NG"],
  ["Cyprus","Impact Investor","Waste Management","Equity",1,0.107,"CY"],
  ["Tanzania","Financial Service Provider","Waste Management","Lending",2,0.7975,"TZ"],
  ["Afghanistan","Impact Investor","Circular Economy","Equity",2,0.1054,"AF"],
  ["Myanmar","Impact Investor","Ocean Cleanup","Equity",2,0.5602,"MM"],
  ["Indonesia","Incubator","Waste Management","Lending",1,0.1298,"ID"],
  ["Haiti","Public / Semi-public","Circular Economy","Lending",2,0.8236,"HT"],
  ["Nigeria","Incubator","Waste Management","Equity",2,0.2343,"NG"],
  ["Oman","Crowdfunding","Ocean Cleanup","Equity",1,0.0339,"OM"],
  ["Germany","Bank","Circular Economy","Lending",4,0.8773,"DE"],
  ["Uzbekistan","Bank","Waste Management","Equity",1,0.3086,"UZ"],
  ["Uganda","Impact Investor","Ocean Cleanup","Lending",1,1.0,"UG"],
  ["Portugal","Venture Capital","Ocean Cleanup","Equity",1,1.0,"PT"],
  ["Mauritania","Public / Semi-public","Circular Economy","Grant",1,0.3609,"MR"],
  ["United States","Bank","Ocean Cleanup","Lending",5,0.6271,"US"],
  ["Peru","Foundation","Waste Management","Equity",1,0.1455,"PE"],
  ["Ghana","Venture Capital","Circular Economy","Equity",2,1.0285,"GH"],
  ["Netherlands Antilles","Venture Capital","Circular Economy","Equity",1,1.0,"AN"],
  ["Philippines","Crowdfunding","Circular Economy","Grant",1,0.5,"PH"],
  ["Austria","Impact Investor","Waste Management","Equity",3,0.3146,"AT"],
  ["Libya","Impact Investor","Ocean Cleanup","Equity",1,0.0278,"LY"],
  ["Algeria","Crowdfunding","Ocean Cleanup","Grant",1,0.0603,"DZ"],
  ["Cameroon","Nonprofit","Waste Management","Lending",2,0.4764,"CM"],
  ["Mongolia","Public / Semi-public","Waste Management","Grant",1,0.0294,"MN"],
  ["Saudi Arabia","Incubator","Waste Management","Lending",1,0.1242,"SA"],
  ["Aruba","Venture Capital","Circular Economy","Equity",1,1.0,"AW"],
  ["Mali","Public / Semi-public","Ocean Cleanup","Grant",1,0.4836,"ML"],
  ["Bermuda","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BM"],
  ["Peru","Public / Semi-public","Circular Economy","Equity",5,0.9762,"PE"],
  ["Australia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"AU"],
  ["Malaysia","Financial Service Provider","Waste Management","Grant",2,0.1944,"MY"],
  ["Japan","Incubator","Ocean Cleanup","Grant",1,0.0573,"JP"],
  ["Malta","Impact Investor","Waste Management","Grant",1,0.449,"MT"],
  ["Italy","Financial Service Provider","Circular Economy","Grant",1,0.107,"IT"],
  ["Qatar","Public / Semi-public","Waste Management","Equity",6,1.7137,"QA"],
  ["France","Bank","Ocean Cleanup","Equity",2,0.4562,"FR"],
  ["India","Incubator","Waste Management","Equity",4,2.2852,"IN"],
  ["Venezuela","Foundation","Waste Management","Grant",1,0.4253,"VE"],
  ["South Africa","Impact Investor","Circular Economy","Equity",5,1.3227,"ZA"],
  ["France","Foundation","Ocean Cleanup","Grant",5,1.4348,"FR"],
  ["Guyana","Public / Semi-public","Waste Management","Equity",2,1.9789,"GY"],
  ["Romania","Incubator","Circular Economy","Grant",1,0.1636,"RO"],
  ["Honduras","Impact Investor","Waste Management","Equity",1,0.8799,"HN"],
  ["Uganda","Public / Semi-public","Circular Economy","Equity",2,0.3738,"UG"],
  ["Qatar","Nonprofit","Circular Economy","Grant",1,0.2192,"QA"],
  ["Australia","Coworking Space","Waste Management","Lending",1,0.0695,"AU"],
  ["Pakistan","Impact Investor","Waste Management","Equity",5,0.896,"PK"],
  ["United Arab Emirates","Bank","Ocean Cleanup","Lending",4,0.5634,"AE"],
  ["Turkey","Incubator","Circular Economy","Grant",1,0.1152,"TR"],
  ["Argentina","Foundation","Ocean Cleanup","Grant",2,0.8348,"AR"],
  ["Malaysia","Financial Service Provider","Ocean Cleanup","Equity",1,0.0431,"MY"],
  ["Cameroon","Nonprofit","Waste Management","Equity",2,0.4764,"CM"],
  ["Netherlands","Nonprofit","Waste Management","Equity",3,1.4698,"NL"],
  ["France","Incubator","Ocean Cleanup","Lending",1,0.2017,"FR"],
  ["Japan","Financial Service Provider","Waste Management","Lending",1,0.1299,"JP"],
  ["Congo, Dem. Rep","Foundation","Waste Management","Lending",1,0.1508,"CD"],
  ["Canada","Bank","Waste Management","Equity",1,0.0994,"CA"],
  ["Indonesia","Impact Investor","Ocean Cleanup","Lending",3,0.3407,"ID"],
  ["Canada","Foundation","Waste Management","Grant",6,1.6728,"CA"],
  ["Saudi Arabia","Financial Service Provider","Circular Economy","Lending",1,0.1309,"SA"],
  ["Venezuela","Public / Semi-public","Ocean Cleanup","Lending",1,0.4072,"VE"],
  ["Bangladesh","Competitions","Waste Management","Grant",1,0.319,"BD"],
  ["Australia","Crowdfunding","Waste Management","Equity",1,0.3309,"AU"],
  ["El Salvador","Financial Service Provider","Ocean Cleanup","Equity",1,0.0946,"SV"],
  ["China","Foundation","Ocean Cleanup","Equity",1,0.1911,"CN"],
  ["Philippines","Incubator","Ocean Cleanup","Grant",1,0.0549,"PH"],
  ["Cameroon","Public / Semi-public","Circular Economy","Grant",3,0.5314,"CM"],
  ["Moldova","Financial Service Provider","Waste Management","Equity",1,0.2645,"MD"],
  ["Portugal","Coworking Space","Waste Management","Equity",1,0.0327,"PT"],
  ["Hong Kong","Public / Semi-public","Waste Management","Lending",1,0.1169,"HK"],
  ["South Africa","Impact Investor","Waste Management","Equity",4,0.5624,"ZA"],
  ["Bahamas, The","Impact Investor","Waste Management","Lending",1,1.0,"BS"],
  ["Mozambique","Foundation","Circular Economy","Grant",1,0.6148,"MZ"],
  ["Uganda","Nonprofit","Waste Management","Equity",3,1.5428,"UG"],
  ["Hong Kong","Competitions","Ocean Cleanup","Grant",1,0.2644,"HK"],
  ["Saudi Arabia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SA"],
  ["United Kingdom","Foundation","Ocean Cleanup","Equity",2,0.5696,"GB"],
  ["Botswana","Impact Investor","Ocean Cleanup","Grant",2,0.1498,"BW"],
  ["Bangladesh","Bank","Ocean Cleanup","Equity",2,0.3951,"BD"],
  ["Latvia","Impact Investor","Ocean Cleanup","Equity",1,0.0895,"LV"],
  ["Zimbabwe","Bank","Circular Economy","Equity",1,0.1109,"ZW"],
  ["Morocco","Public / Semi-public","Waste Management","Equity",10,3.0954,"MA"],
  ["Myanmar","Nonprofit","Waste Management","Lending",1,0.207,"MM"],
  ["Brazil","Crowdfunding","Ocean Cleanup","Grant",1,0.0849,"BR"],
  ["Estonia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"EE"],
  ["France","Competitions","Waste Management","Grant",1,0.2077,"FR"],
  ["Myanmar","Bank","Waste Management","Equity",1,0.1232,"MM"],
  ["Sri Lanka","Public / Semi-public","Waste Management","Lending",4,0.6685,"LK"],
  ["Swaziland","Public / Semi-public","Waste Management","Grant",1,0.0427,"SZ"],
  ["French Southern and Antarctic Lands","Venture Capital","Circular Economy","Equity",1,1.0,"TF"],
  ["India","Foundation","Ocean Cleanup","Equity",2,0.3555,"IN"],
  ["Portugal","Coworking Space","Waste Management","Lending",1,0.0327,"PT"],
  ["Kosovo","Public / Semi-public","Ocean Cleanup","Lending",3,1.4902,"XK"],
  ["South Africa","Nonprofit","Waste Management","Equity",4,0.6301,"ZA"],
  ["Thailand","Incubator","Circular Economy","Grant",1,0.0996,"TH"],
  ["Iceland","Financial Service Provider","Waste Management","Equity",1,0.1618,"IS"],
  ["Brazil","Foundation","Waste Management","Grant",6,1.8606,"BR"],
  ["United States","Incubator","Waste Management","Equity",5,2.6548,"US"],
  ["Yemen","Public / Semi-public","Waste Management","Lending",1,0.485,"YE"],
  ["Angola","Public / Semi-public","Waste Management","Lending",1,0.2469,"AO"],
  ["Brunei","Bank","Ocean Cleanup","Lending",1,0.3757,"BN"],
  ["Eritrea","Venture Capital","Ocean Cleanup","Equity",1,1.0,"ER"],
  ["Botswana","Foundation","Waste Management","Grant",1,0.1664,"BW"],
  ["Israel","Venture Capital","Circular Economy","Equity",2,1.0296,"IL"],
  ["Poland","Public / Semi-public","Waste Management","Lending",2,0.375,"PL"],
  ["Germany","Foundation","Circular Economy","Equity",1,0.1922,"DE"],
  ["Kuwait","Crowdfunding","Waste Management","Lending",1,0.0608,"KW"],
  ["Dominica","Public / Semi-public","Circular Economy","Equity",1,1.0,"DM"],
  ["Italy","Nonprofit","Circular Economy","Grant",5,1.8345,"IT"],
  ["India","Financial Service Provider","Ocean Cleanup","Lending",1,0.1241,"IN"],
  ["India","Public / Semi-public","Circular Economy","Grant",6,1.5821,"IN"],
  ["Cyprus","Public / Semi-public","Circular Economy","Grant",1,0.2005,"CY"],
  ["Egypt","Impact Investor","Circular Economy","Lending",2,0.2427,"EG"],
  ["Argentina","Impact Investor","Waste Management","Equity",4,1.2218,"AR"],
  ["Finland","Public / Semi-public","Waste Management","Grant",1,0.0906,"FI"],
  ["Côte d'Ivoire","Nonprofit","Waste Management","Equity",1,0.0687,"CI"],
  ["Georgia","Bank","Circular Economy","Equity",1,0.3414,"GE"],
  ["Saint Kitts and Nevis","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"KN"],
  ["Belgium","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BE"],
  ["Peru","Nonprofit","Circular Economy","Lending",2,0.2518,"PE"],
  ["South Africa","Public / Semi-public","Ocean Cleanup","Equity",7,2.0291,"ZA"],
  ["Cuba","Venture Capital","Circular Economy","Equity",1,1.0,"CU"],
  ["Kuwait","Nonprofit","Ocean Cleanup","Grant",1,0.2124,"KW"],
  ["Japan","Foundation","Waste Management","Equity",1,0.184,"JP"],
  ["Pakistan","Foundation","Circular Economy","Equity",1,0.1539,"PK"],
  ["Pakistan","Nonprofit","Ocean Cleanup","Lending",6,1.1639,"PK"],
  ["Philippines","Public / Semi-public","Ocean Cleanup","Lending",2,1.3519,"PH"],
  ["Trinidad and Tobago","Impact Investor","Waste Management","Grant",1,0.464,"TT"],
  ["France","Financial Service Provider","Circular Economy","Grant",1,0.2728,"FR"],
  ["Cayman Islands","Public / Semi-public","Waste Management","Equity",1,0.7428,"KY"],
  ["Dominican Republic","Financial Service Provider","Waste Management","Lending",1,0.0929,"DO"],
  ["Albania","Public / Semi-public","Waste Management","Equity",4,1.3981,"AL"],
  ["Bosnia and Herzegovina","Public / Semi-public","Circular Economy","Grant",1,0.4105,"BA"],
  ["Mexico","Impact Investor","Waste Management","Grant",2,0.2489,"MX"],
  ["Albania","Nonprofit","Waste Management","Lending",1,1.0,"AL"],
  ["Ireland","Impact Investor","Circular Economy","Lending",1,0.0953,"IE"],
  ["Falkland Islands (Islas Malvinas)","Venture Capital","Ocean Cleanup","Equity",1,1.0,"FK"],
  ["Niger","Public / Semi-public","Circular Economy","Equity",1,0.4697,"NE"],
  ["Cyprus","Public / Semi-public","Circular Economy","Lending",1,0.0748,"CY"],
  ["Indonesia","Bank","Circular Economy","Equity",3,0.7173,"ID"],
  ["Colombia","Financial Service Provider","Waste Management","Equity",3,0.4772,"CO"],
  ["Costa Rica","Public / Semi-public","Circular Economy","Grant",1,0.0867,"CR"],
  ["Taiwan","Crowdfunding","Ocean Cleanup","Equity",1,0.2193,"TW"],
  ["Argentina","Crowdfunding","Ocean Cleanup","Equity",1,0.029,"AR"],
  ["Argentina","Nonprofit","Ocean Cleanup","Equity",2,0.2498,"AR"],
  ["Saudi Arabia","Nonprofit","Circular Economy","Lending",2,0.2817,"SA"],
  ["Hungary","Public / Semi-public","Ocean Cleanup","Equity",1,0.2434,"HU"],
  ["El Salvador","Venture Capital","Circular Economy","Equity",1,1.0,"SV"],
  ["Australia","Microfinance Institution","Waste Management","Lending",1,0.0461,"AU"],
  ["Egypt","Impact Investor","Circular Economy","Grant",1,0.1139,"EG"],
  ["Lebanon","Microfinance Institution","Waste Management","Lending",1,0.0329,"LB"],
  ["Georgia","Bank","Waste Management","Lending",1,0.3414,"GE"],
  ["United States","Nonprofit","Circular Economy","Lending",2,1.4237,"US"],
  ["Ethiopia","Nonprofit","Ocean Cleanup","Grant",5,1.0436,"ET"],
  ["Nigeria","Foundation","Circular Economy","Lending",1,0.1869,"NG"],
  ["Turkey","Impact Investor","Waste Management","Grant",2,0.1786,"TR"],
  ["Oman","Venture Capital","Ocean Cleanup","Equity",1,1.0,"OM"],
  ["Mauritius","Public / Semi-public","Ocean Cleanup","Equity",3,2.0329,"MU"],
  ["Indonesia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"ID"],
  ["Zambia","Impact Investor","Circular Economy","Grant",1,0.0764,"ZM"],
  ["Malta","Foundation","Waste Management","Grant",1,0.449,"MT"],
  ["British Virgin Islands","Public / Semi-public","Circular Economy","Equity",1,0.6521,"VG"],
  ["Guam","Venture Capital","Circular Economy","Equity",1,1.0,"GU"],
  ["Congo, Dem. Rep","Venture Capital","Circular Economy","Equity",1,1.0,"CD"],
  ["Lithuania","Public / Semi-public","Ocean Cleanup","Equity",1,0.0491,"LT"],
  ["Argentina","Foundation","Waste Management","Equity",1,0.1547,"AR"],
  ["Saudi Arabia","Financial Service Provider","Waste Management","Grant",2,0.1337,"SA"],
  ["Bolivia","Public / Semi-public","Ocean Cleanup","Equity",1,0.2467,"BO"],
  ["South Africa","Impact Investor","Waste Management","Lending",3,0.5348,"ZA"],
  ["Turkey","Incubator","Waste Management","Equity",2,0.2813,"TR"],
  ["Malaysia","Nonprofit","Waste Management","Grant",3,1.0452,"MY"],
  ["Ireland","Foundation","Waste Management","Lending",1,0.1463,"IE"],
  ["Germany","Incubator","Waste Management","Equity",4,0.9658,"DE"],
  ["United Kingdom","Financial Service Provider","Ocean Cleanup","Lending",1,0.1363,"GB"],
  ["Libya","Public / Semi-public","Circular Economy","Lending",1,0.2347,"LY"],
  ["Uganda","Impact Investor","Ocean Cleanup","Equity",3,2.3145,"UG"],
  ["Peru","Bank","Waste Management","Equity",1,0.1073,"PE"],
  ["Colombia","Bank","Waste Management","Equity",1,0.1107,"CO"],
  ["Swaziland","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SZ"],
  ["Burkina Faso","Public / Semi-public","Waste Management","Equity",3,0.6358,"BF"],
  ["Portugal","Incubator","Circular Economy","Equity",1,0.1252,"PT"],
  ["Philippines","Bank","Circular Economy","Equity",3,1.4286,"PH"],
  ["Myanmar","Bank","Waste Management","Lending",1,0.1232,"MM"],
  ["Netherlands","Foundation","Ocean Cleanup","Lending",2,0.3139,"NL"],
  ["Guyana","Public / Semi-public","Circular Economy","Equity",1,1.0,"GY"],
  ["Bangladesh","Nonprofit","Circular Economy","Grant",5,1.3618,"BD"],
  ["Poland","Nonprofit","Ocean Cleanup","Grant",3,1.0163,"PL"],
  ["France","Financial Service Provider","Ocean Cleanup","Equity",2,0.1577,"FR"],
  ["Yemen","Crowdfunding","Waste Management","Equity",1,0.0349,"YE"],
  ["China","Public / Semi-public","Waste Management","Grant",4,0.7808,"CN"],
  ["Mali","Financial Service Provider","Waste Management","Lending",2,0.5464,"ML"],
  ["Fiji","Venture Capital","Ocean Cleanup","Equity",1,1.0,"FJ"],
  ["France","Foundation","Circular Economy","Equity",1,0.1464,"FR"],
  ["South Sudan","Bank","Circular Economy","Equity",1,0.4521,"SS"],
  ["Brazil","Financial Service Provider","Circular Economy","Grant",1,0.2203,"BR"],
  ["Mongolia","Crowdfunding","Waste Management","Equity",1,0.0295,"MN"],
  ["Egypt","Incubator","Ocean Cleanup","Equity",1,0.1169,"EG"],
  ["Botswana","Impact Investor","Ocean Cleanup","Lending",1,0.3088,"BW"],
  ["United Arab Emirates","Public / Semi-public","Ocean Cleanup","Lending",3,0.443,"AE"],
  ["Venezuela","Public / Semi-public","Ocean Cleanup","Equity",2,1.1511,"VE"],
  ["India","Public / Semi-public","Ocean Cleanup","Lending",10,3.1405,"IN"],
  ["Afghanistan","Public / Semi-public","Waste Management","Equity",5,2.0591,"AF"],
  ["Guinea-Bisau","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GW"],
  ["Iraq","Impact Investor","Circular Economy","Grant",1,0.0533,"IQ"],
  ["Portugal","Public / Semi-public","Circular Economy","Lending",1,0.0359,"PT"],
  ["Botswana","Bank","Waste Management","Lending",1,0.5518,"BW"],
  ["Nepal","Venture Capital","Ocean Cleanup","Equity",1,1.0,"NP"],
  ["Lesotho","Public / Semi-public","Waste Management","Grant",1,0.1192,"LS"],
  ["Bangladesh","Bank","Ocean Cleanup","Lending",4,0.4818,"BD"],
  ["Serbia","Foundation","Ocean Cleanup","Grant",1,0.6321,"RS"],
  ["Ghana","Public / Semi-public","Ocean Cleanup","Equity",5,2.0838,"GH"],
  ["India","Foundation","Circular Economy","Equity",1,0.1655,"IN"],
  ["Switzerland","Financial Service Provider","Circular Economy","Grant",1,0.0715,"CH"],
  ["Denmark","Venture Capital","Ocean Cleanup","Equity",1,1.0,"DK"],
  ["Tunisia","Impact Investor","Waste Management","Grant",1,0.0711,"TN"],
  ["Paraguay","Impact Investor","Waste Management","Lending",1,0.9609,"PY"],
  ["Canada","Nonprofit","Circular Economy","Grant",5,1.8099,"CA"],
  ["Czech Republic","Nonprofit","Ocean Cleanup","Grant",1,0.0379,"CZ"],
  ["United States","Nonprofit","Ocean Cleanup","Grant",9,4.6376,"US"],
  ["Philippines","Public / Semi-public","Ocean Cleanup","Equity",3,1.492,"PH"],
  ["Nicaragua","Public / Semi-public","Waste Management","Equity",2,1.3848,"NI"],
  ["Ireland","Impact Investor","Circular Economy","Equity",2,0.1275,"IE"],
  ["Qatar","Nonprofit","Waste Management","Lending",1,0.0498,"QA"],
  ["Colombia","Impact Investor","Circular Economy","Lending",2,0.6987,"CO"],
  ["Pitcairn Islands","Venture Capital","Circular Economy","Equity",1,1.0,"PN"],
  ["Ethiopia","Financial Service Provider","Ocean Cleanup","Lending",1,0.3695,"ET"],
  ["Benin","Impact Investor","Waste Management","Grant",1,0.3631,"BJ"],
  ["Portugal","Public / Semi-public","Ocean Cleanup","Equity",5,1.0392,"PT"],
  ["Namibia","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"NA"],
  ["Zambia","Impact Investor","Ocean Cleanup","Lending",1,0.2714,"ZM"],
  ["Congo, Dem. Rep","Impact Investor","Waste Management","Equity",1,1.0,"CD"],
  ["China","Financial Service Provider","Waste Management","Grant",2,0.4419,"CN"],
  ["Hong Kong","Public / Semi-public","Ocean Cleanup","Grant",1,0.274,"HK"],
  ["China","Financial Service Provider","Ocean Cleanup","Equity",1,0.1038,"CN"],
  ["Oman","Venture Capital","Circular Economy","Equity",2,1.0551,"OM"],
  ["Ethiopia","Impact Investor","Circular Economy","Equity",1,0.0337,"ET"],
  ["Jordan","Impact Investor","Ocean Cleanup","Equity",1,0.0276,"JO"],
  ["Canada","Incubator","Ocean Cleanup","Lending",1,0.1996,"CA"],
  ["Finland","Public / Semi-public","Waste Management","Lending",1,0.2157,"FI"],
  ["Spain","Public / Semi-public","Circular Economy","Equity",4,2.0347,"ES"],
  ["Kenya","Impact Investor","Ocean Cleanup","Grant",4,3.3707,"KE"],
  ["Ethiopia","Financial Service Provider","Waste Management","Grant",1,0.0923,"ET"],
  ["Egypt","Public / Semi-public","Circular Economy","Equity",5,1.5602,"EG"],
  ["Mauritania","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MR"],
  ["Pakistan","Public / Semi-public","Waste Management","Equity",11,3.0298,"PK"],
  ["Peru","Venture Capital","Ocean Cleanup","Equity",1,1.0,"PE"],
  ["Malaysia","Public / Semi-public","Ocean Cleanup","Lending",3,0.9046,"MY"],
  ["India","Impact Investor","Circular Economy","Grant",1,0.0882,"IN"],
  ["Peru","Coworking Space","Waste Management","Equity",1,0.0289,"PE"],
  ["San Marino","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SM"],
  ["Mauritius","Public / Semi-public","Circular Economy","Equity",1,0.0329,"MU"],
  ["Kyrgyz Republic","Bank","Ocean Cleanup","Lending",1,0.0643,"KG"],
  ["Tunisia","Financial Service Provider","Circular Economy","Lending",1,0.0842,"TN"],
  ["Gabon","Public / Semi-public","Waste Management","Equity",1,0.4243,"GA"],
  ["Congo, Rep.","Financial Service Provider","Waste Management","Equity",1,1.0,"CG"],
  ["United States","Foundation","Ocean Cleanup","Grant",5,2.9907,"US"],
  ["Egypt","Bank","Waste Management","Lending",2,0.3037,"EG"],
  ["Ethiopia","Impact Investor","Circular Economy","Grant",1,0.127,"ET"],
  ["Nigeria","Nonprofit","Circular Economy","Grant",3,0.9668,"NG"],
  ["Guinea","Public / Semi-public","Circular Economy","Equity",2,0.3999,"GN"],
  ["South Korea","Impact Investor","Ocean Cleanup","Lending",1,0.1697,"KR"],
  ["United States","Financial Service Provider","Ocean Cleanup","Equity",2,1.2943,"US"],
  ["Hong Kong","Bank","Circular Economy","Lending",1,0.2594,"HK"],
  ["Germany","Competitions","Waste Management","Grant",1,0.2387,"DE"],
  ["Taiwan","Impact Investor","Circular Economy","Lending",1,0.0662,"TW"],
  ["Philippines","Incubator","Waste Management","Equity",3,0.2819,"PH"],
  ["Netherlands","Venture Capital","Circular Economy","Equity",1,1.0,"NL"],
  ["France","Financial Service Provider","Ocean Cleanup","Lending",1,0.1264,"FR"],
  ["France","Financial Service Provider","Waste Management","Grant",2,0.3599,"FR"],
  ["Bosnia and Herzegovina","Foundation","Waste Management","Grant",1,0.4609,"BA"],
  ["Panama","Venture Capital","Circular Economy","Equity",1,1.0,"PA"],
  ["Brazil","Foundation","Ocean Cleanup","Lending",2,0.2885,"BR"],
  ["Mongolia","Venture Capital","Circular Economy","Equity",1,1.0,"MN"],
  ["Thailand","Crowdfunding","Ocean Cleanup","Grant",2,0.5751,"TH"],
  ["Mauritius","Impact Investor","Waste Management","Equity",1,0.0314,"MU"],
  ["Nicaragua","Financial Service Provider","Ocean Cleanup","Equity",1,0.3848,"NI"],
  ["Germany","Venture Capital","Ocean Cleanup","Equity",1,1.0,"DE"],
  ["Gabon","Nonprofit","Waste Management","Lending",1,0.177,"GA"],
  ["Puerto Rico","Venture Capital","Circular Economy","Equity",2,1.0922,"PR"],
  ["Japan","Incubator","Waste Management","Grant",1,0.0573,"JP"],
  ["Saudi Arabia","Foundation","Waste Management","Lending",2,0.3619,"SA"],
  ["United Arab Emirates","Financial Service Provider","Waste Management","Grant",2,0.14,"AE"],
  ["Senegal","Public / Semi-public","Circular Economy","Grant",1,0.3764,"SN"],
  ["Bahrain","Bank","Circular Economy","Equity",2,0.6974,"BH"],
  ["Australia","Incubator","Circular Economy","Grant",1,0.1757,"AU"],
  ["Ecuador","Nonprofit","Waste Management","Grant",1,0.2217,"EC"],
  ["Nicaragua","Public / Semi-public","Waste Management","Lending",2,1.3848,"NI"],
  ["Morocco","Bank","Ocean Cleanup","Equity",1,0.083,"MA"],
  ["Poland","Nonprofit","Waste Management","Equity",1,0.0777,"PL"],
  ["Sudan","Nonprofit","Waste Management","Equity",1,0.1759,"SD"],
  ["Indonesia","Bank","Ocean Cleanup","Lending",4,0.7294,"ID"],
  ["Spain","Financial Service Provider","Waste Management","Grant",1,0.2589,"ES"],
  ["Costa Rica","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CR"],
  ["Kenya","Incubator","Waste Management","Lending",1,0.3037,"KE"],
  ["Argentina","Incubator","Ocean Cleanup","Lending",1,0.1547,"AR"],
  ["Madagascar","Public / Semi-public","Waste Management","Equity",2,0.9678,"MG"],
  ["Belgium","Nonprofit","Waste Management","Equity",4,0.6437,"BE"],
  ["Netherlands","Bank","Circular Economy","Lending",3,1.4124,"NL"],
  ["Kenya","Financial Service Provider","Ocean Cleanup","Lending",1,0.4649,"KE"],
  ["Switzerland","Public / Semi-public","Waste Management","Equity",6,2.1838,"CH"],
  ["Switzerland","Nonprofit","Waste Management","Lending",3,0.472,"CH"],
  ["Tunisia","Bank","Waste Management","Lending",1,0.1131,"TN"],
  ["Sudan","Incubator","Ocean Cleanup","Grant",1,0.0745,"SD"],
  ["Switzerland","Nonprofit","Waste Management","Equity",2,0.4351,"CH"],
  ["Mexico","Impact Investor","Ocean Cleanup","Lending",2,0.4113,"MX"],
  ["Niger","Public / Semi-public","Ocean Cleanup","Lending",3,1.7075,"NE"],
  ["Italy","Incubator","Ocean Cleanup","Equity",2,0.2773,"IT"],
  ["Netherlands","Incubator","Circular Economy","Equity",1,0.1176,"NL"],
  ["Rwanda","Public / Semi-public","Ocean Cleanup","Equity",5,2.0149,"RW"],
  ["South Sudan","Public / Semi-public","Waste Management","Equity",1,0.0497,"SS"],
  ["India","Nonprofit","Waste Management","Lending",5,1.7504,"IN"],
  ["Tokelau","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TK"],
  ["India","Impact Investor","Circular Economy","Equity",4,1.5973,"IN"],
  ["Austria","Public / Semi-public","Waste Management","Lending",2,0.8603,"AT"],
  ["Niger","Financial Service Provider","Ocean Cleanup","Equity",1,0.2378,"NE"],
  ["Slovenia","Public / Semi-public","Circular Economy","Grant",1,0.3047,"SI"],
  ["Congo, Rep.","Public / Semi-public","Ocean Cleanup","Equity",3,1.5274,"CG"],
  ["Uganda","Nonprofit","Waste Management","Lending",3,1.5428,"UG"],
  ["Canada","Public / Semi-public","Waste Management","Lending",8,2.942,"CA"],
  ["Cameroon","Foundation","Ocean Cleanup","Grant",1,0.3483,"CM"],
  ["Bahamas, The","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BS"],
  ["Taiwan","Impact Investor","Waste Management","Lending",1,0.0662,"TW"],
  ["Uruguay","Public / Semi-public","Waste Management","Lending",1,1.0,"UY"],
  ["Rwanda","Financial Service Provider","Ocean Cleanup","Equity",1,0.3697,"RW"],
  ["Cambodia","Financial Service Provider","Circular Economy","Lending",1,0.9712,"KH"],
  ["Norway","Public / Semi-public","Ocean Cleanup","Lending",2,0.3984,"NO"],
  ["New Zealand","Public / Semi-public","Circular Economy","Equity",1,0.2237,"NZ"],
  ["India","Nonprofit","Circular Economy","Equity",2,1.4608,"IN"],
  ["Syria","Foundation","Waste Management","Grant",1,1.0,"SY"],
  ["Guyana","Public / Semi-public","Waste Management","Lending",1,0.9789,"GY"],
  ["Bolivia","Foundation","Ocean Cleanup","Grant",2,0.7357,"BO"],
  ["Iraq","Public / Semi-public","Ocean Cleanup","Equity",6,1.6882,"IQ"],
  ["Australia","Foundation","Ocean Cleanup","Equity",2,0.3742,"AU"],
  ["Thailand","Venture Capital","Circular Economy","Equity",2,1.0388,"TH"],
  ["Burundi","Venture Capital","Circular Economy","Equity",1,1.0,"BI"],
  ["Sudan","Nonprofit","Ocean Cleanup","Grant",1,0.2373,"SD"],
  ["Saudi Arabia","Financial Service Provider","Waste Management","Lending",2,0.1761,"SA"],
  ["United Kingdom","Incubator","Waste Management","Equity",5,1.4438,"GB"],
  ["Côte d'Ivoire","Nonprofit","Waste Management","Grant",1,0.0295,"CI"],
  ["Romania","Foundation","Waste Management","Lending",1,0.14,"RO"],
  ["Turkey","Nonprofit","Circular Economy","Lending",2,0.4145,"TR"],
  ["Papua New Guinea","Foundation","Waste Management","Grant",1,0.207,"PG"],
  ["St. Vincent and the Grenadines","Public / Semi-public","Circular Economy","Equity",1,1.0,"VC"],
  ["Belgium","Public / Semi-public","Circular Economy","Grant",3,0.8497,"BE"],
  ["Malawi","Incubator","Ocean Cleanup","Equity",1,0.2661,"MW"],
  ["Australia","Incubator","Waste Management","Grant",1,0.1042,"AU"],
  ["Qatar","Public / Semi-public","Waste Management","Lending",3,1.2933,"QA"],
  ["Kenya","Impact Investor","Ocean Cleanup","Equity",6,2.7897,"KE"],
  ["Turkey","Competitions","Ocean Cleanup","Grant",1,0.1833,"TR"],
  ["Slovenia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SI"],
  ["Greece","Incubator","Circular Economy","Grant",1,0.1552,"GR"],
  ["India","Public / Semi-public","Circular Economy","Lending",8,2.89,"IN"],
  ["Greece","Impact Investor","Waste Management","Lending",2,0.2336,"GR"],
  ["Mali","Venture Capital","Ocean Cleanup","Equity",1,1.0,"ML"],
  ["Costa Rica","Public / Semi-public","Waste Management","Grant",1,0.0867,"CR"],
  ["Russia","Foundation","Ocean Cleanup","Lending",1,0.1588,"RU"],
  ["France","Public / Semi-public","Waste Management","Lending",10,4.2437,"FR"],
  ["Afghanistan","Public / Semi-public","Ocean Cleanup","Lending",2,1.1613,"AF"],
  ["Denmark","Incubator","Waste Management","Grant",1,0.0637,"DK"],
  ["Romania","Foundation","Ocean Cleanup","Lending",1,0.14,"RO"],
  ["Ethiopia","Impact Investor","Ocean Cleanup","Grant",2,0.4926,"ET"],
  ["Peru","Public / Semi-public","Ocean Cleanup","Equity",9,2.336,"PE"],
  ["Malaysia","Crowdfunding","Ocean Cleanup","Equity",1,1.0,"MY"],
  ["Russia","Incubator","Waste Management","Lending",1,0.1588,"RU"],
  ["Italy","Public / Semi-public","Circular Economy","Lending",6,1.3524,"IT"],
  ["Nicaragua","Public / Semi-public","Ocean Cleanup","Equity",1,0.3848,"NI"],
  ["Guatemala","Nonprofit","Ocean Cleanup","Grant",1,0.583,"GT"],
  ["Oman","Bank","Circular Economy","Equity",2,0.4493,"OM"],
  ["Mauritania","Public / Semi-public","Ocean Cleanup","Grant",1,0.3609,"MR"],
  ["Taiwan","Bank","Circular Economy","Equity",1,0.4476,"TW"],
  ["Timor-Leste","Nonprofit","Ocean Cleanup","Equity",1,0.365,"TL"],
  ["Papua New Guinea","Impact Investor","Waste Management","Grant",1,0.207,"PG"],
  ["United Kingdom","Public / Semi-public","Circular Economy","Equity",7,1.8931,"GB"],
  ["Philippines","Foundation","Waste Management","Equity",2,0.2822,"PH"],
  ["Philippines","Public / Semi-public","Ocean Cleanup","Grant",6,1.9132,"PH"],
  ["United Kingdom","Bank","Waste Management","Lending",2,0.3846,"GB"],
  ["Italy","Impact Investor","Ocean Cleanup","Lending",3,0.8041,"IT"],
  ["Madagascar","Public / Semi-public","Ocean Cleanup","Equity",4,2.0777,"MG"],
  ["Papua New Guinea","Microfinance Institution","Waste Management","Lending",1,0.0536,"PG"],
  ["Barbados","Public / Semi-public","Waste Management","Equity",2,2.0,"BB"],
  ["Libya","Venture Capital","Circular Economy","Equity",1,1.0,"LY"],
  ["Cabo Verde","Nonprofit","Waste Management","Lending",1,0.0634,"CV"],
  ["Taiwan","Foundation","Waste Management","Grant",1,0.0932,"TW"],
  ["Pitcairn Islands","Venture Capital","Ocean Cleanup","Equity",1,1.0,"PN"],
  ["Norway","Nonprofit","Ocean Cleanup","Lending",1,0.2036,"NO"],
  ["Cayman Islands","Venture Capital","Ocean Cleanup","Equity",1,1.0,"KY"],
  ["Tunisia","Foundation","Ocean Cleanup","Grant",1,0.2757,"TN"],
  ["Mexico","Competitions","Ocean Cleanup","Grant",1,0.2488,"MX"],
  ["Singapore","Public / Semi-public","Circular Economy","Lending",3,0.9278,"SG"],
  ["Mongolia","Bank","Ocean Cleanup","Lending",2,0.2963,"MN"],
  ["Kuwait","Public / Semi-public","Waste Management","Equity",1,0.23,"KW"],
  ["United Arab Emirates","Venture Capital","Circular Economy","Equity",1,1.0,"AE"],
  ["Peru","Impact Investor","Waste Management","Equity",4,1.2966,"PE"],
  ["Mexico","Nonprofit","Waste Management","Grant",5,1.391,"MX"],
  ["Macedonia","Crowdfunding","Waste Management","Equity",1,0.04,"MK"],
  ["Zambia","Foundation","Ocean Cleanup","Grant",1,0.1839,"ZM"],
  ["Japan","Microfinance Institution","Waste Management","Lending",1,0.0261,"JP"],
  ["Trinidad and Tobago","Public / Semi-public","Waste Management","Lending",2,0.8399,"TT"],
  ["United Kingdom","Public / Semi-public","Ocean Cleanup","Equity",13,3.0256,"GB"],
  ["Ghana","Competitions","Waste Management","Grant",1,0.2935,"GH"],
  ["South Korea","Coworking Space","Waste Management","Lending",1,0.0313,"KR"],
  ["Ireland","Incubator","Circular Economy","Equity",1,0.0887,"IE"],
  ["Pakistan","Bank","Waste Management","Equity",1,0.3553,"PK"],
  ["Sweden","Foundation","Waste Management","Grant",2,0.6604,"SE"],
  ["Thailand","Foundation","Ocean Cleanup","Lending",2,0.2465,"TH"],
  ["Afghanistan","Impact Investor","Ocean Cleanup","Equity",2,0.4664,"AF"],
  ["Tanzania","Impact Investor","Ocean Cleanup","Grant",3,0.4994,"TZ"],
  ["Malaysia","Coworking Space","Waste Management","Lending",1,0.2409,"MY"],
  ["Pakistan","Bank","Ocean Cleanup","Lending",3,0.7011,"PK"],
  ["Equatorial Guinea","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"GQ"],
  ["Lebanon","Nonprofit","Ocean Cleanup","Grant",2,0.6932,"LB"],
  ["Pakistan","Impact Investor","Ocean Cleanup","Grant",3,0.5313,"PK"],
  ["Ghana","Financial Service Provider","Waste Management","Equity",4,1.4143,"GH"],
  ["Austria","Foundation","Waste Management","Grant",1,0.2637,"AT"],
  ["Puerto Rico","Financial Service Provider","Ocean Cleanup","Equity",1,0.2443,"PR"],
  ["Taiwan","Financial Service Provider","Waste Management","Equity",1,0.0538,"TW"],
  ["Nepal","Bank","Circular Economy","Equity",1,0.11,"NP"],
  ["Argentina","Bank","Waste Management","Lending",1,0.2475,"AR"],
  ["Egypt","Nonprofit","Ocean Cleanup","Equity",4,0.8732,"EG"],
  ["Gabon","Venture Capital","Circular Economy","Equity",1,1.0,"GA"],
  ["India","Bank","Ocean Cleanup","Lending",5,0.6112,"IN"],
  ["Mexico","Venture Capital","Circular Economy","Equity",1,1.0,"MX"],
  ["Denmark","Nonprofit","Circular Economy","Equity",1,0.1324,"DK"],
  ["Vietnam","Crowdfunding","Ocean Cleanup","Grant",1,0.1247,"VN"],
  ["Saint Pierre and Miquelon","Venture Capital","Ocean Cleanup","Equity",1,1.0,"PM"],
  ["Pakistan","Crowdfunding","Waste Management","Lending",1,0.0248,"PK"],
  ["Mexico","Financial Service Provider","Circular Economy","Lending",1,0.1672,"MX"],
  ["Tunisia","Public / Semi-public","Waste Management","Lending",7,2.7236,"TN"],
  ["Cameroon","Nonprofit","Waste Management","Grant",2,0.2683,"CM"],
  ["Gambia","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"GM"],
  ["Sweden","Financial Service Provider","Circular Economy","Equity",1,0.0312,"SE"],
  ["Kenya","Foundation","Ocean Cleanup","Lending",2,1.3037,"KE"],
  ["Russia","Foundation","Waste Management","Lending",1,0.1588,"RU"],
  ["Dominican Republic","Impact Investor","Waste Management","Lending",1,0.2854,"DO"],
  ["Kosovo","Public / Semi-public","Circular Economy","Equity",1,0.3514,"XK"],
  ["Canada","Crowdfunding","Ocean Cleanup","Grant",1,0.1545,"CA"],
  ["Philippines","Crowdfunding","Ocean Cleanup","Grant",2,1.5,"PH"],
  ["Zimbabwe","Venture Capital","Circular Economy","Equity",2,1.0531,"ZW"],
  ["United Arab Emirates","Nonprofit","Circular Economy","Grant",4,0.9435,"AE"],
  ["South Africa","Financial Service Provider","Circular Economy","Lending",1,1.0,"ZA"],
  ["Bangladesh","Public / Semi-public","Waste Management","Grant",6,1.0418,"BD"],
  ["Rwanda","Nonprofit","Ocean Cleanup","Grant",3,1.5237,"RW"],
  ["Belize","Public / Semi-public","Ocean Cleanup","Equity",1,0.9462,"BZ"],
  ["Sudan","Public / Semi-public","Waste Management","Grant",3,0.4478,"SD"],
  ["France","Foundation","Waste Management","Equity",2,0.3481,"FR"],
  ["Denmark","Nonprofit","Circular Economy","Grant",1,0.4268,"DK"],
  ["Sierra Leone","Nonprofit","Waste Management","Equity",1,0.036,"SL"],
  ["Rwanda","Public / Semi-public","Circular Economy","Equity",3,1.004,"RW"],
  ["Tajikistan","Bank","Waste Management","Equity",1,0.4342,"TJ"],
  ["Qatar","Bank","Waste Management","Lending",1,0.1813,"QA"],
  ["Argentina","Public / Semi-public","Waste Management","Grant",2,0.4255,"AR"],
  ["Niger","Public / Semi-public","Ocean Cleanup","Equity",3,1.7075,"NE"],
  ["Trinidad and Tobago","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TT"],
  ["Singapore","Nonprofit","Circular Economy","Equity",2,0.2463,"SG"],
  ["Belgium","Financial Service Provider","Ocean Cleanup","Lending",1,0.1033,"BE"],
  ["Niger","Nonprofit","Waste Management","Lending",1,0.2378,"NE"],
  ["Jamaica","Public / Semi-public","Circular Economy","Equity",1,1.0,"JM"],
  ["Uganda","Incubator","Ocean Cleanup","Grant",1,0.1325,"UG"],
  ["Ukraine","Venture Capital","Ocean Cleanup","Equity",1,1.0,"UA"],
  ["Yemen","Crowdfunding","Ocean Cleanup","Equity",1,0.0349,"YE"],
  ["New Zealand","Nonprofit","Circular Economy","Grant",3,0.8591,"NZ"],
  ["Laos","Venture Capital","Waste Management","Equity",2,0.0637,"LA"],
  ["Ecuador","Public / Semi-public","Waste Management","Grant",1,0.1211,"EC"],
  ["Thailand","Nonprofit","Circular Economy","Equity",2,0.2033,"TH"],
  ["Zimbabwe","Foundation","Ocean Cleanup","Equity",2,0.3427,"ZW"],
  ["Malawi","Incubator","Ocean Cleanup","Lending",1,0.2661,"MW"],
  ["Rwanda","Impact Investor","Ocean Cleanup","Lending",1,1.0,"RW"],
  ["Romania","Foundation","Waste Management","Grant",1,0.3044,"RO"],
  ["Sao Tome and Principe","Venture Capital","Ocean Cleanup","Equity",1,1.0,"ST"],
  ["Bosnia and Herzegovina","Foundation","Ocean Cleanup","Grant",1,0.4609,"BA"],
  ["South Africa","Financial Service Provider","Waste Management","Equity",4,1.4431,"ZA"],
  ["Vietnam","Impact Investor","Waste Management","Lending",1,0.1286,"VN"],
  ["Tanzania","Public / Semi-public","Ocean Cleanup","Grant",5,0.7834,"TZ"],
  ["Australia","Financial Service Provider","Circular Economy","Lending",2,0.5362,"AU"],
  ["Sweden","Incubator","Ocean Cleanup","Equity",1,0.1377,"SE"],
  ["Georgia","Bank","Ocean Cleanup","Lending",2,0.5604,"GE"],
  ["Uzbekistan","Bank","Ocean Cleanup","Equity",1,0.3086,"UZ"],
  ["South Africa","Foundation","Circular Economy","Lending",1,0.2019,"ZA"],
  ["Sweden","Public / Semi-public","Circular Economy","Lending",2,2.0,"SE"],
  ["Jamaica","Venture Capital","Circular Economy","Equity",1,1.0,"JM"],
  ["Netherlands","Public / Semi-public","Circular Economy","Equity",3,0.8557,"NL"],
  ["Kosovo","Public / Semi-public","Waste Management","Lending",2,1.1388,"XK"],
  ["Australia","Nonprofit","Circular Economy","Grant",4,1.6761,"AU"],
  ["Japan","Incubator","Circular Economy","Equity",1,0.2241,"JP"],
  ["Gabon","Public / Semi-public","Ocean Cleanup","Grant",1,0.4243,"GA"],
  ["France","Public / Semi-public","Ocean Cleanup","Grant",8,2.8064,"FR"],
  ["New Zealand","Nonprofit","Waste Management","Lending",2,0.2553,"NZ"],
  ["Georgia","Nonprofit","Waste Management","Grant",1,0.4726,"GE"],
  ["Singapore","Financial Service Provider","Circular Economy","Equity",1,0.2476,"SG"],
  ["Ethiopia","Public / Semi-public","Circular Economy","Lending",4,0.7937,"ET"],
  ["Sudan","Public / Semi-public","Waste Management","Equity",1,0.2875,"SD"],
  ["Belgium","Financial Service Provider","Waste Management","Equity",3,0.35,"BE"],
  ["Jordan","Bank","Circular Economy","Equity",2,0.384,"JO"],
  ["Singapore","Impact Investor","Waste Management","Equity",3,0.2987,"SG"],
  ["Taiwan","Impact Investor","Ocean Cleanup","Lending",1,0.0662,"TW"],
  ["Lebanon","Public / Semi-public","Circular Economy","Grant",1,0.2662,"LB"],
  ["Albania","Bank","Circular Economy","Equity",1,0.1833,"AL"],
  ["Belgium","Bank","Waste Management","Lending",2,0.3399,"BE"],
  ["Albania","Public / Semi-public","Waste Management","Lending",2,1.1681,"AL"],
  ["India","Financial Service Provider","Circular Economy","Equity",2,0.2564,"IN"],
  ["Denmark","Incubator","Circular Economy","Equity",1,0.3224,"DK"],
  ["South Korea","Public / Semi-public","Ocean Cleanup","Grant",3,0.9345,"KR"],
  ["Portugal","Incubator","Waste Management","Lending",1,0.1527,"PT"],
  ["Indonesia","Crowdfunding","Waste Management","Lending",1,0.024,"ID"],
  ["Morocco","Financial Service Provider","Waste Management","Equity",2,0.1045,"MA"],
  ["Morocco","Nonprofit","Ocean Cleanup","Lending",2,0.2611,"MA"],
  ["India","Nonprofit","Circular Economy","Grant",5,2.3008,"IN"],
  ["Haiti","Nonprofit","Waste Management","Equity",1,0.5941,"HT"],
  ["Malaysia","Venture Capital","Circular Economy","Equity",2,1.0606,"MY"],
  ["Sri Lanka","Impact Investor","Waste Management","Equity",1,0.0464,"LK"],
  ["Qatar","Foundation","Waste Management","Grant",2,0.4743,"QA"],
  ["South Korea","Venture Capital","Circular Economy","Equity",1,1.0,"KR"],
  ["Mexico","Financial Service Provider","Waste Management","Equity",2,0.2368,"MX"],
  ["United States","Incubator","Waste Management","Grant",1,0.155,"US"],
  ["Maldives","Impact Investor","Circular Economy","Equity",1,0.098,"MV"],
  ["Turkey","Public / Semi-public","Waste Management","Grant",4,0.7492,"TR"],
  ["Mozambique","Impact Investor","Circular Economy","Grant",1,0.4613,"MZ"],
  ["China","Impact Investor","Circular Economy","Equity",2,0.0708,"CN"],
  ["Trinidad and Tobago","Public / Semi-public","Circular Economy","Equity",1,0.9313,"TT"],
  ["Pakistan","Foundation","Waste Management","Grant",6,2.0849,"PK"],
  ["India","Nonprofit","Ocean Cleanup","Grant",9,3.2207,"IN"],
  ["Burundi","Nonprofit","Ocean Cleanup","Grant",1,0.3605,"BI"],
  ["Morocco","Coworking Space","Waste Management","Lending",1,0.0271,"MA"],
  ["Zambia","Nonprofit","Waste Management","Grant",1,0.0764,"ZM"],
  ["Togo","Public / Semi-public","Waste Management","Lending",1,0.4885,"TG"],
  ["France","Bank","Circular Economy","Equity",3,0.9853,"FR"],
  ["Sudan","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SD"],
  ["Zimbabwe","Bank","Waste Management","Equity",1,0.1109,"ZW"],
  ["St. Lucia","Public / Semi-public","Circular Economy","Equity",1,1.0,"LC"],
  ["Kuwait","Venture Capital","Waste Management","Equity",1,0.0479,"KW"],
  ["Somalia","Incubator","Waste Management","Grant",1,0.1256,"SO"],
  ["Vietnam","Impact Investor","Circular Economy","Grant",1,0.0881,"VN"],
  ["Lithuania","Venture Capital","Circular Economy","Equity",1,1.0,"LT"],
  ["Colombia","Financial Service Provider","Circular Economy","Lending",2,0.1865,"CO"],
  ["Malaysia","Financial Service Provider","Waste Management","Equity",1,0.0431,"MY"],
  ["Israel","Financial Service Provider","Circular Economy","Equity",1,0.0296,"IL"],
  ["Switzerland","Public / Semi-public","Waste Management","Grant",3,0.4768,"CH"],
  ["Cambodia","Nonprofit","Circular Economy","Lending",1,0.0658,"KH"],
  ["Russia","Impact Investor","Ocean Cleanup","Lending",1,0.1588,"RU"],
  ["New Zealand","Foundation","Waste Management","Equity",1,0.143,"NZ"],
  ["Netherlands","Foundation","Circular Economy","Equity",1,0.1534,"NL"],
  ["Japan","Bank","Circular Economy","Lending",1,0.336,"JP"],
  ["United Kingdom","Incubator","Ocean Cleanup","Grant",1,0.125,"GB"],
  ["Ghana","Foundation","Waste Management","Lending",1,0.1774,"GH"],
  ["Ecuador","Financial Service Provider","Waste Management","Equity",2,0.2012,"EC"],
  ["Rwanda","Public / Semi-public","Circular Economy","Lending",3,1.004,"RW"],
  ["Angola","Venture Capital","Circular Economy","Equity",1,1.0,"AO"],
  ["Bahrain","Foundation","Ocean Cleanup","Lending",1,0.1767,"BH"],
  ["Tanzania","Impact Investor","Ocean Cleanup","Equity",4,0.9008,"TZ"],
  ["Russia","Foundation","Ocean Cleanup","Equity",1,0.1588,"RU"],
  ["Nepal","Foundation","Waste Management","Grant",1,0.669,"NP"],
  ["Taiwan","Impact Investor","Waste Management","Equity",1,0.0662,"TW"],
  ["Sweden","Venture Capital","Circular Economy","Equity",2,1.0312,"SE"],
  ["Algeria","Impact Investor","Ocean Cleanup","Grant",2,0.3668,"DZ"],
  ["Timor-Leste","Public / Semi-public","Circular Economy","Equity",1,0.3718,"TL"],
  ["Kuwait","Competitions","Waste Management","Grant",1,0.2481,"KW"],
  ["Peru","Financial Service Provider","Circular Economy","Grant",1,0.1699,"PE"],
  ["Niger","Bank","Circular Economy","Lending",1,0.2239,"NE"],
  ["United States","Financial Service Provider","Circular Economy","Equity",2,0.1225,"US"],
  ["Dominican Republic","Public / Semi-public","Waste Management","Equity",3,0.5639,"DO"],
  ["Israel","Impact Investor","Circular Economy","Lending",1,0.0674,"IL"],
  ["Syria","Public / Semi-public","Ocean Cleanup","Equity",1,0.1343,"SY"],
  ["United Kingdom","Bank","Ocean Cleanup","Lending",3,0.4857,"GB"],
  ["Japan","Public / Semi-public","Circular Economy","Grant",2,0.3783,"JP"],
  ["Angola","Impact Investor","Waste Management","Lending",1,0.3036,"AO"],
  ["Argentina","Foundation","Circular Economy","Grant",2,0.4981,"AR"],
  ["Guadeloupe","Public / Semi-public","Waste Management","Equity",1,0.8946,"GP"],
  ["Israel","Impact Investor","Waste Management","Grant",2,0.1536,"IL"],
  ["Iran","Public / Semi-public","Circular Economy","Grant",2,0.2989,"IR"],
  ["Argentina","Public / Semi-public","Waste Management","Equity",5,1.7156,"AR"],
  ["Peru","Nonprofit","Circular Economy","Grant",4,1.0996,"PE"],
  ["Yemen","Nonprofit","Ocean Cleanup","Grant",1,0.6807,"YE"],
  ["Zimbabwe","Foundation","Circular Economy","Grant",1,0.1598,"ZW"],
  ["Libya","Public / Semi-public","Circular Economy","Grant",2,0.3631,"LY"],
  ["Switzerland","Nonprofit","Circular Economy","Grant",3,1.5289,"CH"],
  ["Argentina","Crowdfunding","Waste Management","Equity",1,0.029,"AR"],
  ["Costa Rica","Impact Investor","Waste Management","Lending",1,0.2987,"CR"],
  ["Nigeria","Nonprofit","Ocean Cleanup","Equity",4,0.4647,"NG"],
  ["Netherlands","Nonprofit","Ocean Cleanup","Equity",5,1.8437,"NL"],
  ["Sweden","Incubator","Waste Management","Equity",3,0.5311,"SE"],
  ["Ireland","Nonprofit","Ocean Cleanup","Equity",2,0.291,"IE"],
  ["Zambia","Public / Semi-public","Waste Management","Grant",3,0.1816,"ZM"],
  ["Timor-Leste","Public / Semi-public","Ocean Cleanup","Lending",1,0.3718,"TL"],
  ["Japan","Impact Investor","Waste Management","Lending",3,0.4101,"JP"],
  ["Nepal","Venture Capital","Waste Management","Equity",1,0.0291,"NP"],
  ["India","Venture Capital","Circular Economy","Equity",3,1.0574,"IN"],
  ["France","Nonprofit","Circular Economy","Grant",5,1.9596,"FR"],
  ["Colombia","Impact Investor","Ocean Cleanup","Equity",4,1.4859,"CO"],
  ["Belgium","Impact Investor","Circular Economy","Grant",1,0.2974,"BE"],
  ["Malawi","Public / Semi-public","Circular Economy","Lending",1,0.167,"MW"],
  ["Bangladesh","Foundation","Ocean Cleanup","Equity",2,0.3228,"BD"],
  ["Vietnam","Impact Investor","Waste Management","Grant",2,0.1573,"VN"],
  ["Argentina","Impact Investor","Ocean Cleanup","Grant",1,0.3296,"AR"],
  ["Sudan","Bank","Waste Management","Lending",1,0.419,"SD"],
  ["Italy","Foundation","Ocean Cleanup","Lending",2,0.3556,"IT"],
  ["Denmark","Impact Investor","Waste Management","Equity",1,0.1324,"DK"],
  ["El Salvador","Public / Semi-public","Waste Management","Lending",2,0.4001,"SV"],
  ["Pakistan","Public / Semi-public","Waste Management","Grant",6,1.0475,"PK"],
  ["Canada","Crowdfunding","Waste Management","Lending",1,0.0263,"CA"],
  ["Denmark","Crowdfunding","Ocean Cleanup","Grant",1,0.0739,"DK"],
  ["United States","Incubator","Circular Economy","Grant",1,0.7201,"US"],
  ["Nigeria","Financial Service Provider","Circular Economy","Grant",1,0.0867,"NG"],
  ["Sweden","Public / Semi-public","Waste Management","Lending",3,1.1331,"SE"],
  ["South Africa","Foundation","Ocean Cleanup","Grant",5,0.9742,"ZA"],
  ["Italy","Crowdfunding","Waste Management","Lending",1,0.0471,"IT"],
  ["Papua New Guinea","Bank","Circular Economy","Lending",1,0.1536,"PG"],
  ["United Kingdom","Foundation","Waste Management","Equity",2,0.5696,"GB"],
  ["Bulgaria","Incubator","Circular Economy","Grant",1,0.1651,"BG"],
  ["Pakistan","Bank","Ocean Cleanup","Equity",2,0.4701,"PK"],
  ["Zambia","Public / Semi-public","Waste Management","Equity",2,0.5729,"ZM"],
  ["Canada","Public / Semi-public","Waste Management","Equity",9,2.5263,"CA"],
  ["Peru","Financial Service Provider","Circular Economy","Lending",2,0.1563,"PE"],
  ["Thailand","Foundation","Ocean Cleanup","Equity",2,0.2465,"TH"],
  ["Indonesia","Impact Investor","Ocean Cleanup","Equity",5,0.9095,"ID"],
  ["Egypt","Bank","Circular Economy","Lending",4,0.472,"EG"],
  ["Uganda","Venture Capital","Circular Economy","Equity",2,1.0459,"UG"],
  ["Netherlands","Financial Service Provider","Ocean Cleanup","Lending",1,1.0,"NL"],
  ["Egypt","Venture Capital","Circular Economy","Equity",2,1.0242,"EG"],
  ["Taiwan","Nonprofit","Ocean Cleanup","Grant",2,0.3748,"TW"],
  ["Hong Kong","Bank","Ocean Cleanup","Equity",1,0.2594,"HK"],
  ["Albania","Public / Semi-public","Circular Economy","Lending",2,0.8322,"AL"],
  ["New Zealand","Impact Investor","Circular Economy","Equity",2,0.2553,"NZ"],
  ["South Africa","Incubator","Waste Management","Grant",1,0.1058,"ZA"],
  ["Nigeria","Financial Service Provider","Waste Management","Equity",4,0.3871,"NG"],
  ["France","Foundation","Circular Economy","Lending",1,0.1464,"FR"],
  ["Angola","Public / Semi-public","Waste Management","Equity",1,0.2469,"AO"],
  ["New Zealand","Crowdfunding","Waste Management","Equity",1,0.0734,"NZ"],
  ["Vietnam","Public / Semi-public","Circular Economy","Grant",4,0.783,"VN"],
  ["Qatar","Bank","Ocean Cleanup","Lending",2,0.3316,"QA"],
  ["Sudan","Foundation","Circular Economy","Equity",1,0.1536,"SD"],
  ["Macau","Bank","Circular Economy","Lending",1,0.3005,"MO"],
  ["Burkina Faso","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BF"],
  ["Ukraine","Public / Semi-public","Circular Economy","Grant",1,0.6434,"UA"],
  ["Cambodia","Nonprofit","Ocean Cleanup","Lending",4,0.9339,"KH"],
  ["Pakistan","Impact Investor","Circular Economy","Grant",1,0.1069,"PK"],
  ["Italy","Financial Service Provider","Waste Management","Grant",2,0.1825,"IT"],
  ["United Arab Emirates","Nonprofit","Ocean Cleanup","Grant",6,1.3091,"AE"],
  ["South Africa","Bank","Circular Economy","Lending",5,2.4381,"ZA"],
  ["British Indian Ocean Territory","Venture Capital","Ocean Cleanup","Equity",1,1.0,"IO"],
  ["Yemen","Incubator","Waste Management","Equity",1,0.1504,"YE"],
  ["Canada","Foundation","Waste Management","Equity",2,0.3725,"CA"],
  ["Mali","Nonprofit","Ocean Cleanup","Equity",1,0.2892,"ML"],
  ["Ethiopia","Competitions","Ocean Cleanup","Grant",1,0.3822,"ET"],
  ["Pakistan","Incubator","Ocean Cleanup","Lending",1,0.1371,"PK"],
  ["Costa Rica","Public / Semi-public","Ocean Cleanup","Grant",1,0.0867,"CR"],
  ["Brazil","Foundation","Ocean Cleanup","Grant",5,1.6748,"BR"],
  ["Thailand","Crowdfunding","Ocean Cleanup","Equity",1,0.3422,"TH"],
  ["Vietnam","Competitions","Waste Management","Grant",1,0.2555,"VN"],
  ["France","Bank","Waste Management","Lending",2,0.4905,"FR"],
  ["Sudan","Bank","Circular Economy","Lending",1,0.419,"SD"],
  ["France","Impact Investor","Ocean Cleanup","Lending",3,0.9119,"FR"],
  ["United Kingdom","Foundation","Waste Management","Grant",6,3.3882,"GB"],
  ["New Zealand","Competitions","Waste Management","Grant",1,0.2009,"NZ"],
  ["Singapore","Foundation","Circular Economy","Grant",1,0.0948,"SG"],
  ["Myanmar","Crowdfunding","Ocean Cleanup","Equity",1,0.2453,"MM"],
  ["Greece","Foundation","Circular Economy","Grant",2,0.4504,"GR"],
  ["Brazil","Nonprofit","Circular Economy","Grant",5,1.3793,"BR"],
  ["United Arab Emirates","Public / Semi-public","Circular Economy","Lending",4,0.7681,"AE"],
  ["Namibia","Venture Capital","Circular Economy","Equity",1,1.0,"NA"],
  ["Switzerland","Foundation","Waste Management","Grant",2,0.7841,"CH"],
  ["China","Nonprofit","Circular Economy","Grant",3,0.9127,"CN"],
  ["Nigeria","Bank","Ocean Cleanup","Lending",3,0.1856,"NG"],
  ["Morocco","Financial Service Provider","Circular Economy","Equity",1,0.0262,"MA"],
  ["United Kingdom","Competitions","Waste Management","Grant",1,1.0,"GB"],
  ["Pakistan","Incubator","Ocean Cleanup","Grant",1,0.0852,"PK"],
  ["France","Financial Service Provider","Circular Economy","Equity",1,0.0298,"FR"],
  ["Cambodia","Public / Semi-public","Waste Management","Equity",7,2.5789,"KH"],
  ["Honduras","Bank","Ocean Cleanup","Equity",1,0.1958,"HN"],
  ["Zimbabwe","Financial Service Provider","Waste Management","Lending",2,0.5163,"ZW"],
  ["Reunion","Public / Semi-public","Circular Economy","Grant",1,0.4382,"RE"],
  ["Colombia","Public / Semi-public","Ocean Cleanup","Lending",6,1.7793,"CO"],
  ["Bolivia","Impact Investor","Ocean Cleanup","Grant",1,0.066,"BO"],
  ["Papua New Guinea","Public / Semi-public","Ocean Cleanup","Grant",1,0.4001,"PG"],
  ["South Africa","Competitions","Waste Management","Grant",1,0.185,"ZA"],
  ["Brazil","Financial Service Provider","Ocean Cleanup","Equity",1,0.0255,"BR"],
  ["Kyrgyz Republic","Public / Semi-public","Waste Management","Lending",2,0.215,"KG"],
  ["Philippines","Foundation","Ocean Cleanup","Grant",4,0.8935,"PH"],
  ["France","Financial Service Provider","Waste Management","Lending",3,0.5126,"FR"],
  ["Rwanda","Venture Capital","Circular Economy","Equity",2,2.0,"RW"],
  ["Burkina Faso","Financial Service Provider","Ocean Cleanup","Equity",1,0.2036,"BF"],
  ["United States","Financial Service Provider","Waste Management","Grant",2,0.5057,"US"],
  ["Nepal","Bank","Ocean Cleanup","Equity",1,0.11,"NP"],
  ["Philippines","Financial Service Provider","Waste Management","Grant",1,0.0608,"PH"],
  ["Mexico","Venture Capital","Waste Management","Equity",1,0.1964,"MX"],
  ["Palestine","Venture Capital","Ocean Cleanup","Equity",1,1.0,""],
  ["Sierra Leone","Nonprofit","Circular Economy","Grant",1,0.2329,"SL"],
  ["Turkey","Public / Semi-public","Ocean Cleanup","Equity",9,2.4419,"TR"],
  ["United Arab Emirates","Impact Investor","Circular Economy","Equity",3,0.3702,"AE"],
  ["Thailand","Incubator","Waste Management","Equity",3,0.2654,"TH"],
  ["Myanmar","Public / Semi-public","Waste Management","Equity",5,1.9578,"MM"],
  ["South Sudan","Public / Semi-public","Ocean Cleanup","Lending",2,1.0497,"SS"],
  ["Ukraine","Impact Investor","Circular Economy","Equity",1,0.0461,"UA"],
  ["France","Crowdfunding","Waste Management","Equity",1,0.0466,"FR"],
  ["Georgia","Public / Semi-public","Ocean Cleanup","Lending",5,1.9162,"GE"],
  ["Oman","Financial Service Provider","Circular Economy","Equity",1,0.0551,"OM"],
  ["France","Public / Semi-public","Circular Economy","Grant",5,1.8407,"FR"],
  ["Kenya","Incubator","Circular Economy","Grant",1,0.342,"KE"],
  ["Mexico","Foundation","Circular Economy","Grant",2,0.6526,"MX"],
  ["Spain","Bank","Circular Economy","Equity",3,0.4955,"ES"],
  ["Ethiopia","Nonprofit","Waste Management","Equity",2,0.5534,"ET"],
  ["Malaysia","Impact Investor","Waste Management","Lending",3,0.4147,"MY"],
  ["Indonesia","Public / Semi-public","Circular Economy","Lending",6,1.6833,"ID"],
  ["Djibouti","Public / Semi-public","Circular Economy","Grant",1,0.5076,"DJ"],
  ["France","Nonprofit","Ocean Cleanup","Lending",6,1.9528,"FR"],
  ["Haiti","Impact Investor","Ocean Cleanup","Equity",1,0.5941,"HT"],
  ["Ghana","Bank","Ocean Cleanup","Equity",1,0.2441,"GH"],
  ["Japan","Bank","Ocean Cleanup","Equity",1,0.336,"JP"],
  ["South Korea","Financial Service Provider","Circular Economy","Grant",1,0.0609,"KR"],
  ["Haiti","Financial Service Provider","Ocean Cleanup","Equity",1,0.0422,"HT"],
  ["Macau","Venture Capital","Circular Economy","Equity",1,1.0,"MO"],
  ["Kenya","Nonprofit","Ocean Cleanup","Lending",6,2.1755,"KE"],
  ["Australia","Public / Semi-public","Circular Economy","Equity",2,0.5302,"AU"],
  ["Singapore","Nonprofit","Circular Economy","Lending",2,0.2463,"SG"],
  ["United States","Bank","Circular Economy","Equity",3,0.6519,"US"],
  ["Zambia","Financial Service Provider","Circular Economy","Equity",1,0.0322,"ZM"],
  ["Zambia","Nonprofit","Waste Management","Equity",2,0.5112,"ZM"],
  ["Russia","Public / Semi-public","Waste Management","Equity",1,0.2545,"RU"],
  ["Benin","Public / Semi-public","Ocean Cleanup","Lending",4,1.7092,"BJ"],
  ["Brazil","Impact Investor","Waste Management","Lending",4,1.6689,"BR"],
  ["Brazil","Financial Service Provider","Waste Management","Grant",2,0.2863,"BR"],
  ["Nepal","Impact Investor","Waste Management","Equity",3,0.9401,"NP"],
  ["Barbados","Impact Investor","Waste Management","Equity",1,1.0,"BB"],
  ["Greece","Nonprofit","Circular Economy","Equity",1,0.0839,"GR"],
  ["Spain","Financial Service Provider","Ocean Cleanup","Equity",1,0.1128,"ES"],
  ["Cyprus","Nonprofit","Ocean Cleanup","Equity",1,0.107,"CY"],
  ["Kenya","Financial Service Provider","Waste Management","Lending",2,1.0256,"KE"],
  ["Yemen","Public / Semi-public","Circular Economy","Grant",1,0.2452,"YE"],
  ["Montserrat","Public / Semi-public","Waste Management","Equity",1,1.0,"MS"],
  ["Kenya","Foundation","Waste Management","Equity",2,1.3037,"KE"],
  ["Puerto Rico","Public / Semi-public","Ocean Cleanup","Grant",1,0.5104,"PR"],
  ["Hong Kong","Nonprofit","Ocean Cleanup","Equity",1,0.1698,"HK"],
  ["Germany","Impact Investor","Waste Management","Equity",5,1.7326,"DE"],
  ["Thailand","Public / Semi-public","Ocean Cleanup","Grant",6,1.3917,"TH"],
  ["Palestine","Venture Capital","Circular Economy","Equity",1,1.0,""],
  ["Barbados","Foundation","Waste Management","Grant",1,0.3399,"BB"],
  ["France","Impact Investor","Waste Management","Lending",4,1.3024,"FR"],
  ["Côte d'Ivoire","Public / Semi-public","Circular Economy","Equity",2,0.4917,"CI"],
  ["Nepal","Impact Investor","Ocean Cleanup","Grant",3,0.4912,"NP"],
  ["South Sudan","Public / Semi-public","Ocean Cleanup","Grant",1,0.1369,"SS"],
  ["Egypt","Impact Investor","Waste Management","Grant",3,0.2704,"EG"],
  ["Armenia","Bank","Waste Management","Lending",1,0.3815,"AM"],
  ["Colombia","Public / Semi-public","Circular Economy","Equity",4,0.9471,"CO"],
  ["Mongolia","Public / Semi-public","Ocean Cleanup","Lending",2,0.8423,"MN"],
  ["Colombia","Foundation","Waste Management","Lending",1,0.147,"CO"],
  ["Switzerland","Nonprofit","Ocean Cleanup","Lending",4,1.0121,"CH"],
  ["Botswana","Impact Investor","Waste Management","Equity",2,0.4003,"BW"],
  ["Sweden","Foundation","Circular Economy","Equity",1,0.1764,"SE"],
  ["Brazil","Bank","Circular Economy","Equity",3,0.3532,"BR"],
  ["Italy","Nonprofit","Ocean Cleanup","Lending",6,1.4931,"IT"],
  ["Iraq","Impact Investor","Ocean Cleanup","Grant",2,0.3407,"IQ"],
  ["Peru","Public / Semi-public","Ocean Cleanup","Grant",8,1.8928,"PE"],
  ["India","Foundation","Waste Management","Lending",2,0.3555,"IN"],
  ["Togo","Public / Semi-public","Ocean Cleanup","Lending",2,1.4885,"TG"],
  ["Argentina","Nonprofit","Waste Management","Equity",3,1.2498,"AR"],
  ["Nepal","Impact Investor","Ocean Cleanup","Equity",4,0.9078,"NP"],
  ["United Kingdom","Public / Semi-public","Waste Management","Equity",12,2.9764,"GB"],
  ["Georgia","Public / Semi-public","Circular Economy","Lending",4,1.2727,"GE"],
  ["Indonesia","Financial Service Provider","Circular Economy","Lending",2,0.6371,"ID"],
  ["Solomon Islands","Nonprofit","Ocean Cleanup","Equity",1,0.9097,"SB"],
  ["Germany","Crowdfunding","Waste Management","Lending",1,0.0828,"DE"],
  ["Suriname","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SR"],
  ["Kenya","Venture Capital","Ocean Cleanup","Equity",2,2.0,"KE"],
  ["Sweden","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SE"],
  ["United States","Foundation","Ocean Cleanup","Equity",2,1.2322,"US"],
  ["Dominican Republic","Crowdfunding","Waste Management","Equity",1,0.0307,"DO"],
  ["Norway","Nonprofit","Ocean Cleanup","Grant",2,0.5422,"NO"],
  ["Sweden","Public / Semi-public","Circular Economy","Equity",2,1.1023,"SE"],
  ["Egypt","Foundation","Ocean Cleanup","Equity",2,0.263,"EG"],
  ["Belgium","Crowdfunding","Waste Management","Lending",1,0.0322,"BE"],
  ["Angola","Foundation","Waste Management","Lending",2,0.4394,"AO"],
  ["Philippines","Crowdfunding","Ocean Cleanup","Equity",1,0.2685,"PH"],
  ["Spain","Foundation","Ocean Cleanup","Equity",2,0.3317,"ES"],
  ["Indonesia","Impact Investor","Circular Economy","Equity",4,0.2596,"ID"],
  ["United Kingdom","Financial Service Provider","Circular Economy","Grant",1,1.0,"GB"],
  ["Colombia","Foundation","Ocean Cleanup","Lending",1,0.147,"CO"],
  ["Mexico","Public / Semi-public","Circular Economy","Lending",8,1.7616,"MX"],
  ["Portugal","Impact Investor","Ocean Cleanup","Grant",1,0.3598,"PT"],
  ["Paraguay","Public / Semi-public","Waste Management","Equity",2,1.0036,"PY"],
  ["Ireland","Nonprofit","Waste Management","Equity",1,0.0953,"IE"],
  ["Jordan","Venture Capital","Circular Economy","Equity",1,1.0,"JO"],
  ["Austria","Venture Capital","Circular Economy","Equity",1,1.0,"AT"],
  ["Brazil","Public / Semi-public","Circular Economy","Grant",6,1.3069,"BR"],
  ["India","Foundation","Ocean Cleanup","Lending",2,0.3555,"IN"],
  ["Afghanistan","Venture Capital","Circular Economy","Lending",1,0.3079,"AF"],
  ["Cambodia","Impact Investor","Ocean Cleanup","Equity",3,0.4457,"KH"],
  ["Mexico","Public / Semi-public","Waste Management","Equity",11,3.5627,"MX"],
  ["Myanmar","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MM"],
  ["Afghanistan","Foundation","Circular Economy","Lending",1,0.1614,"AF"],
  ["Madagascar","Nonprofit","Waste Management","Grant",2,0.3422,"MG"],
  ["Qatar","Foundation","Waste Management","Equity",1,0.2624,"QA"],
  ["Sri Lanka","Nonprofit","Ocean Cleanup","Grant",5,0.9077,"LK"],
  ["United Arab Emirates","Incubator","Circular Economy","Grant",1,0.1215,"AE"],
  ["Tajikistan","Bank","Ocean Cleanup","Equity",1,0.4342,"TJ"],
  ["Botswana","Nonprofit","Waste Management","Grant",1,0.0763,"BW"],
  ["Thailand","Incubator","Waste Management","Lending",1,0.1194,"TH"],
  ["Ireland","Incubator","Waste Management","Equity",3,0.3439,"IE"],
  ["Mexico","Foundation","Waste Management","Grant",4,1.2867,"MX"],
  ["Albania","Bank","Ocean Cleanup","Lending",1,0.1833,"AL"],
  ["United States","Foundation","Circular Economy","Equity",1,0.2322,"US"],
  ["Syria","Incubator","Waste Management","Equity",1,0.1251,"SY"],
  ["Tunisia","Public / Semi-public","Circular Economy","Grant",4,0.7914,"TN"],
  ["Denmark","Incubator","Ocean Cleanup","Grant",1,0.0637,"DK"],
  ["Australia","Impact Investor","Ocean Cleanup","Lending",3,0.8082,"AU"],
  ["Switzerland","Crowdfunding","Waste Management","Equity",1,0.1752,"CH"],
  ["Australia","Nonprofit","Circular Economy","Lending",2,0.6231,"AU"],
  ["Azerbaijan","Public / Semi-public","Ocean Cleanup","Lending",2,1.0037,"AZ"],
  ["Mexico","Nonprofit","Ocean Cleanup","Lending",5,1.9336,"MX"],
  ["Thailand","Crowdfunding","Circular Economy","Grant",1,0.5,"TH"],
  ["Somalia","Venture Capital","Circular Economy","Equity",1,1.0,"SO"],
  ["Egypt","Public / Semi-public","Ocean Cleanup","Lending",8,3.0423,"EG"],
  ["United States","Nonprofit","Circular Economy","Equity",2,1.4237,"US"],
  ["Norfolk Island","Venture Capital","Ocean Cleanup","Equity",1,1.0,"NF"],
  ["Ireland","Foundation","Ocean Cleanup","Equity",1,0.1463,"IE"],
  ["Poland","Impact Investor","Circular Economy","Lending",1,0.0777,"PL"],
  ["Ethiopia","Financial Service Provider","Waste Management","Lending",2,0.5534,"ET"],
  ["Poland","Nonprofit","Waste Management","Lending",1,0.0777,"PL"],
  ["Pakistan","Financial Service Provider","Circular Economy","Grant",1,0.0589,"PK"],
  ["Australia","Nonprofit","Waste Management","Grant",4,1.0187,"AU"],
  ["Angola","Public / Semi-public","Circular Economy","Grant",1,0.2469,"AO"],
  ["Bangladesh","Incubator","Ocean Cleanup","Grant",1,0.096,"BD"],
  ["France","Crowdfunding","Waste Management","Lending",1,0.0469,"FR"],
  ["Reunion","Venture Capital","Circular Economy","Equity",1,1.0,"RE"],
  ["Niger","Public / Semi-public","Waste Management","Grant",1,0.4697,"NE"],
  ["Spain","Nonprofit","Waste Management","Equity",4,0.9315,"ES"],
  ["Hungary","Foundation","Waste Management","Grant",1,0.4006,"HU"],
  ["Mauritius","Foundation","Waste Management","Grant",1,0.1414,"MU"],
  ["Sri Lanka","Nonprofit","Waste Management","Grant",4,0.6559,"LK"],
  ["Switzerland","Bank","Circular Economy","Lending",1,0.0379,"CH"],
  ["Saudi Arabia","Foundation","Waste Management","Equity",2,0.3619,"SA"],
  ["British Virgin Islands","Public / Semi-public","Waste Management","Equity",1,0.6521,"VG"],
  ["United Kingdom","Foundation","Circular Economy","Grant",4,2.0408,"GB"],
  ["Guinea","Public / Semi-public","Ocean Cleanup","Lending",3,1.3999,"GN"],
  ["Myanmar","Nonprofit","Circular Economy","Grant",2,0.753,"MM"],
  ["Somalia","Bank","Circular Economy","Equity",1,0.3262,"SO"],
  ["Fiji","Nonprofit","Ocean Cleanup","Grant",1,0.2947,"FJ"],
  ["United Kingdom","Venture Capital","Waste Management","Equity",2,1.0427,"GB"],
  ["New Zealand","Coworking Space","Waste Management","Lending",1,0.0329,"NZ"],
  ["Singapore","Incubator","Circular Economy","Grant",1,0.1246,"SG"],
  ["Argentina","Incubator","Ocean Cleanup","Equity",1,0.1547,"AR"],
  ["Niue","Venture Capital","Circular Economy","Equity",1,1.0,"NU"],
  ["Portugal","Impact Investor","Circular Economy","Equity",2,0.3427,"PT"],
  ["Bolivia","Nonprofit","Circular Economy","Grant",2,0.2411,"BO"],
  ["Romania","Impact Investor","Waste Management","Lending",1,0.14,"RO"],
  ["Central African Republic","Financial Service Provider","Waste Management","Grant",1,0.1196,"CF"],
  ["Cambodia","Financial Service Provider","Ocean Cleanup","Lending",1,0.3259,"KH"],
  ["New Zealand","Incubator","Waste Management","Lending",1,0.143,"NZ"],
  ["China","Nonprofit","Waste Management","Equity",2,0.2725,"CN"],
  ["Spain","Impact Investor","Circular Economy","Equity",2,0.6234,"ES"],
  ["Bangladesh","Competitions","Ocean Cleanup","Grant",1,0.319,"BD"],
  ["Cayman Islands","Bank","Circular Economy","Lending",1,0.1983,"KY"],
  ["Tanzania","Nonprofit","Circular Economy","Equity",1,0.0598,"TZ"],
  ["Zimbabwe","Foundation","Waste Management","Grant",2,0.2981,"ZW"],
  ["Saudi Arabia","Nonprofit","Waste Management","Lending",4,0.3745,"SA"],
  ["France","Financial Service Provider","Waste Management","Equity",4,0.395,"FR"],
  ["Canada","Incubator","Ocean Cleanup","Equity",2,0.3125,"CA"],
  ["Russia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"RU"],
  ["Congo, Dem. Rep","Nonprofit","Waste Management","Lending",1,0.1017,"CD"],
  ["Comoros","Venture Capital","Ocean Cleanup","Equity",1,1.0,"KM"],
  ["Georgia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GE"],
  ["Belgium","Bank","Ocean Cleanup","Lending",2,0.3341,"BE"],
  ["Belgium","Public / Semi-public","Waste Management","Lending",8,1.7421,"BE"],
  ["China","Foundation","Circular Economy","Lending",1,0.1911,"CN"],
  ["Botswana","Nonprofit","Circular Economy","Grant",1,0.0763,"BW"],
  ["Kenya","Financial Service Provider","Waste Management","Equity",4,1.1438,"KE"],
  ["Ethiopia","Public / Semi-public","Ocean Cleanup","Grant",6,1.3043,"ET"],
  ["Mauritania","Public / Semi-public","Ocean Cleanup","Lending",2,1.3609,"MR"],
  ["Colombia","Financial Service Provider","Circular Economy","Grant",1,0.1608,"CO"],
  ["New Zealand","Bank","Circular Economy","Lending",2,0.1795,"NZ"],
  ["Singapore","Bank","Circular Economy","Equity",2,0.3847,"SG"],
  ["Iceland","Financial Service Provider","Ocean Cleanup","Equity",1,0.1618,"IS"],
  ["Portugal","Impact Investor","Ocean Cleanup","Lending",3,0.4954,"PT"],
  ["Bolivia","Foundation","Waste Management","Grant",2,0.7357,"BO"],
  ["Indonesia","Foundation","Waste Management","Lending",2,0.2581,"ID"],
  ["Kyrgyz Republic","Foundation","Circular Economy","Grant",1,1.0,"KG"],
  ["Myanmar","Public / Semi-public","Ocean Cleanup","Equity",6,1.7101,"MM"],
  ["Albania","Bank","Waste Management","Equity",1,0.1833,"AL"],
  ["Netherlands","Public / Semi-public","Waste Management","Lending",5,1.9272,"NL"],
  ["Italy","Financial Service Provider","Ocean Cleanup","Lending",1,0.1212,"IT"],
  ["Lebanon","Public / Semi-public","Waste Management","Lending",3,0.7644,"LB"],
  ["South Africa","Incubator","Circular Economy","Equity",1,0.1011,"ZA"],
  ["Malaysia","Financial Service Provider","Circular Economy","Lending",1,0.1349,"MY"],
  ["Djibouti","Public / Semi-public","Waste Management","Equity",1,0.5076,"DJ"],
  ["Lesotho","Financial Service Provider","Waste Management","Equity",1,0.0506,"LS"],
  ["Côte d'Ivoire","Public / Semi-public","Waste Management","Equity",3,0.8008,"CI"],
  ["Turkey","Bank","Circular Economy","Lending",2,0.5629,"TR"],
  ["Georgia","Venture Capital","Circular Economy","Equity",1,1.0,"GE"],
  ["Reunion","Public / Semi-public","Ocean Cleanup","Grant",1,0.4382,"RE"],
  ["Tanzania","Incubator","Ocean Cleanup","Lending",1,0.4594,"TZ"],
  ["Spain","Foundation","Waste Management","Equity",2,0.3317,"ES"],
  ["Myanmar","Crowdfunding","Waste Management","Equity",1,0.2453,"MM"],
  ["United Kingdom","Public / Semi-public","Waste Management","Lending",11,2.5327,"GB"],
  ["United Arab Emirates","Public / Semi-public","Ocean Cleanup","Equity",7,1.3822,"AE"],
  ["Indonesia","Crowdfunding","Circular Economy","Grant",1,0.5,"ID"],
  ["Bosnia and Herzegovina","Public / Semi-public","Waste Management","Lending",2,0.7346,"BA"],
  ["Haiti","Public / Semi-public","Waste Management","Equity",4,2.4827,"HT"],
  ["Denmark","Impact Investor","Ocean Cleanup","Grant",1,0.0637,"DK"],
  ["Belgium","Foundation","Waste Management","Grant",5,1.1031,"BE"],
  ["Taiwan","Nonprofit","Circular Economy","Equity",1,0.0662,"TW"],
  ["Nicaragua","Nonprofit","Waste Management","Equity",1,0.3848,"NI"],
  ["South Africa","Incubator","Ocean Cleanup","Lending",1,0.3203,"ZA"],
  ["Belgium","Foundation","Ocean Cleanup","Grant",3,0.8123,"BE"],
  ["Mozambique","Financial Service Provider","Waste Management","Grant",1,0.1055,"MZ"],
  ["Azerbaijan","Venture Capital","Circular Economy","Equity",1,1.0,"AZ"],
  ["United Arab Emirates","Nonprofit","Ocean Cleanup","Lending",6,0.9994,"AE"],
  ["Paraguay","Venture Capital","Ocean Cleanup","Equity",1,1.0,"PY"],
  ["Belgium","Public / Semi-public","Waste Management","Grant",3,0.727,"BE"],
  ["Qatar","Foundation","Circular Economy","Lending",1,0.2624,"QA"],
  ["Greece","Public / Semi-public","Ocean Cleanup","Equity",4,1.4801,"GR"],
  ["Indonesia","Impact Investor","Waste Management","Grant",2,0.2922,"ID"],
  ["Philippines","Impact Investor","Ocean Cleanup","Equity",4,0.6599,"PH"],
  ["Indonesia","Crowdfunding","Waste Management","Equity",1,0.2694,"ID"],
  ["Albania","Nonprofit","Ocean Cleanup","Equity",1,1.0,"AL"],
  ["Djibouti","Public / Semi-public","Ocean Cleanup","Equity",2,1.5076,"DJ"],
  ["Uzbekistan","Public / Semi-public","Ocean Cleanup","Grant",1,0.8243,"UZ"],
  ["Israel","Foundation","Circular Economy","Grant",1,0.3304,"IL"],
  ["Ecuador","Nonprofit","Ocean Cleanup","Grant",2,0.7449,"EC"],
  ["Congo, Dem. Rep","Foundation","Waste Management","Grant",2,0.3732,"CD"],
  ["Libya","Public / Semi-public","Waste Management","Lending",1,0.2347,"LY"],
  ["Japan","Venture Capital","Circular Economy","Equity",1,1.0,"JP"],
  ["Iraq","Bank","Ocean Cleanup","Lending",2,0.2394,"IQ"],
  ["Spain","Incubator","Ocean Cleanup","Equity",1,0.1756,"ES"],
  ["Timor-Leste","Public / Semi-public","Circular Economy","Grant",1,0.3718,"TL"],
  ["Taiwan","Bank","Circular Economy","Lending",1,0.4476,"TW"],
  ["Thailand","Impact Investor","Ocean Cleanup","Grant",1,0.2808,"TH"],
  ["Romania","Impact Investor","Ocean Cleanup","Lending",1,0.14,"RO"],
  ["Afghanistan","Public / Semi-public","Circular Economy","Equity",2,0.876,"AF"],
  ["Australia","Public / Semi-public","Ocean Cleanup","Equity",7,1.6258,"AU"],
  ["Kenya","Crowdfunding","Ocean Cleanup","Equity",1,0.0253,"KE"],
  ["Cabo Verde","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CV"],
  ["Nigeria","Impact Investor","Ocean Cleanup","Equity",5,0.643,"NG"],
  ["Egypt","Impact Investor","Circular Economy","Equity",2,0.2427,"EG"],
  ["Morocco","Impact Investor","Ocean Cleanup","Lending",1,0.1828,"MA"],
  ["Cyprus","Public / Semi-public","Circular Economy","Equity",1,0.0887,"CY"],
  ["Thailand","Nonprofit","Waste Management","Equity",2,0.2033,"TH"],
  ["Mexico","Nonprofit","Ocean Cleanup","Grant",9,3.2566,"MX"],
  ["Turkey","Impact Investor","Circular Economy","Equity",3,0.4594,"TR"],
  ["Vietnam","Impact Investor","Ocean Cleanup","Lending",1,0.1286,"VN"],
  ["Brazil","Nonprofit","Waste Management","Grant",4,1.112,"BR"],
  ["Australia","Public / Semi-public","Circular Economy","Grant",3,0.6164,"AU"],
  ["Malawi","Financial Service Provider","Waste Management","Grant",1,0.214,"MW"],
  ["Belize","Public / Semi-public","Waste Management","Lending",1,0.835,"BZ"],
  ["Iraq","Foundation","Circular Economy","Grant",3,0.5346,"IQ"],
  ["Guinea","Public / Semi-public","Waste Management","Lending",2,0.3999,"GN"],
  ["Italy","Microfinance Institution","Waste Management","Lending",1,0.0497,"IT"],
  ["Albania","Public / Semi-public","Ocean Cleanup","Lending",3,1.5842,"AL"],
  ["Egypt","Foundation","Circular Economy","Equity",1,0.1461,"EG"],
  ["Jordan","Public / Semi-public","Ocean Cleanup","Lending",5,0.9294,"JO"],
  ["Israel","Nonprofit","Circular Economy","Equity",1,0.0674,"IL"],
  ["Niger","Financial Service Provider","Waste Management","Equity",1,0.2378,"NE"],
  ["Portugal","Public / Semi-public","Ocean Cleanup","Grant",3,0.8299,"PT"],
  ["Malaysia","Incubator","Waste Management","Grant",1,0.0576,"MY"],
  ["Anguilla","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"AI"],
  ["Mexico","Nonprofit","Circular Economy","Grant",5,1.7199,"MX"],
  ["Peru","Public / Semi-public","Waste Management","Lending",9,3.3544,"PE"],
  ["Mexico","Nonprofit","Waste Management","Equity",3,0.4618,"MX"],
  ["Switzerland","Public / Semi-public","Ocean Cleanup","Lending",3,0.6491,"CH"],
  ["United States","Public / Semi-public","Circular Economy","Equity",7,1.804,"US"],
  ["Canada","Public / Semi-public","Circular Economy","Equity",6,1.4471,"CA"],
  ["Chile","Public / Semi-public","Circular Economy","Equity",1,0.3556,"CL"],
  ["Serbia","Foundation","Waste Management","Grant",1,0.6321,"RS"],
  ["Turkey","Public / Semi-public","Ocean Cleanup","Lending",7,2.0944,"TR"],
  ["Libya","Public / Semi-public","Ocean Cleanup","Equity",3,1.3167,"LY"],
  ["Laos","Public / Semi-public","Waste Management","Equity",1,0.3935,"LA"],
  ["Congo, Dem. Rep","Public / Semi-public","Circular Economy","Equity",3,0.4617,"CD"],
  ["Spain","Venture Capital","Circular Economy","Equity",1,1.0,"ES"],
  ["India","Microfinance Institution","Waste Management","Lending",1,0.0228,"IN"],
  ["Malawi","Foundation","Ocean Cleanup","Lending",1,0.2661,"MW"],
  ["Algeria","Public / Semi-public","Ocean Cleanup","Lending",5,2.3287,"DZ"],
  ["Zimbabwe","Foundation","Ocean Cleanup","Lending",2,0.3427,"ZW"],
  ["France","Public / Semi-public","Circular Economy","Equity",7,3.3736,"FR"],
  ["Belgium","Incubator","Waste Management","Lending",1,0.1513,"BE"],
  ["Afghanistan","Impact Investor","Ocean Cleanup","Grant",1,0.3959,"AF"],
  ["South Sudan","Foundation","Ocean Cleanup","Lending",1,0.3356,"SS"],
  ["Uzbekistan","Public / Semi-public","Circular Economy","Equity",1,0.8243,"UZ"],
  ["Israel","Competitions","Waste Management","Grant",1,0.2057,"IL"],
  ["Egypt","Impact Investor","Ocean Cleanup","Equity",4,0.6604,"EG"],
  ["West Bank and Gaza","Venture Capital","Ocean Cleanup","Equity",1,1.0,"PS"],
  ["Mexico","Competitions","Waste Management","Grant",1,0.2488,"MX"],
  ["Bangladesh","Impact Investor","Ocean Cleanup","Lending",3,1.0258,"BD"],
  ["Mali","Public / Semi-public","Ocean Cleanup","Lending",3,1.7728,"ML"],
  ["Pakistan","Impact Investor","Waste Management","Lending",4,0.7755,"PK"],
  ["United Kingdom","Impact Investor","Circular Economy","Equity",4,0.5654,"GB"],
  ["Tunisia","Public / Semi-public","Waste Management","Grant",4,0.8733,"TN"],
  ["Indonesia","Venture Capital","Circular Economy","Equity",3,1.0487,"ID"],
  ["Ethiopia","Venture Capital","Circular Economy","Equity",2,1.0337,"ET"],
  ["Czech Republic","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CZ"],
  ["Mexico","Incubator","Ocean Cleanup","Equity",1,0.1863,"MX"],
  ["Dominican Republic","Public / Semi-public","Ocean Cleanup","Lending",1,0.0548,"DO"],
  ["Nigeria","Public / Semi-public","Waste Management","Lending",7,1.6734,"NG"],
  ["Peru","Incubator","Ocean Cleanup","Equity",1,0.1455,"PE"],
  ["Pakistan","Impact Investor","Ocean Cleanup","Equity",5,0.8935,"PK"],
  ["Portugal","Foundation","Circular Economy","Grant",3,1.178,"PT"],
  ["Colombia","Venture Capital","Circular Economy","Equity",1,1.0,"CO"],
  ["Singapore","Bank","Ocean Cleanup","Equity",2,0.3847,"SG"],
  ["Sudan","Public / Semi-public","Ocean Cleanup","Equity",2,1.2875,"SD"],
  ["Reunion","Public / Semi-public","Waste Management","Lending",2,0.6139,"RE"],
  ["Latvia","Impact Investor","Circular Economy","Equity",1,0.0895,"LV"],
  ["Grenada","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GD"],
  ["Kenya","Crowdfunding","Waste Management","Equity",1,0.0253,"KE"],
  ["Spain","Nonprofit","Ocean Cleanup","Equity",5,1.1263,"ES"],
  ["United Arab Emirates","Incubator","Waste Management","Grant",1,0.1286,"AE"],
  ["Pakistan","Bank","Waste Management","Lending",2,0.5398,"PK"],
  ["Cambodia","Public / Semi-public","Waste Management","Lending",7,2.0609,"KH"],
  ["Canada","Nonprofit","Circular Economy","Equity",2,0.5766,"CA"],
  ["Nigeria","Financial Service Provider","Circular Economy","Equity",1,0.037,"NG"],
  ["Botswana","Impact Investor","Ocean Cleanup","Equity",1,0.3088,"BW"],
  ["United Arab Emirates","Foundation","Ocean Cleanup","Equity",2,0.3681,"AE"],
  ["Jamaica","Public / Semi-public","Waste Management","Lending",2,1.6552,"JM"],
  ["Cameroon","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CM"],
  ["Singapore","Impact Investor","Waste Management","Grant",1,0.1257,"SG"],
  ["Tanzania","Public / Semi-public","Waste Management","Lending",5,1.6249,"TZ"],
  ["Syria","Foundation","Ocean Cleanup","Grant",1,1.0,"SY"],
  ["Morocco","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MA"],
  ["Algeria","Impact Investor","Waste Management","Grant",2,0.1879,"DZ"],
  ["Pakistan","Public / Semi-public","Circular Economy","Equity",5,1.2728,"PK"],
  ["Iraq","Financial Service Provider","Waste Management","Grant",1,0.0524,"IQ"],
  ["Vietnam","Bank","Circular Economy","Lending",3,0.4525,"VN"],
  ["Brazil","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BR"],
  ["Mozambique","Public / Semi-public","Ocean Cleanup","Lending",2,1.4,"MZ"],
  ["Mexico","Nonprofit","Ocean Cleanup","Equity",4,0.9336,"MX"],
  ["Georgia","Nonprofit","Ocean Cleanup","Grant",3,1.1196,"GE"],
  ["Mexico","Bank","Ocean Cleanup","Lending",2,0.2829,"MX"],
  ["Cameroon","Impact Investor","Ocean Cleanup","Grant",2,0.1318,"CM"],
  ["Netherlands","Impact Investor","Ocean Cleanup","Equity",5,0.9791,"NL"],
  ["Myanmar","Public / Semi-public","Ocean Cleanup","Grant",6,1.839,"MM"],
  ["Greece","Incubator","Waste Management","Lending",1,0.1497,"GR"],
  ["France","Foundation","Circular Economy","Grant",4,1.3889,"FR"],
  ["Norway","Bank","Circular Economy","Equity",1,0.1145,"NO"],
  ["Venezuela","Venture Capital","Circular Economy","Equity",1,1.0,"VE"],
  ["Chad","Public / Semi-public","Waste Management","Lending",1,0.386,"TD"],
  ["Philippines","Public / Semi-public","Circular Economy","Lending",4,1.6811,"PH"],
  ["Argentina","Nonprofit","Waste Management","Lending",3,1.2498,"AR"],
  ["Thailand","Nonprofit","Ocean Cleanup","Equity",4,0.529,"TH"],
  ["Yemen","Bank","Ocean Cleanup","Lending",1,0.0434,"YE"],
  ["Libya","Public / Semi-public","Ocean Cleanup","Grant",2,0.3631,"LY"],
  ["Uganda","Impact Investor","Waste Management","Equity",1,1.0,"UG"],
  ["Mali","Nonprofit","Waste Management","Lending",2,0.5464,"ML"],
  ["Malaysia","Foundation","Waste Management","Grant",6,1.441,"MY"],
  ["Tanzania","Bank","Circular Economy","Lending",3,1.072,"TZ"],
  ["United Arab Emirates","Bank","Circular Economy","Lending",4,0.5916,"AE"],
  ["Tanzania","Foundation","Waste Management","Lending",2,0.7151,"TZ"],
  ["South Sudan","Foundation","Circular Economy","Equity",1,0.3356,"SS"],
  ["Peru","Public / Semi-public","Waste Management","Grant",5,1.16,"PE"],
  ["Italy","Impact Investor","Circular Economy","Equity",3,0.6548,"IT"],
  ["Dominican Republic","Financial Service Provider","Circular Economy","Lending",1,0.0929,"DO"],
  ["Laos","Venture Capital","Circular Economy","Equity",2,1.0323,"LA"],
  ["Chile","Impact Investor","Ocean Cleanup","Lending",1,0.1561,"CL"],
  ["Pakistan","Foundation","Waste Management","Lending",2,0.291,"PK"],
  ["Saint Kitts and Nevis","Venture Capital","Circular Economy","Equity",1,1.0,"KN"],
  ["Kenya","Foundation","Ocean Cleanup","Equity",2,1.3037,"KE"],
  ["Gambia","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"GM"],
  ["South Africa","Crowdfunding","Waste Management","Lending",1,0.0259,"ZA"],
  ["Cameroon","Financial Service Provider","Waste Management","Lending",2,0.4764,"CM"],
  ["Morocco","Nonprofit","Circular Economy","Lending",1,0.1828,"MA"],
  ["Brazil","Foundation","Waste Management","Equity",2,0.2885,"BR"],
  ["Indonesia","Venture Capital","Waste Management","Equity",2,0.0726,"ID"],
  ["Libya","Impact Investor","Circular Economy","Equity",1,0.0278,"LY"],
  ["Romania","Incubator","Waste Management","Lending",1,0.14,"RO"],
  ["South Africa","Foundation","Ocean Cleanup","Lending",2,0.5222,"ZA"],
  ["Ethiopia","Public / Semi-public","Waste Management","Equity",5,1.5704,"ET"],
  ["Nepal","Public / Semi-public","Waste Management","Equity",5,2.6641,"NP"],
  ["Mali","Public / Semi-public","Circular Economy","Equity",2,0.5513,"ML"],
  ["Uruguay","Venture Capital","Circular Economy","Equity",1,1.0,"UY"],
  ["Greece","Foundation","Ocean Cleanup","Equity",1,0.1497,"GR"],
  ["Angola","Public / Semi-public","Ocean Cleanup","Equity",2,1.2469,"AO"],
  ["Azerbaijan","Public / Semi-public","Circular Economy","Lending",1,0.5155,"AZ"],
  ["Austria","Nonprofit","Circular Economy","Lending",2,0.2765,"AT"],
  ["Tajikistan","Bank","Circular Economy","Equity",1,0.4342,"TJ"],
  ["Cyprus","Nonprofit","Waste Management","Equity",1,0.107,"CY"],
  ["France","Foundation","Ocean Cleanup","Equity",2,0.3481,"FR"],
  ["Bahrain","Bank","Ocean Cleanup","Equity",1,0.4161,"BH"],
  ["Colombia","Incubator","Ocean Cleanup","Lending",1,0.147,"CO"],
  ["South Africa","Nonprofit","Ocean Cleanup","Lending",6,1.0093,"ZA"],
  ["Finland","Impact Investor","Ocean Cleanup","Grant",1,0.0906,"FI"],
  ["Uganda","Nonprofit","Ocean Cleanup","Equity",3,1.5596,"UG"],
  ["Austria","Crowdfunding","Ocean Cleanup","Equity",1,0.0353,"AT"],
  ["Malawi","Impact Investor","Waste Management","Grant",1,0.1866,"MW"],
  ["Malta","Venture Capital","Circular Economy","Equity",1,1.0,"MT"],
  ["Martinique","Venture Capital","Circular Economy","Equity",1,1.0,"MQ"],
  ["Spain","Impact Investor","Waste Management","Grant",2,0.2802,"ES"],
  ["Greece","Financial Service Provider","Waste Management","Lending",1,0.0983,"GR"],
  ["St. Vincent and the Grenadines","Venture Capital","Ocean Cleanup","Equity",1,1.0,"VC"],
  ["Denmark","Impact Investor","Ocean Cleanup","Lending",1,0.1324,"DK"],
  ["Honduras","Bank","Ocean Cleanup","Lending",1,0.1958,"HN"],
  ["Jordan","Public / Semi-public","Waste Management","Grant",1,0.0627,"JO"],
  ["Australia","Venture Capital","Waste Management","Equity",2,0.0717,"AU"],
  ["Bahamas, The","Foundation","Waste Management","Grant",1,0.3626,"BS"],
  ["Kenya","Impact Investor","Waste Management","Equity",5,0.7311,"KE"],
  ["Chile","Nonprofit","Ocean Cleanup","Grant",4,1.085,"CL"],
  ["Canada","Public / Semi-public","Circular Economy","Grant",5,1.1922,"CA"],
  ["Kosovo","Venture Capital","Ocean Cleanup","Equity",1,1.0,"XK"],
  ["Mexico","Foundation","Ocean Cleanup","Grant",3,1.563,"MX"],
  ["Syria","Public / Semi-public","Circular Economy","Equity",1,0.1343,"SY"],
  ["Bosnia and Herzegovina","Venture Capital","Circular Economy","Equity",1,1.0,"BA"],
  ["Algeria","Nonprofit","Circular Economy","Grant",1,0.0775,"DZ"],
  ["Macedonia","Venture Capital","Circular Economy","Equity",1,1.0,"MK"],
  ["Bosnia and Herzegovina","Public / Semi-public","Circular Economy","Lending",2,0.821,"BA"],
  ["India","Public / Semi-public","Waste Management","Lending",11,3.8819,"IN"],
  ["Zambia","Impact Investor","Waste Management","Lending",1,0.2714,"ZM"],
  ["British Virgin Islands","Public / Semi-public","Ocean Cleanup","Equity",1,0.6521,"VG"],
  ["Zambia","Nonprofit","Ocean Cleanup","Lending",2,0.8776,"ZM"],
  ["Zambia","Incubator","Waste Management","Grant",1,0.0735,"ZM"],
  ["Taiwan","Public / Semi-public","Waste Management","Equity",1,0.2931,"TW"],
  ["Malaysia","Crowdfunding","Circular Economy","Grant",1,0.5,"MY"],
  ["Jordan","Foundation","Waste Management","Lending",1,0.143,"JO"],
  ["Chile","Nonprofit","Waste Management","Grant",2,0.2211,"CL"],
  ["Hungary","Incubator","Waste Management","Equity",1,0.1157,"HU"],
  ["United States","Incubator","Ocean Cleanup","Grant",1,0.155,"US"],
  ["Poland","Nonprofit","Waste Management","Grant",1,0.4681,"PL"],
  ["Singapore","Incubator","Waste Management","Equity",3,0.8284,"SG"],
  ["Kenya","Financial Service Provider","Circular Economy","Equity",1,0.0746,"KE"],
  ["Gambia","Venture Capital","Circular Economy","Equity",1,1.0,"GM"],
  ["Germany","Foundation","Waste Management","Equity",2,0.3766,"DE"],
  ["Austria","Impact Investor","Circular Economy","Lending",2,0.2765,"AT"],
  ["Poland","Financial Service Provider","Waste Management","Grant",1,0.1154,"PL"],
  ["Tunisia","Venture Capital","Circular Economy","Equity",1,1.0,"TN"],
  ["Ghana","Crowdfunding","Waste Management","Equity",1,0.028,"GH"],
  ["Denmark","Foundation","Waste Management","Grant",1,0.0515,"DK"],
  ["Thailand","Crowdfunding","Waste Management","Lending",1,0.0239,"TH"],
  ["Nepal","Bank","Waste Management","Equity",1,0.11,"NP"],
  ["Sudan","Incubator","Waste Management","Equity",1,0.3185,"SD"],
  ["Côte d'Ivoire","Venture Capital","Circular Economy","Equity",1,1.0,"CI"],
  ["Armenia","Bank","Waste Management","Equity",1,0.3815,"AM"],
  ["Qatar","Competitions","Ocean Cleanup","Grant",1,0.2888,"QA"],
  ["Ecuador","Nonprofit","Ocean Cleanup","Lending",1,0.5232,"EC"],
  ["Thailand","Public / Semi-public","Circular Economy","Equity",3,0.9329,"TH"],
  ["Denmark","Bank","Ocean Cleanup","Equity",1,0.1139,"DK"],
  ["Pakistan","Incubator","Circular Economy","Equity",1,0.1032,"PK"],
  ["Nepal","Impact Investor","Waste Management","Grant",2,0.1176,"NP"],
  ["Papua New Guinea","Foundation","Ocean Cleanup","Grant",1,0.9996,"PG"],
  ["Ukraine","Foundation","Ocean Cleanup","Grant",1,0.5288,"UA"],
  ["Germany","Foundation","Waste Management","Grant",6,2.0248,"DE"],
  ["Iran","Public / Semi-public","Waste Management","Equity",1,0.6446,"IR"],
  ["Malaysia","Incubator","Ocean Cleanup","Grant",1,0.0576,"MY"],
  ["Chile","Nonprofit","Circular Economy","Grant",1,0.5438,"CL"],
  ["Turkey","Impact Investor","Waste Management","Equity",3,0.543,"TR"],
  ["Russia","Financial Service Provider","Waste Management","Lending",1,0.2459,"RU"],
  ["Lebanon","Public / Semi-public","Ocean Cleanup","Equity",5,2.1097,"LB"],
  ["Greece","Nonprofit","Waste Management","Equity",1,0.0839,"GR"],
  ["Cabo Verde","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"CV"],
  ["Austria","Foundation","Ocean Cleanup","Grant",1,0.2637,"AT"],
  ["Côte d'Ivoire","Public / Semi-public","Waste Management","Grant",1,0.3499,"CI"],
  ["Vietnam","Impact Investor","Waste Management","Equity",2,0.1603,"VN"],
  ["Burundi","Nonprofit","Waste Management","Grant",1,0.3605,"BI"],
  ["Norway","Bank","Circular Economy","Lending",1,0.1145,"NO"],
  ["Cambodia","Bank","Waste Management","Lending",2,0.2624,"KH"],
  ["Turkey","Financial Service Provider","Waste Management","Equity",2,0.2045,"TR"],
  ["Honduras","Impact Investor","Circular Economy","Equity",1,0.0404,"HN"],
  ["United Kingdom","Nonprofit","Circular Economy","Lending",2,0.3977,"GB"],
  ["Haiti","Nonprofit","Ocean Cleanup","Grant",1,0.0412,"HT"],
  ["Tanzania","Nonprofit","Waste Management","Equity",3,0.8573,"TZ"],
  ["Kenya","Nonprofit","Circular Economy","Grant",3,1.3125,"KE"],
  ["Saint Pierre and Miquelon","Venture Capital","Circular Economy","Equity",1,1.0,"PM"],
  ["Thailand","Financial Service Provider","Circular Economy","Grant",1,0.1209,"TH"],
  ["Hungary","Venture Capital","Ocean Cleanup","Equity",1,1.0,"HU"],
  ["Bahrain","Public / Semi-public","Waste Management","Equity",1,0.4208,"BH"],
  ["Japan","Competitions","Ocean Cleanup","Grant",1,0.2432,"JP"],
  ["Japan","Public / Semi-public","Waste Management","Equity",4,0.8615,"JP"],
  ["United Arab Emirates","Crowdfunding","Waste Management","Lending",1,0.0981,"AE"],
  ["Netherlands","Foundation","Circular Economy","Lending",1,0.1534,"NL"],
  ["Colombia","Impact Investor","Waste Management","Lending",4,1.7809,"CO"],
  ["Suriname","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"SR"],
  ["Italy","Bank","Ocean Cleanup","Lending",3,0.4186,"IT"],
  ["Rwanda","Public / Semi-public","Waste Management","Grant",3,0.8674,"RW"],
  ["Senegal","Nonprofit","Ocean Cleanup","Grant",1,0.047,"SN"],
  ["Italy","Public / Semi-public","Circular Economy","Grant",6,1.406,"IT"],
  ["Denmark","Incubator","Waste Management","Equity",3,0.5408,"DK"],
  ["Mexico","Bank","Waste Management","Equity",1,0.108,"MX"],
  ["Bangladesh","Foundation","Waste Management","Equity",2,0.3228,"BD"],
  ["Mexico","Public / Semi-public","Ocean Cleanup","Lending",9,2.3291,"MX"],
  ["Lebanon","Bank","Circular Economy","Equity",2,0.4089,"LB"],
  ["Sao Tome and Principe","Public / Semi-public","Waste Management","Equity",1,0.4041,"ST"],
  ["Guatemala","Public / Semi-public","Ocean Cleanup","Lending",1,0.3085,"GT"],
  ["Guadeloupe","Venture Capital","Circular Economy","Equity",1,1.0,"GP"],
  ["Qatar","Public / Semi-public","Ocean Cleanup","Lending",2,0.6502,"QA"],
  ["Bangladesh","Incubator","Ocean Cleanup","Lending",1,0.1501,"BD"],
  ["Bhutan","Venture Capital","Circular Economy","Equity",1,1.0,"BT"],
  ["Mongolia","Public / Semi-public","Waste Management","Lending",1,0.353,"MN"],
  ["Japan","Financial Service Provider","Circular Economy","Lending",1,0.3304,"JP"],
  ["Senegal","Nonprofit","Waste Management","Equity",1,1.0,"SN"],
  ["Venezuela","Impact Investor","Waste Management","Equity",1,0.8956,"VE"],
  ["Australia","Foundation","Ocean Cleanup","Grant",5,1.8257,"AU"],
  ["Sweden","Bank","Circular Economy","Equity",1,0.5518,"SE"],
  ["Mongolia","Public / Semi-public","Circular Economy","Lending",2,0.8423,"MN"],
  ["Congo, Dem. Rep","Nonprofit","Ocean Cleanup","Equity",1,0.1017,"CD"],
  ["United States","Financial Service Provider","Ocean Cleanup","Lending",1,0.2943,"US"],
  ["Nigeria","Venture Capital","Circular Economy","Equity",2,1.037,"NG"],
  ["Jordan","Public / Semi-public","Circular Economy","Lending",3,0.424,"JO"],
  ["South Korea","Nonprofit","Circular Economy","Lending",1,0.1697,"KR"],
  ["Bangladesh","Nonprofit","Waste Management","Equity",3,1.2453,"BD"],
  ["Brazil","Bank","Ocean Cleanup","Lending",4,0.4336,"BR"],
  ["Thailand","Nonprofit","Ocean Cleanup","Grant",4,1.567,"TH"],
  ["Taiwan","Public / Semi-public","Circular Economy","Grant",2,0.4004,"TW"],
  ["Niger","Public / Semi-public","Ocean Cleanup","Grant",1,0.4697,"NE"],
  ["Poland","Venture Capital","Ocean Cleanup","Equity",1,1.0,"PL"],
  ["Jordan","Public / Semi-public","Circular Economy","Equity",3,0.942,"JO"],
  ["Brazil","Foundation","Circular Economy","Equity",1,0.1225,"BR"],
  ["Egypt","Financial Service Provider","Circular Economy","Lending",1,0.1333,"EG"],
  ["Macedonia","Crowdfunding","Ocean Cleanup","Equity",1,0.04,"MK"],
  ["Canada","Nonprofit","Waste Management","Lending",3,1.5766,"CA"],
  ["Guadeloupe","Public / Semi-public","Ocean Cleanup","Equity",1,0.8946,"GP"],
  ["New Zealand","Impact Investor","Waste Management","Equity",3,0.3983,"NZ"],
  ["Pakistan","Public / Semi-public","Ocean Cleanup","Equity",11,2.8748,"PK"],
  ["Guatemala","Bank","Waste Management","Lending",1,0.1152,"GT"],
  ["Portugal","Public / Semi-public","Waste Management","Equity",4,0.8784,"PT"],
  ["Angola","Incubator","Waste Management","Lending",1,0.3036,"AO"],
  ["Denmark","Nonprofit","Ocean Cleanup","Grant",2,0.524,"DK"],
  ["Somalia","Public / Semi-public","Ocean Cleanup","Grant",1,0.1256,"SO"],
  ["Zimbabwe","Public / Semi-public","Circular Economy","Grant",2,0.2918,"ZW"],
  ["Cameroon","Bank","Circular Economy","Lending",2,0.2979,"CM"],
  ["Nigeria","Public / Semi-public","Ocean Cleanup","Equity",9,2.316,"NG"],
  ["Kuwait","Public / Semi-public","Waste Management","Lending",2,0.5566,"KW"],
  ["India","Nonprofit","Ocean Cleanup","Lending",6,2.394,"IN"],
  ["Turkmenistan","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TM"],
  ["Congo, Rep.","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CG"],
  ["Kiribati","Venture Capital","Circular Economy","Equity",1,1.0,"KI"],
  ["Jordan","Public / Semi-public","Circular Economy","Grant",1,0.1867,"JO"],
  ["Brazil","Incubator","Ocean Cleanup","Lending",1,0.166,"BR"],
  ["Swaziland","Financial Service Provider","Circular Economy","Equity",1,0.0433,"SZ"],
  ["Turkey","Incubator","Waste Management","Lending",1,0.1285,"TR"],
  ["Oman","Bank","Circular Economy","Lending",1,0.179,"OM"],
  ["Nepal","Crowdfunding","Ocean Cleanup","Equity",1,0.1194,"NP"],
  ["Uganda","Bank","Circular Economy","Equity",2,0.9084,"UG"],
  ["Madagascar","Venture Capital","Circular Economy","Equity",2,1.0343,"MG"],
  ["Uganda","Foundation","Waste Management","Equity",1,0.2744,"UG"],
  ["Algeria","Financial Service Provider","Waste Management","Lending",2,0.1944,"DZ"],
  ["Germany","Foundation","Ocean Cleanup","Grant",5,1.6197,"DE"],
  ["Peru","Bank","Ocean Cleanup","Lending",2,0.2619,"PE"],
  ["Zimbabwe","Nonprofit","Ocean Cleanup","Grant",2,0.3264,"ZW"],
  ["Côte d'Ivoire","Nonprofit","Waste Management","Lending",1,0.0687,"CI"],
  ["Sweden","Impact Investor","Ocean Cleanup","Equity",4,0.4663,"SE"],
  ["United Kingdom","Financial Service Provider","Waste Management","Equity",3,1.2005,"GB"],
  ["Germany","Public / Semi-public","Waste Management","Lending",11,3.1843,"DE"],
  ["Israel","Nonprofit","Waste Management","Equity",1,0.0674,"IL"],
  ["Mongolia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MN"],
  ["Jordan","Public / Semi-public","Ocean Cleanup","Grant",2,0.2494,"JO"],
  ["Reunion","Public / Semi-public","Waste Management","Equity",2,0.6139,"RE"],
  ["Morocco","Impact Investor","Waste Management","Equity",1,0.1828,"MA"],
  ["Chile","Crowdfunding","Waste Management","Lending",1,0.2108,"CL"],
  ["Bhutan","Public / Semi-public","Circular Economy","Grant",2,0.5932,"BT"],
  ["Egypt","Nonprofit","Waste Management","Equity",3,0.405,"EG"],
  ["Belgium","Nonprofit","Circular Economy","Lending",2,0.3263,"BE"],
  ["Zimbabwe","Bank","Ocean Cleanup","Equity",1,0.1109,"ZW"],
  ["Hungary","Nonprofit","Waste Management","Equity",1,0.1092,"HU"],
  ["Bangladesh","Incubator","Waste Management","Grant",1,0.096,"BD"],
  ["Japan","Financial Service Provider","Circular Economy","Grant",1,0.0592,"JP"],
  ["Azerbaijan","Venture Capital","Ocean Cleanup","Equity",1,1.0,"AZ"],
  ["Uzbekistan","Public / Semi-public","Circular Economy","Grant",1,0.8243,"UZ"],
  ["United States","Public / Semi-public","Waste Management","Grant",7,2.7772,"US"],
  ["Russia","Public / Semi-public","Circular Economy","Lending",1,0.3753,"RU"],
  ["Brazil","Foundation","Circular Economy","Lending",1,0.1225,"BR"],
  ["Zambia","Foundation","Ocean Cleanup","Equity",2,0.4553,"ZM"],
  ["Ecuador","Impact Investor","Waste Management","Lending",1,0.7624,"EC"],
  ["Greece","Public / Semi-public","Ocean Cleanup","Grant",3,0.8168,"GR"],
  ["Portugal","Nonprofit","Waste Management","Lending",2,0.3427,"PT"],
  ["Georgia","Nonprofit","Circular Economy","Grant",1,0.5655,"GE"],
  ["Peru","Public / Semi-public","Circular Economy","Lending",6,1.2234,"PE"],
  ["Burkina Faso","Public / Semi-public","Circular Economy","Equity",2,0.4322,"BF"],
  ["Belgium","Bank","Circular Economy","Equity",2,0.3866,"BE"],
  ["Australia","Public / Semi-public","Ocean Cleanup","Lending",4,0.7943,"AU"],
  ["France","Nonprofit","Waste Management","Lending",5,1.1365,"FR"],
  ["China","Public / Semi-public","Ocean Cleanup","Equity",5,1.1367,"CN"],
  ["Argentina","Public / Semi-public","Ocean Cleanup","Grant",4,0.9488,"AR"],
  ["Germany","Foundation","Circular Economy","Grant",4,1.6773,"DE"],
  ["Ireland","Nonprofit","Ocean Cleanup","Lending",2,0.291,"IE"],
  ["Swaziland","Venture Capital","Waste Management","Equity",1,0.0433,"SZ"],
  ["Australia","Impact Investor","Waste Management","Equity",4,0.8793,"AU"],
  ["Bolivia","Public / Semi-public","Circular Economy","Grant",2,0.1548,"BO"],
  ["France","Financial Service Provider","Circular Economy","Lending",1,0.1787,"FR"],
  ["Bulgaria","Financial Service Provider","Circular Economy","Equity",1,0.0374,"BG"],
  ["Russia","Financial Service Provider","Circular Economy","Lending",1,0.2459,"RU"],
  ["Thailand","Foundation","Waste Management","Equity",2,0.2465,"TH"],
  ["Italy","Financial Service Provider","Ocean Cleanup","Equity",2,0.1525,"IT"],
  ["Burkina Faso","Public / Semi-public","Ocean Cleanup","Lending",4,1.6358,"BF"],
  ["Brazil","Nonprofit","Waste Management","Equity",3,0.9179,"BR"],
  ["Guatemala","Bank","Ocean Cleanup","Equity",1,0.1152,"GT"],
  ["Gabon","Nonprofit","Waste Management","Equity",1,0.177,"GA"],
  ["Armenia","Bank","Ocean Cleanup","Equity",1,0.3815,"AM"],
  ["Afghanistan","Public / Semi-public","Circular Economy","Lending",3,1.0343,"AF"],
  ["Bulgaria","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BG"],
  ["Kenya","Incubator","Ocean Cleanup","Lending",1,0.3037,"KE"],
  ["Spain","Foundation","Ocean Cleanup","Lending",2,0.3317,"ES"],
  ["Canada","Impact Investor","Waste Management","Equity",4,1.1519,"CA"],
  ["Finland","Public / Semi-public","Circular Economy","Grant",1,0.2157,"FI"],
  ["Spain","Nonprofit","Circular Economy","Lending",2,0.6234,"ES"],
  ["Cyprus","Nonprofit","Waste Management","Lending",1,0.107,"CY"],
  ["Algeria","Bank","Circular Economy","Lending",1,0.0263,"DZ"],
  ["Nicaragua","Nonprofit","Waste Management","Lending",1,0.3848,"NI"],
  ["Macedonia","Public / Semi-public","Ocean Cleanup","Equity",1,0.2824,"MK"],
  ["Zambia","Incubator","Ocean Cleanup","Grant",1,0.0735,"ZM"],
  ["Tokelau","Venture Capital","Circular Economy","Equity",1,1.0,"TK"],
  ["China","Nonprofit","Ocean Cleanup","Equity",3,0.4402,"CN"],
  ["Ethiopia","Foundation","Circular Economy","Lending",1,0.2045,"ET"],
  ["United Kingdom","Incubator","Circular Economy","Grant",1,0.2087,"GB"],
  ["South Korea","Venture Capital","Ocean Cleanup","Equity",1,1.0,"KR"],
  ["Jordan","Foundation","Waste Management","Equity",1,0.143,"JO"],
  ["Afghanistan","Venture Capital","Ocean Cleanup","Equity",1,1.0,"AF"],
  ["Costa Rica","Bank","Ocean Cleanup","Lending",1,0.1133,"CR"],
  ["Malaysia","Bank","Ocean Cleanup","Equity",1,0.3468,"MY"],
  ["Seychelles","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"SC"],
  ["Fiji","Venture Capital","Circular Economy","Equity",1,1.0,"FJ"],
  ["Spain","Foundation","Circular Economy","Equity",1,0.1561,"ES"],
  ["Qatar","Bank","Circular Economy","Lending",2,0.4525,"QA"],
  ["Uganda","Foundation","Circular Economy","Lending",1,0.2744,"UG"],
  ["Venezuela","Impact Investor","Waste Management","Lending",1,0.8956,"VE"],
  ["China","Public / Semi-public","Ocean Cleanup","Lending",5,1.4393,"CN"],
  ["Iran","Public / Semi-public","Ocean Cleanup","Lending",1,0.6446,"IR"],
  ["Morocco","Bank","Waste Management","Lending",1,0.083,"MA"],
  ["Colombia","Public / Semi-public","Circular Economy","Grant",5,1.0658,"CO"],
  ["Indonesia","Public / Semi-public","Waste Management","Grant",5,1.0015,"ID"],
  ["Haiti","Nonprofit","Circular Economy","Equity",1,0.5941,"HT"],
  ["Vanuatu","Venture Capital","Ocean Cleanup","Equity",1,1.0,"VU"],
  ["Lithuania","Public / Semi-public","Waste Management","Equity",2,0.0965,"LT"],
  ["New Zealand","Foundation","Waste Management","Lending",1,0.143,"NZ"],
  ["Italy","Nonprofit","Ocean Cleanup","Equity",5,1.1181,"IT"],
  ["Philippines","Bank","Waste Management","Lending",2,0.4257,"PH"],
  ["Pakistan","Venture Capital","Ocean Cleanup","Equity",1,1.0,"PK"],
  ["Mozambique","Public / Semi-public","Waste Management","Lending",1,0.4,"MZ"],
  ["Pakistan","Financial Service Provider","Ocean Cleanup","Lending",1,0.1087,"PK"],
  ["Spain","Venture Capital","Ocean Cleanup","Equity",1,1.0,"ES"],
  ["Bangladesh","Venture Capital","Waste Management","Equity",1,0.7347,"BD"],
  ["Greece","Incubator","Waste Management","Equity",1,0.1497,"GR"],
  ["Pakistan","Incubator","Waste Management","Lending",1,0.1371,"PK"],
  ["Jamaica","Venture Capital","Ocean Cleanup","Equity",1,1.0,"JM"],
  ["China","Crowdfunding","Ocean Cleanup","Equity",1,0.2524,"CN"],
  ["Somalia","Impact Investor","Waste Management","Grant",1,0.1256,"SO"],
  ["Argentina","Incubator","Waste Management","Lending",1,0.1547,"AR"],
  ["Jordan","Public / Semi-public","Waste Management","Equity",8,2.6604,"JO"],
  ["Denmark","Nonprofit","Ocean Cleanup","Equity",2,0.3667,"DK"],
  ["Spain","Incubator","Circular Economy","Equity",1,0.1394,"ES"],
  ["Spain","Public / Semi-public","Waste Management","Equity",8,3.274,"ES"],
  ["Peru","Nonprofit","Ocean Cleanup","Equity",5,0.8847,"PE"],
  ["Portugal","Public / Semi-public","Waste Management","Grant",2,0.4701,"PT"],
  ["Canada","Financial Service Provider","Waste Management","Lending",2,1.1672,"CA"],
  ["Rwanda","Venture Capital","Ocean Cleanup","Equity",2,2.0,"RW"],
  ["Bangladesh","Impact Investor","Circular Economy","Lending",2,0.8757,"BD"],
  ["Nepal","Crowdfunding","Waste Management","Equity",1,0.1194,"NP"],
  ["Pakistan","Nonprofit","Circular Economy","Lending",2,0.3771,"PK"],
  ["Georgia","Public / Semi-public","Ocean Cleanup","Grant",3,1.067,"GE"],
  ["Mongolia","Bank","Waste Management","Equity",1,0.2663,"MN"],
  ["South Africa","Foundation","Circular Economy","Grant",4,0.7842,"ZA"],
  ["Laos","Financial Service Provider","Waste Management","Lending",1,0.3935,"LA"],
  ["North Korea","Venture Capital","Ocean Cleanup","Equity",1,1.0,"KP"],
  ["Turkey","Financial Service Provider","Ocean Cleanup","Equity",1,0.0297,"TR"],
  ["Morocco","Incubator","Circular Economy","Grant",1,0.1031,"MA"],
  ["Angola","Foundation","Circular Economy","Lending",1,0.1358,"AO"],
  ["Australia","Incubator","Ocean Cleanup","Lending",1,0.1851,"AU"],
  ["Greece","Foundation","Waste Management","Grant",2,0.4504,"GR"],
  ["Morocco","Financial Service Provider","Waste Management","Grant",1,0.0715,"MA"],
  ["United Arab Emirates","Crowdfunding","Ocean Cleanup","Equity",1,0.027,"AE"],
  ["Sudan","Public / Semi-public","Ocean Cleanup","Grant",3,0.4478,"SD"],
  ["Bahrain","Public / Semi-public","Waste Management","Lending",1,0.4208,"BH"],
  ["Botswana","Financial Service Provider","Waste Management","Equity",2,0.2323,"BW"],
  ["Kenya","Foundation","Ocean Cleanup","Grant",4,2.4821,"KE"],
  ["Vietnam","Impact Investor","Ocean Cleanup","Grant",3,0.5135,"VN"],
  ["Pakistan","Nonprofit","Waste Management","Lending",4,0.5118,"PK"],
  ["Myanmar","Public / Semi-public","Waste Management","Lending",6,2.1217,"MM"],
  ["Bahrain","Incubator","Waste Management","Equity",2,0.2351,"BH"],
  ["Argentina","Impact Investor","Ocean Cleanup","Equity",4,0.7341,"AR"],
  ["Sweden","Incubator","Circular Economy","Grant",1,0.1503,"SE"],
  ["Mexico","Impact Investor","Circular Economy","Equity",1,0.225,"MX"],
  ["Netherlands","Foundation","Waste Management","Lending",2,0.3139,"NL"],
  ["Grenada","Public / Semi-public","Circular Economy","Equity",1,1.0,"GD"],
  ["India","Incubator","Waste Management","Grant",1,0.101,"IN"],
  ["Egypt","Incubator","Waste Management","Equity",3,1.504,"EG"],
  ["Saudi Arabia","Public / Semi-public","Ocean Cleanup","Equity",7,1.5073,"SA"],
  ["Bolivia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BO"],
  ["South Africa","Venture Capital","Ocean Cleanup","Equity",2,2.0,"ZA"],
  ["South Sudan","Impact Investor","Ocean Cleanup","Equity",1,0.0464,"SS"],
  ["Malawi","Foundation","Waste Management","Lending",1,0.2661,"MW"],
  ["Nepal","Competitions","Waste Management","Grant",1,0.543,"NP"],
  ["South Africa","Foundation","Waste Management","Lending",2,0.5222,"ZA"],
  ["Bangladesh","Financial Service Provider","Ocean Cleanup","Equity",2,0.399,"BD"],
  ["Japan","Venture Capital","Ocean Cleanup","Equity",1,1.0,"JP"],
  ["Sweden","Financial Service Provider","Ocean Cleanup","Lending",1,0.0989,"SE"],
  ["Colombia","Financial Service Provider","Circular Economy","Equity",1,0.0318,"CO"],
  ["Philippines","Bank","Waste Management","Equity",1,0.2507,"PH"],
  ["Argentina","Public / Semi-public","Ocean Cleanup","Equity",6,1.3923,"AR"],
  ["Peru","Financial Service Provider","Ocean Cleanup","Lending",1,0.3019,"PE"],
  ["Netherlands","Incubator","Waste Management","Grant",1,0.0739,"NL"],
  ["Botswana","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"BW"],
  ["Hungary","Bank","Ocean Cleanup","Lending",1,0.206,"HU"],
  ["Uganda","Foundation","Circular Economy","Grant",2,0.8936,"UG"],
  ["Belgium","Incubator","Ocean Cleanup","Grant",1,0.0896,"BE"],
  ["Belize","Public / Semi-public","Circular Economy","Equity",1,0.9462,"BZ"],
  ["Chile","Public / Semi-public","Ocean Cleanup","Equity",2,0.3868,"CL"],
  ["Taiwan","Impact Investor","Ocean Cleanup","Equity",1,0.0662,"TW"],
  ["Costa Rica","Venture Capital","Waste Management","Equity",1,0.0451,"CR"],
  ["Portugal","Public / Semi-public","Circular Economy","Equity",2,0.1276,"PT"],
  ["Egypt","Nonprofit","Waste Management","Grant",4,0.9365,"EG"],
  ["Vietnam","Incubator","Waste Management","Equity",3,0.3192,"VN"],
  ["Iraq","Foundation","Ocean Cleanup","Grant",2,0.4822,"IQ"],
  ["Puerto Rico","Foundation","Waste Management","Grant",1,0.0861,"PR"],
  ["Tunisia","Impact Investor","Circular Economy","Lending",1,0.609,"TN"],
  ["Cambodia","Bank","Ocean Cleanup","Equity",2,0.2154,"KH"],
  ["Zimbabwe","Foundation","Ocean Cleanup","Grant",1,0.1598,"ZW"],
  ["Mauritania","Public / Semi-public","Waste Management","Equity",1,0.3609,"MR"],
  ["Saudi Arabia","Public / Semi-public","Circular Economy","Lending",5,0.9998,"SA"],
  ["Grenada","Venture Capital","Circular Economy","Equity",1,1.0,"GD"],
  ["Mauritania","Public / Semi-public","Circular Economy","Lending",1,0.3609,"MR"],
  ["Algeria","Foundation","Ocean Cleanup","Grant",1,0.3256,"DZ"],
  ["Bahrain","Public / Semi-public","Circular Economy","Lending",1,0.4208,"BH"],
  ["Nepal","Crowdfunding","Waste Management","Lending",1,0.0764,"NP"],
  ["South Africa","Incubator","Waste Management","Lending",1,0.3203,"ZA"],
  ["Brazil","Impact Investor","Ocean Cleanup","Grant",3,0.6718,"BR"],
  ["Tanzania","Foundation","Circular Economy","Lending",1,0.2557,"TZ"],
  ["Indonesia","Impact Investor","Circular Economy","Lending",2,0.2109,"ID"],
  ["Myanmar","Bank","Circular Economy","Lending",3,0.3096,"MM"],
  ["Jamaica","Public / Semi-public","Waste Management","Equity",3,2.6552,"JM"],
  ["Pakistan","Public / Semi-public","Circular Economy","Grant",5,1.3797,"PK"],
  ["United Arab Emirates","Public / Semi-public","Waste Management","Equity",6,1.2179,"AE"],
  ["Ethiopia","Public / Semi-public","Waste Management","Lending",5,1.7144,"ET"],
  ["Hong Kong","Crowdfunding","Ocean Cleanup","Grant",1,0.1431,"HK"],
  ["Zambia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"ZM"],
  ["Indonesia","Financial Service Provider","Waste Management","Grant",2,0.1955,"ID"],
  ["France","Bank","Ocean Cleanup","Lending",3,0.661,"FR"],
  ["Peru","Bank","Ocean Cleanup","Equity",1,0.1073,"PE"],
  ["Iraq","Venture Capital","Circular Economy","Equity",1,1.0,"IQ"],
  ["Zambia","Bank","Circular Economy","Lending",2,0.8792,"ZM"],
  ["United Kingdom","Crowdfunding","Ocean Cleanup","Grant",1,0.1258,"GB"],
  ["Brazil","Impact Investor","Waste Management","Equity",4,1.6689,"BR"],
  ["Nepal","Impact Investor","Ocean Cleanup","Lending",2,0.5047,"NP"],
  ["Ethiopia","Financial Service Provider","Ocean Cleanup","Equity",1,0.3695,"ET"],
  ["Guadeloupe","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GP"],
  ["Papua New Guinea","Venture Capital","Ocean Cleanup","Equity",1,1.0,"PG"],
  ["Tuvalu","Venture Capital","Circular Economy","Equity",1,1.0,"TV"],
  ["Gabon","Public / Semi-public","Ocean Cleanup","Equity",2,1.4243,"GA"],
  ["Switzerland","Incubator","Waste Management","Grant",1,0.0897,"CH"],
  ["El Salvador","Nonprofit","Waste Management","Equity",1,0.0946,"SV"],
  ["Portugal","Public / Semi-public","Waste Management","Lending",2,0.4368,"PT"],
  ["United Arab Emirates","Public / Semi-public","Circular Economy","Equity",3,0.6553,"AE"],
  ["Malaysia","Impact Investor","Waste Management","Equity",4,0.4414,"MY"],
  ["Ecuador","Venture Capital","Ocean Cleanup","Equity",1,1.0,"EC"],
  ["Jordan","Foundation","Waste Management","Grant",1,0.143,"JO"],
  ["Vietnam","Nonprofit","Ocean Cleanup","Lending",4,1.0548,"VN"],
  ["Cayman Islands","Public / Semi-public","Ocean Cleanup","Equity",2,0.9596,"KY"],
  ["South Korea","Financial Service Provider","Ocean Cleanup","Lending",1,0.1092,"KR"],
  ["Afghanistan","Nonprofit","Circular Economy","Grant",1,0.6192,"AF"],
  ["Oman","Venture Capital","Waste Management","Equity",2,0.1092,"OM"],
  ["China","Foundation","Ocean Cleanup","Grant",3,0.7547,"CN"],
  ["Taiwan","Nonprofit","Waste Management","Equity",1,0.0662,"TW"],
  ["United Arab Emirates","Financial Service Provider","Waste Management","Lending",3,0.2251,"AE"],
  ["Liberia","Bank","Waste Management","Lending",1,0.2622,"LR"],
  ["Moldova","Venture Capital","Circular Economy","Equity",1,1.0,"MD"],
  ["Singapore","Bank","Waste Management","Equity",1,0.0926,"SG"],
  ["Mayotte","Venture Capital","Ocean Cleanup","Equity",1,1.0,"YT"],
  ["Portugal","Foundation","Waste Management","Grant",5,1.4603,"PT"],
  ["Nigeria","Public / Semi-public","Circular Economy","Equity",5,0.8478,"NG"],
  ["Chile","Venture Capital","Circular Economy","Lending",1,0.0281,"CL"],
  ["Brazil","Impact Investor","Waste Management","Grant",3,0.2595,"BR"],
  ["French Guiana","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GF"],
  ["Japan","Incubator","Ocean Cleanup","Lending",1,0.184,"JP"],
  ["Barbados","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BB"],
  ["New Zealand","Public / Semi-public","Circular Economy","Lending",1,0.2237,"NZ"],
  ["Canada","Public / Semi-public","Ocean Cleanup","Grant",8,2.0864,"CA"],
  ["Jordan","Incubator","Waste Management","Grant",1,0.0627,"JO"],
  ["Hong Kong","Bank","Circular Economy","Equity",1,0.2594,"HK"],
  ["Bahrain","Bank","Ocean Cleanup","Lending",1,0.4161,"BH"],
  ["Chile","Financial Service Provider","Circular Economy","Lending",1,0.0956,"CL"],
  ["Greece","Public / Semi-public","Ocean Cleanup","Lending",1,0.2308,"GR"],
  ["Philippines","Financial Service Provider","Circular Economy","Equity",1,0.5968,"PH"],
  ["Saudi Arabia","Nonprofit","Ocean Cleanup","Lending",3,0.4672,"SA"],
  ["Cyprus","Public / Semi-public","Waste Management","Lending",1,0.0748,"CY"],
  ["Kenya","Impact Investor","Waste Management","Lending",4,0.6874,"KE"],
  ["Cabo Verde","Nonprofit","Waste Management","Equity",1,0.0634,"CV"],
  ["Canada","Public / Semi-public","Circular Economy","Lending",6,2.1666,"CA"],
  ["Sudan","Nonprofit","Circular Economy","Grant",1,0.2373,"SD"],
  ["Jordan","Nonprofit","Circular Economy","Grant",1,0.631,"JO"],
  ["Belize","Public / Semi-public","Waste Management","Equity",2,1.7812,"BZ"],
  ["Germany","Impact Investor","Circular Economy","Lending",2,0.9297,"DE"],
  ["Brazil","Financial Service Provider","Waste Management","Equity",3,0.242,"BR"],
  ["Malaysia","Incubator","Circular Economy","Equity",1,0.1023,"MY"],
  ["Tanzania","Incubator","Ocean Cleanup","Equity",1,0.4594,"TZ"],
  ["China","Public / Semi-public","Ocean Cleanup","Grant",5,1.2549,"CN"],
  ["Malaysia","Nonprofit","Circular Economy","Grant",4,1.3949,"MY"],
  ["Thailand","Impact Investor","Circular Economy","Equity",2,0.2033,"TH"],
  ["Japan","Venture Capital","Waste Management","Equity",1,0.0396,"JP"],
  ["Taiwan","Financial Service Provider","Ocean Cleanup","Equity",1,0.0538,"TW"],
  ["Cameroon","Nonprofit","Circular Economy","Grant",1,0.0722,"CM"],
  ["Niger","Venture Capital","Ocean Cleanup","Equity",1,1.0,"NE"],
  ["Chad","Public / Semi-public","Circular Economy","Lending",1,0.386,"TD"],
  ["Djibouti","Public / Semi-public","Ocean Cleanup","Lending",2,1.5076,"DJ"],
  ["Netherlands","Venture Capital","Ocean Cleanup","Equity",1,1.0,"NL"],
  ["Canada","Impact Investor","Circular Economy","Lending",2,0.5766,"CA"],
  ["Cyprus","Bank","Waste Management","Lending",1,0.2723,"CY"],
  ["Morocco","Public / Semi-public","Circular Economy","Equity",5,1.4782,"MA"],
  ["China","Foundation","Circular Economy","Grant",3,0.6828,"CN"],
  ["Morocco","Impact Investor","Ocean Cleanup","Grant",1,0.2917,"MA"],
  ["Saudi Arabia","Nonprofit","Circular Economy","Equity",2,0.2817,"SA"],
  ["Norway","Public / Semi-public","Ocean Cleanup","Grant",1,0.1992,"NO"],
  ["Oman","Foundation","Circular Economy","Lending",1,0.1749,"OM"],
  ["Switzerland","Incubator","Ocean Cleanup","Grant",1,0.0897,"CH"],
  ["Reunion","Venture Capital","Ocean Cleanup","Equity",1,1.0,"RE"],
  ["Greece","Foundation","Ocean Cleanup","Grant",1,0.3733,"GR"],
  ["Bhutan","Public / Semi-public","Circular Economy","Equity",1,0.4851,"BT"],
  ["South Korea","Coworking Space","Waste Management","Equity",1,0.0313,"KR"],
  ["South Korea","Public / Semi-public","Waste Management","Grant",1,0.2763,"KR"],
  ["United Kingdom","Nonprofit","Ocean Cleanup","Equity",5,1.7355,"GB"],
  ["Cameroon","Public / Semi-public","Waste Management","Equity",3,0.7404,"CM"],
  ["Belgium","Impact Investor","Ocean Cleanup","Lending",3,0.4776,"BE"],
  ["Netherlands","Incubator","Ocean Cleanup","Equity",1,0.1605,"NL"],
  ["Egypt","Impact Investor","Waste Management","Equity",5,0.5775,"EG"],
  ["Uganda","Public / Semi-public","Waste Management","Lending",5,1.7718,"UG"],
  ["Brazil","Nonprofit","Circular Economy","Lending",2,0.7256,"BR"],
  ["Sri Lanka","Venture Capital","Circular Economy","Equity",1,1.0,"LK"],
  ["Ghana","Public / Semi-public","Ocean Cleanup","Grant",3,0.6539,"GH"],
  ["Ireland","Venture Capital","Ocean Cleanup","Equity",1,1.0,"IE"],
  ["India","Crowdfunding","Waste Management","Equity",1,0.2261,"IN"],
  ["Israel","Nonprofit","Ocean Cleanup","Equity",1,0.0674,"IL"],
  ["United Kingdom","Venture Capital","Circular Economy","Equity",3,2.0273,"GB"],
  ["United States","Bank","Circular Economy","Lending",5,0.6805,"US"],
  ["Egypt","Incubator","Ocean Cleanup","Lending",1,0.1169,"EG"],
  ["Sudan","Foundation","Waste Management","Grant",1,0.1536,"SD"],
  ["Austria","Impact Investor","Circular Economy","Equity",2,0.2765,"AT"],
  ["Qatar","Public / Semi-public","Circular Economy","Lending",2,0.4883,"QA"],
  ["Congo, Dem. Rep","Nonprofit","Ocean Cleanup","Grant",3,0.5687,"CD"],
  ["United Kingdom","Financial Service Provider","Circular Economy","Equity",2,1.027,"GB"],
  ["France","Nonprofit","Ocean Cleanup","Equity",5,1.3735,"FR"],
  ["Turkey","Public / Semi-public","Circular Economy","Equity",5,0.858,"TR"],
  ["Vietnam","Public / Semi-public","Waste Management","Equity",8,2.0379,"VN"],
  ["Sierra Leone","Impact Investor","Waste Management","Grant",1,0.1579,"SL"],
  ["Bangladesh","Impact Investor","Circular Economy","Equity",4,1.9039,"BD"],
  ["Albania","Impact Investor","Waste Management","Lending",1,1.0,"AL"],
  ["Japan","Public / Semi-public","Circular Economy","Equity",2,0.2912,"JP"],
  ["Serbia","Public / Semi-public","Circular Economy","Grant",1,0.2945,"RS"],
  ["United States","Competitions","Ocean Cleanup","Grant",1,0.378,"US"],
  ["Kosovo","Public / Semi-public","Ocean Cleanup","Grant",1,0.3514,"XK"],
  ["Canada","Incubator","Waste Management","Equity",5,0.8015,"CA"],
  ["Zimbabwe","Incubator","Waste Management","Equity",1,0.1829,"ZW"],
  ["Pakistan","Competitions","Waste Management","Grant",1,0.5473,"PK"],
  ["Kenya","Impact Investor","Ocean Cleanup","Lending",4,1.4974,"KE"],
  ["Laos","Public / Semi-public","Ocean Cleanup","Grant",1,0.4599,"LA"],
  ["Georgia","Public / Semi-public","Ocean Cleanup","Equity",3,1.5097,"GE"],
  ["Ecuador","Public / Semi-public","Circular Economy","Equity",1,0.0341,"EC"],
  ["United Kingdom","Bank","Ocean Cleanup","Equity",2,0.2839,"GB"],
  ["Malaysia","Public / Semi-public","Waste Management","Equity",5,1.2807,"MY"],
  ["Brazil","Public / Semi-public","Circular Economy","Equity",7,1.459,"BR"],
  ["Nigeria","Venture Capital","Waste Management","Equity",2,0.0734,"NG"],
  ["Thailand","Crowdfunding","Waste Management","Equity",1,0.3422,"TH"],
  ["Ghana","Foundation","Circular Economy","Lending",1,0.1774,"GH"],
  ["Greece","Financial Service Provider","Waste Management","Grant",1,0.0771,"GR"],
  ["Algeria","Public / Semi-public","Circular Economy","Equity",2,1.246,"DZ"],
  ["Guinea-Bisau","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"GW"],
  ["Belgium","Foundation","Ocean Cleanup","Equity",2,0.3402,"BE"],
  ["Algeria","Impact Investor","Waste Management","Equity",1,0.0279,"DZ"],
  ["Zimbabwe","Incubator","Ocean Cleanup","Lending",1,0.1829,"ZW"],
  ["Germany","Nonprofit","Waste Management","Lending",4,1.2722,"DE"],
  ["Myanmar","Nonprofit","Waste Management","Equity",1,0.207,"MM"],
  ["Lebanon","Bank","Ocean Cleanup","Lending",1,0.1628,"LB"],
  ["Cyprus","Impact Investor","Circular Economy","Equity",1,0.107,"CY"],
  ["Singapore","Financial Service Provider","Ocean Cleanup","Equity",1,0.0522,"SG"],
  ["Bangladesh","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BD"],
  ["South Korea","Public / Semi-public","Ocean Cleanup","Equity",6,1.3246,"KR"],
  ["Zambia","Bank","Waste Management","Lending",1,0.572,"ZM"],
  ["Ghana","Bank","Ocean Cleanup","Lending",2,0.2741,"GH"],
  ["Nepal","Incubator","Ocean Cleanup","Grant",1,0.0576,"NP"],
  ["Spain","Crowdfunding","Waste Management","Lending",1,0.0299,"ES"],
  ["Turkey","Nonprofit","Circular Economy","Grant",4,1.4289,"TR"],
  ["Kazakhstan","Foundation","Waste Management","Grant",1,0.8492,"KZ"],
  ["Sri Lanka","Nonprofit","Ocean Cleanup","Lending",1,0.1508,"LK"],
  ["Netherlands","Bank","Circular Economy","Equity",3,1.3162,"NL"],
  ["Japan","Impact Investor","Circular Economy","Lending",2,0.2261,"JP"],
  ["Singapore","Public / Semi-public","Circular Economy","Equity",2,0.5179,"SG"],
  ["French Polynesia","Public / Semi-public","Circular Economy","Equity",1,0.6939,"PF"],
  ["Botswana","Impact Investor","Circular Economy","Grant",1,0.0763,"BW"],
  ["Ethiopia","Impact Investor","Waste Management","Equity",1,0.035,"ET"],
  ["Argentina","Public / Semi-public","Waste Management","Lending",3,1.2392,"AR"],
  ["Vietnam","Crowdfunding","Ocean Cleanup","Equity",1,0.4364,"VN"],
  ["Kyrgyz Republic","Venture Capital","Ocean Cleanup","Equity",1,1.0,"KG"],
  ["Netherlands","Nonprofit","Ocean Cleanup","Lending",6,2.1657,"NL"],
  ["Nigeria","Public / Semi-public","Circular Economy","Grant",5,0.8039,"NG"],
  ["Chile","Public / Semi-public","Ocean Cleanup","Grant",1,0.1183,"CL"],
  ["Canada","Impact Investor","Waste Management","Lending",4,1.1519,"CA"],
  ["Nepal","Foundation","Ocean Cleanup","Grant",2,0.9555,"NP"],
  ["Romania","Venture Capital","Circular Economy","Equity",1,1.0,"RO"],
  ["Uzbekistan","Financial Service Provider","Circular Economy","Equity",1,0.3284,"UZ"],
  ["Sweden","Incubator","Waste Management","Lending",1,0.1377,"SE"],
  ["New Zealand","Nonprofit","Ocean Cleanup","Grant",7,1.5439,"NZ"],
  ["Qatar","Public / Semi-public","Ocean Cleanup","Grant",2,0.3802,"QA"],
  ["Botswana","Incubator","Waste Management","Lending",1,0.3088,"BW"],
  ["United Arab Emirates","Financial Service Provider","Ocean Cleanup","Equity",1,0.0828,"AE"],
  ["Panama","Impact Investor","Waste Management","Equity",1,0.9208,"PA"],
  ["South Korea","Foundation","Waste Management","Grant",1,0.0609,"KR"],
  ["Colombia","Public / Semi-public","Waste Management","Lending",8,3.3793,"CO"],
  ["West Bank and Gaza","Public / Semi-public","Circular Economy","Lending",3,0.4749,"PS"],
  ["Sudan","Impact Investor","Ocean Cleanup","Grant",2,0.3118,"SD"],
  ["Philippines","Nonprofit","Circular Economy","Grant",4,1.8071,"PH"],
  ["Iran","Financial Service Provider","Circular Economy","Lending",2,0.4381,"IR"],
  ["Indonesia","Public / Semi-public","Circular Economy","Equity",3,0.9066,"ID"],
  ["Indonesia","Foundation","Ocean Cleanup","Lending",2,0.2581,"ID"],
  ["Venezuela","Nonprofit","Ocean Cleanup","Grant",1,0.3811,"VE"],
  ["Serbia","Venture Capital","Circular Economy","Equity",1,1.0,"RS"],
  ["Nigeria","Nonprofit","Ocean Cleanup","Grant",5,1.2998,"NG"],
  ["Kyrgyz Republic","Public / Semi-public","Circular Economy","Lending",1,0.1117,"KG"],
  ["Kenya","Foundation","Circular Economy","Equity",1,1.0,"KE"],
  ["Philippines","Nonprofit","Ocean Cleanup","Equity",3,0.5244,"PH"],
  ["Bangladesh","Nonprofit","Waste Management","Grant",5,0.9424,"BD"],
  ["Libya","Public / Semi-public","Circular Economy","Equity",2,0.3167,"LY"],
  ["Macedonia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MK"],
  ["Ukraine","Foundation","Circular Economy","Grant",1,0.0921,"UA"],
  ["Pakistan","Public / Semi-public","Waste Management","Lending",10,2.7104,"PK"],
  ["Senegal","Venture Capital","Circular Economy","Equity",1,1.0,"SN"],
  ["Mauritius","Public / Semi-public","Circular Economy","Lending",1,0.0329,"MU"],
  ["Kenya","Impact Investor","Waste Management","Grant",3,1.5688,"KE"],
  ["Brazil","Public / Semi-public","Ocean Cleanup","Grant",9,2.331,"BR"],
  ["Netherlands","Nonprofit","Waste Management","Grant",3,1.6474,"NL"],
  ["Thailand","Impact Investor","Waste Management","Equity",4,0.4137,"TH"],
  ["Nigeria","Incubator","Ocean Cleanup","Grant",1,0.0755,"NG"],
  ["Denmark","Public / Semi-public","Ocean Cleanup","Equity",2,0.2442,"DK"],
  ["Croatia","Venture Capital","Circular Economy","Equity",1,1.0,"HR"],
  ["Italy","Foundation","Circular Economy","Grant",4,0.9177,"IT"],
  ["Kenya","Venture Capital","Circular Economy","Lending",1,1.0,"KE"],
  ["Benin","Venture Capital","Circular Economy","Equity",1,1.0,"BJ"],
  ["Djibouti","Public / Semi-public","Circular Economy","Lending",1,0.5076,"DJ"],
  ["Lebanon","Public / Semi-public","Waste Management","Equity",5,2.1097,"LB"],
  ["Spain","Financial Service Provider","Waste Management","Equity",2,0.3081,"ES"],
  ["Malaysia","Public / Semi-public","Waste Management","Grant",4,0.5317,"MY"],
  ["Canada","Incubator","Ocean Cleanup","Grant",1,0.0605,"CA"],
  ["India","Financial Service Provider","Waste Management","Lending",3,0.429,"IN"],
  ["Lithuania","Bank","Ocean Cleanup","Lending",1,0.0453,"LT"],
  ["Indonesia","Impact Investor","Waste Management","Lending",3,0.3407,"ID"],
  ["New Zealand","Crowdfunding","Ocean Cleanup","Equity",1,0.0734,"NZ"],
  ["Israel","Foundation","Ocean Cleanup","Grant",2,0.4799,"IL"],
  ["Turkey","Venture Capital","Circular Economy","Lending",1,0.0544,"TR"],
  ["New Zealand","Crowdfunding","Waste Management","Lending",1,0.0501,"NZ"],
  ["Saudi Arabia","Impact Investor","Circular Economy","Grant",1,0.076,"SA"],
  ["Austria","Nonprofit","Waste Management","Lending",2,0.2765,"AT"],
  ["Uganda","Public / Semi-public","Waste Management","Grant",4,0.6247,"UG"],
  ["Norway","Incubator","Circular Economy","Grant",1,0.1347,"NO"],
  ["Chile","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CL"],
  ["Sweden","Venture Capital","Waste Management","Equity",1,0.0312,"SE"],
  ["Jordan","Competitions","Ocean Cleanup","Grant",1,0.3531,"JO"],
  ["Singapore","Coworking Space","Waste Management","Lending",1,0.3303,"SG"],
  ["Saudi Arabia","Bank","Circular Economy","Equity",3,0.9586,"SA"],
  ["Pakistan","Crowdfunding","Waste Management","Equity",1,0.0795,"PK"],
  ["Congo, Dem. Rep","Financial Service Provider","Waste Management","Equity",2,1.1017,"CD"],
  ["Spain","Foundation","Waste Management","Grant",6,1.5381,"ES"],
  ["Armenia","Venture Capital","Circular Economy","Equity",1,1.0,"AM"],
  ["Madagascar","Impact Investor","Circular Economy","Equity",1,0.0343,"MG"],
  ["Malaysia","Impact Investor","Circular Economy","Lending",2,0.2745,"MY"],
  ["Qatar","Competitions","Waste Management","Grant",1,0.2888,"QA"],
  ["Singapore","Competitions","Ocean Cleanup","Grant",1,0.2029,"SG"],
  ["Poland","Impact Investor","Ocean Cleanup","Equity",2,0.2375,"PL"],
  ["Papua New Guinea","Public / Semi-public","Ocean Cleanup","Equity",1,0.4001,"PG"],
  ["Sweden","Public / Semi-public","Waste Management","Grant",1,0.0305,"SE"],
  ["India","Public / Semi-public","Ocean Cleanup","Equity",13,4.1993,"IN"],
  ["China","Incubator","Waste Management","Grant",1,0.0959,"CN"],
  ["Egypt","Nonprofit","Ocean Cleanup","Lending",5,1.1452,"EG"],
  ["Uruguay","Nonprofit","Ocean Cleanup","Grant",1,0.1004,"UY"],
  ["Taiwan","Crowdfunding","Waste Management","Equity",1,0.2193,"TW"],
  ["Malaysia","Financial Service Provider","Circular Economy","Grant",1,0.1124,"MY"],
  ["Vanuatu","Foundation","Ocean Cleanup","Grant",1,1.0,"VU"],
  ["Kenya","Bank","Waste Management","Lending",2,0.8717,"KE"],
  ["Laos","Financial Service Provider","Circular Economy","Equity",2,0.3778,"LA"],
  ["U.S. Virgin Islands","Venture Capital","Circular Economy","Equity",1,1.0,"VI"],
  ["Ethiopia","Foundation","Waste Management","Equity",1,0.2045,"ET"],
  ["Kenya","Foundation","Circular Economy","Grant",2,1.577,"KE"],
  ["Argentina","Nonprofit","Ocean Cleanup","Grant",4,1.6617,"AR"],
  ["Benin","Financial Service Provider","Ocean Cleanup","Equity",1,0.2566,"BJ"],
  ["Spain","Impact Investor","Waste Management","Equity",4,1.3615,"ES"],
  ["Sri Lanka","Incubator","Circular Economy","Equity",1,0.0852,"LK"],
  ["Tunisia","Financial Service Provider","Waste Management","Lending",2,0.2743,"TN"],
  ["Argentina","Financial Service Provider","Waste Management","Lending",2,1.1092,"AR"],
  ["Somalia","Foundation","Ocean Cleanup","Lending",1,0.2496,"SO"],
  ["Rwanda","Foundation","Circular Economy","Equity",1,0.2108,"RW"],
  ["Netherlands","Impact Investor","Ocean Cleanup","Lending",3,0.6303,"NL"],
  ["United States","Venture Capital","Waste Management","Equity",2,1.0744,"US"],
  ["Malaysia","Public / Semi-public","Waste Management","Lending",5,1.3635,"MY"],
  ["India","Bank","Circular Economy","Lending",5,0.9245,"IN"],
  ["Kenya","Venture Capital","Circular Economy","Equity",3,2.0746,"KE"],
  ["Nepal","Crowdfunding","Ocean Cleanup","Grant",1,0.0575,"NP"],
  ["Finland","Public / Semi-public","Ocean Cleanup","Grant",2,0.3063,"FI"],
  ["Vietnam","Nonprofit","Ocean Cleanup","Grant",5,1.6742,"VN"],
  ["Central African Republic","Public / Semi-public","Ocean Cleanup","Lending",2,1.1834,"CF"],
  ["Canada","Financial Service Provider","Waste Management","Grant",2,0.3234,"CA"],
  ["Sierra Leone","Financial Service Provider","Waste Management","Equity",1,0.036,"SL"],
  ["India","Impact Investor","Waste Management","Grant",3,0.3995,"IN"],
  ["Italy","Public / Semi-public","Waste Management","Grant",6,1.6519,"IT"],
  ["Haiti","Public / Semi-public","Circular Economy","Equity",2,1.5017,"HT"],
  ["South Africa","Nonprofit","Waste Management","Grant",5,0.7889,"ZA"],
  ["Greece","Nonprofit","Waste Management","Lending",1,0.0839,"GR"],
  ["Brazil","Public / Semi-public","Waste Management","Lending",10,3.4366,"BR"],
  ["France","Public / Semi-public","Waste Management","Equity",11,4.3043,"FR"],
  ["Guatemala","Venture Capital","Waste Management","Equity",1,0.0343,"GT"],
  ["Iran","Nonprofit","Waste Management","Grant",1,0.36,"IR"],
  ["Finland","Public / Semi-public","Circular Economy","Lending",2,0.4314,"FI"],
  ["Côte d'Ivoire","Bank","Circular Economy","Lending",1,0.2309,"CI"],
  ["Turkey","Impact Investor","Ocean Cleanup","Equity",5,0.9126,"TR"],
  ["Vietnam","Impact Investor","Ocean Cleanup","Equity",3,0.5152,"VN"],
  ["Indonesia","Incubator","Waste Management","Equity",4,0.4099,"ID"],
  ["Brazil","Incubator","Waste Management","Grant",1,0.0549,"BR"],
  ["Peru","Public / Semi-public","Circular Economy","Grant",6,1.2541,"PE"],
  ["Algeria","Public / Semi-public","Circular Economy","Lending",2,0.5487,"DZ"],
  ["Colombia","Impact Investor","Circular Economy","Equity",2,0.6987,"CO"],
  ["Uganda","Financial Service Provider","Circular Economy","Equity",1,0.0459,"UG"],
  ["Bangladesh","Impact Investor","Waste Management","Grant",3,0.4137,"BD"],
  ["Singapore","Bank","Circular Economy","Lending",2,0.3847,"SG"],
  ["Iran","Public / Semi-public","Waste Management","Grant",3,0.6169,"IR"],
  ["Saudi Arabia","Public / Semi-public","Ocean Cleanup","Lending",5,0.8274,"SA"],
  ["Nigeria","Bank","Circular Economy","Lending",4,1.6493,"NG"],
  ["Sweden","Nonprofit","Waste Management","Lending",3,0.3776,"SE"],
  ["Madagascar","Impact Investor","Circular Economy","Grant",1,0.0696,"MG"],
  ["Myanmar","Impact Investor","Circular Economy","Lending",1,0.207,"MM"],
  ["Netherlands","Coworking Space","Waste Management","Equity",1,0.0483,"NL"],
  ["China","Impact Investor","Ocean Cleanup","Grant",2,0.1862,"CN"],
  ["Algeria","Public / Semi-public","Ocean Cleanup","Grant",5,1.1932,"DZ"],
  ["Colombia","Foundation","Waste Management","Grant",4,1.3498,"CO"],
  ["Italy","Impact Investor","Ocean Cleanup","Grant",3,0.9851,"IT"],
  ["Singapore","Crowdfunding","Waste Management","Equity",1,0.3849,"SG"],
  ["Tunisia","Bank","Ocean Cleanup","Equity",1,0.1131,"TN"],
  ["Bulgaria","Nonprofit","Circular Economy","Grant",1,0.485,"BG"],
  ["Thailand","Competitions","Ocean Cleanup","Grant",1,0.1859,"TH"],
  ["Thailand","Financial Service Provider","Circular Economy","Equity",2,1.0388,"TH"],
  ["Saudi Arabia","Impact Investor","Circular Economy","Lending",2,0.2817,"SA"],
  ["Germany","Incubator","Circular Economy","Equity",1,0.1644,"DE"],
  ["Peru","Impact Investor","Ocean Cleanup","Lending",3,0.3973,"PE"],
  ["Belgium","Nonprofit","Circular Economy","Grant",4,1.464,"BE"],
  ["Romania","Foundation","Waste Management","Equity",1,0.14,"RO"],
  ["Vietnam","Public / Semi-public","Waste Management","Lending",8,2.6396,"VN"],
  ["Mexico","Impact Investor","Circular Economy","Grant",1,0.0688,"MX"],
  ["Mexico","Incubator","Ocean Cleanup","Lending",1,0.1863,"MX"],
  ["Greece","Nonprofit","Ocean Cleanup","Grant",4,1.3212,"GR"],
  ["Bhutan","Public / Semi-public","Ocean Cleanup","Equity",1,0.4851,"BT"],
  ["Portugal","Incubator","Circular Economy","Grant",1,0.213,"PT"],
  ["Nigeria","Impact Investor","Circular Economy","Grant",1,0.0856,"NG"],
  ["Finland","Public / Semi-public","Circular Economy","Equity",2,0.2974,"FI"],
  ["United Arab Emirates","Crowdfunding","Ocean Cleanup","Grant",1,0.1765,"AE"],
  ["South Korea","Public / Semi-public","Ocean Cleanup","Lending",3,0.5205,"KR"],
  ["Nigeria","Nonprofit","Waste Management","Grant",4,0.912,"NG"],
  ["Cambodia","Nonprofit","Waste Management","Lending",3,0.4214,"KH"],
  ["Papua New Guinea","Nonprofit","Waste Management","Lending",1,0.0536,"PG"],
  ["Antigua and Barbuda","Venture Capital","Ocean Cleanup","Equity",1,1.0,"AG"],
  ["Myanmar","Nonprofit","Ocean Cleanup","Lending",2,0.4352,"MM"],
  ["Iraq","Nonprofit","Waste Management","Grant",2,0.3937,"IQ"],
  ["Ghana","Impact Investor","Waste Management","Grant",3,0.7121,"GH"],
  ["Italy","Competitions","Ocean Cleanup","Grant",1,0.2219,"IT"],
  ["Nigeria","Impact Investor","Waste Management","Lending",4,0.4972,"NG"],
  ["Morocco","Public / Semi-public","Ocean Cleanup","Grant",4,1.0909,"MA"],
  ["Bhutan","Public / Semi-public","Ocean Cleanup","Grant",2,0.5932,"BT"],
  ["Colombia","Nonprofit","Waste Management","Lending",4,1.1427,"CO"],
  ["Zambia","Impact Investor","Circular Economy","Equity",1,0.0514,"ZM"],
  ["India","Crowdfunding","Ocean Cleanup","Grant",3,1.5947,"IN"],
  ["Germany","Impact Investor","Ocean Cleanup","Grant",3,0.5824,"DE"],
  ["Mexico","Financial Service Provider","Waste Management","Grant",1,0.1402,"MX"],
  ["Tunisia","Public / Semi-public","Ocean Cleanup","Equity",9,4.1429,"TN"],
  ["Uganda","Impact Investor","Waste Management","Grant",3,0.4123,"UG"],
  ["Martinique","Public / Semi-public","Waste Management","Equity",1,0.8653,"MQ"],
  ["Botswana","Financial Service Provider","Waste Management","Lending",1,0.1563,"BW"],
  ["Oman","Competitions","Waste Management","Grant",1,0.2488,"OM"],
  ["Cyprus","Bank","Circular Economy","Equity",1,0.4329,"CY"],
  ["Vietnam","Nonprofit","Circular Economy","Grant",3,0.9354,"VN"],
  ["Russia","Incubator","Circular Economy","Grant",1,0.1428,"RU"],
  ["Austria","Impact Investor","Ocean Cleanup","Equity",2,0.2765,"AT"],
  ["Bhutan","Public / Semi-public","Ocean Cleanup","Lending",1,0.4851,"BT"],
  ["Ukraine","Incubator","Waste Management","Lending",1,0.1787,"UA"],
  ["Finland","Incubator","Circular Economy","Grant",1,0.1791,"FI"],
  ["Austria","Public / Semi-public","Ocean Cleanup","Lending",2,0.8603,"AT"],
  ["Nepal","Nonprofit","Waste Management","Lending",3,1.0581,"NP"],
  ["Iraq","Public / Semi-public","Waste Management","Lending",4,1.4457,"IQ"],
  ["Japan","Public / Semi-public","Ocean Cleanup","Grant",5,0.9421,"JP"],
  ["Chad","Public / Semi-public","Waste Management","Grant",1,0.386,"TD"],
  ["Germany","Public / Semi-public","Ocean Cleanup","Grant",9,1.9481,"DE"],
  ["Antigua and Barbuda","Public / Semi-public","Ocean Cleanup","Equity",1,0.4639,"AG"],
  ["Nigeria","Public / Semi-public","Waste Management","Equity",8,1.6536,"NG"],
  ["Fiji","Public / Semi-public","Circular Economy","Lending",1,0.5692,"FJ"],
  ["Saudi Arabia","Venture Capital","Circular Economy","Equity",2,1.0835,"SA"],
  ["Switzerland","Public / Semi-public","Ocean Cleanup","Equity",6,1.9796,"CH"],
  ["Hungary","Nonprofit","Waste Management","Lending",1,0.1092,"HU"],
  ["Cambodia","Venture Capital","Circular Economy","Equity",1,1.0,"KH"],
  ["Madagascar","Nonprofit","Circular Economy","Grant",1,0.0696,"MG"],
  ["Afghanistan","Foundation","Waste Management","Lending",1,0.1614,"AF"],
  ["Philippines","Bank","Ocean Cleanup","Lending",3,1.4393,"PH"],
  ["Ecuador","Public / Semi-public","Ocean Cleanup","Lending",1,0.0341,"EC"],
  ["Reunion","Public / Semi-public","Ocean Cleanup","Lending",2,0.6139,"RE"],
  ["Vietnam","Incubator","Ocean Cleanup","Lending",1,0.1286,"VN"],
  ["Zambia","Public / Semi-public","Ocean Cleanup","Lending",2,1.32,"ZM"],
  ["Rwanda","Incubator","Waste Management","Grant",1,0.0745,"RW"],
  ["Zimbabwe","Impact Investor","Ocean Cleanup","Grant",1,0.076,"ZW"],
  ["Iraq","Public / Semi-public","Waste Management","Grant",4,0.5663,"IQ"],
  ["Netherlands","Bank","Ocean Cleanup","Equity",2,1.1111,"NL"],
  ["Romania","Incubator","Waste Management","Equity",1,0.14,"RO"],
  ["China","Crowdfunding","Ocean Cleanup","Grant",1,0.0884,"CN"],
  ["Rwanda","Financial Service Provider","Circular Economy","Equity",1,1.0,"RW"],
  ["Colombia","Incubator","Waste Management","Equity",2,0.746,"CO"],
  ["Martinique","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MQ"],
  ["Denmark","Public / Semi-public","Circular Economy","Grant",1,0.2086,"DK"],
  ["Niger","Nonprofit","Ocean Cleanup","Lending",1,0.2378,"NE"],
  ["Congo, Dem. Rep","Foundation","Circular Economy","Grant",2,0.3732,"CD"],
  ["Bangladesh","Nonprofit","Ocean Cleanup","Equity",5,2.1607,"BD"],
  ["Zambia","Public / Semi-public","Circular Economy","Grant",1,0.0764,"ZM"],
  ["Argentina","Public / Semi-public","Circular Economy","Lending",2,0.3874,"AR"],
  ["Antigua and Barbuda","Public / Semi-public","Waste Management","Equity",1,0.4639,"AG"],
  ["Cambodia","Nonprofit","Circular Economy","Grant",2,0.5623,"KH"],
  ["Taiwan","Nonprofit","Waste Management","Lending",1,0.0662,"TW"],
  ["Cambodia","Bank","Ocean Cleanup","Lending",2,0.2154,"KH"],
  ["Morocco","Foundation","Waste Management","Grant",1,0.2998,"MA"],
  ["Mongolia","Public / Semi-public","Circular Economy","Equity",1,0.4893,"MN"],
  ["India","Incubator","Circular Economy","Grant",1,0.4735,"IN"],
  ["France","Impact Investor","Ocean Cleanup","Grant",3,0.9303,"FR"],
  ["China","Public / Semi-public","Circular Economy","Equity",3,0.951,"CN"],
  ["Bahrain","Public / Semi-public","Circular Economy","Equity",1,0.4208,"BH"],
  ["Poland","Public / Semi-public","Waste Management","Equity",2,0.375,"PL"],
  ["El Salvador","Financial Service Provider","Waste Management","Equity",1,0.0946,"SV"],
  ["Pakistan","Foundation","Ocean Cleanup","Equity",2,0.291,"PK"],
  ["Vietnam","Financial Service Provider","Circular Economy","Lending",2,0.409,"VN"],
  ["Lebanon","Bank","Circular Economy","Lending",1,0.1628,"LB"],
  ["Sudan","Foundation","Circular Economy","Lending",1,0.1536,"SD"],
  ["Austria","Impact Investor","Waste Management","Lending",2,0.2765,"AT"],
  ["Japan","Public / Semi-public","Circular Economy","Lending",4,1.409,"JP"],
  ["Switzerland","Foundation","Circular Economy","Grant",2,0.7841,"CH"],
  ["Iraq","Incubator","Waste Management","Equity",1,0.1317,"IQ"],
  ["Samoa","Venture Capital","Circular Economy","Equity",1,1.0,"WS"],
  ["Mongolia","Crowdfunding","Ocean Cleanup","Equity",1,0.0295,"MN"],
  ["Kenya","Incubator","Ocean Cleanup","Grant",1,1.0,"KE"],
  ["Benin","Public / Semi-public","Ocean Cleanup","Equity",5,1.7895,"BJ"],
  ["Kenya","Nonprofit","Ocean Cleanup","Grant",7,3.0201,"KE"],
  ["Norway","Foundation","Ocean Cleanup","Grant",1,0.3553,"NO"],
  ["South Africa","Bank","Ocean Cleanup","Equity",2,1.1141,"ZA"],
  ["France","Competitions","Ocean Cleanup","Grant",1,0.2077,"FR"],
  ["Turkey","Crowdfunding","Ocean Cleanup","Grant",1,0.0634,"TR"],
  ["United States","Financial Service Provider","Waste Management","Lending",3,1.2078,"US"],
  ["Lebanon","Nonprofit","Waste Management","Lending",1,0.0329,"LB"],
  ["Chile","Financial Service Provider","Waste Management","Lending",2,0.3118,"CL"],
  ["Liberia","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"LR"],
  ["Germany","Bank","Waste Management","Lending",2,0.3731,"DE"],
  ["Hungary","Foundation","Circular Economy","Grant",1,0.4006,"HU"],
  ["Congo, Dem. Rep","Foundation","Circular Economy","Lending",1,0.1508,"CD"],
  ["Chad","Public / Semi-public","Ocean Cleanup","Lending",2,1.386,"TD"],
  ["South Africa","Foundation","Waste Management","Equity",2,0.5222,"ZA"],
  ["Bahrain","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BH"],
  ["Madagascar","Foundation","Ocean Cleanup","Grant",2,1.4149,"MG"],
  ["Somalia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SO"],
  ["South Korea","Crowdfunding","Ocean Cleanup","Grant",1,0.1242,"KR"],
  ["India","Nonprofit","Circular Economy","Lending",2,1.4608,"IN"],
  ["Turkey","Incubator","Ocean Cleanup","Lending",1,0.1285,"TR"],
  ["Serbia","Public / Semi-public","Waste Management","Lending",2,0.9152,"RS"],
  ["Rwanda","Impact Investor","Ocean Cleanup","Grant",3,1.4806,"RW"],
  ["Zambia","Foundation","Circular Economy","Lending",1,0.1839,"ZM"],
  ["Peru","Nonprofit","Waste Management","Lending",4,0.7459,"PE"],
  ["Mozambique","Financial Service Provider","Waste Management","Lending",1,0.4,"MZ"],
  ["Mali","Public / Semi-public","Waste Management","Grant",1,0.4836,"ML"],
  ["South Africa","Impact Investor","Ocean Cleanup","Grant",4,1.4753,"ZA"],
  ["Egypt","Competitions","Waste Management","Grant",1,0.3418,"EG"],
  ["Afghanistan","Foundation","Waste Management","Equity",1,0.1614,"AF"],
  ["South Korea","Nonprofit","Ocean Cleanup","Equity",2,0.2789,"KR"],
  ["Tanzania","Bank","Circular Economy","Equity",2,0.6702,"TZ"],
  ["Tanzania","Public / Semi-public","Circular Economy","Grant",3,0.3464,"TZ"],
  ["Togo","Public / Semi-public","Waste Management","Equity",1,0.4885,"TG"],
  ["Philippines","Impact Investor","Waste Management","Grant",1,0.0549,"PH"],
  ["Argentina","Public / Semi-public","Ocean Cleanup","Lending",3,0.6156,"AR"],
  ["New Zealand","Bank","Circular Economy","Equity",1,0.148,"NZ"],
  ["Uganda","Incubator","Circular Economy","Equity",1,0.0897,"UG"],
  ["Turkey","Crowdfunding","Waste Management","Lending",1,0.0277,"TR"],
  ["South Africa","Bank","Circular Economy","Equity",3,1.4011,"ZA"],
  ["South Africa","Public / Semi-public","Waste Management","Lending",7,1.0967,"ZA"],
  ["Azerbaijan","Public / Semi-public","Circular Economy","Equity",1,0.5155,"AZ"],
  ["United States","Financial Service Provider","Circular Economy","Lending",2,0.856,"US"],
  ["India","Financial Service Provider","Circular Economy","Grant",1,0.1627,"IN"],
  ["Russia","Bank","Waste Management","Lending",1,0.2354,"RU"],
  ["Zambia","Financial Service Provider","Waste Management","Equity",3,0.5434,"ZM"],
  ["Brazil","Crowdfunding","Waste Management","Lending",1,0.0239,"BR"],
  ["Central African Republic","Public / Semi-public","Waste Management","Lending",1,0.1834,"CF"],
  ["Argentina","Impact Investor","Waste Management","Lending",4,1.2218,"AR"],
  ["Ethiopia","Foundation","Ocean Cleanup","Lending",1,0.2045,"ET"],
  ["Uzbekistan","Financial Service Provider","Circular Economy","Lending",1,0.3284,"UZ"],
  ["Iraq","Nonprofit","Ocean Cleanup","Grant",5,1.4205,"IQ"],
  ["United Kingdom","Bank","Waste Management","Equity",1,0.1297,"GB"],
  ["Afghanistan","Financial Service Provider","Circular Economy","Lending",1,0.0347,"AF"],
  ["Qatar","Venture Capital","Waste Management","Equity",1,0.0687,"QA"],
  ["Tanzania","Public / Semi-public","Circular Economy","Equity",2,0.3223,"TZ"],
  ["Mali","Nonprofit","Ocean Cleanup","Grant",1,0.0588,"ML"],
  ["Mexico","Bank","Circular Economy","Equity",1,0.108,"MX"],
  ["Madagascar","Financial Service Provider","Waste Management","Equity",1,0.0343,"MG"],
  ["Hungary","Impact Investor","Ocean Cleanup","Equity",1,0.1092,"HU"],
  ["Somalia","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"SO"],
  ["Guatemala","Foundation","Ocean Cleanup","Grant",1,0.3814,"GT"],
  ["Australia","Impact Investor","Circular Economy","Equity",2,0.6231,"AU"],
  ["South Korea","Bank","Ocean Cleanup","Equity",1,0.4225,"KR"],
  ["Bahrain","Crowdfunding","Ocean Cleanup","Grant",1,0.0917,"BH"],
  ["United States","Competitions","Waste Management","Grant",1,0.378,"US"],
  ["Iraq","Public / Semi-public","Ocean Cleanup","Lending",4,1.0648,"IQ"],
  ["Ghana","Foundation","Ocean Cleanup","Lending",1,0.1774,"GH"],
  ["Vietnam","Nonprofit","Ocean Cleanup","Equity",3,0.6999,"VN"],
  ["Botswana","Incubator","Ocean Cleanup","Lending",1,0.3088,"BW"],
  ["United Arab Emirates","Foundation","Waste Management","Lending",2,0.3681,"AE"],
  ["Ecuador","Foundation","Ocean Cleanup","Grant",2,0.7118,"EC"],
  ["Japan","Public / Semi-public","Ocean Cleanup","Lending",4,1.3189,"JP"],
  ["Colombia","Foundation","Ocean Cleanup","Grant",2,1.0622,"CO"],
  ["Israel","Public / Semi-public","Ocean Cleanup","Equity",2,0.5881,"IL"],
  ["Syria","Nonprofit","Circular Economy","Grant",1,0.759,"SY"],
  ["Turkey","Public / Semi-public","Waste Management","Lending",6,2.0867,"TR"],
  ["Hong Kong","Nonprofit","Ocean Cleanup","Lending",1,0.1698,"HK"],
  ["Colombia","Bank","Ocean Cleanup","Equity",1,0.1107,"CO"],
  ["United Kingdom","Competitions","Ocean Cleanup","Grant",1,1.0,"GB"],
  ["Myanmar","Public / Semi-public","Circular Economy","Equity",4,1.376,"MM"],
  ["United Arab Emirates","Foundation","Ocean Cleanup","Grant",4,1.0619,"AE"],
  ["Peru","Impact Investor","Circular Economy","Equity",2,0.2518,"PE"],
  ["Myanmar","Foundation","Waste Management","Grant",3,0.8765,"MM"],
  ["South Sudan","Incubator","Ocean Cleanup","Grant",1,0.1369,"SS"],
  ["Kenya","Public / Semi-public","Circular Economy","Grant",5,1.3308,"KE"],
  ["Greenland","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GL"],
  ["Taiwan","Public / Semi-public","Waste Management","Lending",1,0.2518,"TW"],
  ["Malaysia","Incubator","Waste Management","Equity",4,0.4546,"MY"],
  ["Bulgaria","Nonprofit","Waste Management","Lending",1,0.0386,"BG"],
  ["Germany","Venture Capital","Circular Economy","Lending",1,0.0285,"DE"],
  ["Haiti","Nonprofit","Waste Management","Lending",1,0.5941,"HT"],
  ["Martinique","Public / Semi-public","Circular Economy","Equity",1,0.8653,"MQ"],
  ["India","Bank","Circular Economy","Equity",3,0.5923,"IN"],
  ["Austria","Public / Semi-public","Circular Economy","Equity",1,0.4102,"AT"],
  ["Pakistan","Financial Service Provider","Ocean Cleanup","Equity",1,0.1087,"PK"],
  ["Zambia","Public / Semi-public","Ocean Cleanup","Grant",2,0.1499,"ZM"],
  ["Brunei","Bank","Ocean Cleanup","Equity",1,0.3757,"BN"],
  ["Haiti","Venture Capital","Ocean Cleanup","Equity",1,1.0,"HT"],
  ["Poland","Venture Capital","Waste Management","Equity",1,0.0576,"PL"],
  ["Romania","Public / Semi-public","Ocean Cleanup","Grant",2,0.3451,"RO"],
  ["Bangladesh","Financial Service Provider","Circular Economy","Lending",1,0.3354,"BD"],
  ["Philippines","Foundation","Circular Economy","Grant",2,0.4122,"PH"],
  ["Ecuador","Impact Investor","Waste Management","Equity",1,0.7624,"EC"],
  ["Spain","Bank","Waste Management","Equity",1,0.0907,"ES"],
  ["Zambia","Public / Semi-public","Circular Economy","Equity",1,0.2529,"ZM"],
  ["United States","Impact Investor","Ocean Cleanup","Grant",3,0.6534,"US"],
  ["Rwanda","Impact Investor","Ocean Cleanup","Equity",2,1.0662,"RW"],
  ["Tanzania","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TZ"],
  ["Afghanistan","Foundation","Circular Economy","Equity",1,0.1614,"AF"],
  ["South Sudan","Foundation","Waste Management","Equity",1,0.3356,"SS"],
  ["Burkina Faso","Public / Semi-public","Circular Economy","Grant",1,0.3578,"BF"],
  ["Sudan","Foundation","Ocean Cleanup","Equity",1,0.1536,"SD"],
  ["Morocco","Financial Service Provider","Circular Economy","Lending",1,0.1001,"MA"],
  ["Tanzania","Nonprofit","Waste Management","Lending",3,0.8573,"TZ"],
  ["Norway","Public / Semi-public","Ocean Cleanup","Equity",1,0.1992,"NO"],
  ["Netherlands","Nonprofit","Circular Economy","Equity",2,0.4698,"NL"],
  ["Albania","Nonprofit","Circular Economy","Lending",1,1.0,"AL"],
  ["Sweden","Foundation","Ocean Cleanup","Grant",3,0.818,"SE"],
  ["Zambia","Impact Investor","Waste Management","Equity",1,0.2714,"ZM"],
  ["Madagascar","Nonprofit","Ocean Cleanup","Grant",3,0.7,"MG"],
  ["Netherlands","Financial Service Provider","Waste Management","Grant",2,0.1732,"NL"],
  ["South Korea","Impact Investor","Ocean Cleanup","Grant",1,0.3516,"KR"],
  ["Cayman Islands","Venture Capital","Circular Economy","Equity",1,1.0,"KY"],
  ["Armenia","Bank","Circular Economy","Equity",1,0.3815,"AM"],
  ["Vietnam","Bank","Ocean Cleanup","Equity",2,0.2226,"VN"],
  ["Mauritania","Venture Capital","Circular Economy","Equity",1,1.0,"MR"],
  ["Spain","Impact Investor","Circular Economy","Grant",1,0.0806,"ES"],
  ["Congo, Dem. Rep","Public / Semi-public","Ocean Cleanup","Equity",5,1.5634,"CD"],
  ["Slovakia","Public / Semi-public","Waste Management","Equity",1,0.0694,"SK"],
  ["Ethiopia","Public / Semi-public","Waste Management","Grant",4,0.7277,"ET"],
  ["Senegal","Public / Semi-public","Waste Management","Equity",3,0.9461,"SN"],
  ["Canada","Venture Capital","Waste Management","Equity",2,0.0684,"CA"],
  ["Netherlands","Financial Service Provider","Waste Management","Equity",1,1.0,"NL"],
  ["Sierra Leone","Nonprofit","Waste Management","Lending",1,0.036,"SL"],
  ["French Guiana","Public / Semi-public","Ocean Cleanup","Equity",1,0.5862,"GF"],
  ["China","Bank","Ocean Cleanup","Lending",4,0.8618,"CN"],
  ["Chile","Nonprofit","Ocean Cleanup","Equity",1,0.1561,"CL"],
  ["Haiti","Impact Investor","Ocean Cleanup","Lending",1,0.5941,"HT"],
  ["Indonesia","Nonprofit","Waste Management","Equity",4,0.6473,"ID"],
  ["British Virgin Islands","Venture Capital","Circular Economy","Equity",1,1.0,"VG"],
  ["Laos","Public / Semi-public","Circular Economy","Grant",1,0.4599,"LA"],
  ["Somalia","Foundation","Waste Management","Grant",1,0.2496,"SO"],
  ["Guinea","Public / Semi-public","Circular Economy","Lending",2,0.3999,"GN"],
  ["West Bank and Gaza","Public / Semi-public","Ocean Cleanup","Lending",3,0.4749,"PS"],
  ["Mexico","Impact Investor","Waste Management","Equity",3,1.2588,"MX"],
  ["Austria","Nonprofit","Ocean Cleanup","Equity",2,0.2765,"AT"],
  ["New Zealand","Financial Service Provider","Waste Management","Grant",1,0.064,"NZ"],
  ["Liberia","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"LR"],
  ["Burkina Faso","Public / Semi-public","Waste Management","Lending",3,0.6358,"BF"],
  ["Poland","Impact Investor","Circular Economy","Equity",2,0.2375,"PL"],
  ["Marshall Islands","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MH"],
  ["Nicaragua","Public / Semi-public","Ocean Cleanup","Lending",1,0.3848,"NI"],
  ["Indonesia","Crowdfunding","Ocean Cleanup","Equity",1,0.2694,"ID"],
  ["Argentina","Foundation","Ocean Cleanup","Lending",1,0.1547,"AR"],
  ["Zimbabwe","Financial Service Provider","Waste Management","Grant",1,0.1737,"ZW"],
  ["Belgium","Financial Service Provider","Circular Economy","Equity",1,0.0326,"BE"],
  ["Belgium","Financial Service Provider","Circular Economy","Grant",1,0.1413,"BE"],
  ["Philippines","Impact Investor","Waste Management","Equity",4,0.5528,"PH"],
  ["Sudan","Foundation","Waste Management","Equity",1,0.1536,"SD"],
  ["Canada","Nonprofit","Ocean Cleanup","Equity",4,1.1732,"CA"],
  ["Haiti","Public / Semi-public","Circular Economy","Grant",1,0.5017,"HT"],
  ["Burkina Faso","Venture Capital","Circular Economy","Equity",1,1.0,"BF"],
  ["Kenya","Impact Investor","Circular Economy","Lending",3,1.1937,"KE"],
  ["Myanmar","Public / Semi-public","Waste Management","Grant",3,0.7522,"MM"],
  ["Lithuania","Public / Semi-public","Waste Management","Lending",1,0.0491,"LT"],
  ["Hong Kong","Financial Service Provider","Circular Economy","Grant",1,0.1366,"HK"],
  ["Albania","Nonprofit","Waste Management","Equity",1,1.0,"AL"],
  ["Philippines","Venture Capital","Ocean Cleanup","Equity",1,1.0,"PH"],
  ["Tunisia","Nonprofit","Circular Economy","Lending",1,0.609,"TN"],
  ["Kenya","Nonprofit","Ocean Cleanup","Equity",5,1.1755,"KE"],
  ["Mozambique","Public / Semi-public","Ocean Cleanup","Grant",1,0.4613,"MZ"],
  ["Mauritania","Public / Semi-public","Waste Management","Grant",1,0.3609,"MR"],
  ["Vietnam","Crowdfunding","Waste Management","Equity",1,0.4364,"VN"],
  ["United Kingdom","Nonprofit","Waste Management","Equity",4,0.5982,"GB"],
  ["Botswana","Impact Investor","Waste Management","Lending",1,0.3088,"BW"],
  ["Philippines","Public / Semi-public","Waste Management","Equity",4,1.025,"PH"],
  ["Jordan","Public / Semi-public","Waste Management","Lending",5,1.4036,"JO"],
  ["Uganda","Competitions","Ocean Cleanup","Grant",1,0.2759,"UG"],
  ["Australia","Foundation","Circular Economy","Equity",1,0.1891,"AU"],
  ["Saint Helena","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SH"],
  ["South Korea","Incubator","Waste Management","Equity",2,0.1791,"KR"],
  ["Rwanda","Bank","Ocean Cleanup","Lending",1,0.433,"RW"],
  ["Nepal","Public / Semi-public","Waste Management","Grant",5,0.9294,"NP"],
  ["Germany","Nonprofit","Waste Management","Equity",4,1.2722,"DE"],
  ["Uganda","Impact Investor","Ocean Cleanup","Grant",3,0.5236,"UG"],
  ["Israel","Nonprofit","Ocean Cleanup","Lending",1,0.0674,"IL"],
  ["Norway","Bank","Ocean Cleanup","Equity",1,0.1145,"NO"],
  ["Morocco","Bank","Circular Economy","Equity",1,0.083,"MA"],
  ["Netherlands","Nonprofit","Circular Economy","Grant",4,2.2232,"NL"],
  ["Netherlands","Venture Capital","Circular Economy","Lending",1,1.0,"NL"],
  ["Chile","Public / Semi-public","Ocean Cleanup","Lending",1,0.0312,"CL"],
  ["Ethiopia","Incubator","Waste Management","Equity",1,0.1094,"ET"],
  ["Myanmar","Public / Semi-public","Circular Economy","Lending",7,2.1319,"MM"],
  ["Liberia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"LR"],
  ["Yemen","Public / Semi-public","Ocean Cleanup","Equity",4,1.1902,"YE"],
  ["Germany","Financial Service Provider","Circular Economy","Grant",1,0.4465,"DE"],
  ["Qatar","Incubator","Circular Economy","Equity",1,0.0749,"QA"],
  ["Togo","Public / Semi-public","Circular Economy","Equity",1,0.4885,"TG"],
  ["China","Impact Investor","Ocean Cleanup","Equity",1,0.0351,"CN"],
  ["Saudi Arabia","Incubator","Ocean Cleanup","Grant",1,0.1111,"SA"],
  ["United States","Public / Semi-public","Ocean Cleanup","Lending",9,2.9661,"US"],
  ["South Korea","Bank","Ocean Cleanup","Lending",2,0.4885,"KR"],
  ["Saudi Arabia","Bank","Ocean Cleanup","Lending",4,0.9824,"SA"],
  ["Switzerland","Public / Semi-public","Ocean Cleanup","Grant",3,0.4768,"CH"],
  ["Belgium","Bank","Ocean Cleanup","Equity",1,0.1255,"BE"],
  ["Hungary","Impact Investor","Ocean Cleanup","Lending",1,0.1092,"HU"],
  ["Colombia","Foundation","Ocean Cleanup","Equity",1,0.147,"CO"],
  ["India","Foundation","Waste Management","Equity",2,0.3555,"IN"],
  ["Australia","Crowdfunding","Ocean Cleanup","Grant",1,0.1675,"AU"],
  ["Pakistan","Nonprofit","Ocean Cleanup","Grant",8,2.6627,"PK"],
  ["Swaziland","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"SZ"],
  ["Indonesia","Nonprofit","Waste Management","Lending",4,0.6473,"ID"],
  ["Rwanda","Foundation","Ocean Cleanup","Grant",1,0.2108,"RW"],
  ["Slovenia","Public / Semi-public","Ocean Cleanup","Grant",1,0.3047,"SI"],
  ["El Salvador","Nonprofit","Waste Management","Lending",1,0.0946,"SV"],
  ["Zambia","Financial Service Provider","Ocean Cleanup","Equity",1,0.32,"ZM"],
  ["Guinea","Public / Semi-public","Ocean Cleanup","Grant",1,0.3291,"GN"],
  ["Cambodia","Impact Investor","Circular Economy","Equity",2,0.1118,"KH"],
  ["Macedonia","Public / Semi-public","Ocean Cleanup","Lending",1,0.2824,"MK"],
  ["Poland","Venture Capital","Circular Economy","Equity",1,1.0,"PL"],
  ["Brunei","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BN"],
  ["Italy","Public / Semi-public","Ocean Cleanup","Grant",9,2.4893,"IT"],
  ["Bosnia and Herzegovina","Public / Semi-public","Ocean Cleanup","Equity",2,0.7346,"BA"],
  ["Benin","Nonprofit","Waste Management","Lending",2,0.4377,"BJ"],
  ["Portugal","Competitions","Waste Management","Grant",1,0.2315,"PT"],
  ["Hong Kong","Public / Semi-public","Ocean Cleanup","Equity",2,0.339,"HK"],
  ["Namibia","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"NA"],
  ["Tanzania","Impact Investor","Ocean Cleanup","Lending",2,0.5192,"TZ"],
  ["South Korea","Public / Semi-public","Circular Economy","Grant",1,0.3066,"KR"],
  ["Benin","Bank","Waste Management","Lending",1,0.2869,"BJ"],
  ["Vietnam","Public / Semi-public","Ocean Cleanup","Equity",8,1.7848,"VN"],
  ["Nigeria","Crowdfunding","Ocean Cleanup","Grant",1,0.0524,"NG"],
  ["Ecuador","Financial Service Provider","Ocean Cleanup","Equity",1,0.0324,"EC"],
  ["Belgium","Incubator","Ocean Cleanup","Equity",1,0.1513,"BE"],
  ["Uzbekistan","Public / Semi-public","Ocean Cleanup","Lending",2,1.1844,"UZ"],
  ["Reunion","Public / Semi-public","Circular Economy","Equity",2,0.6139,"RE"],
  ["Saudi Arabia","Financial Service Provider","Circular Economy","Grant",1,0.0569,"SA"],
  ["Netherlands","Public / Semi-public","Circular Economy","Grant",3,1.2629,"NL"],
  ["Ghana","Financial Service Provider","Circular Economy","Equity",2,0.0569,"GH"],
  ["Zambia","Incubator","Ocean Cleanup","Lending",1,0.2714,"ZM"],
  ["Switzerland","Public / Semi-public","Circular Economy","Lending",2,0.4613,"CH"],
  ["Bahrain","Foundation","Circular Economy","Equity",1,0.1767,"BH"],
  ["South Korea","Financial Service Provider","Circular Economy","Lending",1,0.1943,"KR"],
  ["Saint Kitts and Nevis","Public / Semi-public","Waste Management","Equity",1,1.0,"KN"],
  ["Australia","Bank","Circular Economy","Equity",3,0.9496,"AU"],
  ["Germany","Impact Investor","Circular Economy","Equity",4,1.0188,"DE"],
  ["Libya","Crowdfunding","Waste Management","Equity",1,0.0549,"LY"],
  ["South Africa","Venture Capital","Circular Economy","Lending",2,1.0255,"ZA"],
  ["Brunei","Crowdfunding","Ocean Cleanup","Grant",1,0.1342,"BN"],
  ["Netherlands","Impact Investor","Circular Economy","Equity",3,0.4989,"NL"],
  ["Ethiopia","Nonprofit","Ocean Cleanup","Equity",1,0.3695,"ET"],
  ["Bangladesh","Foundation","Ocean Cleanup","Lending",2,0.3228,"BD"],
  ["Hong Kong","Public / Semi-public","Ocean Cleanup","Lending",2,0.3909,"HK"],
  ["Ireland","Impact Investor","Ocean Cleanup","Lending",2,0.2416,"IE"],
  ["Rwanda","Foundation","Waste Management","Equity",1,0.2108,"RW"],
  ["Mauritius","Nonprofit","Ocean Cleanup","Grant",1,0.0692,"MU"],
  ["Italy","Impact Investor","Waste Management","Grant",3,0.7437,"IT"],
  ["Chile","Nonprofit","Circular Economy","Equity",1,0.1561,"CL"],
  ["Nigeria","Crowdfunding","Ocean Cleanup","Equity",1,0.0362,"NG"],
  ["Australia","Bank","Waste Management","Lending",2,0.265,"AU"],
  ["Thailand","Foundation","Ocean Cleanup","Grant",3,0.6963,"TH"],
  ["Reunion","Public / Semi-public","Ocean Cleanup","Equity",3,0.9881,"RE"],
  ["Malawi","Impact Investor","Waste Management","Equity",2,1.2661,"MW"],
  ["Malaysia","Bank","Circular Economy","Equity",2,0.5334,"MY"],
  ["Mexico","Incubator","Circular Economy","Equity",1,0.1023,"MX"],
  ["Indonesia","Nonprofit","Ocean Cleanup","Equity",5,1.077,"ID"],
  ["Uganda","Impact Investor","Waste Management","Lending",1,1.0,"UG"],
  ["Canada","Nonprofit","Circular Economy","Lending",2,0.5766,"CA"],
  ["Turkey","Microfinance Institution","Waste Management","Lending",1,0.0292,"TR"],
  ["Zambia","Public / Semi-public","Ocean Cleanup","Equity",3,1.4036,"ZM"],
  ["Vietnam","Public / Semi-public","Circular Economy","Lending",7,1.9594,"VN"],
  ["Singapore","Venture Capital","Circular Economy","Equity",2,1.0631,"SG"],
  ["Albania","Impact Investor","Waste Management","Equity",2,1.1073,"AL"],
  ["Hungary","Nonprofit","Ocean Cleanup","Lending",1,0.1092,"HU"],
  ["Côte d'Ivoire","Public / Semi-public","Ocean Cleanup","Grant",1,0.3499,"CI"],
  ["Ecuador","Financial Service Provider","Waste Management","Lending",2,0.2619,"EC"],
  ["Egypt","Nonprofit","Ocean Cleanup","Grant",8,1.7597,"EG"],
  ["China","Public / Semi-public","Circular Economy","Grant",3,0.8621,"CN"],
  ["Congo, Rep.","Venture Capital","Circular Economy","Equity",1,1.0,"CG"],
  ["Albania","Bank","Ocean Cleanup","Equity",1,0.1833,"AL"],
  ["Spain","Venture Capital","Circular Economy","Lending",1,0.059,"ES"],
  ["Peru","Financial Service Provider","Waste Management","Grant",1,0.1699,"PE"],
  ["Romania","Public / Semi-public","Waste Management","Lending",3,0.3453,"RO"],
  ["United Arab Emirates","Financial Service Provider","Waste Management","Equity",2,0.1104,"AE"],
  ["Myanmar","Financial Service Provider","Circular Economy","Grant",1,0.1013,"MM"],
  ["Tunisia","Impact Investor","Ocean Cleanup","Equity",2,0.8826,"TN"],
  ["Singapore","Coworking Space","Waste Management","Equity",1,0.3303,"SG"],
  ["Mozambique","Nonprofit","Waste Management","Grant",1,0.4613,"MZ"],
  ["Japan","Public / Semi-public","Waste Management","Lending",5,1.7181,"JP"],
  ["Peru","Financial Service Provider","Waste Management","Lending",3,0.6226,"PE"],
  ["Chile","Incubator","Waste Management","Equity",1,0.0849,"CL"],
  ["Bangladesh","Foundation","Circular Economy","Lending",1,0.1727,"BD"],
  ["Thailand","Bank","Waste Management","Equity",1,0.0769,"TH"],
  ["Saudi Arabia","Public / Semi-public","Waste Management","Grant",5,0.8749,"SA"],
  ["Congo, Dem. Rep","Nonprofit","Waste Management","Equity",1,0.1017,"CD"],
  ["Australia","Nonprofit","Ocean Cleanup","Equity",5,1.2281,"AU"],
  ["China","Financial Service Provider","Ocean Cleanup","Lending",1,0.1038,"CN"],
  ["Bangladesh","Crowdfunding","Waste Management","Lending",1,0.0444,"BD"],
  ["South Korea","Impact Investor","Waste Management","Equity",2,0.397,"KR"],
  ["Sudan","Bank","Circular Economy","Equity",1,0.2143,"SD"],
  ["Saudi Arabia","Incubator","Ocean Cleanup","Lending",1,0.1242,"SA"],
  ["Algeria","Public / Semi-public","Waste Management","Grant",4,0.9039,"DZ"],
  ["South Africa","Nonprofit","Ocean Cleanup","Grant",9,1.732,"ZA"],
  ["Laos","Nonprofit","Ocean Cleanup","Equity",1,0.3935,"LA"],
  ["Greece","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GR"],
  ["Peru","Foundation","Circular Economy","Grant",2,0.5838,"PE"],
  ["Egypt","Foundation","Waste Management","Equity",2,0.263,"EG"],
  ["Spain","Incubator","Waste Management","Equity",4,0.5508,"ES"],
  ["Mexico","Foundation","Ocean Cleanup","Lending",1,0.1863,"MX"],
  ["Tonga","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TO"],
  ["Nigeria","Financial Service Provider","Waste Management","Lending",2,0.2993,"NG"],
  ["Ghana","Impact Investor","Circular Economy","Equity",1,0.0885,"GH"],
  ["Colombia","Financial Service Provider","Ocean Cleanup","Lending",1,0.2543,"CO"],
  ["Nigeria","Financial Service Provider","Waste Management","Grant",2,0.2223,"NG"],
  ["Mexico","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MX"],
  ["Singapore","Public / Semi-public","Ocean Cleanup","Lending",2,0.7101,"SG"],
  ["Argentina","Financial Service Provider","Circular Economy","Grant",1,0.1293,"AR"],
  ["United Kingdom","Bank","Circular Economy","Equity",3,0.562,"GB"],
  ["Portugal","Nonprofit","Waste Management","Equity",2,0.3427,"PT"],
  ["Vietnam","Public / Semi-public","Waste Management","Grant",4,0.6293,"VN"],
  ["Peru","Coworking Space","Waste Management","Lending",1,0.0289,"PE"],
  ["Malaysia","Impact Investor","Waste Management","Grant",2,0.1994,"MY"],
  ["Qatar","Impact Investor","Waste Management","Grant",1,0.1194,"QA"],
  ["United Arab Emirates","Microfinance Institution","Waste Management","Lending",1,0.0888,"AE"],
  ["Italy","Venture Capital","Ocean Cleanup","Equity",1,1.0,"IT"],
  ["Switzerland","Nonprofit","Waste Management","Grant",3,0.5651,"CH"],
  ["Netherlands","Crowdfunding","Ocean Cleanup","Grant",1,0.1025,"NL"],
  ["Thailand","Foundation","Circular Economy","Lending",1,0.1271,"TH"],
  ["Yemen","Public / Semi-public","Ocean Cleanup","Lending",1,0.485,"YE"],
  ["Zimbabwe","Public / Semi-public","Ocean Cleanup","Grant",3,0.3678,"ZW"],
  ["Singapore","Nonprofit","Waste Management","Equity",2,0.2463,"SG"],
  ["Hungary","Impact Investor","Circular Economy","Equity",1,0.1092,"HU"],
  ["Tunisia","Nonprofit","Waste Management","Lending",2,0.7991,"TN"],
  ["Egypt","Competitions","Ocean Cleanup","Grant",1,0.3418,"EG"],
  ["Denmark","Impact Investor","Waste Management","Lending",1,0.1324,"DK"],
  ["Laos","Nonprofit","Waste Management","Equity",1,0.3935,"LA"],
  ["Uganda","Foundation","Ocean Cleanup","Equity",1,0.2744,"UG"],
  ["Zambia","Foundation","Circular Economy","Grant",1,0.1839,"ZM"],
  ["India","Competitions","Ocean Cleanup","Grant",1,0.3063,"IN"],
  ["Philippines","Public / Semi-public","Waste Management","Lending",5,1.4636,"PH"],
  ["Turkey","Impact Investor","Circular Economy","Grant",1,0.0671,"TR"],
  ["Swaziland","Venture Capital","Circular Economy","Equity",2,1.0433,"SZ"],
  ["Jamaica","Foundation","Waste Management","Grant",1,0.1992,"JM"],
  ["French Guiana","Public / Semi-public","Circular Economy","Equity",1,0.5862,"GF"],
  ["Nigeria","Nonprofit","Ocean Cleanup","Lending",4,0.4647,"NG"],
  ["Maldives","Public / Semi-public","Waste Management","Equity",1,0.7429,"MV"],
  ["Malaysia","Crowdfunding","Ocean Cleanup","Grant",2,0.6159,"MY"],
  ["Peru","Nonprofit","Waste Management","Grant",4,1.2911,"PE"],
  ["Albania","Impact Investor","Ocean Cleanup","Lending",1,1.0,"AL"],
  ["Thailand","Foundation","Circular Economy","Equity",1,0.1271,"TH"],
  ["Afghanistan","Public / Semi-public","Waste Management","Grant",1,0.1671,"AF"],
  ["Norway","Venture Capital","Ocean Cleanup","Equity",1,1.0,"NO"],
  ["Philippines","Public / Semi-public","Circular Economy","Equity",2,1.1717,"PH"],
  ["Ukraine","Financial Service Provider","Ocean Cleanup","Equity",1,0.0561,"UA"],
  ["Egypt","Impact Investor","Waste Management","Lending",4,0.552,"EG"],
  ["Bangladesh","Financial Service Provider","Waste Management","Equity",2,0.399,"BD"],
  ["Australia","Nonprofit","Waste Management","Lending",5,0.9679,"AU"],
  ["Sudan","Nonprofit","Waste Management","Grant",2,0.537,"SD"],
  ["Botswana","Incubator","Ocean Cleanup","Grant",1,0.0735,"BW"],
  ["Colombia","Competitions","Waste Management","Grant",1,0.1988,"CO"],
  ["Laos","Financial Service Provider","Ocean Cleanup","Equity",1,0.3935,"LA"],
  ["Pakistan","Financial Service Provider","Waste Management","Equity",1,0.1087,"PK"],
  ["South Korea","Impact Investor","Circular Economy","Lending",1,0.1697,"KR"],
  ["Palau","Venture Capital","Circular Economy","Equity",1,1.0,"PW"],
  ["Uganda","Financial Service Provider","Ocean Cleanup","Lending",1,0.3731,"UG"],
  ["Madagascar","Public / Semi-public","Circular Economy","Grant",3,0.9463,"MG"],
  ["Ghana","Bank","Circular Economy","Equity",2,0.4664,"GH"],
  ["Netherlands","Incubator","Waste Management","Equity",4,0.8644,"NL"],
  ["Yemen","Venture Capital","Ocean Cleanup","Equity",1,1.0,"YE"],
  ["Congo, Dem. Rep","Foundation","Circular Economy","Equity",1,0.1508,"CD"],
  ["Zambia","Venture Capital","Circular Economy","Equity",2,1.0322,"ZM"],
  ["Germany","Public / Semi-public","Waste Management","Grant",7,1.1533,"DE"],
  ["Angola","Incubator","Ocean Cleanup","Equity",1,0.3036,"AO"],
  ["Switzerland","Bank","Ocean Cleanup","Lending",1,0.0379,"CH"],
  ["New Zealand","Nonprofit","Ocean Cleanup","Equity",3,0.52,"NZ"],
  ["Qatar","Microfinance Institution","Waste Management","Lending",1,0.0498,"QA"],
  ["Guatemala","Venture Capital","Circular Economy","Equity",1,1.0,"GT"],
  ["Saudi Arabia","Venture Capital","Waste Management","Equity",1,0.1169,"SA"],
  ["Colombia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CO"],
  ["United Arab Emirates","Financial Service Provider","Circular Economy","Lending",1,0.1147,"AE"],
  ["Switzerland","Nonprofit","Ocean Cleanup","Equity",3,0.6575,"CH"],
  ["U.S. Virgin Islands","Venture Capital","Ocean Cleanup","Equity",1,1.0,"VI"],
  ["Indonesia","Incubator","Ocean Cleanup","Grant",1,0.0615,"ID"],
  ["Tunisia","Nonprofit","Waste Management","Equity",2,0.7991,"TN"],
  ["Burkina Faso","Nonprofit","Ocean Cleanup","Equity",1,0.2036,"BF"],
  ["Belarus","Venture Capital","Circular Economy","Equity",1,1.0,"BY"],
  ["Sri Lanka","Public / Semi-public","Circular Economy","Grant",1,0.3177,"LK"],
  ["Spain","Incubator","Circular Economy","Grant",1,0.2491,"ES"],
  ["Spain","Nonprofit","Ocean Cleanup","Lending",6,1.4936,"ES"],
  ["Mauritania","Public / Semi-public","Circular Economy","Equity",1,0.3609,"MR"],
  ["Costa Rica","Nonprofit","Waste Management","Grant",1,0.1839,"CR"],
  ["Romania","Bank","Ocean Cleanup","Lending",1,0.2072,"RO"],
  ["Ethiopia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"ET"],
  ["Ghana","Public / Semi-public","Ocean Cleanup","Lending",3,1.5478,"GH"],
  ["Jordan","Impact Investor","Ocean Cleanup","Grant",1,0.0627,"JO"],
  ["Brazil","Crowdfunding","Ocean Cleanup","Equity",1,0.0238,"BR"],
  ["Sudan","Nonprofit","Waste Management","Lending",1,0.1759,"SD"],
  ["China","Financial Service Provider","Circular Economy","Equity",2,0.297,"CN"],
  ["Serbia","Public / Semi-public","Waste Management","Equity",2,0.9152,"RS"],
  ["Cyprus","Nonprofit","Circular Economy","Lending",1,0.107,"CY"],
  ["Burkina Faso","Public / Semi-public","Circular Economy","Lending",2,0.4322,"BF"],
  ["Papua New Guinea","Bank","Ocean Cleanup","Equity",1,0.1536,"PG"],
  ["Netherlands","Nonprofit","Circular Economy","Lending",2,0.4698,"NL"],
  ["Tunisia","Bank","Circular Economy","Equity",1,0.1131,"TN"],
  ["France","Impact Investor","Waste Management","Equity",4,1.3024,"FR"],
  ["Georgia","Bank","Waste Management","Equity",1,0.3414,"GE"],
  ["Belgium","Financial Service Provider","Waste Management","Grant",2,0.2652,"BE"],
  ["Montserrat","Venture Capital","Circular Economy","Equity",1,1.0,"MS"],
  ["Burundi","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BI"],
  ["Trinidad and Tobago","Public / Semi-public","Ocean Cleanup","Lending",1,0.0853,"TT"],
  ["Bangladesh","Foundation","Ocean Cleanup","Grant",4,1.3273,"BD"],
  ["Haiti","Impact Investor","Waste Management","Lending",2,1.5043,"HT"],
  ["Egypt","Foundation","Circular Economy","Lending",1,0.1461,"EG"],
  ["Portugal","Public / Semi-public","Circular Economy","Grant",1,0.1636,"PT"],
  ["Vietnam","Foundation","Ocean Cleanup","Lending",2,0.2963,"VN"],
  ["Hong Kong","Crowdfunding","Waste Management","Equity",1,0.075,"HK"],
  ["Cambodia","Crowdfunding","Waste Management","Lending",1,0.0285,"KH"],
  ["Ethiopia","Public / Semi-public","Ocean Cleanup","Equity",6,2.2364,"ET"],
  ["Turkey","Competitions","Waste Management","Grant",1,0.1833,"TR"],
  ["Guinea","Public / Semi-public","Waste Management","Equity",2,0.3999,"GN"],
  ["Cambodia","Bank","Circular Economy","Equity",2,0.2154,"KH"],
  ["China","Foundation","Waste Management","Grant",3,0.6828,"CN"],
  ["Saudi Arabia","Impact Investor","Ocean Cleanup","Lending",3,0.4059,"SA"],
  ["Macau","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MO"],
  ["Mauritius","Bank","Circular Economy","Lending",1,0.1519,"MU"],
  ["Cameroon","Public / Semi-public","Ocean Cleanup","Grant",4,0.591,"CM"],
  ["Tunisia","Impact Investor","Circular Economy","Equity",1,0.609,"TN"],
  ["Kenya","Venture Capital","Waste Management","Equity",1,0.0746,"KE"],
  ["Morocco","Bank","Ocean Cleanup","Lending",3,0.2642,"MA"],
  ["Zambia","Financial Service Provider","Ocean Cleanup","Lending",1,0.32,"ZM"],
  ["Bahrain","Foundation","Waste Management","Lending",1,0.1767,"BH"],
  ["Switzerland","Public / Semi-public","Circular Economy","Grant",2,0.3871,"CH"],
  ["Russia","Bank","Ocean Cleanup","Lending",2,0.2411,"RU"],
  ["Mexico","Incubator","Waste Management","Lending",1,0.1863,"MX"],
  ["Libya","Nonprofit","Ocean Cleanup","Grant",1,0.4748,"LY"],
  ["Angola","Foundation","Ocean Cleanup","Grant",2,0.3299,"AO"],
  ["Uganda","Nonprofit","Waste Management","Grant",3,1.2562,"UG"],
  ["Philippines","Foundation","Circular Economy","Lending",1,0.1217,"PH"],
  ["Zambia","Foundation","Waste Management","Equity",2,0.4553,"ZM"],
  ["Spain","Financial Service Provider","Ocean Cleanup","Lending",1,0.1128,"ES"],
  ["Hungary","Public / Semi-public","Ocean Cleanup","Lending",1,0.2434,"HU"],
  ["Trinidad and Tobago","Foundation","Waste Management","Grant",1,0.464,"TT"],
  ["Malawi","Financial Service Provider","Waste Management","Equity",1,1.0,"MW"],
  ["United States","Impact Investor","Ocean Cleanup","Lending",3,2.4237,"US"],
  ["Bahrain","Competitions","Ocean Cleanup","Grant",1,0.2715,"BH"],
  ["Vietnam","Bank","Waste Management","Equity",1,0.1012,"VN"],
  ["Belize","Nonprofit","Ocean Cleanup","Equity",1,0.7236,"BZ"],
  ["Netherlands","Incubator","Waste Management","Lending",1,0.1605,"NL"],
  ["Ireland","Financial Service Provider","Waste Management","Grant",1,0.0646,"IE"],
  ["Brazil","Financial Service Provider","Waste Management","Lending",2,0.3269,"BR"],
  ["Ghana","Financial Service Provider","Ocean Cleanup","Equity",2,0.3858,"GH"],
  ["Indonesia","Incubator","Ocean Cleanup","Lending",1,0.1298,"ID"],
  ["Guyana","Foundation","Waste Management","Grant",1,0.1954,"GY"],
  ["China","Venture Capital","Waste Management","Equity",2,0.3685,"CN"],
  ["Peru","Incubator","Waste Management","Lending",1,0.1455,"PE"],
  ["France","Crowdfunding","Ocean Cleanup","Equity",1,0.0466,"FR"],
  ["Angola","Public / Semi-public","Circular Economy","Lending",1,0.2469,"AO"],
  ["Uganda","Public / Semi-public","Circular Economy","Grant",4,0.6911,"UG"],
  ["Peru","Impact Investor","Circular Economy","Lending",2,0.2518,"PE"],
  ["Cyprus","Impact Investor","Circular Economy","Lending",1,0.107,"CY"],
  ["South Korea","Bank","Circular Economy","Equity",1,0.4225,"KR"],
  ["Sao Tome and Principe","Public / Semi-public","Ocean Cleanup","Equity",2,1.4041,"ST"],
  ["Ireland","Impact Investor","Waste Management","Equity",2,0.2416,"IE"],
  ["Armenia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"AM"],
  ["Equatorial Guinea","Venture Capital","Waste Management","Equity",1,0.0649,"GQ"],
  ["Portugal","Public / Semi-public","Ocean Cleanup","Lending",1,0.0359,"PT"],
  ["United Arab Emirates","Incubator","Circular Economy","Equity",1,0.1494,"AE"],
  ["Palau","Venture Capital","Ocean Cleanup","Equity",1,1.0,"PW"],
  ["Jordan","Impact Investor","Circular Economy","Equity",1,0.0276,"JO"],
  ["Philippines","Public / Semi-public","Circular Economy","Grant",3,1.2645,"PH"],
  ["Azerbaijan","Bank","Ocean Cleanup","Lending",1,0.3127,"AZ"],
  ["Dominican Republic","Impact Investor","Waste Management","Equity",1,0.2854,"DO"],
  ["Taiwan","Bank","Ocean Cleanup","Equity",1,0.4476,"TW"],
  ["Turkey","Nonprofit","Ocean Cleanup","Lending",5,1.0191,"TR"],
  ["Cameroon","Incubator","Waste Management","Grant",1,0.0596,"CM"],
  ["Vietnam","Foundation","Circular Economy","Grant",2,0.2389,"VN"],
  ["Japan","Financial Service Provider","Circular Economy","Equity",1,0.3304,"JP"],
  ["French Guiana","Public / Semi-public","Waste Management","Equity",1,0.5862,"GF"],
  ["Fiji","Nonprofit","Waste Management","Grant",1,0.2947,"FJ"],
  ["Cyprus","Crowdfunding","Ocean Cleanup","Equity",1,0.0464,"CY"],
  ["Brazil","Impact Investor","Circular Economy","Grant",1,0.0852,"BR"],
  ["Tanzania","Public / Semi-public","Waste Management","Equity",5,1.3524,"TZ"],
  ["Chile","Public / Semi-public","Circular Economy","Grant",1,0.1183,"CL"],
  ["Belgium","Financial Service Provider","Circular Economy","Lending",1,0.1128,"BE"],
  ["Egypt","Public / Semi-public","Circular Economy","Lending",7,1.6329,"EG"],
  ["Cambodia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"KH"],
  ["Libya","Venture Capital","Ocean Cleanup","Equity",1,1.0,"LY"],
  ["Rwanda","Financial Service Provider","Waste Management","Lending",2,0.7087,"RW"],
  ["China","Foundation","Waste Management","Lending",1,0.1911,"CN"],
  ["Vietnam","Foundation","Ocean Cleanup","Grant",3,0.7062,"VN"],
  ["Mozambique","Nonprofit","Waste Management","Lending",1,0.4,"MZ"],
  ["Sri Lanka","Public / Semi-public","Circular Economy","Lending",3,0.5451,"LK"],
  ["France","Public / Semi-public","Circular Economy","Lending",8,3.8574,"FR"],
  ["New Zealand","Impact Investor","Waste Management","Lending",3,0.3983,"NZ"],
  ["Canada","Financial Service Provider","Waste Management","Equity",2,1.0266,"CA"],
  ["Congo, Dem. Rep","Financial Service Provider","Waste Management","Grant",1,0.1306,"CD"],
  ["West Bank and Gaza","Nonprofit","Circular Economy","Grant",2,0.7377,"PS"],
  ["Cameroon","Nonprofit","Ocean Cleanup","Grant",2,0.2683,"CM"],
  ["Canada","Foundation","Ocean Cleanup","Lending",2,0.3725,"CA"],
  ["Kazakhstan","Venture Capital","Ocean Cleanup","Equity",1,1.0,"KZ"],
  ["Ghana","Foundation","Waste Management","Grant",3,0.8224,"GH"],
  ["Ireland","Impact Investor","Waste Management","Lending",2,0.2416,"IE"],
  ["Singapore","Nonprofit","Ocean Cleanup","Grant",4,1.2196,"SG"],
  ["Morocco","Public / Semi-public","Waste Management","Grant",2,0.6357,"MA"],
  ["Switzerland","Crowdfunding","Ocean Cleanup","Grant",1,0.1201,"CH"],
  ["Haiti","Public / Semi-public","Waste Management","Grant",1,0.5017,"HT"],
  ["Japan","Impact Investor","Ocean Cleanup","Lending",3,0.4101,"JP"],
  ["Congo, Dem. Rep","Public / Semi-public","Circular Economy","Grant",2,0.4349,"CD"],
  ["Bangladesh","Public / Semi-public","Waste Management","Equity",8,2.4742,"BD"],
  ["Jordan","Foundation","Circular Economy","Equity",1,0.143,"JO"],
  ["Ireland","Foundation","Waste Management","Grant",1,0.0646,"IE"],
  ["Ukraine","Foundation","Waste Management","Equity",1,0.1787,"UA"],
  ["Angola","Bank","Ocean Cleanup","Lending",1,0.4266,"AO"],
  ["Egypt","Incubator","Waste Management","Lending",1,0.1169,"EG"],
  ["United States","Crowdfunding","Ocean Cleanup","Grant",2,1.1985,"US"],
  ["Japan","Bank","Ocean Cleanup","Lending",1,0.336,"JP"],
  ["Myanmar","Bank","Circular Economy","Equity",2,0.2476,"MM"],
  ["Thailand","Public / Semi-public","Circular Economy","Lending",6,1.7052,"TH"],
  ["French Guiana","Venture Capital","Circular Economy","Equity",1,1.0,"GF"],
  ["Canada","Public / Semi-public","Ocean Cleanup","Lending",5,0.9964,"CA"],
  ["Laos","Venture Capital","Circular Economy","Lending",1,0.0305,"LA"],
  ["Bangladesh","Nonprofit","Waste Management","Lending",3,1.2453,"BD"],
  ["Colombia","Public / Semi-public","Waste Management","Grant",5,1.1839,"CO"],
  ["Puerto Rico","Financial Service Provider","Waste Management","Grant",1,0.0861,"PR"],
  ["Syria","Foundation","Circular Economy","Grant",1,1.0,"SY"],
  ["Guyana","Venture Capital","Circular Economy","Equity",1,1.0,"GY"],
  ["Togo","Public / Semi-public","Ocean Cleanup","Grant",1,0.4885,"TG"],
  ["Djibouti","Venture Capital","Ocean Cleanup","Equity",1,1.0,"DJ"],
  ["Rwanda","Nonprofit","Waste Management","Lending",2,0.7087,"RW"],
  ["India","Incubator","Ocean Cleanup","Lending",1,0.19,"IN"],
  ["Afghanistan","Foundation","Ocean Cleanup","Grant",2,1.0697,"AF"],
  ["Kuwait","Competitions","Ocean Cleanup","Grant",1,0.2481,"KW"],
  ["Slovakia","Financial Service Provider","Ocean Cleanup","Equity",1,0.0583,"SK"],
  ["Philippines","Foundation","Ocean Cleanup","Equity",2,0.2822,"PH"],
  ["Kuwait","Public / Semi-public","Circular Economy","Lending",2,0.5566,"KW"],
  ["Iraq","Public / Semi-public","Circular Economy","Lending",4,0.7289,"IQ"],
  ["Peru","Impact Investor","Waste Management","Lending",4,1.2966,"PE"],
  ["Georgia","Public / Semi-public","Circular Economy","Equity",2,0.8662,"GE"],
  ["Germany","Public / Semi-public","Circular Economy","Lending",8,1.4612,"DE"],
  ["United States","Nonprofit","Ocean Cleanup","Lending",6,3.8033,"US"],
  ["Pakistan","Public / Semi-public","Circular Economy","Lending",7,1.6824,"PK"],
  ["Morocco","Venture Capital","Circular Economy","Lending",1,0.0255,"MA"],
  ["Qatar","Foundation","Ocean Cleanup","Grant",3,0.6387,"QA"],
  ["Mongolia","Public / Semi-public","Circular Economy","Grant",1,0.4893,"MN"],
  ["Bulgaria","Microfinance Institution","Waste Management","Lending",1,0.0386,"BG"],
  ["India","Public / Semi-public","Waste Management","Equity",12,3.8705,"IN"],
  ["Kenya","Venture Capital","Circular Economy","Grant",1,1.0,"KE"],
  ["Austria","Foundation","Circular Economy","Grant",1,0.2637,"AT"],
  ["Netherlands","Financial Service Provider","Waste Management","Lending",2,1.1275,"NL"],
  ["Algeria","Public / Semi-public","Waste Management","Lending",6,2.1476,"DZ"],
  ["Singapore","Financial Service Provider","Circular Economy","Grant",1,0.0948,"SG"],
  ["Seychelles","Bank","Circular Economy","Lending",1,0.096,"SC"],
  ["Belgium","Venture Capital","Circular Economy","Lending",1,0.3671,"BE"],
  ["Argentina","Bank","Ocean Cleanup","Lending",2,0.4323,"AR"],
  ["United Kingdom","Impact Investor","Circular Economy","Lending",2,0.3977,"GB"],
  ["Uganda","Financial Service Provider","Waste Management","Lending",2,0.5428,"UG"],
  ["Luxembourg","Venture Capital","Circular Economy","Equity",1,1.0,"LU"],
  ["Pakistan","Financial Service Provider","Waste Management","Grant",2,0.1463,"PK"],
  ["Ukraine","Public / Semi-public","Ocean Cleanup","Lending",3,1.6382,"UA"],
  ["Indonesia","Foundation","Circular Economy","Grant",4,0.7387,"ID"],
  ["Rwanda","Public / Semi-public","Ocean Cleanup","Grant",3,0.8674,"RW"],
  ["Chile","Foundation","Circular Economy","Grant",1,0.4053,"CL"],
  ["Mozambique","Foundation","Waste Management","Grant",1,0.6148,"MZ"],
  ["Bolivia","Venture Capital","Circular Economy","Equity",1,1.0,"BO"],
  ["Mexico","Impact Investor","Waste Management","Lending",3,1.2588,"MX"],
  ["Czech Republic","Nonprofit","Waste Management","Grant",1,0.0379,"CZ"],
  ["Botswana","Venture Capital","Ocean Cleanup","Equity",1,1.0,"BW"],
  ["Ethiopia","Impact Investor","Waste Management","Grant",1,0.127,"ET"],
  ["Algeria","Bank","Ocean Cleanup","Lending",2,0.197,"DZ"],
  ["South Sudan","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SS"],
  ["South Sudan","Incubator","Waste Management","Grant",1,0.1369,"SS"],
  ["Côte d'Ivoire","Public / Semi-public","Ocean Cleanup","Equity",5,1.8467,"CI"],
  ["Ghana","Crowdfunding","Ocean Cleanup","Equity",1,0.028,"GH"],
  ["Austria","Nonprofit","Waste Management","Equity",2,0.2765,"AT"],
  ["Brazil","Incubator","Waste Management","Lending",1,0.166,"BR"],
  ["Sudan","Foundation","Waste Management","Lending",1,0.1536,"SD"],
  ["Zimbabwe","Impact Investor","Waste Management","Lending",1,0.1829,"ZW"],
  ["St. Vincent and the Grenadines","Public / Semi-public","Waste Management","Equity",1,1.0,"VC"],
  ["Barbados","Impact Investor","Waste Management","Lending",1,1.0,"BB"],
  ["Canada","Bank","Circular Economy","Lending",3,0.5394,"CA"],
  ["Bosnia and Herzegovina","Public / Semi-public","Ocean Cleanup","Lending",3,1.1451,"BA"],
  ["Taiwan","Venture Capital","Circular Economy","Equity",1,1.0,"TW"],
  ["Qatar","Crowdfunding","Ocean Cleanup","Grant",1,0.1354,"QA"],
  ["El Salvador","Nonprofit","Ocean Cleanup","Equity",1,0.0946,"SV"],
  ["Mozambique","Venture Capital","Circular Economy","Equity",2,1.0453,"MZ"],
  ["Ireland","Impact Investor","Ocean Cleanup","Equity",3,0.2738,"IE"],
  ["Japan","Nonprofit","Waste Management","Lending",4,0.3821,"JP"],
  ["Togo","Public / Semi-public","Waste Management","Grant",2,0.5207,"TG"],
  ["French Polynesia","Public / Semi-public","Circular Economy","Lending",1,0.6939,"PF"],
  ["Sao Tome and Principe","Public / Semi-public","Ocean Cleanup","Lending",2,1.4041,"ST"],
  ["Sri Lanka","Incubator","Waste Management","Equity",1,0.0852,"LK"],
  ["Sudan","Financial Service Provider","Waste Management","Lending",1,0.1759,"SD"],
  ["Belgium","Impact Investor","Ocean Cleanup","Grant",3,0.7409,"BE"],
  ["Haiti","Financial Service Provider","Waste Management","Equity",1,0.0422,"HT"],
  ["Belgium","Public / Semi-public","Ocean Cleanup","Lending",7,1.3843,"BE"],
  ["Costa Rica","Nonprofit","Ocean Cleanup","Lending",1,0.3206,"CR"],
  ["Brazil","Public / Semi-public","Waste Management","Equity",10,3.422,"BR"],
  ["West Bank and Gaza","Nonprofit","Ocean Cleanup","Grant",2,0.7377,"PS"],
  ["Switzerland","Nonprofit","Circular Economy","Lending",2,0.4351,"CH"],
  ["Philippines","Crowdfunding","Waste Management","Lending",1,0.0381,"PH"],
  ["Austria","Public / Semi-public","Waste Management","Equity",4,1.3086,"AT"],
  ["Oman","Competitions","Ocean Cleanup","Grant",1,0.2488,"OM"],
  ["Turkey","Foundation","Waste Management","Grant",5,1.3494,"TR"],
  ["South Africa","Incubator","Ocean Cleanup","Grant",1,0.1058,"ZA"],
  ["Ireland","Financial Service Provider","Waste Management","Equity",1,0.0336,"IE"],
  ["Switzerland","Financial Service Provider","Waste Management","Grant",2,0.1515,"CH"],
  ["Germany","Crowdfunding","Ocean Cleanup","Equity",1,0.0288,"DE"],
  ["Peru","Bank","Circular Economy","Equity",1,0.1073,"PE"],
  ["Canada","Foundation","Circular Economy","Grant",4,1.3643,"CA"],
  ["Singapore","Impact Investor","Circular Economy","Lending",2,0.2463,"SG"],
  ["China","Financial Service Provider","Waste Management","Lending",3,0.4437,"CN"],
  ["Gabon","Nonprofit","Waste Management","Grant",1,0.0343,"GA"],
  ["Bahrain","Foundation","Circular Economy","Grant",1,0.1767,"BH"],
  ["Iraq","Impact Investor","Ocean Cleanup","Equity",1,0.2874,"IQ"],
  ["Spain","Impact Investor","Ocean Cleanup","Lending",3,0.799,"ES"],
  ["Colombia","Foundation","Waste Management","Equity",1,0.147,"CO"],
  ["Switzerland","Crowdfunding","Ocean Cleanup","Equity",1,0.1752,"CH"],
  ["Belgium","Incubator","Circular Economy","Equity",1,0.1108,"BE"],
  ["Netherlands","Impact Investor","Circular Economy","Lending",2,0.4698,"NL"],
  ["Belgium","Impact Investor","Waste Management","Grant",3,0.5365,"BE"],
  ["Ethiopia","Bank","Ocean Cleanup","Lending",1,0.0725,"ET"],
  ["United States","Public / Semi-public","Circular Economy","Grant",6,2.0626,"US"],
  ["Costa Rica","Public / Semi-public","Circular Economy","Equity",1,0.1612,"CR"],
  ["Turkey","Nonprofit","Waste Management","Lending",4,0.6185,"TR"],
  ["France","Venture Capital","Waste Management","Equity",1,0.0298,"FR"],
  ["Qatar","Public / Semi-public","Ocean Cleanup","Equity",4,1.0392,"QA"],
  ["Chile","Incubator","Circular Economy","Equity",1,0.0849,"CL"],
  ["Thailand","Nonprofit","Ocean Cleanup","Lending",5,0.8005,"TH"],
  ["Switzerland","Impact Investor","Waste Management","Lending",3,0.8397,"CH"],
  ["Tunisia","Public / Semi-public","Circular Economy","Equity",5,1.9794,"TN"],
  ["Tunisia","Public / Semi-public","Circular Economy","Lending",6,1.6811,"TN"],
  ["Indonesia","Crowdfunding","Ocean Cleanup","Grant",2,0.6138,"ID"],
  ["Tunisia","Nonprofit","Ocean Cleanup","Grant",3,0.6737,"TN"],
  ["Mozambique","Financial Service Provider","Waste Management","Equity",3,1.4453,"MZ"],
  ["South Korea","Nonprofit","Circular Economy","Equity",1,0.1697,"KR"],
  ["South Sudan","Public / Semi-public","Waste Management","Grant",1,0.1369,"SS"],
  ["Uruguay","Public / Semi-public","Waste Management","Equity",1,1.0,"UY"],
  ["United States","Foundation","Waste Management","Lending",2,1.2322,"US"],
  ["Tunisia","Impact Investor","Waste Management","Equity",1,0.609,"TN"],
  ["Russia","Impact Investor","Ocean Cleanup","Equity",1,0.1588,"RU"],
  ["Bahrain","Microfinance Institution","Waste Management","Lending",1,0.0376,"BH"],
  ["Hungary","Nonprofit","Circular Economy","Lending",1,0.1092,"HU"],
  ["Algeria","Nonprofit","Ocean Cleanup","Lending",3,0.5317,"DZ"],
  ["Bulgaria","Venture Capital","Circular Economy","Lending",1,0.0365,"BG"],
  ["Thailand","Public / Semi-public","Waste Management","Equity",7,1.9824,"TH"],
  ["Haiti","Impact Investor","Circular Economy","Lending",1,0.5941,"HT"],
  ["Indonesia","Impact Investor","Circular Economy","Grant",1,0.2307,"ID"],
  ["Japan","Incubator","Ocean Cleanup","Equity",1,0.184,"JP"],
  ["Nigeria","Incubator","Ocean Cleanup","Lending",1,0.1221,"NG"],
  ["Cyprus","Public / Semi-public","Ocean Cleanup","Equity",1,0.0887,"CY"],
  ["Cambodia","Nonprofit","Ocean Cleanup","Equity",3,0.6308,"KH"],
  ["Montserrat","Public / Semi-public","Circular Economy","Equity",1,1.0,"MS"],
  ["Albania","Venture Capital","Circular Economy","Equity",1,1.0,"AL"],
  ["Chile","Incubator","Circular Economy","Grant",1,0.1389,"CL"],
  ["Indonesia","Public / Semi-public","Waste Management","Lending",8,2.6343,"ID"],
  ["Netherlands","Foundation","Waste Management","Grant",6,1.3052,"NL"],
  ["Mexico","Nonprofit","Waste Management","Lending",3,0.4618,"MX"],
  ["Colombia","Public / Semi-public","Circular Economy","Lending",5,1.1764,"CO"],
  ["Turkey","Financial Service Provider","Waste Management","Grant",2,0.1763,"TR"],
  ["Colombia","Impact Investor","Ocean Cleanup","Grant",2,0.7049,"CO"],
  ["Turks and Caicos Islands","Public / Semi-public","Ocean Cleanup","Equity",1,0.7953,"TC"],
  ["Morocco","Nonprofit","Ocean Cleanup","Grant",3,0.4819,"MA"],
  ["Benin","Nonprofit","Waste Management","Equity",2,0.4377,"BJ"],
  ["Swaziland","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"SZ"],
  ["Puerto Rico","Public / Semi-public","Waste Management","Grant",2,0.5547,"PR"],
  ["Romania","Public / Semi-public","Waste Management","Equity",3,0.6179,"RO"],
  ["Nigeria","Foundation","Ocean Cleanup","Equity",2,0.309,"NG"],
  ["Congo, Rep.","Public / Semi-public","Circular Economy","Lending",1,0.4715,"CG"],
  ["Congo, Rep.","Impact Investor","Waste Management","Equity",1,1.0,"CG"],
  ["China","Nonprofit","Ocean Cleanup","Lending",3,0.4402,"CN"],
  ["South Sudan","Venture Capital","Circular Economy","Equity",1,1.0,"SS"],
  ["Bulgaria","Financial Service Provider","Waste Management","Equity",1,0.0374,"BG"],
  ["Israel","Public / Semi-public","Ocean Cleanup","Grant",2,0.1536,"IL"],
  ["Denmark","Crowdfunding","Waste Management","Lending",1,0.0322,"DK"],
  ["French Polynesia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"PF"],
  ["Sri Lanka","Public / Semi-public","Ocean Cleanup","Equity",3,0.6605,"LK"],
  ["Greece","Foundation","Waste Management","Lending",1,0.1497,"GR"],
  ["Nepal","Public / Semi-public","Circular Economy","Equity",2,0.8474,"NP"],
  ["Somalia","Bank","Ocean Cleanup","Lending",1,0.0551,"SO"],
  ["Bahamas, The","Public / Semi-public","Circular Economy","Equity",1,1.0,"BS"],
  ["Cambodia","Public / Semi-public","Circular Economy","Lending",7,1.8838,"KH"],
  ["Honduras","Bank","Circular Economy","Equity",1,0.1958,"HN"],
  ["Germany","Public / Semi-public","Waste Management","Equity",13,4.2566,"DE"],
  ["Singapore","Microfinance Institution","Waste Management","Lending",1,0.0513,"SG"],
  ["Portugal","Nonprofit","Waste Management","Grant",3,0.7476,"PT"],
  ["Qatar","Impact Investor","Waste Management","Equity",1,0.0314,"QA"],
  ["Togo","Public / Semi-public","Ocean Cleanup","Equity",2,1.4885,"TG"],
  ["South Africa","Public / Semi-public","Circular Economy","Equity",3,0.3806,"ZA"],
  ["Algeria","Impact Investor","Circular Economy","Grant",1,0.0775,"DZ"],
  ["India","Crowdfunding","Waste Management","Grant",1,1.0,"IN"],
  ["Australia","Nonprofit","Waste Management","Equity",4,0.9218,"AU"],
  ["Papua New Guinea","Venture Capital","Circular Economy","Equity",1,1.0,"PG"],
  ["Tanzania","Crowdfunding","Waste Management","Lending",1,0.0259,"TZ"],
  ["Cayman Islands","Public / Semi-public","Circular Economy","Equity",1,0.7428,"KY"],
  ["Romania","Incubator","Ocean Cleanup","Grant",1,0.0612,"RO"],
  ["Lithuania","Public / Semi-public","Ocean Cleanup","Lending",1,0.0491,"LT"],
  ["Malawi","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MW"],
  ["Malaysia","Foundation","Waste Management","Lending",2,0.2636,"MY"],
  ["Turkey","Foundation","Waste Management","Lending",1,0.1285,"TR"],
  ["Nigeria","Public / Semi-public","Ocean Cleanup","Grant",8,1.4122,"NG"],
  ["Paraguay","Financial Service Provider","Ocean Cleanup","Equity",1,0.0415,"PY"],
  ["Seychelles","Public / Semi-public","Ocean Cleanup","Lending",1,1.0,"SC"],
  ["Chad","Public / Semi-public","Circular Economy","Equity",1,0.386,"TD"],
  ["Hong Kong","Competitions","Waste Management","Grant",1,0.2644,"HK"],
  ["China","Competitions","Waste Management","Grant",1,0.2745,"CN"],
  ["Rwanda","Nonprofit","Circular Economy","Grant",1,0.4061,"RW"],
  ["Kenya","Incubator","Ocean Cleanup","Equity",1,0.3037,"KE"],
  ["Indonesia","Foundation","Circular Economy","Equity",1,0.1283,"ID"],
  ["Rwanda","Nonprofit","Ocean Cleanup","Lending",1,0.3697,"RW"],
  ["Germany","Bank","Ocean Cleanup","Equity",2,0.442,"DE"],
  ["Canada","Crowdfunding","Waste Management","Equity",1,0.0262,"CA"],
  ["Algeria","Venture Capital","Circular Economy","Equity",1,1.0,"DZ"],
  ["Poland","Impact Investor","Waste Management","Equity",1,0.0777,"PL"],
  ["Poland","Impact Investor","Ocean Cleanup","Lending",1,0.0777,"PL"],
  ["Ethiopia","Nonprofit","Waste Management","Grant",3,0.5206,"ET"],
  ["Italy","Impact Investor","Circular Economy","Grant",1,0.2254,"IT"],
  ["Spain","Public / Semi-public","Circular Economy","Lending",5,1.0403,"ES"],
  ["Chile","Venture Capital","Circular Economy","Equity",1,1.0,"CL"],
  ["Thailand","Impact Investor","Waste Management","Lending",3,0.3227,"TH"],
  ["Senegal","Nonprofit","Waste Management","Lending",1,1.0,"SN"],
  ["Ireland","Nonprofit","Circular Economy","Grant",1,0.5381,"IE"],
  ["Switzerland","Microfinance Institution","Waste Management","Lending",1,0.0369,"CH"],
  ["Greece","Public / Semi-public","Circular Economy","Grant",1,0.1504,"GR"],
  ["Myanmar","Impact Investor","Ocean Cleanup","Lending",1,0.207,"MM"],
  ["Portugal","Competitions","Ocean Cleanup","Grant",1,0.2315,"PT"],
  ["Suriname","Public / Semi-public","Waste Management","Equity",2,2.0,"SR"],
  ["Israel","Nonprofit","Waste Management","Lending",2,0.0979,"IL"],
  ["South Sudan","Foundation","Circular Economy","Grant",1,0.3356,"SS"],
  ["Uganda","Nonprofit","Circular Economy","Lending",1,1.0,"UG"],
  ["Tanzania","Foundation","Ocean Cleanup","Grant",4,1.5089,"TZ"],
  ["Cambodia","Nonprofit","Ocean Cleanup","Grant",4,1.0865,"KH"],
  ["Zambia","Nonprofit","Ocean Cleanup","Grant",2,0.3035,"ZM"],
  ["Tanzania","Financial Service Provider","Circular Economy","Equity",1,1.0,"TZ"],
  ["Romania","Nonprofit","Ocean Cleanup","Lending",2,0.5161,"RO"],
  ["Congo, Dem. Rep","Impact Investor","Circular Economy","Equity",1,1.0,"CD"],
  ["Kuwait","Bank","Ocean Cleanup","Equity",1,0.3238,"KW"],
  ["Ghana","Foundation","Ocean Cleanup","Equity",1,0.1774,"GH"],
  ["Botswana","Incubator","Waste Management","Grant",1,0.0735,"BW"],
  ["Singapore","Crowdfunding","Ocean Cleanup","Equity",1,0.3849,"SG"],
  ["Argentina","Impact Investor","Circular Economy","Lending",2,0.2498,"AR"],
  ["United Kingdom","Incubator","Ocean Cleanup","Lending",1,0.3691,"GB"],
  ["El Salvador","Public / Semi-public","Ocean Cleanup","Lending",1,0.0946,"SV"],
  ["Timor-Leste","Public / Semi-public","Ocean Cleanup","Grant",1,0.3718,"TL"],
  ["Israel","Impact Investor","Ocean Cleanup","Equity",1,0.0674,"IL"],
  ["Japan","Foundation","Ocean Cleanup","Lending",1,0.184,"JP"],
  ["Egypt","Impact Investor","Ocean Cleanup","Lending",3,0.3596,"EG"],
  ["Belgium","Foundation","Circular Economy","Grant",4,0.9536,"BE"],
  ["Nepal","Financial Service Provider","Circular Economy","Equity",1,0.3557,"NP"],
  ["Zimbabwe","Nonprofit","Ocean Cleanup","Equity",1,0.3336,"ZW"],
  ["Kuwait","Microfinance Institution","Waste Management","Lending",1,0.0319,"KW"],
  ["Bahrain","Bank","Circular Economy","Lending",1,0.4161,"BH"],
  ["Swaziland","Financial Service Provider","Waste Management","Equity",1,0.0433,"SZ"],
  ["Egypt","Crowdfunding","Waste Management","Equity",1,0.0377,"EG"],
  ["Israel","Impact Investor","Circular Economy","Equity",1,0.0674,"IL"],
  ["Greece","Impact Investor","Circular Economy","Lending",1,0.0839,"GR"],
  ["Tanzania","Nonprofit","Ocean Cleanup","Equity",3,0.6031,"TZ"],
  ["Liberia","Venture Capital","Circular Economy","Equity",1,1.0,"LR"],
  ["Tanzania","Bank","Waste Management","Lending",2,0.5798,"TZ"],
  ["Zimbabwe","Public / Semi-public","Waste Management","Equity",5,1.3346,"ZW"],
  ["India","Competitions","Waste Management","Grant",1,0.3063,"IN"],
  ["Singapore","Nonprofit","Ocean Cleanup","Equity",4,0.6257,"SG"],
  ["Malaysia","Foundation","Waste Management","Equity",2,0.2636,"MY"],
  ["Egypt","Incubator","Circular Economy","Grant",1,0.0993,"EG"],
  ["Bangladesh","Financial Service Provider","Waste Management","Lending",1,0.3696,"BD"],
  ["Vietnam","Financial Service Provider","Circular Economy","Grant",1,0.0712,"VN"],
  ["Oman","Incubator","Waste Management","Equity",2,0.2846,"OM"],
  ["Cambodia","Public / Semi-public","Circular Economy","Grant",5,1.2892,"KH"],
  ["Saudi Arabia","Public / Semi-public","Waste Management","Equity",8,1.6016,"SA"],
  ["New Zealand","Incubator","Circular Economy","Equity",1,0.0939,"NZ"],
  ["Italy","Nonprofit","Circular Economy","Lending",2,0.607,"IT"],
  ["Colombia","Public / Semi-public","Ocean Cleanup","Equity",8,2.5877,"CO"],
  ["Kenya","Public / Semi-public","Waste Management","Lending",11,2.9623,"KE"],
  ["Botswana","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"BW"],
  ["South Sudan","Public / Semi-public","Waste Management","Lending",1,0.0497,"SS"],
  ["Australia","Incubator","Ocean Cleanup","Grant",1,0.1042,"AU"],
  ["Faroe Islands","Venture Capital","Ocean Cleanup","Equity",1,1.0,"FO"],
  ["Zambia","Incubator","Waste Management","Equity",1,0.2714,"ZM"],
  ["Netherlands","Nonprofit","Waste Management","Lending",3,1.4698,"NL"],
  ["Nepal","Bank","Ocean Cleanup","Lending",2,0.1395,"NP"],
  ["Togo","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TG"],
  ["Israel","Bank","Circular Economy","Equity",1,0.3428,"IL"],
  ["United States","Venture Capital","Ocean Cleanup","Equity",1,1.0,"US"],
  ["Wallis and Futuna","Venture Capital","Ocean Cleanup","Equity",1,1.0,"WF"],
  ["Niger","Public / Semi-public","Circular Economy","Grant",1,0.4697,"NE"],
  ["Philippines","Nonprofit","Ocean Cleanup","Grant",7,2.5108,"PH"],
  ["Zambia","Nonprofit","Circular Economy","Grant",2,0.3035,"ZM"],
  ["Malaysia","Impact Investor","Circular Economy","Equity",3,0.3351,"MY"],
  ["Nepal","Financial Service Provider","Ocean Cleanup","Lending",1,0.5534,"NP"],
  ["Cameroon","Public / Semi-public","Waste Management","Lending",3,0.7404,"CM"],
  ["Saudi Arabia","Foundation","Circular Economy","Equity",1,0.2377,"SA"],
  ["Syria","Public / Semi-public","Waste Management","Equity",2,0.2096,"SY"],
  ["St. Lucia","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"LC"],
  ["Rwanda","Foundation","Circular Economy","Grant",1,0.2108,"RW"],
  ["Zambia","Impact Investor","Ocean Cleanup","Equity",2,0.3228,"ZM"],
  ["Pakistan","Foundation","Circular Economy","Grant",4,1.5256,"PK"],
  ["Peru","Venture Capital","Waste Management","Equity",1,0.0445,"PE"],
  ["Egypt","Venture Capital","Waste Management","Equity",1,0.0242,"EG"],
  ["Bangladesh","Bank","Waste Management","Equity",1,0.2875,"BD"],
  ["Bangladesh","Financial Service Provider","Waste Management","Grant",1,0.0773,"BD"],
  ["Congo, Dem. Rep","Public / Semi-public","Ocean Cleanup","Lending",4,1.5012,"CD"],
  ["Guernsey","Venture Capital","Ocean Cleanup","Equity",1,1.0,"GG"],
  ["South Africa","Nonprofit","Circular Economy","Lending",2,0.2145,"ZA"],
  ["Singapore","Impact Investor","Ocean Cleanup","Equity",3,0.2957,"SG"],
  ["Bouvet Island","Venture Capital","Circular Economy","Equity",1,1.0,"BV"],
  ["Vietnam","Incubator","Ocean Cleanup","Equity",1,0.1286,"VN"],
  ["Burkina Faso","Nonprofit","Waste Management","Equity",1,0.2036,"BF"],
  ["Somalia","Foundation","Circular Economy","Equity",1,0.2496,"SO"],
  ["Guinea-Bisau","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"GW"],
  ["Madagascar","Public / Semi-public","Ocean Cleanup","Grant",3,0.9463,"MG"],
  ["Afghanistan","Foundation","Circular Economy","Grant",2,1.0697,"AF"],
  ["Sweden","Incubator","Ocean Cleanup","Lending",1,0.1377,"SE"],
  ["Yemen","Nonprofit","Circular Economy","Grant",1,0.6807,"YE"],
  ["Uganda","Public / Semi-public","Waste Management","Equity",4,1.4384,"UG"],
  ["Serbia","Public / Semi-public","Circular Economy","Equity",1,0.2945,"RS"],
  ["Australia","Incubator","Circular Economy","Equity",2,0.1819,"AU"],
  ["South Sudan","Foundation","Ocean Cleanup","Grant",1,0.3356,"SS"],
  ["Italy","Foundation","Waste Management","Lending",2,0.3556,"IT"],
  ["Algeria","Nonprofit","Waste Management","Grant",3,0.7621,"DZ"],
  ["India","Venture Capital","Waste Management","Equity",2,0.3341,"IN"],
  ["United Arab Emirates","Foundation","Waste Management","Grant",4,0.9175,"AE"],
  ["Zimbabwe","Incubator","Waste Management","Lending",1,0.1829,"ZW"],
  ["South Korea","Nonprofit","Ocean Cleanup","Lending",2,0.2789,"KR"],
  ["Ethiopia","Nonprofit","Ocean Cleanup","Lending",1,0.3695,"ET"],
  ["Laos","Public / Semi-public","Circular Economy","Lending",2,0.7897,"LA"],
  ["Belgium","Foundation","Circular Economy","Lending",1,0.1889,"BE"],
  ["Uruguay","Venture Capital","Ocean Cleanup","Equity",1,1.0,"UY"],
  ["Mauritius","Impact Investor","Waste Management","Grant",1,0.1414,"MU"],
  ["Oman","Crowdfunding","Waste Management","Equity",1,0.0339,"OM"],
  ["St. Vincent and the Grenadines","Public / Semi-public","Ocean Cleanup","Equity",1,1.0,"VC"],
  ["Bahamas, The","Impact Investor","Waste Management","Grant",1,0.3626,"BS"],
  ["Malawi","Foundation","Ocean Cleanup","Equity",1,0.2661,"MW"],
  ["Canada","Impact Investor","Circular Economy","Grant",1,0.1691,"CA"],
  ["France","Incubator","Waste Management","Lending",1,0.2017,"FR"],
  ["Algeria","Foundation","Circular Economy","Grant",1,0.3256,"DZ"],
  ["Japan","Crowdfunding","Ocean Cleanup","Grant",1,0.1347,"JP"],
  ["Belize","Nonprofit","Ocean Cleanup","Lending",1,0.7236,"BZ"],
  ["South Korea","Financial Service Provider","Circular Economy","Equity",1,0.1943,"KR"],
  ["Romania","Public / Semi-public","Waste Management","Grant",2,0.3451,"RO"],
  ["Greece","Nonprofit","Waste Management","Grant",1,0.0334,"GR"],
  ["Ghana","Nonprofit","Ocean Cleanup","Lending",2,0.516,"GH"],
  ["Nepal","Incubator","Waste Management","Equity",2,0.5482,"NP"],
  ["United States","Bank","Waste Management","Lending",2,0.4352,"US"],
  ["Bolivia","Impact Investor","Waste Management","Grant",1,0.066,"BO"],
  ["Uganda","Foundation","Circular Economy","Equity",1,0.2744,"UG"],
  ["Burkina Faso","Public / Semi-public","Ocean Cleanup","Grant",1,0.3578,"BF"],
  ["Haiti","Public / Semi-public","Ocean Cleanup","Lending",2,0.5725,"HT"],
  ["Ghana","Public / Semi-public","Waste Management","Equity",4,1.4075,"GH"],
  ["Kosovo","Public / Semi-public","Circular Economy","Grant",1,0.3514,"XK"],
  ["Libya","Bank","Ocean Cleanup","Lending",2,0.1806,"LY"],
  ["Uzbekistan","Venture Capital","Circular Economy","Equity",1,1.0,"UZ"],
  ["Austria","Crowdfunding","Waste Management","Equity",1,0.0353,"AT"],
  ["Algeria","Public / Semi-public","Waste Management","Equity",8,3.214,"DZ"],
  ["Kenya","Public / Semi-public","Circular Economy","Equity",4,0.9056,"KE"],
  ["Taiwan","Bank","Ocean Cleanup","Lending",1,0.4476,"TW"],
  ["Benin","Financial Service Provider","Ocean Cleanup","Lending",1,0.2566,"BJ"],
  ["Romania","Impact Investor","Waste Management","Equity",1,0.14,"RO"],
  ["Portugal","Nonprofit","Circular Economy","Equity",2,0.3427,"PT"],
  ["Morocco","Crowdfunding","Waste Management","Equity",1,0.0257,"MA"],
  ["Suriname","Impact Investor","Waste Management","Lending",1,1.0,"SR"],
  ["Nepal","Impact Investor","Waste Management","Lending",2,0.5047,"NP"],
  ["Oman","Public / Semi-public","Circular Economy","Lending",1,0.2405,"OM"],
  ["Cameroon","Bank","Waste Management","Lending",1,0.2318,"CM"],
  ["Colombia","Impact Investor","Ocean Cleanup","Lending",3,0.8457,"CO"],
  ["United States","Foundation","Circular Economy","Grant",4,2.0873,"US"],
  ["Botswana","Foundation","Waste Management","Equity",1,0.3088,"BW"],
  ["Ethiopia","Bank","Circular Economy","Equity",1,0.2541,"ET"],
  ["Brazil","Public / Semi-public","Ocean Cleanup","Lending",8,2.0581,"BR"],
  ["Chile","Public / Semi-public","Waste Management","Lending",2,0.8337,"CL"],
  ["Rwanda","Nonprofit","Ocean Cleanup","Equity",1,0.3697,"RW"],
  ["Saudi Arabia","Crowdfunding","Waste Management","Lending",1,0.08,"SA"],
  ["Senegal","Bank","Circular Economy","Lending",2,0.2244,"SN"],
  ["New Zealand","Incubator","Ocean Cleanup","Equity",1,0.143,"NZ"],
  ["Pakistan","Foundation","Waste Management","Equity",2,0.291,"PK"],
  ["Singapore","Nonprofit","Ocean Cleanup","Lending",5,0.9427,"SG"],
  ["Poland","Nonprofit","Ocean Cleanup","Equity",1,0.0777,"PL"],
  ["Morocco","Nonprofit","Circular Economy","Grant",2,0.4302,"MA"],
  ["Malaysia","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MY"],
  ["Cabo Verde","Public / Semi-public","Ocean Cleanup","Equity",2,1.0925,"CV"],
  ["Portugal","Nonprofit","Ocean Cleanup","Lending",5,1.0854,"PT"],
  ["Burkina Faso","Financial Service Provider","Ocean Cleanup","Lending",1,0.2036,"BF"],
  ["Guinea","Public / Semi-public","Waste Management","Grant",1,0.3291,"GN"],
  ["Mexico","Bank","Circular Economy","Lending",1,0.108,"MX"],
  ["Ukraine","Impact Investor","Ocean Cleanup","Equity",1,0.1787,"UA"],
  ["Vietnam","Bank","Circular Economy","Equity",3,0.4689,"VN"],
  ["Greece","Incubator","Ocean Cleanup","Equity",1,0.1497,"GR"],
  ["Guatemala","Impact Investor","Waste Management","Equity",1,0.8792,"GT"],
  ["Eritrea","Venture Capital","Circular Economy","Equity",1,1.0,"ER"],
  ["Germany","Bank","Waste Management","Equity",1,0.1403,"DE"],
  ["Madagascar","Venture Capital","Ocean Cleanup","Equity",1,1.0,"MG"],
  ["Iraq","Nonprofit","Ocean Cleanup","Lending",1,0.1332,"IQ"],
  ["Bhutan","Financial Service Provider","Circular Economy","Lending",1,0.241,"BT"],
  ["United Arab Emirates","Public / Semi-public","Circular Economy","Grant",3,0.4726,"AE"],
  ["Ghana","Bank","Waste Management","Lending",2,0.8217,"GH"],
  ["Vietnam","Financial Service Provider","Waste Management","Grant",2,0.1546,"VN"],
  ["Rwanda","Bank","Circular Economy","Lending",1,0.433,"RW"],
  ["Angola","Crowdfunding","Waste Management","Lending",1,0.0289,"AO"],
  ["Ethiopia","Foundation","Ocean Cleanup","Grant",2,0.7563,"ET"],
  ["Angola","Incubator","Ocean Cleanup","Lending",1,0.3036,"AO"],
  ["Morocco","Impact Investor","Ocean Cleanup","Equity",2,0.4745,"MA"],
  ["El Salvador","Financial Service Provider","Ocean Cleanup","Lending",1,0.0946,"SV"],
  ["Azerbaijan","Public / Semi-public","Circular Economy","Grant",1,0.5155,"AZ"],
  ["Peru","Financial Service Provider","Waste Management","Equity",3,0.5386,"PE"],
  ["Portugal","Impact Investor","Waste Management","Equity",4,0.8963,"PT"],
  ["United States","Nonprofit","Ocean Cleanup","Equity",5,2.8033,"US"],
  ["Macedonia","Public / Semi-public","Waste Management","Equity",1,0.2824,"MK"],
  ["Ireland","Financial Service Provider","Circular Economy","Grant",1,0.0646,"IE"],
  ["Slovakia","Venture Capital","Circular Economy","Equity",1,1.0,"SK"],
  ["China","Foundation","Circular Economy","Equity",1,0.1911,"CN"],
  ["Burkina Faso","Public / Semi-public","Ocean Cleanup","Equity",5,1.8421,"BF"],
  ["Nepal","Public / Semi-public","Ocean Cleanup","Grant",7,1.9018,"NP"],
  ["Dominica","Venture Capital","Ocean Cleanup","Equity",1,1.0,"DM"],
  ["Egypt","Impact Investor","Ocean Cleanup","Grant",3,0.4619,"EG"],
  ["Turks and Caicos Islands","Public / Semi-public","Waste Management","Equity",1,0.7953,"TC"],
  ["Malawi","Public / Semi-public","Waste Management","Lending",2,0.8959,"MW"],
  ["Sri Lanka","Public / Semi-public","Ocean Cleanup","Grant",1,0.3177,"LK"],
  ["Thailand","Foundation","Circular Economy","Grant",3,0.5327,"TH"],
  ["Puerto Rico","Nonprofit","Waste Management","Grant",1,0.4355,"PR"],
  ["Australia","Foundation","Waste Management","Lending",2,0.3742,"AU"],
  ["Australia","Foundation","Waste Management","Equity",2,0.3742,"AU"],
  ["Lebanon","Bank","Ocean Cleanup","Equity",1,0.1628,"LB"],
  ["Russia","Impact Investor","Circular Economy","Equity",1,0.0375,"RU"],
  ["Portugal","Incubator","Waste Management","Equity",3,0.3735,"PT"],
  ["Solomon Islands","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SB"],
  ["Botswana","Nonprofit","Ocean Cleanup","Grant",1,0.0763,"BW"],
  ["Sierra Leone","Venture Capital","Ocean Cleanup","Equity",1,1.0,"SL"],
  ["Denmark","Nonprofit","Waste Management","Equity",1,0.1324,"DK"],
  ["Tanzania","Impact Investor","Circular Economy","Grant",1,0.0624,"TZ"],
  ["Australia","Competitions","Waste Management","Grant",1,0.2815,"AU"],
  ["Nepal","Financial Service Provider","Circular Economy","Lending",1,0.3557,"NP"],
  ["Jordan","Incubator","Ocean Cleanup","Grant",1,0.0627,"JO"],
  ["South Sudan","Public / Semi-public","Ocean Cleanup","Equity",2,1.0497,"SS"],
  ["Philippines","Nonprofit","Circular Economy","Equity",1,0.1309,"PH"],
  ["Taiwan","Nonprofit","Ocean Cleanup","Lending",3,0.515,"TW"],
  ["Russia","Public / Semi-public","Waste Management","Lending",2,0.6298,"RU"],
  ["Nigeria","Venture Capital","Ocean Cleanup","Equity",1,1.0,"NG"],
  ["Hong Kong","Coworking Space","Waste Management","Equity",1,0.0541,"HK"],
  ["Central African Republic","Public / Semi-public","Circular Economy","Equity",1,0.1834,"CF"],
  ["Italy","Incubator","Ocean Cleanup","Lending",1,0.1971,"IT"],
  ["Georgia","Foundation","Waste Management","Grant",1,0.4367,"GE"],
  ["Somalia","Foundation","Waste Management","Lending",1,0.2496,"SO"],
  ["Lebanon","Foundation","Waste Management","Lending",1,0.1624,"LB"],
  ["Egypt","Financial Service Provider","Waste Management","Equity",2,0.1865,"EG"],
  ["Japan","Foundation","Waste Management","Lending",1,0.184,"JP"],
  ["China","Crowdfunding","Waste Management","Equity",1,0.2524,"CN"],
  ["Portugal","Incubator","Ocean Cleanup","Equity",1,0.1527,"PT"],
  ["Azerbaijan","Public / Semi-public","Waste Management","Equity",1,0.4882,"AZ"],
  ["Liechtenstein","Venture Capital","Ocean Cleanup","Equity",1,1.0,"LI"],
  ["Croatia","Public / Semi-public","Waste Management","Equity",1,0.1004,"HR"],
  ["Guatemala","Public / Semi-public","Ocean Cleanup","Equity",1,0.3085,"GT"],
  ["Thailand","Bank","Waste Management","Lending",2,0.2253,"TH"],
  ["Belgium","Nonprofit","Circular Economy","Equity",2,0.3263,"BE"],
  ["Turks and Caicos Islands","Venture Capital","Ocean Cleanup","Equity",1,1.0,"TC"],
  ["Philippines","Foundation","Waste Management","Grant",3,0.7382,"PH"],
  ["Lesotho","Venture Capital","Ocean Cleanup","Equity",1,1.0,"LS"],
  ["Sweden","Nonprofit","Ocean Cleanup","Equity",4,0.5671,"SE"],
  ["Saudi Arabia","Nonprofit","Waste Management","Equity",3,0.3269,"SA"],
  ["Ireland","Nonprofit","Waste Management","Lending",1,0.0953,"IE"],
  ["Benin","Public / Semi-public","Circular Economy","Grant",2,0.7428,"BJ"],
  ["Kenya","Nonprofit","Waste Management","Equity",4,1.2193,"KE"],
  ["Tajikistan","Foundation","Waste Management","Grant",1,1.0,"TJ"],
  ["South Korea","Public / Semi-public","Waste Management","Equity",4,1.0215,"KR"],
  ["Mexico","Incubator","Circular Economy","Grant",1,0.189,"MX"],
  ["Pakistan","Incubator","Waste Management","Equity",4,0.4865,"PK"],
  ["Tunisia","Foundation","Waste Management","Grant",1,0.2757,"TN"],
  ["Netherlands","Foundation","Ocean Cleanup","Grant",5,1.2383,"NL"],
  ["Madagascar","Foundation","Circular Economy","Grant",1,1.0,"MG"],
  ["Czech Republic","Bank","Ocean Cleanup","Lending",1,0.2262,"CZ"],
  ["Côte d'Ivoire","Financial Service Provider","Waste Management","Equity",1,0.0687,"CI"],
  ["Honduras","Impact Investor","Waste Management","Lending",1,0.8799,"HN"],
  ["United States","Crowdfunding","Waste Management","Equity",1,0.5548,"US"],
  ["Malaysia","Impact Investor","Ocean Cleanup","Equity",4,0.7561,"MY"],
  ["Poland","Nonprofit","Circular Economy","Grant",2,0.9322,"PL"],
  ["Germany","Financial Service Provider","Ocean Cleanup","Equity",2,0.1879,"DE"],
  ["Tunisia","Incubator","Waste Management","Equity",2,0.2258,"TN"],
  ["Nigeria","Bank","Waste Management","Equity",1,0.1225,"NG"],
  ["Martinique","Public / Semi-public","Ocean Cleanup","Equity",1,0.8653,"MQ"],
  ["Uganda","Financial Service Provider","Waste Management","Equity",3,0.5887,"UG"],
  ["Indonesia","Coworking Space","Waste Management","Lending",1,1.0,"ID"],
  ["Turks and Caicos Islands","Venture Capital","Circular Economy","Equity",1,1.0,"TC"],
  ["Puerto Rico","Venture Capital","Waste Management","Equity",1,0.0922,"PR"],
  ["Congo, Dem. Rep","Venture Capital","Ocean Cleanup","Equity",1,1.0,"CD"],
  ["Bahamas, The","Venture Capital","Circular Economy","Equity",1,1.0,"BS"]
]



// WEBPACK FOOTER //
// ./src/assets/chartData.js